// AUTO-GENERATED by scripts/derive_brand_expertise.mjs — do not hand-edit.
// Source: barcode_identity_corrections (filtered to min-count=10)
// Generated: 2026-04-27T16:36:12.331Z
// Brands kept: 2461 (filtered from 7070 at min-count=3)

// Hand-tuned counts in src/data/brandExpertise.js add ON TOP of
// these derived counts at runtime — see expertiseFor() in that
// file for the merge.

export const BRAND_EXPERTISE_FROM_USDA = {
  "meijer": {
    "displayName": "Meijer",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 1159,
      "dairy": 397,
      "meat": 29,
      "produce": 98,
      "beverage": 173,
      "frozen": 238
    },
    "subtypeCounts": {
      "spread": 43,
      "cheese": 257,
      "baking": 12,
      "sauce": 57,
      "boxed_meal": 127,
      "dressing": 54,
      "cookie": 80,
      "beverage": 173,
      "candy": 116,
      "bread": 166,
      "chocolate": 11,
      "sausage": 21,
      "milk": 57,
      "sweetener": 10,
      "yogurt": 71,
      "ice_cream": 79
    },
    "subtypes": [
      "cheese",
      "beverage",
      "bread",
      "boxed_meal",
      "candy",
      "cookie",
      "ice_cream",
      "yogurt",
      "sauce",
      "milk",
      "dressing",
      "spread",
      "sausage",
      "baking",
      "chocolate",
      "sweetener"
    ],
    "totalObs": 2094,
    "source": "usda"
  },
  "wegmans": {
    "displayName": "Wegmans",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 215,
      "pantry": 788,
      "dairy": 309,
      "beverage": 175,
      "frozen": 269,
      "meat": 46
    },
    "subtypeCounts": {
      "chocolate": 48,
      "cheese": 186,
      "dressing": 28,
      "beverage": 176,
      "yogurt": 95,
      "ice_cream": 93,
      "bread": 78,
      "sauce": 47,
      "milk": 24,
      "boxed_meal": 141,
      "candy": 87,
      "spread": 23,
      "baking": 13,
      "sweetener": 10,
      "sausage": 17,
      "cookie": 75
    },
    "subtypes": [
      "cheese",
      "beverage",
      "boxed_meal",
      "yogurt",
      "ice_cream",
      "candy",
      "bread",
      "cookie",
      "chocolate",
      "sauce",
      "dressing",
      "milk",
      "spread",
      "sausage",
      "baking",
      "sweetener"
    ],
    "totalObs": 1802,
    "source": "usda"
  },
  "food_club": {
    "displayName": "Food Club",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 940,
      "dairy": 333,
      "frozen": 259,
      "beverage": 126,
      "meat": 12,
      "produce": 2
    },
    "subtypeCounts": {
      "candy": 116,
      "cheese": 222,
      "sauce": 73,
      "baking": 30,
      "ice_cream": 140,
      "milk": 50,
      "bread": 71,
      "dressing": 50,
      "beverage": 127,
      "yogurt": 56,
      "cookie": 44,
      "boxed_meal": 41,
      "spread": 13,
      "sausage": 12,
      "chocolate": 11,
      "sweetener": 6
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "beverage",
      "candy",
      "sauce",
      "bread",
      "yogurt",
      "milk",
      "dressing",
      "cookie",
      "boxed_meal",
      "baking",
      "spread",
      "sausage",
      "chocolate",
      "sweetener"
    ],
    "totalObs": 1672,
    "source": "usda"
  },
  "great_value": {
    "displayName": "Great Value",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 825,
      "frozen": 350,
      "meat": 18,
      "produce": 5,
      "dairy": 349,
      "beverage": 118
    },
    "subtypeCounts": {
      "baking": 24,
      "bread": 55,
      "sausage": 17,
      "boxed_meal": 199,
      "cookie": 63,
      "milk": 51,
      "yogurt": 78,
      "sauce": 69,
      "cheese": 213,
      "ice_cream": 99,
      "candy": 43,
      "dressing": 70,
      "beverage": 118,
      "chocolate": 3,
      "spread": 22,
      "sweetener": 16
    },
    "subtypes": [
      "cheese",
      "boxed_meal",
      "beverage",
      "ice_cream",
      "yogurt",
      "dressing",
      "sauce",
      "cookie",
      "bread",
      "milk",
      "candy",
      "baking",
      "spread",
      "sausage",
      "sweetener",
      "chocolate"
    ],
    "totalObs": 1665,
    "source": "usda"
  },
  "hy_vee": {
    "displayName": "Hy-vee",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 826,
      "dairy": 335,
      "beverage": 130,
      "frozen": 240,
      "produce": 48,
      "meat": 18
    },
    "subtypeCounts": {
      "spread": 23,
      "cheese": 221,
      "cookie": 60,
      "beverage": 131,
      "bread": 113,
      "sauce": 53,
      "candy": 106,
      "milk": 41,
      "boxed_meal": 79,
      "ice_cream": 81,
      "baking": 15,
      "dressing": 55,
      "sausage": 14,
      "yogurt": 66,
      "chocolate": 8,
      "sweetener": 4
    },
    "subtypes": [
      "cheese",
      "beverage",
      "bread",
      "candy",
      "ice_cream",
      "boxed_meal",
      "yogurt",
      "cookie",
      "dressing",
      "sauce",
      "milk",
      "spread",
      "baking",
      "sausage",
      "chocolate",
      "sweetener"
    ],
    "totalObs": 1597,
    "source": "usda"
  },
  "giant_eagle": {
    "displayName": "Giant Eagle",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 336,
      "pantry": 610,
      "dairy": 258,
      "beverage": 96,
      "produce": 114,
      "meat": 46
    },
    "subtypeCounts": {
      "ice_cream": 118,
      "cookie": 56,
      "cheese": 165,
      "candy": 39,
      "boxed_meal": 89,
      "yogurt": 58,
      "beverage": 96,
      "bread": 80,
      "dressing": 40,
      "chocolate": 2,
      "sausage": 26,
      "baking": 3,
      "sweetener": 4,
      "sauce": 6,
      "spread": 15,
      "milk": 28
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "beverage",
      "boxed_meal",
      "bread",
      "yogurt",
      "cookie",
      "dressing",
      "candy",
      "milk",
      "sausage",
      "spread",
      "sauce",
      "sweetener",
      "baking",
      "chocolate"
    ],
    "totalObs": 1460,
    "source": "usda"
  },
  "ahold": {
    "displayName": "Ahold",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 726,
      "dairy": 211,
      "beverage": 159,
      "produce": 97,
      "frozen": 231,
      "meat": 27
    },
    "subtypeCounts": {
      "candy": 104,
      "cheese": 143,
      "beverage": 159,
      "boxed_meal": 113,
      "ice_cream": 92,
      "cookie": 47,
      "sweetener": 7,
      "sausage": 10,
      "sauce": 25,
      "bread": 137,
      "yogurt": 30,
      "chocolate": 16,
      "baking": 12,
      "dressing": 26,
      "spread": 13,
      "milk": 19
    },
    "subtypes": [
      "beverage",
      "cheese",
      "bread",
      "boxed_meal",
      "candy",
      "ice_cream",
      "cookie",
      "yogurt",
      "dressing",
      "sauce",
      "milk",
      "chocolate",
      "spread",
      "baking",
      "sausage",
      "sweetener"
    ],
    "totalObs": 1451,
    "source": "usda"
  },
  "signature_select": {
    "displayName": "Signature Select",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 797,
      "frozen": 355,
      "meat": 19,
      "beverage": 206,
      "dairy": 12,
      "produce": 4
    },
    "subtypeCounts": {
      "sauce": 44,
      "dressing": 35,
      "baking": 11,
      "cookie": 72,
      "bread": 248,
      "boxed_meal": 147,
      "sausage": 19,
      "ice_cream": 157,
      "beverage": 206,
      "chocolate": 13,
      "candy": 32,
      "spread": 42,
      "cheese": 7,
      "sweetener": 4,
      "milk": 5
    },
    "subtypes": [
      "bread",
      "beverage",
      "ice_cream",
      "boxed_meal",
      "cookie",
      "sauce",
      "spread",
      "dressing",
      "candy",
      "sausage",
      "chocolate",
      "baking",
      "cheese",
      "milk",
      "sweetener"
    ],
    "totalObs": 1393,
    "source": "usda"
  },
  "kroger": {
    "displayName": "Kroger",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 682,
      "dairy": 273,
      "frozen": 230,
      "beverage": 114,
      "produce": 46,
      "meat": 19
    },
    "subtypeCounts": {
      "cheese": 143,
      "yogurt": 59,
      "candy": 53,
      "boxed_meal": 102,
      "ice_cream": 114,
      "beverage": 114,
      "chocolate": 2,
      "sauce": 32,
      "cookie": 40,
      "milk": 57,
      "dressing": 69,
      "bread": 62,
      "sausage": 11,
      "baking": 13,
      "sweetener": 5,
      "spread": 27
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "beverage",
      "boxed_meal",
      "dressing",
      "bread",
      "yogurt",
      "milk",
      "candy",
      "cookie",
      "sauce",
      "spread",
      "baking",
      "sausage",
      "sweetener",
      "chocolate"
    ],
    "totalObs": 1364,
    "source": "usda"
  },
  "not_a_ed_item": {
    "displayName": "Not A Branded Item",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 867,
      "dairy": 82,
      "meat": 80,
      "beverage": 38,
      "frozen": 80,
      "produce": 200
    },
    "subtypeCounts": {
      "bread": 91,
      "milk": 14,
      "boxed_meal": 122,
      "chocolate": 57,
      "cheese": 47,
      "spread": 8,
      "candy": 325,
      "cookie": 167,
      "beverage": 38,
      "sauce": 11,
      "yogurt": 21,
      "ice_cream": 19,
      "baking": 5,
      "dressing": 10,
      "sausage": 7,
      "sweetener": 11
    },
    "subtypes": [
      "candy",
      "cookie",
      "boxed_meal",
      "bread",
      "chocolate",
      "cheese",
      "beverage",
      "yogurt",
      "ice_cream",
      "milk",
      "sauce",
      "sweetener",
      "dressing",
      "spread",
      "sausage",
      "baking"
    ],
    "totalObs": 1347,
    "source": "usda"
  },
  "harris_teeter": {
    "displayName": "Harris Teeter",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 225,
      "pantry": 569,
      "dairy": 282,
      "beverage": 171,
      "produce": 41,
      "meat": 13
    },
    "subtypeCounts": {
      "ice_cream": 133,
      "yogurt": 79,
      "beverage": 171,
      "spread": 31,
      "sweetener": 8,
      "bread": 32,
      "milk": 85,
      "dressing": 41,
      "cheese": 111,
      "boxed_meal": 60,
      "sauce": 22,
      "cookie": 36,
      "candy": 17,
      "chocolate": 5,
      "baking": 15,
      "sausage": 9
    },
    "subtypes": [
      "beverage",
      "ice_cream",
      "cheese",
      "milk",
      "yogurt",
      "boxed_meal",
      "dressing",
      "cookie",
      "bread",
      "spread",
      "sauce",
      "candy",
      "baking",
      "sausage",
      "sweetener",
      "chocolate"
    ],
    "totalObs": 1301,
    "source": "usda"
  },
  "market_pantry": {
    "displayName": "Market Pantry",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 658,
      "dairy": 316,
      "frozen": 221,
      "beverage": 77,
      "meat": 13,
      "produce": 2
    },
    "subtypeCounts": {
      "candy": 110,
      "cheese": 244,
      "ice_cream": 121,
      "beverage": 77,
      "cookie": 183,
      "yogurt": 21,
      "milk": 40,
      "boxed_meal": 84,
      "bread": 60,
      "dressing": 42,
      "sweetener": 1,
      "spread": 11,
      "baking": 11,
      "sauce": 7,
      "sausage": 10,
      "chocolate": 1
    },
    "subtypes": [
      "cheese",
      "cookie",
      "ice_cream",
      "candy",
      "boxed_meal",
      "beverage",
      "bread",
      "dressing",
      "milk",
      "yogurt",
      "spread",
      "baking",
      "sausage",
      "sauce",
      "sweetener",
      "chocolate"
    ],
    "totalObs": 1287,
    "source": "usda"
  },
  "tops": {
    "displayName": "Tops",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 133,
      "dairy": 368,
      "pantry": 639,
      "beverage": 51,
      "meat": 11
    },
    "subtypeCounts": {
      "cheese": 226,
      "sauce": 26,
      "dressing": 58,
      "baking": 6,
      "cookie": 47,
      "beverage": 51,
      "bread": 35,
      "boxed_meal": 40,
      "ice_cream": 40,
      "yogurt": 90,
      "milk": 46,
      "sweetener": 10,
      "candy": 126,
      "chocolate": 20,
      "sausage": 5,
      "spread": 19
    },
    "subtypes": [
      "cheese",
      "candy",
      "yogurt",
      "dressing",
      "beverage",
      "cookie",
      "milk",
      "boxed_meal",
      "ice_cream",
      "bread",
      "sauce",
      "chocolate",
      "spread",
      "sweetener",
      "baking",
      "sausage"
    ],
    "totalObs": 1202,
    "source": "usda"
  },
  "essential_everyday": {
    "displayName": "Essential Everyday",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 661,
      "meat": 14,
      "beverage": 77,
      "dairy": 276,
      "frozen": 131,
      "produce": 3
    },
    "subtypeCounts": {
      "dressing": 37,
      "sausage": 11,
      "candy": 67,
      "beverage": 78,
      "yogurt": 31,
      "milk": 59,
      "cookie": 31,
      "baking": 17,
      "sauce": 40,
      "boxed_meal": 67,
      "cheese": 179,
      "bread": 54,
      "chocolate": 2,
      "ice_cream": 16,
      "sweetener": 6,
      "spread": 22
    },
    "subtypes": [
      "cheese",
      "beverage",
      "candy",
      "boxed_meal",
      "milk",
      "bread",
      "sauce",
      "dressing",
      "yogurt",
      "cookie",
      "spread",
      "baking",
      "ice_cream",
      "sausage",
      "sweetener",
      "chocolate"
    ],
    "totalObs": 1162,
    "source": "usda"
  },
  "schnucks": {
    "displayName": "Schnucks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 619,
      "frozen": 105,
      "dairy": 255,
      "beverage": 82,
      "produce": 8,
      "meat": 10
    },
    "subtypeCounts": {
      "bread": 44,
      "cookie": 26,
      "cheese": 206,
      "boxed_meal": 38,
      "beverage": 83,
      "dressing": 53,
      "yogurt": 20,
      "sauce": 43,
      "ice_cream": 39,
      "baking": 7,
      "milk": 25,
      "candy": 51,
      "sweetener": 5,
      "spread": 7,
      "chocolate": 3,
      "sausage": 7
    },
    "subtypes": [
      "cheese",
      "beverage",
      "dressing",
      "candy",
      "bread",
      "sauce",
      "ice_cream",
      "boxed_meal",
      "cookie",
      "milk",
      "yogurt",
      "baking",
      "spread",
      "sausage",
      "sweetener",
      "chocolate"
    ],
    "totalObs": 1079,
    "source": "usda"
  },
  "raleys": {
    "displayName": "Raley's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 624,
      "frozen": 127,
      "meat": 24,
      "beverage": 98,
      "dairy": 146,
      "produce": 58
    },
    "subtypeCounts": {
      "sauce": 43,
      "sausage": 17,
      "beverage": 98,
      "milk": 8,
      "dressing": 33,
      "candy": 14,
      "chocolate": 21,
      "cookie": 20,
      "boxed_meal": 50,
      "cheese": 133,
      "baking": 29,
      "bread": 43,
      "ice_cream": 11,
      "sweetener": 6,
      "spread": 25
    },
    "subtypes": [
      "cheese",
      "beverage",
      "boxed_meal",
      "sauce",
      "bread",
      "dressing",
      "baking",
      "spread",
      "chocolate",
      "cookie",
      "sausage",
      "candy",
      "ice_cream",
      "milk",
      "sweetener"
    ],
    "totalObs": 1077,
    "source": "usda"
  },
  "hannaford": {
    "displayName": "Hannaford",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 40,
      "frozen": 133,
      "dairy": 238,
      "pantry": 447,
      "beverage": 92,
      "meat": 18
    },
    "subtypeCounts": {
      "ice_cream": 58,
      "cheese": 143,
      "cookie": 30,
      "beverage": 92,
      "dressing": 49,
      "boxed_meal": 44,
      "bread": 59,
      "sauce": 12,
      "yogurt": 52,
      "candy": 27,
      "baking": 11,
      "sausage": 8,
      "milk": 35,
      "sweetener": 5,
      "spread": 6,
      "chocolate": 1
    },
    "subtypes": [
      "cheese",
      "beverage",
      "bread",
      "ice_cream",
      "yogurt",
      "dressing",
      "boxed_meal",
      "milk",
      "cookie",
      "candy",
      "sauce",
      "baking",
      "sausage",
      "spread",
      "sweetener",
      "chocolate"
    ],
    "totalObs": 968,
    "source": "usda"
  },
  "big_y": {
    "displayName": "Big Y",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 120,
      "pantry": 511,
      "beverage": 64,
      "dairy": 190,
      "meat": 12,
      "produce": 20
    },
    "subtypeCounts": {
      "bread": 78,
      "beverage": 64,
      "dressing": 21,
      "sweetener": 10,
      "sauce": 56,
      "boxed_meal": 51,
      "cheese": 114,
      "ice_cream": 49,
      "candy": 39,
      "milk": 37,
      "cookie": 17,
      "chocolate": 7,
      "baking": 10,
      "yogurt": 33,
      "sausage": 2,
      "spread": 9
    },
    "subtypes": [
      "cheese",
      "bread",
      "beverage",
      "sauce",
      "boxed_meal",
      "ice_cream",
      "candy",
      "milk",
      "yogurt",
      "dressing",
      "cookie",
      "sweetener",
      "baking",
      "spread",
      "chocolate",
      "sausage"
    ],
    "totalObs": 917,
    "source": "usda"
  },
  "food_lion": {
    "displayName": "Food Lion",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 12,
      "pantry": 419,
      "dairy": 212,
      "frozen": 155,
      "beverage": 94,
      "meat": 18
    },
    "subtypeCounts": {
      "baking": 15,
      "beverage": 94,
      "ice_cream": 66,
      "candy": 36,
      "sauce": 16,
      "boxed_meal": 45,
      "sausage": 11,
      "bread": 52,
      "cookie": 42,
      "sweetener": 5,
      "cheese": 140,
      "dressing": 32,
      "spread": 16,
      "yogurt": 31,
      "milk": 36
    },
    "subtypes": [
      "cheese",
      "beverage",
      "ice_cream",
      "bread",
      "boxed_meal",
      "cookie",
      "candy",
      "milk",
      "dressing",
      "yogurt",
      "sauce",
      "spread",
      "baking",
      "sausage",
      "sweetener"
    ],
    "totalObs": 910,
    "source": "usda"
  },
  "whole_market": {
    "displayName": "Whole Market",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 453,
      "dairy": 74,
      "beverage": 119,
      "produce": 69,
      "frozen": 80,
      "meat": 47
    },
    "subtypeCounts": {
      "chocolate": 26,
      "sauce": 45,
      "cookie": 24,
      "cheese": 42,
      "beverage": 120,
      "ice_cream": 32,
      "candy": 38,
      "dressing": 25,
      "boxed_meal": 92,
      "bread": 85,
      "milk": 11,
      "sweetener": 1,
      "spread": 5,
      "yogurt": 20,
      "baking": 2
    },
    "subtypes": [
      "beverage",
      "boxed_meal",
      "bread",
      "sauce",
      "cheese",
      "candy",
      "ice_cream",
      "chocolate",
      "dressing",
      "cookie",
      "yogurt",
      "milk",
      "spread",
      "baking",
      "sweetener"
    ],
    "totalObs": 842,
    "source": "usda"
  },
  "shurfine": {
    "displayName": "Shurfine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 55,
      "pantry": 480,
      "dairy": 197,
      "frozen": 78,
      "produce": 1
    },
    "subtypeCounts": {
      "beverage": 55,
      "milk": 52,
      "sauce": 36,
      "cookie": 28,
      "ice_cream": 48,
      "candy": 20,
      "cheese": 117,
      "bread": 21,
      "boxed_meal": 28,
      "baking": 23,
      "yogurt": 23,
      "dressing": 40,
      "sweetener": 1,
      "spread": 7
    },
    "subtypes": [
      "cheese",
      "beverage",
      "milk",
      "ice_cream",
      "dressing",
      "sauce",
      "cookie",
      "boxed_meal",
      "baking",
      "yogurt",
      "bread",
      "candy",
      "spread",
      "sweetener"
    ],
    "totalObs": 811,
    "source": "usda"
  },
  "our_family": {
    "displayName": "Our Family",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 124,
      "pantry": 444,
      "dairy": 175,
      "beverage": 56,
      "meat": 6
    },
    "subtypeCounts": {
      "ice_cream": 68,
      "bread": 37,
      "cheese": 110,
      "baking": 12,
      "dressing": 33,
      "beverage": 56,
      "boxed_meal": 23,
      "candy": 55,
      "yogurt": 36,
      "sauce": 29,
      "cookie": 19,
      "sausage": 6,
      "milk": 25,
      "spread": 27,
      "sweetener": 5,
      "chocolate": 2
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "beverage",
      "candy",
      "bread",
      "yogurt",
      "dressing",
      "sauce",
      "spread",
      "milk",
      "boxed_meal",
      "cookie",
      "baking",
      "sausage",
      "sweetener",
      "chocolate"
    ],
    "totalObs": 805,
    "source": "usda"
  },
  "first_street": {
    "displayName": "First Street",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 19,
      "pantry": 482,
      "dairy": 123,
      "produce": 14,
      "frozen": 103,
      "beverage": 64
    },
    "subtypeCounts": {
      "sausage": 9,
      "milk": 25,
      "cookie": 30,
      "dressing": 39,
      "bread": 34,
      "sweetener": 7,
      "boxed_meal": 42,
      "ice_cream": 51,
      "beverage": 64,
      "candy": 48,
      "chocolate": 3,
      "sauce": 51,
      "cheese": 94,
      "baking": 23,
      "spread": 9,
      "yogurt": 2
    },
    "subtypes": [
      "cheese",
      "beverage",
      "ice_cream",
      "sauce",
      "candy",
      "boxed_meal",
      "dressing",
      "bread",
      "cookie",
      "milk",
      "baking",
      "sausage",
      "spread",
      "sweetener",
      "chocolate",
      "yogurt"
    ],
    "totalObs": 805,
    "source": "usda"
  },
  "spartan": {
    "displayName": "Spartan",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 458,
      "dairy": 179,
      "meat": 3,
      "frozen": 72,
      "beverage": 49,
      "produce": 3
    },
    "subtypeCounts": {
      "dressing": 46,
      "yogurt": 45,
      "cheese": 101,
      "spread": 34,
      "candy": 45,
      "sweetener": 4,
      "baking": 7,
      "sauce": 21,
      "sausage": 2,
      "boxed_meal": 29,
      "cookie": 28,
      "ice_cream": 45,
      "bread": 18,
      "milk": 26,
      "chocolate": 2,
      "beverage": 49
    },
    "subtypes": [
      "cheese",
      "beverage",
      "dressing",
      "yogurt",
      "candy",
      "ice_cream",
      "spread",
      "boxed_meal",
      "cookie",
      "milk",
      "sauce",
      "bread",
      "baking",
      "sweetener",
      "sausage",
      "chocolate"
    ],
    "totalObs": 764,
    "source": "usda"
  },
  "365_everyday_value": {
    "displayName": "365 Everyday Value",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 199,
      "pantry": 379,
      "beverage": 68,
      "frozen": 97,
      "meat": 7,
      "produce": 3
    },
    "subtypeCounts": {
      "cheese": 59,
      "beverage": 69,
      "boxed_meal": 25,
      "baking": 12,
      "sweetener": 2,
      "spread": 16,
      "milk": 102,
      "candy": 13,
      "chocolate": 7,
      "bread": 56,
      "sausage": 7,
      "ice_cream": 45,
      "yogurt": 27,
      "dressing": 39,
      "cookie": 33,
      "sauce": 16
    },
    "subtypes": [
      "milk",
      "beverage",
      "cheese",
      "bread",
      "ice_cream",
      "dressing",
      "cookie",
      "yogurt",
      "boxed_meal",
      "spread",
      "sauce",
      "candy",
      "baking",
      "chocolate",
      "sausage",
      "sweetener"
    ],
    "totalObs": 753,
    "source": "usda"
  },
  "shoprite": {
    "displayName": "Shoprite",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 425,
      "beverage": 46,
      "produce": 8,
      "dairy": 185,
      "meat": 5,
      "frozen": 50
    },
    "subtypeCounts": {
      "beverage": 46,
      "dressing": 44,
      "cookie": 19,
      "sauce": 19,
      "bread": 46,
      "milk": 37,
      "baking": 5,
      "cheese": 98,
      "spread": 21,
      "yogurt": 43,
      "candy": 16,
      "boxed_meal": 20,
      "sausage": 5,
      "ice_cream": 26
    },
    "subtypes": [
      "cheese",
      "beverage",
      "bread",
      "dressing",
      "yogurt",
      "milk",
      "ice_cream",
      "spread",
      "boxed_meal",
      "cookie",
      "sauce",
      "candy",
      "baking",
      "sausage"
    ],
    "totalObs": 719,
    "source": "usda"
  },
  "good_gather": {
    "displayName": "Good& Gather",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 100,
      "beverage": 36,
      "pantry": 255,
      "dairy": 235,
      "meat": 19,
      "frozen": 67
    },
    "subtypeCounts": {
      "beverage": 36,
      "baking": 11,
      "boxed_meal": 72,
      "sausage": 4,
      "cheese": 165,
      "sweetener": 12,
      "spread": 11,
      "dressing": 21,
      "candy": 7,
      "yogurt": 22,
      "milk": 38,
      "sauce": 7
    },
    "subtypes": [
      "cheese",
      "boxed_meal",
      "milk",
      "beverage",
      "yogurt",
      "dressing",
      "sweetener",
      "baking",
      "spread",
      "candy",
      "sauce",
      "sausage"
    ],
    "totalObs": 712,
    "source": "usda"
  },
  "stater_bros": {
    "displayName": "Stater Bros",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 167,
      "pantry": 324,
      "frozen": 133,
      "produce": 4,
      "beverage": 60,
      "meat": 14
    },
    "subtypeCounts": {
      "cheese": 113,
      "bread": 39,
      "yogurt": 35,
      "milk": 13,
      "cookie": 9,
      "beverage": 60,
      "candy": 10,
      "ice_cream": 73,
      "baking": 10,
      "dressing": 13,
      "sausage": 11,
      "boxed_meal": 26,
      "spread": 13,
      "sweetener": 6,
      "sauce": 6
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "beverage",
      "bread",
      "yogurt",
      "boxed_meal",
      "milk",
      "dressing",
      "spread",
      "sausage",
      "candy",
      "baking",
      "cookie",
      "sweetener",
      "sauce"
    ],
    "totalObs": 702,
    "source": "usda"
  },
  "weis_quality": {
    "displayName": "Weis Quality",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 455,
      "dairy": 112,
      "frozen": 41,
      "meat": 6,
      "produce": 2,
      "beverage": 85
    },
    "subtypeCounts": {
      "sauce": 25,
      "cheese": 45,
      "candy": 92,
      "chocolate": 7,
      "spread": 17,
      "yogurt": 27,
      "boxed_meal": 31,
      "dressing": 33,
      "bread": 22,
      "milk": 36,
      "sausage": 6,
      "sweetener": 4,
      "ice_cream": 24,
      "baking": 13,
      "cookie": 16,
      "beverage": 85
    },
    "subtypes": [
      "candy",
      "beverage",
      "cheese",
      "milk",
      "dressing",
      "boxed_meal",
      "yogurt",
      "sauce",
      "ice_cream",
      "bread",
      "spread",
      "cookie",
      "baking",
      "chocolate",
      "sausage",
      "sweetener"
    ],
    "totalObs": 701,
    "source": "usda"
  },
  "russell_stover": {
    "displayName": "Russell Stover",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 659
    },
    "subtypeCounts": {
      "chocolate": 401,
      "candy": 252,
      "cookie": 5,
      "beverage": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie",
      "beverage"
    ],
    "totalObs": 659,
    "source": "usda"
  },
  "archer_farms": {
    "displayName": "Archer Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 408,
      "dairy": 42,
      "frozen": 102,
      "meat": 42,
      "produce": 36,
      "beverage": 1
    },
    "subtypeCounts": {
      "bread": 78,
      "cheese": 41,
      "sauce": 20,
      "beverage": 7,
      "boxed_meal": 89,
      "cookie": 100,
      "dressing": 33,
      "spread": 12,
      "ice_cream": 27,
      "candy": 8,
      "chocolate": 10,
      "sausage": 5
    },
    "subtypes": [
      "cookie",
      "boxed_meal",
      "bread",
      "cheese",
      "dressing",
      "ice_cream",
      "sauce",
      "spread",
      "chocolate",
      "candy",
      "beverage",
      "sausage"
    ],
    "totalObs": 631,
    "source": "usda"
  },
  "roundys": {
    "displayName": "Roundys",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 379,
      "dairy": 83,
      "frozen": 75,
      "meat": 14,
      "beverage": 41,
      "produce": 3
    },
    "subtypeCounts": {
      "cheese": 38,
      "chocolate": 8,
      "sausage": 11,
      "baking": 8,
      "sauce": 23,
      "cookie": 16,
      "ice_cream": 47,
      "boxed_meal": 23,
      "yogurt": 19,
      "bread": 35,
      "milk": 21,
      "dressing": 30,
      "candy": 26,
      "spread": 11,
      "sweetener": 3,
      "beverage": 42
    },
    "subtypes": [
      "ice_cream",
      "beverage",
      "cheese",
      "bread",
      "dressing",
      "candy",
      "sauce",
      "boxed_meal",
      "milk",
      "yogurt",
      "cookie",
      "sausage",
      "spread",
      "chocolate",
      "baking",
      "sweetener"
    ],
    "totalObs": 595,
    "source": "usda"
  },
  "best_choice": {
    "displayName": "Best Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 325,
      "frozen": 100,
      "beverage": 59,
      "dairy": 100,
      "produce": 1
    },
    "subtypeCounts": {
      "cookie": 28,
      "ice_cream": 62,
      "beverage": 60,
      "bread": 21,
      "boxed_meal": 23,
      "yogurt": 38,
      "baking": 18,
      "cheese": 30,
      "milk": 21,
      "dressing": 36,
      "sauce": 27,
      "candy": 18,
      "spread": 11,
      "sweetener": 1
    },
    "subtypes": [
      "ice_cream",
      "beverage",
      "yogurt",
      "dressing",
      "cheese",
      "cookie",
      "sauce",
      "boxed_meal",
      "bread",
      "milk",
      "baking",
      "candy",
      "spread",
      "sweetener"
    ],
    "totalObs": 585,
    "source": "usda"
  },
  "weis": {
    "displayName": "Weis",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 123,
      "pantry": 299,
      "produce": 17,
      "frozen": 115,
      "meat": 4,
      "beverage": 25
    },
    "subtypeCounts": {
      "cheese": 88,
      "spread": 5,
      "candy": 83,
      "bread": 42,
      "cookie": 28,
      "ice_cream": 60,
      "boxed_meal": 15,
      "milk": 16,
      "yogurt": 18,
      "sausage": 4,
      "sauce": 8,
      "sweetener": 1,
      "chocolate": 13,
      "beverage": 25,
      "dressing": 5
    },
    "subtypes": [
      "cheese",
      "candy",
      "ice_cream",
      "bread",
      "cookie",
      "beverage",
      "yogurt",
      "milk",
      "boxed_meal",
      "chocolate",
      "sauce",
      "spread",
      "dressing",
      "sausage",
      "sweetener"
    ],
    "totalObs": 583,
    "source": "usda"
  },
  "mc_rmick": {
    "displayName": "Mccormick",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 546,
      "frozen": 3,
      "produce": 1,
      "meat": 6
    },
    "subtypeCounts": {
      "sauce": 449,
      "dressing": 33,
      "spread": 4,
      "boxed_meal": 3,
      "baking": 3,
      "sausage": 6
    },
    "subtypes": [
      "sauce",
      "dressing",
      "sausage",
      "spread",
      "boxed_meal",
      "baking"
    ],
    "totalObs": 556,
    "source": "usda"
  },
  "goya": {
    "displayName": "Goya",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 357,
      "beverage": 82,
      "frozen": 96,
      "meat": 2,
      "dairy": 9,
      "produce": 2
    },
    "subtypeCounts": {
      "cookie": 28,
      "baking": 35,
      "sauce": 77,
      "beverage": 82,
      "boxed_meal": 63,
      "sausage": 1,
      "spread": 7,
      "bread": 10,
      "cheese": 3,
      "dressing": 3,
      "milk": 5,
      "sweetener": 3,
      "yogurt": 1,
      "candy": 1
    },
    "subtypes": [
      "beverage",
      "sauce",
      "boxed_meal",
      "baking",
      "cookie",
      "bread",
      "spread",
      "milk",
      "cheese",
      "dressing",
      "sweetener",
      "sausage",
      "yogurt",
      "candy"
    ],
    "totalObs": 548,
    "source": "usda"
  },
  "clover_valley": {
    "displayName": "Clover Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 364,
      "dairy": 51,
      "beverage": 43,
      "frozen": 67
    },
    "subtypeCounts": {
      "cookie": 62,
      "cheese": 39,
      "sauce": 26,
      "milk": 11,
      "beverage": 44,
      "bread": 29,
      "dressing": 20,
      "candy": 8,
      "ice_cream": 34,
      "spread": 9,
      "boxed_meal": 26,
      "baking": 12,
      "sweetener": 1
    },
    "subtypes": [
      "cookie",
      "beverage",
      "cheese",
      "ice_cream",
      "bread",
      "sauce",
      "boxed_meal",
      "dressing",
      "baking",
      "milk",
      "spread",
      "candy",
      "sweetener"
    ],
    "totalObs": 525,
    "source": "usda"
  },
  "o_organics": {
    "displayName": "O Organics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 119,
      "produce": 59,
      "pantry": 228,
      "beverage": 37,
      "frozen": 61,
      "meat": 6
    },
    "subtypeCounts": {
      "milk": 53,
      "boxed_meal": 38,
      "cheese": 46,
      "cookie": 23,
      "beverage": 37,
      "dressing": 22,
      "ice_cream": 21,
      "bread": 29,
      "spread": 10,
      "sweetener": 4,
      "candy": 6,
      "yogurt": 16,
      "baking": 5,
      "sausage": 5,
      "sauce": 5
    },
    "subtypes": [
      "milk",
      "cheese",
      "boxed_meal",
      "beverage",
      "bread",
      "cookie",
      "dressing",
      "ice_cream",
      "yogurt",
      "spread",
      "candy",
      "baking",
      "sausage",
      "sauce",
      "sweetener"
    ],
    "totalObs": 510,
    "source": "usda"
  },
  "simply_balanced": {
    "displayName": "Simply Balanced",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 84,
      "pantry": 260,
      "frozen": 77,
      "dairy": 80,
      "produce": 3,
      "meat": 5
    },
    "subtypeCounts": {
      "beverage": 84,
      "sweetener": 5,
      "bread": 30,
      "yogurt": 49,
      "cheese": 6,
      "chocolate": 5,
      "ice_cream": 22,
      "sauce": 5,
      "candy": 18,
      "boxed_meal": 36,
      "cookie": 13,
      "sausage": 5,
      "baking": 7,
      "milk": 21,
      "dressing": 19,
      "spread": 8
    },
    "subtypes": [
      "beverage",
      "yogurt",
      "boxed_meal",
      "bread",
      "ice_cream",
      "milk",
      "dressing",
      "candy",
      "cookie",
      "spread",
      "baking",
      "cheese",
      "sweetener",
      "chocolate",
      "sauce",
      "sausage"
    ],
    "totalObs": 509,
    "source": "usda"
  },
  "brookshires": {
    "displayName": "Brookshire's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 307,
      "beverage": 38,
      "produce": 13,
      "frozen": 66,
      "dairy": 66,
      "meat": 13
    },
    "subtypeCounts": {
      "sweetener": 5,
      "candy": 30,
      "beverage": 38,
      "sauce": 23,
      "baking": 9,
      "bread": 22,
      "cookie": 22,
      "chocolate": 8,
      "cheese": 49,
      "sausage": 8,
      "spread": 12,
      "milk": 15,
      "yogurt": 2,
      "dressing": 17,
      "boxed_meal": 9
    },
    "subtypes": [
      "cheese",
      "beverage",
      "candy",
      "sauce",
      "bread",
      "cookie",
      "dressing",
      "milk",
      "spread",
      "baking",
      "boxed_meal",
      "chocolate",
      "sausage",
      "sweetener",
      "yogurt"
    ],
    "totalObs": 503,
    "source": "usda"
  },
  "mms": {
    "displayName": "M&m's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 477,
      "frozen": 19
    },
    "subtypeCounts": {
      "candy": 338,
      "ice_cream": 19,
      "chocolate": 135,
      "cookie": 3
    },
    "subtypes": [
      "candy",
      "chocolate",
      "ice_cream",
      "cookie"
    ],
    "totalObs": 496,
    "source": "usda"
  },
  "brachs": {
    "displayName": "Brach's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 489
    },
    "subtypeCounts": {
      "candy": 465,
      "chocolate": 22,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 489,
    "source": "usda"
  },
  "kraft": {
    "displayName": "Kraft",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 299,
      "pantry": 171,
      "frozen": 7
    },
    "subtypeCounts": {
      "cheese": 298,
      "dressing": 105,
      "candy": 54,
      "milk": 1,
      "sauce": 7,
      "baking": 1,
      "boxed_meal": 7
    },
    "subtypes": [
      "cheese",
      "dressing",
      "candy",
      "sauce",
      "boxed_meal",
      "milk",
      "baking"
    ],
    "totalObs": 477,
    "source": "usda"
  },
  "se_grocers": {
    "displayName": "Se Grocers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 108,
      "pantry": 239,
      "frozen": 68,
      "beverage": 26,
      "produce": 8,
      "meat": 2
    },
    "subtypeCounts": {
      "cheese": 70,
      "cookie": 14,
      "dressing": 19,
      "ice_cream": 49,
      "candy": 8,
      "beverage": 26,
      "milk": 24,
      "sauce": 15,
      "bread": 12,
      "spread": 11,
      "boxed_meal": 12,
      "yogurt": 14,
      "baking": 4,
      "sweetener": 3,
      "chocolate": 4
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "beverage",
      "milk",
      "dressing",
      "sauce",
      "cookie",
      "yogurt",
      "bread",
      "boxed_meal",
      "spread",
      "candy",
      "baking",
      "chocolate",
      "sweetener"
    ],
    "totalObs": 451,
    "source": "usda"
  },
  "kemps": {
    "displayName": "Kemps",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 290,
      "dairy": 150,
      "beverage": 5,
      "pantry": 1
    },
    "subtypeCounts": {
      "ice_cream": 290,
      "milk": 104,
      "beverage": 5,
      "cheese": 25,
      "yogurt": 21,
      "candy": 1
    },
    "subtypes": [
      "ice_cream",
      "milk",
      "cheese",
      "yogurt",
      "beverage",
      "candy"
    ],
    "totalObs": 446,
    "source": "usda"
  },
  "hersheys": {
    "displayName": "Hershey's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 411,
      "frozen": 11,
      "dairy": 17
    },
    "subtypeCounts": {
      "candy": 108,
      "chocolate": 284,
      "cookie": 15,
      "ice_cream": 11,
      "milk": 16,
      "yogurt": 1,
      "baking": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "milk",
      "cookie",
      "ice_cream",
      "yogurt",
      "baking"
    ],
    "totalObs": 439,
    "source": "usda"
  },
  "galerie": {
    "displayName": "Galerie",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 411
    },
    "subtypeCounts": {
      "chocolate": 85,
      "candy": 324,
      "cookie": 2
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 411,
    "source": "usda"
  },
  "lays": {
    "displayName": "Lay's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 371
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 371,
    "source": "usda"
  },
  "lindt": {
    "displayName": "Lindt",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 370
    },
    "subtypeCounts": {
      "chocolate": 347,
      "candy": 20,
      "cookie": 3
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 370,
    "source": "usda"
  },
  "del_monte": {
    "displayName": "Del Monte",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 332,
      "beverage": 21,
      "dairy": 6,
      "frozen": 7,
      "produce": 3
    },
    "subtypeCounts": {
      "candy": 1,
      "sauce": 3,
      "beverage": 21,
      "yogurt": 6,
      "boxed_meal": 7
    },
    "subtypes": [
      "beverage",
      "boxed_meal",
      "yogurt",
      "sauce",
      "candy"
    ],
    "totalObs": 369,
    "source": "usda"
  },
  "marketside": {
    "displayName": "Marketside",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 195,
      "meat": 14,
      "produce": 119,
      "dairy": 9,
      "beverage": 10,
      "frozen": 18
    },
    "subtypeCounts": {
      "cookie": 47,
      "boxed_meal": 22,
      "bread": 77,
      "cheese": 6,
      "candy": 6,
      "yogurt": 3,
      "dressing": 15,
      "beverage": 10,
      "chocolate": 3,
      "ice_cream": 6
    },
    "subtypes": [
      "bread",
      "cookie",
      "boxed_meal",
      "dressing",
      "beverage",
      "cheese",
      "candy",
      "ice_cream",
      "yogurt",
      "chocolate"
    ],
    "totalObs": 365,
    "source": "usda"
  },
  "blue_bunny": {
    "displayName": "Blue Bunny",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 364
    },
    "subtypeCounts": {
      "ice_cream": 364
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 364,
    "source": "usda"
  },
  "members_mark": {
    "displayName": "Member's Mark",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 70,
      "pantry": 143,
      "dairy": 111,
      "beverage": 25,
      "meat": 4,
      "produce": 3
    },
    "subtypeCounts": {
      "boxed_meal": 49,
      "sauce": 5,
      "milk": 23,
      "bread": 12,
      "cheese": 84,
      "beverage": 25,
      "candy": 7,
      "cookie": 5,
      "yogurt": 1,
      "dressing": 9,
      "sweetener": 3,
      "sausage": 2,
      "ice_cream": 3,
      "chocolate": 2,
      "baking": 2
    },
    "subtypes": [
      "cheese",
      "boxed_meal",
      "beverage",
      "milk",
      "bread",
      "dressing",
      "candy",
      "sauce",
      "cookie",
      "sweetener",
      "ice_cream",
      "sausage",
      "chocolate",
      "baking",
      "yogurt"
    ],
    "totalObs": 356,
    "source": "usda"
  },
  "publix": {
    "displayName": "Publix",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 109,
      "frozen": 103,
      "dairy": 89,
      "meat": 6,
      "beverage": 22,
      "produce": 14
    },
    "subtypeCounts": {
      "cookie": 22,
      "boxed_meal": 18,
      "cheese": 24,
      "ice_cream": 61,
      "milk": 18,
      "yogurt": 44,
      "sauce": 11,
      "bread": 17,
      "beverage": 22,
      "dressing": 2,
      "chocolate": 1,
      "candy": 5,
      "baking": 1
    },
    "subtypes": [
      "ice_cream",
      "yogurt",
      "cheese",
      "cookie",
      "beverage",
      "boxed_meal",
      "milk",
      "bread",
      "sauce",
      "candy",
      "dressing",
      "chocolate",
      "baking"
    ],
    "totalObs": 343,
    "source": "usda"
  },
  "lucerne_dairy_farms": {
    "displayName": "Lucerne Dairy Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 306,
      "frozen": 30
    },
    "subtypeCounts": {
      "milk": 96,
      "cheese": 185,
      "yogurt": 25,
      "ice_cream": 30
    },
    "subtypes": [
      "cheese",
      "milk",
      "ice_cream",
      "yogurt"
    ],
    "totalObs": 336,
    "source": "usda"
  },
  "reeses": {
    "displayName": "Reese's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 329,
      "frozen": 3,
      "dairy": 1
    },
    "subtypeCounts": {
      "candy": 315,
      "ice_cream": 3,
      "cookie": 4,
      "chocolate": 9,
      "milk": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie",
      "ice_cream",
      "milk"
    ],
    "totalObs": 333,
    "source": "usda"
  },
  "heinens": {
    "displayName": "Heinens",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 121,
      "dairy": 88,
      "meat": 15,
      "frozen": 57,
      "beverage": 22,
      "produce": 23
    },
    "subtypeCounts": {
      "bread": 22,
      "cheese": 55,
      "boxed_meal": 35,
      "dressing": 4,
      "ice_cream": 15,
      "beverage": 22,
      "sauce": 4,
      "sweetener": 3,
      "milk": 27,
      "baking": 4,
      "chocolate": 2,
      "candy": 3
    },
    "subtypes": [
      "cheese",
      "boxed_meal",
      "milk",
      "bread",
      "beverage",
      "ice_cream",
      "dressing",
      "sauce",
      "baking",
      "sweetener",
      "candy",
      "chocolate"
    ],
    "totalObs": 326,
    "source": "usda"
  },
  "birds_eye": {
    "displayName": "Birds Eye",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 322,
      "produce": 1,
      "pantry": 1
    },
    "subtypeCounts": {
      "boxed_meal": 107
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 324,
    "source": "usda"
  },
  "dannon": {
    "displayName": "Dannon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 311,
      "frozen": 10,
      "beverage": 1
    },
    "subtypeCounts": {
      "yogurt": 303,
      "milk": 8,
      "ice_cream": 10,
      "beverage": 1
    },
    "subtypes": [
      "yogurt",
      "ice_cream",
      "milk",
      "beverage"
    ],
    "totalObs": 322,
    "source": "usda"
  },
  "welchs": {
    "displayName": "Welch's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 134,
      "beverage": 170,
      "frozen": 4,
      "dairy": 10
    },
    "subtypeCounts": {
      "candy": 89,
      "spread": 43,
      "beverage": 170,
      "ice_cream": 4,
      "yogurt": 10
    },
    "subtypes": [
      "beverage",
      "candy",
      "spread",
      "yogurt",
      "ice_cream"
    ],
    "totalObs": 318,
    "source": "usda"
  },
  "full_circle_market": {
    "displayName": "Full Circle Market",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 190,
      "dairy": 42,
      "beverage": 23,
      "meat": 4,
      "produce": 22,
      "frozen": 35
    },
    "subtypeCounts": {
      "sweetener": 6,
      "cookie": 20,
      "milk": 26,
      "beverage": 23,
      "sauce": 9,
      "dressing": 18,
      "sausage": 4,
      "spread": 7,
      "boxed_meal": 19,
      "bread": 24,
      "baking": 6,
      "ice_cream": 8,
      "candy": 4,
      "yogurt": 4,
      "cheese": 11,
      "chocolate": 1
    },
    "subtypes": [
      "milk",
      "bread",
      "beverage",
      "cookie",
      "boxed_meal",
      "dressing",
      "cheese",
      "sauce",
      "ice_cream",
      "spread",
      "sweetener",
      "baking",
      "sausage",
      "candy",
      "yogurt",
      "chocolate"
    ],
    "totalObs": 316,
    "source": "usda"
  },
  "lowes": {
    "displayName": "Lowes",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 39,
      "beverage": 7,
      "pantry": 187,
      "dairy": 67,
      "produce": 1,
      "meat": 6
    },
    "subtypeCounts": {
      "ice_cream": 29,
      "beverage": 7,
      "boxed_meal": 19,
      "cheese": 31,
      "cookie": 23,
      "dressing": 13,
      "sauce": 12,
      "milk": 20,
      "yogurt": 16,
      "bread": 10,
      "spread": 10,
      "sausage": 6
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "cookie",
      "milk",
      "boxed_meal",
      "yogurt",
      "dressing",
      "sauce",
      "bread",
      "spread",
      "beverage",
      "sausage"
    ],
    "totalObs": 307,
    "source": "usda"
  },
  "iga": {
    "displayName": "Iga",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 14,
      "pantry": 195,
      "dairy": 40,
      "frozen": 45,
      "produce": 3,
      "meat": 2
    },
    "subtypeCounts": {
      "beverage": 14,
      "dressing": 22,
      "milk": 4,
      "cheese": 31,
      "spread": 9,
      "sauce": 16,
      "boxed_meal": 13,
      "cookie": 10,
      "ice_cream": 21,
      "baking": 7,
      "candy": 8,
      "bread": 9,
      "sausage": 2,
      "sweetener": 2
    },
    "subtypes": [
      "cheese",
      "dressing",
      "ice_cream",
      "sauce",
      "beverage",
      "boxed_meal",
      "cookie",
      "spread",
      "bread",
      "candy",
      "baking",
      "milk",
      "sausage",
      "sweetener"
    ],
    "totalObs": 299,
    "source": "usda"
  },
  "wild_harvest": {
    "displayName": "Wild Harvest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 176,
      "produce": 31,
      "beverage": 33,
      "dairy": 30,
      "meat": 2,
      "frozen": 21
    },
    "subtypeCounts": {
      "cookie": 23,
      "baking": 6,
      "boxed_meal": 23,
      "candy": 6,
      "beverage": 33,
      "chocolate": 7,
      "milk": 21,
      "cheese": 5,
      "dressing": 15,
      "bread": 9,
      "sauce": 5,
      "spread": 3,
      "sausage": 2,
      "sweetener": 4
    },
    "subtypes": [
      "beverage",
      "cookie",
      "boxed_meal",
      "milk",
      "dressing",
      "bread",
      "chocolate",
      "baking",
      "candy",
      "cheese",
      "sauce",
      "sweetener",
      "spread",
      "sausage"
    ],
    "totalObs": 293,
    "source": "usda"
  },
  "nice": {
    "displayName": "Nice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 202,
      "frozen": 35,
      "beverage": 38,
      "dairy": 17
    },
    "subtypeCounts": {
      "candy": 103,
      "dressing": 3,
      "cookie": 34,
      "boxed_meal": 18,
      "chocolate": 8,
      "sauce": 2,
      "sweetener": 4,
      "spread": 3,
      "beverage": 38,
      "cheese": 7,
      "ice_cream": 17,
      "bread": 5,
      "baking": 1
    },
    "subtypes": [
      "candy",
      "beverage",
      "cookie",
      "boxed_meal",
      "ice_cream",
      "chocolate",
      "cheese",
      "bread",
      "sweetener",
      "dressing",
      "spread",
      "sauce",
      "baking"
    ],
    "totalObs": 292,
    "source": "usda"
  },
  "winn_dixie": {
    "displayName": "Winn-dixie",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 187,
      "dairy": 41,
      "frozen": 41,
      "meat": 6,
      "beverage": 9,
      "produce": 1
    },
    "subtypeCounts": {
      "sauce": 26,
      "cookie": 17,
      "cheese": 25,
      "ice_cream": 13,
      "candy": 17,
      "dressing": 38,
      "chocolate": 1,
      "bread": 3,
      "boxed_meal": 11,
      "sausage": 1,
      "beverage": 9,
      "baking": 1,
      "milk": 9,
      "sweetener": 3,
      "yogurt": 1
    },
    "subtypes": [
      "dressing",
      "sauce",
      "cheese",
      "cookie",
      "candy",
      "ice_cream",
      "boxed_meal",
      "beverage",
      "milk",
      "bread",
      "sweetener",
      "chocolate",
      "sausage",
      "baking",
      "yogurt"
    ],
    "totalObs": 285,
    "source": "usda"
  },
  "tillamook": {
    "displayName": "Tillamook",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 211,
      "frozen": 66,
      "pantry": 1
    },
    "subtypeCounts": {
      "cheese": 148,
      "yogurt": 58,
      "milk": 5,
      "ice_cream": 66,
      "sauce": 1
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "yogurt",
      "milk",
      "sauce"
    ],
    "totalObs": 278,
    "source": "usda"
  },
  "valu_time": {
    "displayName": "Valu Time",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 187,
      "frozen": 44,
      "dairy": 29,
      "meat": 1,
      "beverage": 15
    },
    "subtypeCounts": {
      "sauce": 17,
      "ice_cream": 34,
      "cookie": 61,
      "bread": 14,
      "cheese": 20,
      "milk": 8,
      "spread": 3,
      "sweetener": 3,
      "dressing": 10,
      "boxed_meal": 10,
      "candy": 6,
      "sausage": 1,
      "beverage": 15,
      "baking": 5,
      "yogurt": 1
    },
    "subtypes": [
      "cookie",
      "ice_cream",
      "cheese",
      "sauce",
      "beverage",
      "bread",
      "dressing",
      "boxed_meal",
      "milk",
      "candy",
      "baking",
      "spread",
      "sweetener",
      "sausage",
      "yogurt"
    ],
    "totalObs": 276,
    "source": "usda"
  },
  "private_selection": {
    "displayName": "Private Selection",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 151,
      "frozen": 63,
      "meat": 1,
      "dairy": 59
    },
    "subtypeCounts": {
      "sauce": 23,
      "dressing": 7,
      "cookie": 16,
      "ice_cream": 35,
      "beverage": 3,
      "sweetener": 2,
      "chocolate": 14,
      "baking": 1,
      "boxed_meal": 15,
      "sausage": 1,
      "cheese": 51,
      "bread": 26,
      "spread": 10,
      "yogurt": 8,
      "candy": 7
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "bread",
      "sauce",
      "cookie",
      "boxed_meal",
      "chocolate",
      "spread",
      "yogurt",
      "dressing",
      "candy",
      "beverage",
      "sweetener",
      "baking",
      "sausage"
    ],
    "totalObs": 274,
    "source": "usda"
  },
  "ht_traders": {
    "displayName": "Ht Traders",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 189,
      "frozen": 51,
      "dairy": 13,
      "beverage": 15,
      "produce": 4
    },
    "subtypeCounts": {
      "cookie": 28,
      "boxed_meal": 20,
      "ice_cream": 30,
      "spread": 15,
      "cheese": 10,
      "sauce": 10,
      "beverage": 15,
      "bread": 1,
      "chocolate": 15,
      "candy": 1,
      "sweetener": 3,
      "dressing": 12,
      "milk": 1
    },
    "subtypes": [
      "ice_cream",
      "cookie",
      "boxed_meal",
      "spread",
      "beverage",
      "chocolate",
      "dressing",
      "cheese",
      "sauce",
      "sweetener",
      "bread",
      "candy",
      "milk"
    ],
    "totalObs": 272,
    "source": "usda"
  },
  "chobani": {
    "displayName": "Chobani",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 267,
      "pantry": 1
    },
    "subtypeCounts": {
      "yogurt": 267,
      "chocolate": 1
    },
    "subtypes": [
      "yogurt",
      "chocolate"
    ],
    "totalObs": 268,
    "source": "usda"
  },
  "gold_emblem": {
    "displayName": "Gold Emblem",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 205,
      "dairy": 2,
      "beverage": 60
    },
    "subtypeCounts": {
      "candy": 107,
      "chocolate": 22,
      "cookie": 31,
      "cheese": 2,
      "sauce": 6,
      "baking": 1,
      "sweetener": 2,
      "beverage": 60,
      "dressing": 1,
      "spread": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "candy",
      "beverage",
      "cookie",
      "chocolate",
      "sauce",
      "cheese",
      "sweetener",
      "baking",
      "dressing",
      "spread",
      "boxed_meal"
    ],
    "totalObs": 267,
    "source": "usda"
  },
  "wellsley_farms": {
    "displayName": "Wellsley Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 45,
      "pantry": 112,
      "beverage": 12,
      "dairy": 39,
      "produce": 43,
      "meat": 15
    },
    "subtypeCounts": {
      "ice_cream": 2,
      "beverage": 12,
      "milk": 17,
      "cheese": 20,
      "sweetener": 4,
      "boxed_meal": 33,
      "spread": 1,
      "candy": 3,
      "cookie": 8,
      "dressing": 7,
      "sauce": 10,
      "bread": 18,
      "chocolate": 2,
      "sausage": 5,
      "yogurt": 2
    },
    "subtypes": [
      "boxed_meal",
      "cheese",
      "bread",
      "milk",
      "beverage",
      "sauce",
      "cookie",
      "dressing",
      "sausage",
      "sweetener",
      "candy",
      "ice_cream",
      "chocolate",
      "yogurt",
      "spread"
    ],
    "totalObs": 266,
    "source": "usda"
  },
  "365_whole_market": {
    "displayName": "365 Whole Market",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 86,
      "frozen": 16,
      "dairy": 131,
      "beverage": 19,
      "produce": 2,
      "meat": 1
    },
    "subtypeCounts": {
      "sweetener": 5,
      "ice_cream": 6,
      "cheese": 60,
      "milk": 66,
      "bread": 32,
      "boxed_meal": 10,
      "baking": 3,
      "cookie": 5,
      "beverage": 19,
      "dressing": 9,
      "yogurt": 2,
      "chocolate": 3,
      "sauce": 1,
      "spread": 1,
      "candy": 1
    },
    "subtypes": [
      "milk",
      "cheese",
      "bread",
      "beverage",
      "boxed_meal",
      "dressing",
      "ice_cream",
      "sweetener",
      "cookie",
      "baking",
      "chocolate",
      "yogurt",
      "sauce",
      "spread",
      "candy"
    ],
    "totalObs": 255,
    "source": "usda"
  },
  "utz": {
    "displayName": "Utz",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 248,
      "dairy": 5,
      "frozen": 1
    },
    "subtypeCounts": {
      "cheese": 5,
      "chocolate": 1,
      "candy": 3,
      "boxed_meal": 1
    },
    "subtypes": [
      "cheese",
      "candy",
      "chocolate",
      "boxed_meal"
    ],
    "totalObs": 254,
    "source": "usda"
  },
  "lunds_byerlys": {
    "displayName": "Lunds & Byerlys",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 193,
      "beverage": 4,
      "dairy": 13,
      "frozen": 35,
      "meat": 3,
      "produce": 3
    },
    "subtypeCounts": {
      "cookie": 35,
      "beverage": 4,
      "cheese": 5,
      "chocolate": 46,
      "bread": 29,
      "boxed_meal": 18,
      "candy": 34,
      "ice_cream": 17,
      "spread": 12,
      "dressing": 10,
      "milk": 8,
      "sauce": 1,
      "sweetener": 1,
      "sausage": 2
    },
    "subtypes": [
      "chocolate",
      "cookie",
      "candy",
      "bread",
      "boxed_meal",
      "ice_cream",
      "spread",
      "dressing",
      "milk",
      "cheese",
      "beverage",
      "sausage",
      "sauce",
      "sweetener"
    ],
    "totalObs": 251,
    "source": "usda"
  },
  "kind": {
    "displayName": "Kind",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 250
    },
    "subtypeCounts": {
      "chocolate": 3,
      "candy": 3
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 250,
    "source": "usda"
  },
  "sunnyside_farms": {
    "displayName": "Sunnyside Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 122,
      "beverage": 16,
      "frozen": 87,
      "pantry": 18,
      "produce": 6,
      "meat": 1
    },
    "subtypeCounts": {
      "yogurt": 33,
      "cheese": 15,
      "beverage": 16,
      "ice_cream": 87,
      "milk": 68,
      "boxed_meal": 1,
      "bread": 5
    },
    "subtypes": [
      "ice_cream",
      "milk",
      "yogurt",
      "beverage",
      "cheese",
      "bread",
      "boxed_meal"
    ],
    "totalObs": 250,
    "source": "usda"
  },
  "taste_of_inspirations": {
    "displayName": "Taste Of Inspirations",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 59,
      "pantry": 121,
      "frozen": 55,
      "meat": 9,
      "beverage": 5
    },
    "subtypeCounts": {
      "cheese": 30,
      "cookie": 15,
      "yogurt": 29,
      "boxed_meal": 31,
      "bread": 12,
      "sausage": 4,
      "chocolate": 20,
      "ice_cream": 23,
      "sauce": 19,
      "spread": 11,
      "dressing": 12,
      "beverage": 5,
      "candy": 2
    },
    "subtypes": [
      "boxed_meal",
      "cheese",
      "yogurt",
      "ice_cream",
      "chocolate",
      "sauce",
      "cookie",
      "bread",
      "dressing",
      "spread",
      "beverage",
      "sausage",
      "candy"
    ],
    "totalObs": 249,
    "source": "usda"
  },
  "crystal_farms": {
    "displayName": "Crystal Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 245,
      "pantry": 4
    },
    "subtypeCounts": {
      "cheese": 242,
      "bread": 4,
      "milk": 1
    },
    "subtypes": [
      "cheese",
      "bread",
      "milk"
    ],
    "totalObs": 249,
    "source": "usda"
  },
  "springfield": {
    "displayName": "Springfield",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 150,
      "dairy": 33,
      "beverage": 15,
      "frozen": 48,
      "produce": 2
    },
    "subtypeCounts": {
      "cheese": 27,
      "milk": 6,
      "beverage": 15,
      "boxed_meal": 2,
      "sauce": 4,
      "cookie": 9,
      "candy": 3,
      "dressing": 8,
      "bread": 2,
      "sweetener": 3,
      "baking": 6,
      "spread": 4
    },
    "subtypes": [
      "cheese",
      "beverage",
      "cookie",
      "dressing",
      "milk",
      "baking",
      "sauce",
      "spread",
      "candy",
      "sweetener",
      "boxed_meal",
      "bread"
    ],
    "totalObs": 248,
    "source": "usda"
  },
  "delallo": {
    "displayName": "Delallo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 227,
      "dairy": 6,
      "beverage": 2,
      "meat": 7,
      "produce": 1
    },
    "subtypeCounts": {
      "bread": 5,
      "dressing": 10,
      "cheese": 6,
      "beverage": 3,
      "cookie": 3,
      "baking": 2,
      "sauce": 7,
      "boxed_meal": 7,
      "spread": 1
    },
    "subtypes": [
      "dressing",
      "sauce",
      "boxed_meal",
      "cheese",
      "bread",
      "beverage",
      "cookie",
      "baking",
      "spread"
    ],
    "totalObs": 243,
    "source": "usda"
  },
  "natures_promise": {
    "displayName": "Nature's Promise",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 57,
      "pantry": 112,
      "produce": 26,
      "frozen": 15,
      "dairy": 29,
      "meat": 4
    },
    "subtypeCounts": {
      "beverage": 57,
      "dressing": 3,
      "cookie": 10,
      "bread": 19,
      "boxed_meal": 20,
      "sauce": 4,
      "sweetener": 7,
      "milk": 3,
      "ice_cream": 2,
      "candy": 3,
      "yogurt": 8,
      "cheese": 9,
      "sausage": 3,
      "baking": 3,
      "spread": 4
    },
    "subtypes": [
      "beverage",
      "boxed_meal",
      "bread",
      "cookie",
      "cheese",
      "yogurt",
      "sweetener",
      "sauce",
      "spread",
      "dressing",
      "milk",
      "candy",
      "sausage",
      "baking",
      "ice_cream"
    ],
    "totalObs": 243,
    "source": "usda"
  },
  "7_select": {
    "displayName": "7 Select",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 166,
      "frozen": 41,
      "produce": 1,
      "dairy": 7,
      "meat": 2,
      "beverage": 25
    },
    "subtypeCounts": {
      "candy": 96,
      "ice_cream": 35,
      "chocolate": 14,
      "milk": 2,
      "sausage": 2,
      "beverage": 25,
      "boxed_meal": 6,
      "cheese": 5,
      "cookie": 31
    },
    "subtypes": [
      "candy",
      "ice_cream",
      "cookie",
      "beverage",
      "chocolate",
      "boxed_meal",
      "cheese",
      "milk",
      "sausage"
    ],
    "totalObs": 242,
    "source": "usda"
  },
  "western_family": {
    "displayName": "Western Family",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 136,
      "dairy": 63,
      "beverage": 32,
      "frozen": 6,
      "meat": 1
    },
    "subtypeCounts": {
      "candy": 11,
      "sauce": 6,
      "cheese": 46,
      "beverage": 32,
      "yogurt": 9,
      "bread": 4,
      "milk": 8,
      "dressing": 10,
      "sweetener": 2,
      "spread": 10,
      "baking": 4,
      "cookie": 11,
      "ice_cream": 5,
      "boxed_meal": 8,
      "sausage": 1
    },
    "subtypes": [
      "cheese",
      "beverage",
      "candy",
      "cookie",
      "dressing",
      "spread",
      "yogurt",
      "milk",
      "boxed_meal",
      "sauce",
      "ice_cream",
      "bread",
      "baking",
      "sweetener",
      "sausage"
    ],
    "totalObs": 238,
    "source": "usda"
  },
  "prairie_farms": {
    "displayName": "Prairie Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 148,
      "beverage": 11,
      "frozen": 78,
      "pantry": 1
    },
    "subtypeCounts": {
      "milk": 95,
      "beverage": 11,
      "yogurt": 36,
      "ice_cream": 78,
      "cheese": 17,
      "dressing": 1
    },
    "subtypes": [
      "milk",
      "ice_cream",
      "yogurt",
      "cheese",
      "beverage",
      "dressing"
    ],
    "totalObs": 238,
    "source": "usda"
  },
  "stouffers": {
    "displayName": "Stouffer's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 227,
      "pantry": 10
    },
    "subtypeCounts": {
      "boxed_meal": 226,
      "sauce": 8
    },
    "subtypes": [
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 237,
    "source": "usda"
  },
  "key_food": {
    "displayName": "Key Food",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 105,
      "frozen": 49,
      "dairy": 64,
      "meat": 3,
      "beverage": 16
    },
    "subtypeCounts": {
      "ice_cream": 18,
      "baking": 3,
      "yogurt": 7,
      "milk": 5,
      "cheese": 52,
      "spread": 2,
      "cookie": 6,
      "dressing": 14,
      "sauce": 2,
      "bread": 5,
      "sausage": 3,
      "boxed_meal": 2,
      "beverage": 16
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "beverage",
      "dressing",
      "yogurt",
      "cookie",
      "milk",
      "bread",
      "baking",
      "sausage",
      "spread",
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 237,
    "source": "usda"
  },
  "kraft_heinz": {
    "displayName": "Kraft Heinz",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 90,
      "frozen": 82,
      "beverage": 5,
      "dairy": 54,
      "meat": 4
    },
    "subtypeCounts": {
      "candy": 6,
      "boxed_meal": 81,
      "beverage": 6,
      "chocolate": 1,
      "yogurt": 1,
      "cheese": 49,
      "sausage": 4,
      "sauce": 8,
      "dressing": 64,
      "milk": 4,
      "bread": 2,
      "ice_cream": 1
    },
    "subtypes": [
      "boxed_meal",
      "dressing",
      "cheese",
      "sauce",
      "candy",
      "beverage",
      "sausage",
      "milk",
      "bread",
      "chocolate",
      "yogurt",
      "ice_cream"
    ],
    "totalObs": 235,
    "source": "usda"
  },
  "simple_truth": {
    "displayName": "Simple Truth",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 119,
      "meat": 6,
      "frozen": 32,
      "dairy": 24,
      "beverage": 46,
      "produce": 7
    },
    "subtypeCounts": {
      "sausage": 6,
      "sweetener": 5,
      "spread": 3,
      "cookie": 16,
      "candy": 4,
      "ice_cream": 23,
      "boxed_meal": 16,
      "milk": 6,
      "dressing": 7,
      "beverage": 46,
      "baking": 5,
      "chocolate": 5,
      "yogurt": 12,
      "cheese": 3,
      "bread": 7,
      "sauce": 3
    },
    "subtypes": [
      "beverage",
      "ice_cream",
      "cookie",
      "boxed_meal",
      "yogurt",
      "dressing",
      "bread",
      "sausage",
      "milk",
      "sweetener",
      "baking",
      "chocolate",
      "candy",
      "spread",
      "cheese",
      "sauce"
    ],
    "totalObs": 234,
    "source": "usda"
  },
  "southern_home": {
    "displayName": "Southern Home",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 163,
      "frozen": 39,
      "dairy": 16,
      "beverage": 9
    },
    "subtypeCounts": {
      "cookie": 17,
      "bread": 2,
      "yogurt": 6,
      "candy": 22,
      "chocolate": 1,
      "beverage": 9,
      "cheese": 4,
      "sauce": 8,
      "boxed_meal": 8,
      "baking": 2,
      "ice_cream": 17,
      "milk": 4,
      "dressing": 6
    },
    "subtypes": [
      "candy",
      "cookie",
      "ice_cream",
      "beverage",
      "sauce",
      "boxed_meal",
      "yogurt",
      "dressing",
      "cheese",
      "milk",
      "bread",
      "baking",
      "chocolate"
    ],
    "totalObs": 227,
    "source": "usda"
  },
  "wegmans_food_markets": {
    "displayName": "Wegmans Food Markets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 76,
      "produce": 65,
      "beverage": 22,
      "dairy": 9,
      "frozen": 49,
      "meat": 1
    },
    "subtypeCounts": {
      "bread": 23,
      "beverage": 22,
      "cheese": 4,
      "dressing": 14,
      "ice_cream": 23,
      "candy": 6,
      "chocolate": 1,
      "sauce": 1,
      "boxed_meal": 11,
      "cookie": 2,
      "baking": 2,
      "yogurt": 2,
      "milk": 2
    },
    "subtypes": [
      "bread",
      "ice_cream",
      "beverage",
      "dressing",
      "boxed_meal",
      "candy",
      "cheese",
      "cookie",
      "baking",
      "yogurt",
      "milk",
      "chocolate",
      "sauce"
    ],
    "totalObs": 222,
    "source": "usda"
  },
  "wish_bone": {
    "displayName": "Wish-bone",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 219
    },
    "subtypeCounts": {
      "dressing": 211,
      "sauce": 8
    },
    "subtypes": [
      "dressing",
      "sauce"
    ],
    "totalObs": 219,
    "source": "usda"
  },
  "yoplait": {
    "displayName": "Yoplait",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 206,
      "pantry": 1,
      "frozen": 8,
      "beverage": 3
    },
    "subtypeCounts": {
      "yogurt": 202,
      "candy": 1,
      "ice_cream": 8,
      "beverage": 3,
      "milk": 4
    },
    "subtypes": [
      "yogurt",
      "ice_cream",
      "milk",
      "beverage",
      "candy"
    ],
    "totalObs": 218,
    "source": "usda"
  },
  "target": {
    "displayName": "Target",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 3,
      "pantry": 205,
      "meat": 4
    },
    "subtypeCounts": {
      "boxed_meal": 5,
      "cookie": 32,
      "candy": 101,
      "chocolate": 47,
      "sauce": 4,
      "bread": 16,
      "ice_cream": 2
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie",
      "bread",
      "boxed_meal",
      "sauce",
      "ice_cream"
    ],
    "totalObs": 212,
    "source": "usda"
  },
  "green_giant": {
    "displayName": "Green Giant",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 119,
      "produce": 53,
      "pantry": 40
    },
    "subtypeCounts": {
      "bread": 3,
      "boxed_meal": 7
    },
    "subtypes": [
      "boxed_meal",
      "bread"
    ],
    "totalObs": 212,
    "source": "usda"
  },
  "ghirardelli": {
    "displayName": "Ghirardelli",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 204
    },
    "subtypeCounts": {
      "chocolate": 171,
      "candy": 30,
      "baking": 3
    },
    "subtypes": [
      "chocolate",
      "candy",
      "baking"
    ],
    "totalObs": 204,
    "source": "usda"
  },
  "wakefern_food": {
    "displayName": "Wakefern Food",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 37,
      "pantry": 75,
      "frozen": 52,
      "beverage": 25,
      "produce": 15
    },
    "subtypeCounts": {
      "cheese": 11,
      "milk": 22,
      "baking": 1,
      "ice_cream": 38,
      "cookie": 17,
      "beverage": 25,
      "bread": 5,
      "dressing": 6,
      "spread": 18,
      "boxed_meal": 8,
      "sauce": 2,
      "yogurt": 2
    },
    "subtypes": [
      "ice_cream",
      "beverage",
      "milk",
      "spread",
      "cookie",
      "cheese",
      "boxed_meal",
      "dressing",
      "bread",
      "sauce",
      "yogurt",
      "baking"
    ],
    "totalObs": 204,
    "source": "usda"
  },
  "sams_choice": {
    "displayName": "Sam's Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 76,
      "pantry": 117,
      "meat": 3,
      "beverage": 1,
      "dairy": 6,
      "produce": 1
    },
    "subtypeCounts": {
      "ice_cream": 25,
      "boxed_meal": 63,
      "dressing": 9,
      "bread": 17,
      "cookie": 11,
      "chocolate": 14,
      "sausage": 3,
      "sweetener": 9,
      "beverage": 1,
      "spread": 9,
      "cheese": 6,
      "candy": 2,
      "sauce": 5
    },
    "subtypes": [
      "boxed_meal",
      "ice_cream",
      "bread",
      "chocolate",
      "cookie",
      "dressing",
      "sweetener",
      "spread",
      "cheese",
      "sauce",
      "sausage",
      "candy",
      "beverage"
    ],
    "totalObs": 204,
    "source": "usda"
  },
  "lidl": {
    "displayName": "Lidl",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 105,
      "frozen": 27,
      "produce": 9,
      "beverage": 22,
      "meat": 5,
      "dairy": 36
    },
    "subtypeCounts": {
      "ice_cream": 14,
      "bread": 9,
      "beverage": 23,
      "cookie": 13,
      "sausage": 4,
      "cheese": 25,
      "chocolate": 9,
      "dressing": 7,
      "milk": 5,
      "boxed_meal": 12,
      "sauce": 6,
      "yogurt": 6,
      "spread": 1,
      "baking": 1,
      "candy": 1
    },
    "subtypes": [
      "cheese",
      "beverage",
      "ice_cream",
      "cookie",
      "boxed_meal",
      "bread",
      "chocolate",
      "dressing",
      "sauce",
      "yogurt",
      "milk",
      "sausage",
      "spread",
      "baking",
      "candy"
    ],
    "totalObs": 204,
    "source": "usda"
  },
  "open_nature": {
    "displayName": "Open Nature",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 62,
      "dairy": 61,
      "beverage": 6,
      "meat": 6,
      "frozen": 68
    },
    "subtypeCounts": {
      "bread": 24,
      "yogurt": 57,
      "dressing": 6,
      "beverage": 6,
      "sausage": 5,
      "ice_cream": 54,
      "milk": 1,
      "cheese": 2,
      "boxed_meal": 15,
      "baking": 2,
      "sweetener": 1
    },
    "subtypes": [
      "yogurt",
      "ice_cream",
      "bread",
      "boxed_meal",
      "dressing",
      "beverage",
      "sausage",
      "cheese",
      "baking",
      "milk",
      "sweetener"
    ],
    "totalObs": 203,
    "source": "usda"
  },
  "dove": {
    "displayName": "Dove",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 187,
      "frozen": 16
    },
    "subtypeCounts": {
      "chocolate": 146,
      "candy": 36,
      "ice_cream": 16,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "ice_cream",
      "cookie"
    ],
    "totalObs": 203,
    "source": "usda"
  },
  "dole": {
    "displayName": "Dole",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 122,
      "beverage": 26,
      "produce": 49,
      "frozen": 3,
      "dairy": 1,
      "meat": 1
    },
    "subtypeCounts": {
      "candy": 1,
      "dressing": 5,
      "beverage": 26,
      "cookie": 1,
      "yogurt": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "beverage",
      "dressing",
      "candy",
      "cookie",
      "yogurt",
      "boxed_meal"
    ],
    "totalObs": 202,
    "source": "usda"
  },
  "ocean_spray": {
    "displayName": "Ocean Spray",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 191,
      "pantry": 7,
      "dairy": 1,
      "produce": 1
    },
    "subtypeCounts": {
      "beverage": 191,
      "cheese": 1,
      "candy": 3
    },
    "subtypes": [
      "beverage",
      "candy",
      "cheese"
    ],
    "totalObs": 200,
    "source": "usda"
  },
  "freedoms_choice": {
    "displayName": "Freedom's Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 31,
      "beverage": 14,
      "dairy": 83,
      "pantry": 71
    },
    "subtypeCounts": {
      "ice_cream": 9,
      "beverage": 14,
      "cheese": 79,
      "sauce": 5,
      "dressing": 11,
      "baking": 10,
      "milk": 4,
      "boxed_meal": 6,
      "spread": 6,
      "candy": 2,
      "sweetener": 5
    },
    "subtypes": [
      "cheese",
      "beverage",
      "dressing",
      "baking",
      "ice_cream",
      "boxed_meal",
      "spread",
      "sauce",
      "sweetener",
      "milk",
      "candy"
    ],
    "totalObs": 199,
    "source": "usda"
  },
  "wise": {
    "displayName": "Wise",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 195,
      "dairy": 2,
      "produce": 1
    },
    "subtypeCounts": {
      "cheese": 2,
      "sauce": 1
    },
    "subtypes": [
      "cheese",
      "sauce"
    ],
    "totalObs": 198,
    "source": "usda"
  },
  "wegmans_organic": {
    "displayName": "Wegmans Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 84,
      "produce": 48,
      "dairy": 28,
      "beverage": 25,
      "frozen": 11,
      "meat": 2
    },
    "subtypeCounts": {
      "yogurt": 18,
      "spread": 7,
      "boxed_meal": 6,
      "candy": 8,
      "beverage": 25,
      "baking": 3,
      "ice_cream": 2,
      "milk": 2,
      "dressing": 7,
      "bread": 5,
      "sweetener": 1,
      "cheese": 2,
      "sauce": 4,
      "cookie": 2
    },
    "subtypes": [
      "beverage",
      "yogurt",
      "candy",
      "spread",
      "dressing",
      "boxed_meal",
      "bread",
      "sauce",
      "baking",
      "ice_cream",
      "milk",
      "cheese",
      "cookie",
      "sweetener"
    ],
    "totalObs": 198,
    "source": "usda"
  },
  "jelly_belly": {
    "displayName": "Jelly Belly",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 192,
      "beverage": 5
    },
    "subtypeCounts": {
      "candy": 186,
      "cookie": 3,
      "spread": 2,
      "beverage": 5,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "beverage",
      "cookie",
      "spread",
      "chocolate"
    ],
    "totalObs": 197,
    "source": "usda"
  },
  "sargento": {
    "displayName": "Sargento",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 193,
      "pantry": 1
    },
    "subtypeCounts": {
      "cheese": 193
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 194,
    "source": "usda"
  },
  "snyders_of_hanover": {
    "displayName": "Snyder's Of Hanover",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 193,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 194,
    "source": "usda"
  },
  "bobs_red_mill": {
    "displayName": "Bobs Red Mill",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 191,
      "dairy": 2
    },
    "subtypeCounts": {
      "baking": 154,
      "sauce": 4
    },
    "subtypes": [
      "baking",
      "sauce"
    ],
    "totalObs": 193,
    "source": "usda"
  },
  "pictsweet_farms": {
    "displayName": "Pictsweet Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 189,
      "produce": 3
    },
    "subtypeCounts": {
      "boxed_meal": 8
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 192,
    "source": "usda"
  },
  "wondershop": {
    "displayName": "Wondershop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 190
    },
    "subtypeCounts": {
      "cookie": 64,
      "candy": 102,
      "chocolate": 18,
      "sauce": 1,
      "sweetener": 1,
      "spread": 3
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate",
      "spread",
      "sauce",
      "sweetener"
    ],
    "totalObs": 190,
    "source": "usda"
  },
  "peeps": {
    "displayName": "Peeps",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 189
    },
    "subtypeCounts": {
      "candy": 181,
      "chocolate": 3,
      "cookie": 5
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate"
    ],
    "totalObs": 189,
    "source": "usda"
  },
  "frankford": {
    "displayName": "Frankford",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 188
    },
    "subtypeCounts": {
      "candy": 137,
      "chocolate": 47,
      "baking": 1,
      "cookie": 3
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie",
      "baking"
    ],
    "totalObs": 188,
    "source": "usda"
  },
  "doritos": {
    "displayName": "Doritos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 182,
      "frozen": 6
    },
    "subtypeCounts": {
      "boxed_meal": 6
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 188,
    "source": "usda"
  },
  "fresh_market": {
    "displayName": "Fresh Market",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 132,
      "produce": 10,
      "beverage": 14,
      "frozen": 15,
      "dairy": 4,
      "meat": 12
    },
    "subtypeCounts": {
      "candy": 60,
      "beverage": 14,
      "ice_cream": 11,
      "cheese": 4,
      "boxed_meal": 16,
      "sauce": 8,
      "chocolate": 10,
      "cookie": 4,
      "baking": 1,
      "bread": 4
    },
    "subtypes": [
      "candy",
      "boxed_meal",
      "beverage",
      "ice_cream",
      "chocolate",
      "sauce",
      "cheese",
      "cookie",
      "bread",
      "baking"
    ],
    "totalObs": 187,
    "source": "usda"
  },
  "amys": {
    "displayName": "Amy's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 142,
      "pantry": 42
    },
    "subtypeCounts": {
      "boxed_meal": 173,
      "bread": 1,
      "cookie": 1,
      "candy": 8
    },
    "subtypes": [
      "boxed_meal",
      "candy",
      "bread",
      "cookie"
    ],
    "totalObs": 184,
    "source": "usda"
  },
  "signature_farms": {
    "displayName": "Signature Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 131,
      "pantry": 36,
      "frozen": 2,
      "beverage": 11,
      "meat": 2,
      "dairy": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "beverage": 11,
      "sausage": 2,
      "candy": 1,
      "yogurt": 1
    },
    "subtypes": [
      "beverage",
      "sausage",
      "boxed_meal",
      "candy",
      "yogurt"
    ],
    "totalObs": 183,
    "source": "usda"
  },
  "trolli": {
    "displayName": "Trolli",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 181
    },
    "subtypeCounts": {
      "candy": 181
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 181,
    "source": "usda"
  },
  "avenue": {
    "displayName": "Avenue",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 53,
      "frozen": 77,
      "dairy": 30,
      "beverage": 18,
      "meat": 1
    },
    "subtypeCounts": {
      "ice_cream": 31,
      "milk": 8,
      "cheese": 20,
      "spread": 5,
      "yogurt": 2,
      "beverage": 18,
      "sausage": 1,
      "boxed_meal": 2,
      "sauce": 2,
      "dressing": 4,
      "sweetener": 5,
      "baking": 2
    },
    "subtypes": [
      "ice_cream",
      "cheese",
      "beverage",
      "milk",
      "spread",
      "sweetener",
      "dressing",
      "yogurt",
      "boxed_meal",
      "sauce",
      "baking",
      "sausage"
    ],
    "totalObs": 179,
    "source": "usda"
  },
  "disney": {
    "displayName": "Disney",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 161,
      "frozen": 8,
      "produce": 2,
      "beverage": 2,
      "dairy": 2
    },
    "subtypeCounts": {
      "chocolate": 33,
      "candy": 121,
      "boxed_meal": 1,
      "ice_cream": 7,
      "cookie": 5,
      "beverage": 2,
      "sweetener": 1,
      "cheese": 2
    },
    "subtypes": [
      "candy",
      "chocolate",
      "ice_cream",
      "cookie",
      "beverage",
      "cheese",
      "boxed_meal",
      "sweetener"
    ],
    "totalObs": 175,
    "source": "usda"
  },
  "libbys": {
    "displayName": "Libby's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 153,
      "beverage": 14,
      "frozen": 7,
      "produce": 1
    },
    "subtypeCounts": {
      "beverage": 14,
      "sauce": 2,
      "dressing": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "beverage",
      "sauce",
      "dressing",
      "boxed_meal"
    ],
    "totalObs": 175,
    "source": "usda"
  },
  "h_e_butt_grocery": {
    "displayName": "H E Butt Grocery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 3,
      "frozen": 66,
      "pantry": 66,
      "produce": 29,
      "dairy": 11
    },
    "subtypeCounts": {
      "beverage": 3,
      "ice_cream": 53,
      "cheese": 3,
      "cookie": 2,
      "bread": 1,
      "sauce": 22,
      "boxed_meal": 11,
      "yogurt": 4,
      "candy": 1,
      "baking": 5
    },
    "subtypes": [
      "ice_cream",
      "sauce",
      "boxed_meal",
      "baking",
      "yogurt",
      "beverage",
      "cheese",
      "cookie",
      "bread",
      "candy"
    ],
    "totalObs": 175,
    "source": "usda"
  },
  "deans": {
    "displayName": "Dean's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 113,
      "dairy": 59,
      "beverage": 1,
      "pantry": 1
    },
    "subtypeCounts": {
      "ice_cream": 113,
      "cheese": 17,
      "milk": 42,
      "beverage": 1,
      "sauce": 1
    },
    "subtypes": [
      "ice_cream",
      "milk",
      "cheese",
      "beverage",
      "sauce"
    ],
    "totalObs": 174,
    "source": "usda"
  },
  "fresh_easy": {
    "displayName": "Fresh & Easy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 90,
      "frozen": 23,
      "dairy": 16,
      "beverage": 2,
      "produce": 33,
      "meat": 10
    },
    "subtypeCounts": {
      "sauce": 8,
      "ice_cream": 14,
      "dressing": 17,
      "cheese": 5,
      "boxed_meal": 20,
      "spread": 1,
      "sweetener": 3,
      "bread": 13,
      "cookie": 7,
      "beverage": 2,
      "yogurt": 11
    },
    "subtypes": [
      "boxed_meal",
      "dressing",
      "ice_cream",
      "bread",
      "yogurt",
      "sauce",
      "cookie",
      "cheese",
      "sweetener",
      "beverage",
      "spread"
    ],
    "totalObs": 174,
    "source": "usda"
  },
  "sweetarts": {
    "displayName": "Sweetarts",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 171,
      "frozen": 2
    },
    "subtypeCounts": {
      "candy": 171,
      "ice_cream": 2
    },
    "subtypes": [
      "candy",
      "ice_cream"
    ],
    "totalObs": 173,
    "source": "usda"
  },
  "target_stores": {
    "displayName": "Target Stores",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 116,
      "produce": 7,
      "dairy": 23,
      "frozen": 17,
      "beverage": 4,
      "meat": 6
    },
    "subtypeCounts": {
      "bread": 7,
      "cookie": 40,
      "candy": 20,
      "cheese": 12,
      "sweetener": 1,
      "boxed_meal": 21,
      "beverage": 4,
      "sausage": 2,
      "chocolate": 3,
      "ice_cream": 3,
      "baking": 1,
      "dressing": 1
    },
    "subtypes": [
      "cookie",
      "boxed_meal",
      "candy",
      "cheese",
      "bread",
      "beverage",
      "chocolate",
      "ice_cream",
      "sausage",
      "sweetener",
      "baking",
      "dressing"
    ],
    "totalObs": 173,
    "source": "usda"
  },
  "giant": {
    "displayName": "Giant",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10,
      "dairy": 34,
      "pantry": 111,
      "produce": 4,
      "frozen": 12,
      "meat": 1
    },
    "subtypeCounts": {
      "beverage": 10,
      "cheese": 25,
      "cookie": 21,
      "bread": 8,
      "boxed_meal": 7,
      "sauce": 7,
      "yogurt": 8,
      "spread": 2,
      "sausage": 1,
      "dressing": 3,
      "candy": 8,
      "milk": 1,
      "ice_cream": 3,
      "chocolate": 1
    },
    "subtypes": [
      "cheese",
      "cookie",
      "beverage",
      "bread",
      "yogurt",
      "candy",
      "boxed_meal",
      "sauce",
      "dressing",
      "ice_cream",
      "spread",
      "sausage",
      "milk",
      "chocolate"
    ],
    "totalObs": 172,
    "source": "usda"
  },
  "quaker": {
    "displayName": "Quaker",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 167,
      "dairy": 1,
      "frozen": 2
    },
    "subtypeCounts": {
      "cookie": 31,
      "baking": 1,
      "yogurt": 1,
      "bread": 2
    },
    "subtypes": [
      "cookie",
      "bread",
      "baking",
      "yogurt"
    ],
    "totalObs": 170,
    "source": "usda"
  },
  "taylor_farms": {
    "displayName": "Taylor Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 58,
      "produce": 90,
      "meat": 9,
      "dairy": 11,
      "frozen": 2
    },
    "subtypeCounts": {
      "boxed_meal": 10,
      "yogurt": 11,
      "ice_cream": 1,
      "bread": 1
    },
    "subtypes": [
      "yogurt",
      "boxed_meal",
      "ice_cream",
      "bread"
    ],
    "totalObs": 170,
    "source": "usda"
  },
  "clif_bar": {
    "displayName": "Clif Bar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 168
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 168,
    "source": "usda"
  },
  "lala": {
    "displayName": "Lala",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 168
    },
    "subtypeCounts": {
      "milk": 19,
      "yogurt": 149
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 168,
    "source": "usda"
  },
  "tyson": {
    "displayName": "Tyson",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 164,
      "meat": 4
    },
    "subtypeCounts": {
      "boxed_meal": 164,
      "sausage": 4
    },
    "subtypes": [
      "boxed_meal",
      "sausage"
    ],
    "totalObs": 168,
    "source": "usda"
  },
  "mt_olive": {
    "displayName": "Mt. Olive",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 166,
      "produce": 1
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 167,
    "source": "usda"
  },
  "fareway": {
    "displayName": "Fareway",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 68,
      "beverage": 16,
      "pantry": 74,
      "dairy": 8,
      "meat": 1
    },
    "subtypeCounts": {
      "ice_cream": 48,
      "beverage": 16,
      "bread": 10,
      "cheese": 8,
      "candy": 7,
      "chocolate": 3,
      "cookie": 11,
      "baking": 2,
      "boxed_meal": 4,
      "dressing": 3,
      "sauce": 1
    },
    "subtypes": [
      "ice_cream",
      "beverage",
      "cookie",
      "bread",
      "cheese",
      "candy",
      "boxed_meal",
      "chocolate",
      "dressing",
      "baking",
      "sauce"
    ],
    "totalObs": 167,
    "source": "usda"
  },
  "godiva": {
    "displayName": "Godiva",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 166
    },
    "subtypeCounts": {
      "chocolate": 147,
      "candy": 15,
      "cookie": 4
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 166,
    "source": "usda"
  },
  "nature_valley": {
    "displayName": "Nature Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 165,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1,
      "cookie": 23,
      "candy": 2
    },
    "subtypes": [
      "cookie",
      "candy",
      "cheese"
    ],
    "totalObs": 166,
    "source": "usda"
  },
  "shoppers_value": {
    "displayName": "Shoppers Value",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 102,
      "frozen": 37,
      "dairy": 9,
      "beverage": 16,
      "meat": 2
    },
    "subtypeCounts": {
      "sweetener": 1,
      "ice_cream": 32,
      "bread": 6,
      "cookie": 25,
      "beverage": 16,
      "sauce": 6,
      "dressing": 3,
      "candy": 33,
      "sausage": 2,
      "milk": 4,
      "spread": 4,
      "cheese": 3
    },
    "subtypes": [
      "candy",
      "ice_cream",
      "cookie",
      "beverage",
      "bread",
      "sauce",
      "milk",
      "spread",
      "dressing",
      "cheese",
      "sausage",
      "sweetener"
    ],
    "totalObs": 166,
    "source": "usda"
  },
  "safeway": {
    "displayName": "Safeway",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 14,
      "beverage": 37,
      "frozen": 16,
      "pantry": 67,
      "dairy": 25,
      "meat": 5
    },
    "subtypeCounts": {
      "beverage": 37,
      "ice_cream": 1,
      "boxed_meal": 17,
      "sauce": 2,
      "dressing": 2,
      "cheese": 10,
      "candy": 12,
      "cookie": 11,
      "milk": 5,
      "chocolate": 2,
      "baking": 3,
      "sausage": 3,
      "bread": 9
    },
    "subtypes": [
      "beverage",
      "boxed_meal",
      "candy",
      "cookie",
      "cheese",
      "bread",
      "milk",
      "baking",
      "sausage",
      "sauce",
      "dressing",
      "chocolate",
      "ice_cream"
    ],
    "totalObs": 164,
    "source": "usda"
  },
  "always_save": {
    "displayName": "Always Save",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 101,
      "frozen": 28,
      "produce": 1,
      "beverage": 6,
      "dairy": 24,
      "meat": 1
    },
    "subtypeCounts": {
      "ice_cream": 15,
      "spread": 3,
      "boxed_meal": 9,
      "beverage": 6,
      "cookie": 17,
      "milk": 5,
      "baking": 9,
      "cheese": 19,
      "bread": 4,
      "dressing": 2,
      "candy": 2,
      "sausage": 1
    },
    "subtypes": [
      "cheese",
      "cookie",
      "ice_cream",
      "boxed_meal",
      "baking",
      "beverage",
      "milk",
      "bread",
      "spread",
      "dressing",
      "candy",
      "sausage"
    ],
    "totalObs": 161,
    "source": "usda"
  },
  "clif": {
    "displayName": "Clif",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 158
    },
    "subtypeCounts": {
      "candy": 2
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 158,
    "source": "usda"
  },
  "barilla": {
    "displayName": "Barilla",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 156,
      "frozen": 1
    },
    "subtypeCounts": {
      "cookie": 2,
      "boxed_meal": 1,
      "bread": 1
    },
    "subtypes": [
      "cookie",
      "boxed_meal",
      "bread"
    ],
    "totalObs": 157,
    "source": "usda"
  },
  "lifeway": {
    "displayName": "Lifeway",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 145,
      "frozen": 12
    },
    "subtypeCounts": {
      "yogurt": 127,
      "ice_cream": 12,
      "cheese": 16,
      "milk": 2
    },
    "subtypes": [
      "yogurt",
      "cheese",
      "ice_cream",
      "milk"
    ],
    "totalObs": 157,
    "source": "usda"
  },
  "palmer": {
    "displayName": "Palmer",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 156
    },
    "subtypeCounts": {
      "candy": 91,
      "chocolate": 61,
      "cookie": 3
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 156,
    "source": "usda"
  },
  "old_dutch": {
    "displayName": "Old Dutch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 149,
      "dairy": 4
    },
    "subtypeCounts": {
      "cheese": 4,
      "dressing": 2
    },
    "subtypes": [
      "cheese",
      "dressing"
    ],
    "totalObs": 153,
    "source": "usda"
  },
  "bolthouse_farms": {
    "displayName": "Bolthouse Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10,
      "pantry": 33,
      "beverage": 92,
      "produce": 17,
      "frozen": 1
    },
    "subtypeCounts": {
      "yogurt": 8,
      "dressing": 33,
      "beverage": 92,
      "milk": 2
    },
    "subtypes": [
      "beverage",
      "dressing",
      "yogurt",
      "milk"
    ],
    "totalObs": 153,
    "source": "usda"
  },
  "borden": {
    "displayName": "Borden",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 150,
      "beverage": 2
    },
    "subtypeCounts": {
      "cheese": 105,
      "milk": 43,
      "beverage": 2,
      "yogurt": 2
    },
    "subtypes": [
      "cheese",
      "milk",
      "beverage",
      "yogurt"
    ],
    "totalObs": 152,
    "source": "usda"
  },
  "wal_mart_stores": {
    "displayName": "Wal-mart Stores,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 18,
      "pantry": 94,
      "produce": 11,
      "meat": 4,
      "dairy": 12,
      "beverage": 13
    },
    "subtypeCounts": {
      "boxed_meal": 21,
      "cookie": 22,
      "bread": 12,
      "cheese": 8,
      "milk": 1,
      "yogurt": 3,
      "beverage": 13,
      "chocolate": 2,
      "dressing": 4,
      "sauce": 5,
      "candy": 6,
      "ice_cream": 1,
      "spread": 2,
      "sausage": 2
    },
    "subtypes": [
      "cookie",
      "boxed_meal",
      "beverage",
      "bread",
      "cheese",
      "candy",
      "sauce",
      "dressing",
      "yogurt",
      "chocolate",
      "spread",
      "sausage",
      "milk",
      "ice_cream"
    ],
    "totalObs": 152,
    "source": "usda"
  },
  "organic_valley": {
    "displayName": "Organic Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 147,
      "meat": 3,
      "produce": 1
    },
    "subtypeCounts": {
      "yogurt": 10,
      "cheese": 53,
      "sausage": 3,
      "milk": 82
    },
    "subtypes": [
      "milk",
      "cheese",
      "yogurt",
      "sausage"
    ],
    "totalObs": 151,
    "source": "usda"
  },
  "w_o": {
    "displayName": "Winco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 25,
      "pantry": 102,
      "beverage": 19,
      "meat": 1,
      "frozen": 4
    },
    "subtypeCounts": {
      "cheese": 8,
      "sauce": 11,
      "dressing": 3,
      "sweetener": 3,
      "cookie": 20,
      "candy": 4,
      "baking": 1,
      "spread": 1,
      "beverage": 19,
      "sausage": 1,
      "milk": 13,
      "boxed_meal": 1,
      "yogurt": 4,
      "bread": 6
    },
    "subtypes": [
      "cookie",
      "beverage",
      "milk",
      "sauce",
      "cheese",
      "bread",
      "candy",
      "yogurt",
      "dressing",
      "sweetener",
      "baking",
      "spread",
      "sausage",
      "boxed_meal"
    ],
    "totalObs": 151,
    "source": "usda"
  },
  "roland": {
    "displayName": "Roland",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 149,
      "beverage": 2
    },
    "subtypeCounts": {
      "cookie": 7,
      "baking": 4,
      "sauce": 8,
      "dressing": 4,
      "spread": 1,
      "beverage": 2
    },
    "subtypes": [
      "sauce",
      "cookie",
      "baking",
      "dressing",
      "beverage",
      "spread"
    ],
    "totalObs": 151,
    "source": "usda"
  },
  "larabar": {
    "displayName": "Larabar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 150
    },
    "subtypeCounts": {
      "chocolate": 1,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 150,
    "source": "usda"
  },
  "hood": {
    "displayName": "Hood",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 94,
      "frozen": 53,
      "beverage": 3
    },
    "subtypeCounts": {
      "milk": 65,
      "cheese": 29,
      "ice_cream": 53,
      "beverage": 3
    },
    "subtypes": [
      "milk",
      "ice_cream",
      "cheese",
      "beverage"
    ],
    "totalObs": 150,
    "source": "usda"
  },
  "haagen_dazs": {
    "displayName": "Haagen-dazs",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 150
    },
    "subtypeCounts": {
      "ice_cream": 150
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 150,
    "source": "usda"
  },
  "price_chopper": {
    "displayName": "Price Chopper",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 82,
      "dairy": 23,
      "frozen": 23,
      "beverage": 10,
      "produce": 6,
      "meat": 4
    },
    "subtypeCounts": {
      "cookie": 18,
      "cheese": 15,
      "boxed_meal": 10,
      "beverage": 10,
      "candy": 29,
      "bread": 3,
      "baking": 2,
      "ice_cream": 14,
      "sweetener": 1,
      "milk": 4,
      "yogurt": 4,
      "dressing": 1,
      "chocolate": 1,
      "sauce": 1
    },
    "subtypes": [
      "candy",
      "cookie",
      "cheese",
      "ice_cream",
      "boxed_meal",
      "beverage",
      "milk",
      "yogurt",
      "bread",
      "baking",
      "sweetener",
      "dressing",
      "chocolate",
      "sauce"
    ],
    "totalObs": 148,
    "source": "usda"
  },
  "darigold": {
    "displayName": "Darigold",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 147
    },
    "subtypeCounts": {
      "cheese": 27,
      "milk": 116,
      "yogurt": 4
    },
    "subtypes": [
      "milk",
      "cheese",
      "yogurt"
    ],
    "totalObs": 147,
    "source": "usda"
  },
  "smuckers": {
    "displayName": "Smucker's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 122,
      "frozen": 25
    },
    "subtypeCounts": {
      "spread": 119,
      "boxed_meal": 25,
      "sweetener": 3
    },
    "subtypes": [
      "spread",
      "boxed_meal",
      "sweetener"
    ],
    "totalObs": 147,
    "source": "usda"
  },
  "rouses_markets": {
    "displayName": "Rouses Markets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 39,
      "pantry": 88,
      "beverage": 14,
      "meat": 3,
      "dairy": 2
    },
    "subtypeCounts": {
      "ice_cream": 31,
      "beverage": 14,
      "boxed_meal": 4,
      "dressing": 5,
      "sauce": 3,
      "bread": 1,
      "spread": 5,
      "baking": 1,
      "sausage": 3,
      "cookie": 1,
      "milk": 2
    },
    "subtypes": [
      "ice_cream",
      "beverage",
      "dressing",
      "spread",
      "boxed_meal",
      "sauce",
      "sausage",
      "milk",
      "bread",
      "baking",
      "cookie"
    ],
    "totalObs": 146,
    "source": "usda"
  },
  "marzetti": {
    "displayName": "Marzetti",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 141,
      "dairy": 2
    },
    "subtypeCounts": {
      "dressing": 127,
      "bread": 13,
      "cheese": 2,
      "sauce": 1
    },
    "subtypes": [
      "dressing",
      "bread",
      "cheese",
      "sauce"
    ],
    "totalObs": 143,
    "source": "usda"
  },
  "aunt_millies": {
    "displayName": "Aunt Millie's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 143
    },
    "subtypeCounts": {
      "bread": 143
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 143,
    "source": "usda"
  },
  "market_basket": {
    "displayName": "Market Basket",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 21,
      "dairy": 21,
      "pantry": 62,
      "beverage": 30,
      "produce": 1,
      "meat": 6
    },
    "subtypeCounts": {
      "ice_cream": 16,
      "yogurt": 5,
      "cheese": 13,
      "candy": 6,
      "chocolate": 9,
      "cookie": 14,
      "beverage": 30,
      "bread": 9,
      "sweetener": 2,
      "boxed_meal": 6,
      "milk": 2,
      "dressing": 1,
      "sausage": 1
    },
    "subtypes": [
      "beverage",
      "ice_cream",
      "cookie",
      "cheese",
      "chocolate",
      "bread",
      "candy",
      "boxed_meal",
      "yogurt",
      "sweetener",
      "milk",
      "dressing",
      "sausage"
    ],
    "totalObs": 141,
    "source": "usda"
  },
  "lean_cuisine": {
    "displayName": "Lean Cuisine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 138,
      "pantry": 2
    },
    "subtypeCounts": {
      "boxed_meal": 138
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 140,
    "source": "usda"
  },
  "kettle": {
    "displayName": "Kettle",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 140
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 140,
    "source": "usda"
  },
  "lofthouse": {
    "displayName": "Lofthouse",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 139
    },
    "subtypeCounts": {
      "cookie": 138,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 139,
    "source": "usda"
  },
  "turkey_hill": {
    "displayName": "Turkey Hill",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 118,
      "dairy": 7,
      "beverage": 13
    },
    "subtypeCounts": {
      "ice_cream": 118,
      "milk": 7,
      "beverage": 13
    },
    "subtypes": [
      "ice_cream",
      "beverage",
      "milk"
    ],
    "totalObs": 138,
    "source": "usda"
  },
  "quest": {
    "displayName": "Quest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 132,
      "beverage": 2
    },
    "subtypeCounts": {
      "cookie": 13,
      "beverage": 2
    },
    "subtypes": [
      "cookie",
      "beverage"
    ],
    "totalObs": 134,
    "source": "usda"
  },
  "franz": {
    "displayName": "Franz",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 133
    },
    "subtypeCounts": {
      "cookie": 19,
      "bread": 114
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 133,
    "source": "usda"
  },
  "starburst": {
    "displayName": "Starburst",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 130,
      "frozen": 3
    },
    "subtypeCounts": {
      "candy": 129,
      "ice_cream": 3
    },
    "subtypes": [
      "candy",
      "ice_cream"
    ],
    "totalObs": 133,
    "source": "usda"
  },
  "pepperidge_farm": {
    "displayName": "Pepperidge Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 130,
      "frozen": 3
    },
    "subtypeCounts": {
      "bread": 98,
      "cookie": 26
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 133,
    "source": "usda"
  },
  "harmons": {
    "displayName": "Harmons",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 110,
      "beverage": 6,
      "frozen": 5,
      "meat": 1,
      "dairy": 8,
      "produce": 3
    },
    "subtypeCounts": {
      "candy": 44,
      "beverage": 6,
      "boxed_meal": 4,
      "chocolate": 17,
      "cookie": 1,
      "spread": 9,
      "sausage": 1,
      "cheese": 4,
      "milk": 4
    },
    "subtypes": [
      "candy",
      "chocolate",
      "spread",
      "beverage",
      "boxed_meal",
      "cheese",
      "milk",
      "cookie",
      "sausage"
    ],
    "totalObs": 133,
    "source": "usda"
  },
  "laura_lynn": {
    "displayName": "Laura Lynn",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 69,
      "dairy": 36,
      "beverage": 10,
      "frozen": 16,
      "meat": 1
    },
    "subtypeCounts": {
      "yogurt": 13,
      "candy": 18,
      "baking": 1,
      "cookie": 14,
      "chocolate": 8,
      "beverage": 10,
      "cheese": 20,
      "milk": 3,
      "ice_cream": 6,
      "dressing": 2,
      "bread": 2,
      "boxed_meal": 7,
      "sausage": 1,
      "sauce": 1,
      "spread": 1
    },
    "subtypes": [
      "cheese",
      "candy",
      "cookie",
      "yogurt",
      "beverage",
      "chocolate",
      "boxed_meal",
      "ice_cream",
      "milk",
      "dressing",
      "bread",
      "baking",
      "sausage",
      "sauce",
      "spread"
    ],
    "totalObs": 132,
    "source": "usda"
  },
  "snickers": {
    "displayName": "Snickers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 118,
      "frozen": 14
    },
    "subtypeCounts": {
      "candy": 74,
      "ice_cream": 14,
      "chocolate": 44
    },
    "subtypes": [
      "candy",
      "chocolate",
      "ice_cream"
    ],
    "totalObs": 132,
    "source": "usda"
  },
  "h_e_b": {
    "displayName": "H-e-b",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 58,
      "dairy": 30,
      "beverage": 23,
      "produce": 6,
      "frozen": 12,
      "meat": 2
    },
    "subtypeCounts": {
      "milk": 3,
      "dressing": 3,
      "bread": 8,
      "boxed_meal": 9,
      "beverage": 23,
      "cheese": 22,
      "cookie": 3,
      "candy": 2,
      "yogurt": 5,
      "sausage": 2,
      "ice_cream": 3,
      "baking": 2,
      "sweetener": 1,
      "chocolate": 1
    },
    "subtypes": [
      "beverage",
      "cheese",
      "boxed_meal",
      "bread",
      "yogurt",
      "milk",
      "dressing",
      "cookie",
      "ice_cream",
      "candy",
      "sausage",
      "baking",
      "sweetener",
      "chocolate"
    ],
    "totalObs": 131,
    "source": "usda"
  },
  "bakery": {
    "displayName": "Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 129
    },
    "subtypeCounts": {
      "bread": 27,
      "cookie": 97,
      "candy": 4,
      "chocolate": 1
    },
    "subtypes": [
      "cookie",
      "bread",
      "candy",
      "chocolate"
    ],
    "totalObs": 129,
    "source": "usda"
  },
  "culinary_tours": {
    "displayName": "Culinary Tours",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 42,
      "pantry": 72,
      "dairy": 15
    },
    "subtypeCounts": {
      "boxed_meal": 16,
      "ice_cream": 30,
      "dressing": 7,
      "chocolate": 10,
      "sauce": 1,
      "spread": 13,
      "bread": 6,
      "cookie": 6,
      "cheese": 6,
      "yogurt": 9,
      "candy": 3
    },
    "subtypes": [
      "ice_cream",
      "boxed_meal",
      "spread",
      "chocolate",
      "yogurt",
      "dressing",
      "bread",
      "cookie",
      "cheese",
      "candy",
      "sauce"
    ],
    "totalObs": 129,
    "source": "usda"
  },
  "natures_place": {
    "displayName": "Nature's Place",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 66,
      "beverage": 12,
      "produce": 23,
      "dairy": 17,
      "frozen": 5,
      "meat": 6
    },
    "subtypeCounts": {
      "sweetener": 2,
      "candy": 3,
      "dressing": 12,
      "spread": 7,
      "beverage": 12,
      "bread": 8,
      "cheese": 7,
      "cookie": 1,
      "boxed_meal": 3,
      "sausage": 6,
      "sauce": 1,
      "milk": 4,
      "yogurt": 4
    },
    "subtypes": [
      "dressing",
      "beverage",
      "bread",
      "spread",
      "cheese",
      "sausage",
      "milk",
      "yogurt",
      "candy",
      "boxed_meal",
      "sweetener",
      "cookie",
      "sauce"
    ],
    "totalObs": 129,
    "source": "usda"
  },
  "litehouse": {
    "displayName": "Litehouse",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 19,
      "pantry": 107,
      "produce": 1
    },
    "subtypeCounts": {
      "cheese": 19,
      "dressing": 106,
      "sauce": 1
    },
    "subtypes": [
      "dressing",
      "cheese",
      "sauce"
    ],
    "totalObs": 127,
    "source": "usda"
  },
  "simple_truth_organic": {
    "displayName": "Simple Truth Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 9,
      "beverage": 15,
      "dairy": 42,
      "pantry": 45,
      "produce": 16
    },
    "subtypeCounts": {
      "beverage": 15,
      "cheese": 15,
      "yogurt": 12,
      "sweetener": 1,
      "milk": 13,
      "chocolate": 5,
      "bread": 10,
      "boxed_meal": 5,
      "dressing": 3,
      "cookie": 5,
      "ice_cream": 3,
      "sauce": 2
    },
    "subtypes": [
      "beverage",
      "cheese",
      "milk",
      "yogurt",
      "bread",
      "chocolate",
      "boxed_meal",
      "cookie",
      "dressing",
      "ice_cream",
      "sauce",
      "sweetener"
    ],
    "totalObs": 127,
    "source": "usda"
  },
  "jolly_rancher": {
    "displayName": "Jolly Rancher",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 121,
      "frozen": 6
    },
    "subtypeCounts": {
      "candy": 121,
      "ice_cream": 6
    },
    "subtypes": [
      "candy",
      "ice_cream"
    ],
    "totalObs": 127,
    "source": "usda"
  },
  "morton_bassett": {
    "displayName": "Morton Bassett",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 127
    },
    "subtypeCounts": {
      "sauce": 4,
      "baking": 6
    },
    "subtypes": [
      "baking",
      "sauce"
    ],
    "totalObs": 127,
    "source": "usda"
  },
  "newmans_own": {
    "displayName": "Newman's Own",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 108,
      "dairy": 5,
      "frozen": 11,
      "beverage": 1
    },
    "subtypeCounts": {
      "dressing": 57,
      "cookie": 28,
      "yogurt": 4,
      "candy": 13,
      "chocolate": 6,
      "boxed_meal": 11,
      "cheese": 1,
      "beverage": 1
    },
    "subtypes": [
      "dressing",
      "cookie",
      "candy",
      "boxed_meal",
      "chocolate",
      "yogurt",
      "cheese",
      "beverage"
    ],
    "totalObs": 125,
    "source": "usda"
  },
  "cabot": {
    "displayName": "Cabot",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 123
    },
    "subtypeCounts": {
      "cheese": 113,
      "milk": 4,
      "yogurt": 6
    },
    "subtypes": [
      "cheese",
      "yogurt",
      "milk"
    ],
    "totalObs": 123,
    "source": "usda"
  },
  "butterfinger": {
    "displayName": "Butterfinger",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 119,
      "frozen": 4
    },
    "subtypeCounts": {
      "candy": 113,
      "chocolate": 6,
      "ice_cream": 4
    },
    "subtypes": [
      "candy",
      "chocolate",
      "ice_cream"
    ],
    "totalObs": 123,
    "source": "usda"
  },
  "ghirardelli_cho_late": {
    "displayName": "Ghirardelli Chocolate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 121
    },
    "subtypeCounts": {
      "chocolate": 113,
      "candy": 6,
      "baking": 1,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "baking",
      "cookie"
    ],
    "totalObs": 121,
    "source": "usda"
  },
  "hidden_valley": {
    "displayName": "Hidden Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 120,
      "meat": 1
    },
    "subtypeCounts": {
      "dressing": 103,
      "sauce": 13,
      "bread": 3,
      "boxed_meal": 1
    },
    "subtypes": [
      "dressing",
      "sauce",
      "bread",
      "boxed_meal"
    ],
    "totalObs": 121,
    "source": "usda"
  },
  "breyers": {
    "displayName": "Breyers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 120
    },
    "subtypeCounts": {
      "ice_cream": 120
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 120,
    "source": "usda"
  },
  "cape_d": {
    "displayName": "Cape Cod",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 120
    },
    "subtypeCounts": {
      "boxed_meal": 2,
      "cookie": 1
    },
    "subtypes": [
      "boxed_meal",
      "cookie"
    ],
    "totalObs": 120,
    "source": "usda"
  },
  "follow_your_heart": {
    "displayName": "Follow Your Heart",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 73,
      "dairy": 46
    },
    "subtypeCounts": {
      "dressing": 73,
      "cheese": 36,
      "milk": 1,
      "yogurt": 8
    },
    "subtypes": [
      "dressing",
      "cheese",
      "yogurt",
      "milk"
    ],
    "totalObs": 119,
    "source": "usda"
  },
  "signature_cafe": {
    "displayName": "Signature Cafe",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 67,
      "meat": 32,
      "frozen": 8,
      "dairy": 9,
      "produce": 2
    },
    "subtypeCounts": {
      "boxed_meal": 37,
      "cheese": 9,
      "sausage": 3
    },
    "subtypes": [
      "boxed_meal",
      "cheese",
      "sausage"
    ],
    "totalObs": 118,
    "source": "usda"
  },
  "evolution_fresh": {
    "displayName": "Evolution Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 112,
      "dairy": 6
    },
    "subtypeCounts": {
      "beverage": 112,
      "yogurt": 6
    },
    "subtypes": [
      "beverage",
      "yogurt"
    ],
    "totalObs": 118,
    "source": "usda"
  },
  "sara_lee": {
    "displayName": "Sara Lee",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 108,
      "frozen": 1,
      "dairy": 9
    },
    "subtypeCounts": {
      "bread": 108,
      "boxed_meal": 1,
      "cheese": 8
    },
    "subtypes": [
      "bread",
      "cheese",
      "boxed_meal"
    ],
    "totalObs": 118,
    "source": "usda"
  },
  "atkins": {
    "displayName": "Atkins",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 25,
      "pantry": 91,
      "dairy": 1
    },
    "subtypeCounts": {
      "boxed_meal": 23,
      "milk": 1,
      "candy": 4,
      "chocolate": 5,
      "cookie": 1
    },
    "subtypes": [
      "boxed_meal",
      "chocolate",
      "candy",
      "milk",
      "cookie"
    ],
    "totalObs": 117,
    "source": "usda"
  },
  "purple_w": {
    "displayName": "Purple Cow",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 94,
      "dairy": 21
    },
    "subtypeCounts": {
      "ice_cream": 94,
      "yogurt": 20,
      "milk": 1
    },
    "subtypes": [
      "ice_cream",
      "yogurt",
      "milk"
    ],
    "totalObs": 115,
    "source": "usda"
  },
  "el_monterey": {
    "displayName": "El Monterey",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 115
    },
    "subtypeCounts": {
      "boxed_meal": 114,
      "bread": 1
    },
    "subtypes": [
      "boxed_meal",
      "bread"
    ],
    "totalObs": 115,
    "source": "usda"
  },
  "market_district": {
    "displayName": "Market District",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 56,
      "dairy": 16,
      "frozen": 29,
      "beverage": 7,
      "produce": 7
    },
    "subtypeCounts": {
      "cookie": 8,
      "cheese": 11,
      "bread": 5,
      "spread": 8,
      "yogurt": 4,
      "boxed_meal": 14,
      "beverage": 7,
      "chocolate": 11,
      "ice_cream": 22,
      "dressing": 10,
      "milk": 1
    },
    "subtypes": [
      "ice_cream",
      "boxed_meal",
      "cheese",
      "chocolate",
      "dressing",
      "cookie",
      "spread",
      "beverage",
      "bread",
      "yogurt",
      "milk"
    ],
    "totalObs": 115,
    "source": "usda"
  },
  "black_forest": {
    "displayName": "Black Forest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 115
    },
    "subtypeCounts": {
      "candy": 115
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 115,
    "source": "usda"
  },
  "clover_sonoma": {
    "displayName": "Clover Sonoma",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 105,
      "frozen": 10
    },
    "subtypeCounts": {
      "cheese": 13,
      "milk": 75,
      "yogurt": 10,
      "ice_cream": 10
    },
    "subtypes": [
      "milk",
      "cheese",
      "yogurt",
      "ice_cream"
    ],
    "totalObs": 115,
    "source": "usda"
  },
  "stater_bros_markets": {
    "displayName": "Stater Bros. Markets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 42,
      "pantry": 42,
      "frozen": 2,
      "produce": 23,
      "beverage": 5
    },
    "subtypeCounts": {
      "milk": 16,
      "cheese": 26,
      "cookie": 1,
      "dressing": 16,
      "ice_cream": 2,
      "boxed_meal": 2,
      "bread": 1,
      "sauce": 8,
      "beverage": 5
    },
    "subtypes": [
      "cheese",
      "milk",
      "dressing",
      "sauce",
      "beverage",
      "ice_cream",
      "boxed_meal",
      "cookie",
      "bread"
    ],
    "totalObs": 114,
    "source": "usda"
  },
  "hammonds": {
    "displayName": "Hammond's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 112
    },
    "subtypeCounts": {
      "cookie": 1,
      "candy": 74,
      "chocolate": 35
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 112,
    "source": "usda"
  },
  "hersheys_kisses": {
    "displayName": "Hershey's Kisses",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 111
    },
    "subtypeCounts": {
      "chocolate": 83,
      "candy": 27,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 111,
    "source": "usda"
  },
  "ben_jerrys": {
    "displayName": "Ben & Jerry's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 110
    },
    "subtypeCounts": {
      "ice_cream": 104,
      "bread": 6
    },
    "subtypes": [
      "ice_cream",
      "bread"
    ],
    "totalObs": 110,
    "source": "usda"
  },
  "horizon_organic": {
    "displayName": "Horizon Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 108,
      "pantry": 2
    },
    "subtypeCounts": {
      "cheese": 18,
      "milk": 79,
      "yogurt": 11,
      "candy": 2
    },
    "subtypes": [
      "milk",
      "cheese",
      "yogurt",
      "candy"
    ],
    "totalObs": 110,
    "source": "usda"
  },
  "skittles": {
    "displayName": "Skittles",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 110
    },
    "subtypeCounts": {
      "candy": 110
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 110,
    "source": "usda"
  },
  "belgioioso": {
    "displayName": "Belgioioso",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 109
    },
    "subtypeCounts": {
      "cheese": 109
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 109,
    "source": "usda"
  },
  "powerbar": {
    "displayName": "Powerbar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 108
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 108,
    "source": "usda"
  },
  "pure_protein": {
    "displayName": "Pure Protein",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 107
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 107,
    "source": "usda"
  },
  "trader_joes": {
    "displayName": "Trader Joe's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 3,
      "dairy": 17,
      "pantry": 64,
      "beverage": 23
    },
    "subtypeCounts": {
      "ice_cream": 2,
      "cheese": 6,
      "bread": 7,
      "yogurt": 9,
      "boxed_meal": 3,
      "chocolate": 6,
      "sauce": 7,
      "cookie": 8,
      "spread": 1,
      "baking": 2,
      "sweetener": 2,
      "dressing": 3,
      "beverage": 23,
      "milk": 2
    },
    "subtypes": [
      "beverage",
      "yogurt",
      "cookie",
      "bread",
      "sauce",
      "cheese",
      "chocolate",
      "boxed_meal",
      "dressing",
      "ice_cream",
      "baking",
      "sweetener",
      "milk",
      "spread"
    ],
    "totalObs": 107,
    "source": "usda"
  },
  "family_gourmet": {
    "displayName": "Family Gourmet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 99,
      "dairy": 7,
      "beverage": 1
    },
    "subtypeCounts": {
      "candy": 29,
      "cookie": 23,
      "baking": 2,
      "sauce": 4,
      "cheese": 6,
      "spread": 1,
      "dressing": 7,
      "boxed_meal": 7,
      "milk": 1,
      "beverage": 1
    },
    "subtypes": [
      "candy",
      "cookie",
      "dressing",
      "boxed_meal",
      "cheese",
      "sauce",
      "baking",
      "spread",
      "milk",
      "beverage"
    ],
    "totalObs": 107,
    "source": "usda"
  },
  "michelinas": {
    "displayName": "Michelina's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 106
    },
    "subtypeCounts": {
      "boxed_meal": 106
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 106,
    "source": "usda"
  },
  "kings": {
    "displayName": "Kings",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 62,
      "beverage": 6,
      "dairy": 14,
      "frozen": 24
    },
    "subtypeCounts": {
      "cookie": 22,
      "beverage": 6,
      "candy": 3,
      "chocolate": 7,
      "bread": 1,
      "baking": 1,
      "cheese": 11,
      "sweetener": 4,
      "ice_cream": 13,
      "boxed_meal": 2
    },
    "subtypes": [
      "cookie",
      "ice_cream",
      "cheese",
      "chocolate",
      "beverage",
      "sweetener",
      "candy",
      "boxed_meal",
      "bread",
      "baking"
    ],
    "totalObs": 106,
    "source": "usda"
  },
  "nestle": {
    "displayName": "Nestle",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 8,
      "frozen": 31,
      "pantry": 47,
      "dairy": 20
    },
    "subtypeCounts": {
      "beverage": 12,
      "boxed_meal": 19,
      "sauce": 4,
      "milk": 20,
      "chocolate": 19,
      "candy": 13,
      "cookie": 7,
      "ice_cream": 12
    },
    "subtypes": [
      "milk",
      "boxed_meal",
      "chocolate",
      "candy",
      "beverage",
      "ice_cream",
      "cookie",
      "sauce"
    ],
    "totalObs": 106,
    "source": "usda"
  },
  "fiber_one": {
    "displayName": "Fiber One",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 105,
      "dairy": 1
    },
    "subtypeCounts": {
      "bread": 6,
      "cheese": 1,
      "cookie": 21,
      "candy": 3
    },
    "subtypes": [
      "cookie",
      "bread",
      "candy",
      "cheese"
    ],
    "totalObs": 106,
    "source": "usda"
  },
  "chestnut_hill": {
    "displayName": "Chestnut Hill",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 85,
      "dairy": 18,
      "frozen": 1,
      "beverage": 1
    },
    "subtypeCounts": {
      "boxed_meal": 4,
      "dressing": 7,
      "cookie": 2,
      "sweetener": 1,
      "spread": 1,
      "cheese": 16,
      "milk": 2,
      "baking": 6,
      "candy": 6,
      "bread": 2,
      "sauce": 14,
      "beverage": 1
    },
    "subtypes": [
      "cheese",
      "sauce",
      "dressing",
      "baking",
      "candy",
      "boxed_meal",
      "cookie",
      "milk",
      "bread",
      "sweetener",
      "spread",
      "beverage"
    ],
    "totalObs": 105,
    "source": "usda"
  },
  "ready_pac": {
    "displayName": "Ready Pac",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 49,
      "pantry": 55,
      "meat": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "chocolate": 1
    },
    "subtypes": [
      "boxed_meal",
      "chocolate"
    ],
    "totalObs": 105,
    "source": "usda"
  },
  "pics": {
    "displayName": "Pics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 52,
      "dairy": 28,
      "frozen": 9,
      "beverage": 14,
      "produce": 1
    },
    "subtypeCounts": {
      "spread": 1,
      "baking": 2,
      "cheese": 21,
      "candy": 8,
      "chocolate": 2,
      "ice_cream": 7,
      "sauce": 8,
      "beverage": 14,
      "yogurt": 6,
      "milk": 1,
      "cookie": 4,
      "bread": 3,
      "dressing": 3,
      "sweetener": 1
    },
    "subtypes": [
      "cheese",
      "beverage",
      "candy",
      "sauce",
      "ice_cream",
      "yogurt",
      "cookie",
      "bread",
      "dressing",
      "baking",
      "chocolate",
      "spread",
      "milk",
      "sweetener"
    ],
    "totalObs": 104,
    "source": "usda"
  },
  "mus_family_olive": {
    "displayName": "Musco Family Olive",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 103
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 103,
    "source": "usda"
  },
  "lawrys": {
    "displayName": "Lawry's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 103
    },
    "subtypeCounts": {
      "sauce": 95,
      "dressing": 1
    },
    "subtypes": [
      "sauce",
      "dressing"
    ],
    "totalObs": 103,
    "source": "usda"
  },
  "sunny_select": {
    "displayName": "Sunny Select",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 18,
      "pantry": 72,
      "frozen": 11,
      "dairy": 1
    },
    "subtypeCounts": {
      "beverage": 18,
      "sauce": 5,
      "baking": 4,
      "candy": 11,
      "chocolate": 1,
      "sweetener": 3,
      "spread": 3,
      "cheese": 1,
      "boxed_meal": 9,
      "dressing": 2,
      "cookie": 9
    },
    "subtypes": [
      "beverage",
      "candy",
      "boxed_meal",
      "cookie",
      "sauce",
      "baking",
      "sweetener",
      "spread",
      "dressing",
      "chocolate",
      "cheese"
    ],
    "totalObs": 102,
    "source": "usda"
  },
  "twizzlers": {
    "displayName": "Twizzlers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 102
    },
    "subtypeCounts": {
      "candy": 102
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 102,
    "source": "usda"
  },
  "oroweat": {
    "displayName": "Oroweat",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 102
    },
    "subtypeCounts": {
      "bread": 102
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 102,
    "source": "usda"
  },
  "friendlys": {
    "displayName": "Friendly's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 99
    },
    "subtypeCounts": {
      "ice_cream": 99
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 99,
    "source": "usda"
  },
  "poland_spring": {
    "displayName": "Poland Spring",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 99
    },
    "subtypeCounts": {
      "beverage": 99
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 99,
    "source": "usda"
  },
  "keebler": {
    "displayName": "Keebler",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 99
    },
    "subtypeCounts": {
      "cookie": 97,
      "candy": 2
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 99,
    "source": "usda"
  },
  "daily_chef": {
    "displayName": "Daily Chef",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 23,
      "pantry": 35,
      "dairy": 35,
      "beverage": 3,
      "meat": 3
    },
    "subtypeCounts": {
      "boxed_meal": 13,
      "candy": 6,
      "cheese": 30,
      "beverage": 3,
      "milk": 3,
      "cookie": 2,
      "bread": 8,
      "sausage": 3,
      "ice_cream": 2,
      "dressing": 1
    },
    "subtypes": [
      "cheese",
      "boxed_meal",
      "bread",
      "candy",
      "beverage",
      "milk",
      "sausage",
      "cookie",
      "ice_cream",
      "dressing"
    ],
    "totalObs": 99,
    "source": "usda"
  },
  "shullsburg_creamery": {
    "displayName": "Shullsburg Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 85,
      "pantry": 13,
      "meat": 1
    },
    "subtypeCounts": {
      "cheese": 85,
      "bread": 13,
      "sausage": 1
    },
    "subtypes": [
      "cheese",
      "bread",
      "sausage"
    ],
    "totalObs": 99,
    "source": "usda"
  },
  "campbells": {
    "displayName": "Campbell's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 93,
      "frozen": 6
    },
    "subtypeCounts": {
      "boxed_meal": 98,
      "cookie": 1
    },
    "subtypes": [
      "boxed_meal",
      "cookie"
    ],
    "totalObs": 99,
    "source": "usda"
  },
  "herrs": {
    "displayName": "Herr's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 1,
      "pantry": 97
    },
    "subtypeCounts": {
      "cheese": 1,
      "candy": 1,
      "sauce": 1,
      "cookie": 3
    },
    "subtypes": [
      "cookie",
      "cheese",
      "candy",
      "sauce"
    ],
    "totalObs": 98,
    "source": "usda"
  },
  "good_delish": {
    "displayName": "Good & Delish",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 52,
      "frozen": 26,
      "beverage": 15,
      "produce": 4,
      "meat": 1
    },
    "subtypeCounts": {
      "cookie": 9,
      "candy": 15,
      "ice_cream": 19,
      "chocolate": 14,
      "beverage": 16,
      "boxed_meal": 8
    },
    "subtypes": [
      "ice_cream",
      "beverage",
      "candy",
      "chocolate",
      "cookie",
      "boxed_meal"
    ],
    "totalObs": 98,
    "source": "usda"
  },
  "luna": {
    "displayName": "Luna",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 98
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 98,
    "source": "usda"
  },
  "mezzetta": {
    "displayName": "Mezzetta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 97
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 97,
    "source": "usda"
  },
  "arrowhead": {
    "displayName": "Arrowhead",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 88,
      "dairy": 9
    },
    "subtypeCounts": {
      "beverage": 88,
      "milk": 6,
      "cheese": 3
    },
    "subtypes": [
      "beverage",
      "milk",
      "cheese"
    ],
    "totalObs": 97,
    "source": "usda"
  },
  "ferrara_candy": {
    "displayName": "Ferrara Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 97
    },
    "subtypeCounts": {
      "candy": 95,
      "chocolate": 2
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 97,
    "source": "usda"
  },
  "marie_callenders": {
    "displayName": "Marie Callender's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 91,
      "pantry": 6
    },
    "subtypeCounts": {
      "boxed_meal": 93,
      "dressing": 4
    },
    "subtypes": [
      "boxed_meal",
      "dressing"
    ],
    "totalObs": 97,
    "source": "usda"
  },
  "less": {
    "displayName": "Brandless",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 97
    },
    "subtypeCounts": {
      "dressing": 10,
      "cookie": 13,
      "baking": 4,
      "sweetener": 4,
      "candy": 10,
      "sauce": 4,
      "spread": 2,
      "boxed_meal": 5,
      "chocolate": 1
    },
    "subtypes": [
      "cookie",
      "dressing",
      "candy",
      "boxed_meal",
      "baking",
      "sweetener",
      "sauce",
      "spread",
      "chocolate"
    ],
    "totalObs": 97,
    "source": "usda"
  },
  "deer_park": {
    "displayName": "Deer Park",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 95
    },
    "subtypeCounts": {
      "beverage": 95
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 95,
    "source": "usda"
  },
  "ruffles": {
    "displayName": "Ruffles",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 95
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 95,
    "source": "usda"
  },
  "badia": {
    "displayName": "Badia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 91,
      "beverage": 3
    },
    "subtypeCounts": {
      "sauce": 66,
      "dressing": 1,
      "beverage": 3,
      "candy": 1
    },
    "subtypes": [
      "sauce",
      "beverage",
      "dressing",
      "candy"
    ],
    "totalObs": 94,
    "source": "usda"
  },
  "big_win": {
    "displayName": "Big Win",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 2,
      "pantry": 76,
      "beverage": 16
    },
    "subtypeCounts": {
      "candy": 49,
      "cookie": 6,
      "beverage": 16,
      "chocolate": 2,
      "sauce": 4,
      "boxed_meal": 1
    },
    "subtypes": [
      "candy",
      "beverage",
      "cookie",
      "sauce",
      "chocolate",
      "boxed_meal"
    ],
    "totalObs": 94,
    "source": "usda"
  },
  "homemade": {
    "displayName": "Homemade Brand",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 93,
      "dairy": 1
    },
    "subtypeCounts": {
      "ice_cream": 93,
      "milk": 1
    },
    "subtypes": [
      "ice_cream",
      "milk"
    ],
    "totalObs": 94,
    "source": "usda"
  },
  "americas_choice": {
    "displayName": "America's Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15,
      "pantry": 48,
      "frozen": 23,
      "beverage": 7,
      "meat": 1
    },
    "subtypeCounts": {
      "cheese": 13,
      "candy": 9,
      "ice_cream": 7,
      "cookie": 18,
      "beverage": 7,
      "bread": 1,
      "boxed_meal": 13,
      "sausage": 1,
      "milk": 1,
      "dressing": 5,
      "yogurt": 1,
      "sauce": 1
    },
    "subtypes": [
      "cookie",
      "cheese",
      "boxed_meal",
      "candy",
      "ice_cream",
      "beverage",
      "dressing",
      "bread",
      "sausage",
      "milk",
      "yogurt",
      "sauce"
    ],
    "totalObs": 94,
    "source": "usda"
  },
  "oikos": {
    "displayName": "Oikos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 94
    },
    "subtypeCounts": {
      "yogurt": 91,
      "milk": 3
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 94,
    "source": "usda"
  },
  "airheads": {
    "displayName": "Airheads",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 79,
      "frozen": 15
    },
    "subtypeCounts": {
      "candy": 79,
      "ice_cream": 15
    },
    "subtypes": [
      "candy",
      "ice_cream"
    ],
    "totalObs": 94,
    "source": "usda"
  },
  "lundberg_family_farms": {
    "displayName": "Lundberg Family Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 85,
      "frozen": 8
    },
    "subtypeCounts": {
      "boxed_meal": 8,
      "chocolate": 3
    },
    "subtypes": [
      "boxed_meal",
      "chocolate"
    ],
    "totalObs": 93,
    "source": "usda"
  },
  "hanover": {
    "displayName": "Hanover",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 72,
      "pantry": 20,
      "produce": 1
    },
    "subtypeCounts": {
      "boxed_meal": 13
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 93,
    "source": "usda"
  },
  "langers": {
    "displayName": "Langers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 93
    },
    "subtypeCounts": {
      "beverage": 93
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 93,
    "source": "usda"
  },
  "healthy_choice": {
    "displayName": "Healthy Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 85,
      "pantry": 8
    },
    "subtypeCounts": {
      "ice_cream": 9,
      "boxed_meal": 80,
      "dressing": 4
    },
    "subtypes": [
      "boxed_meal",
      "ice_cream",
      "dressing"
    ],
    "totalObs": 93,
    "source": "usda"
  },
  "thats_smart": {
    "displayName": "That's Smart!",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 63,
      "beverage": 3,
      "dairy": 11,
      "frozen": 16
    },
    "subtypeCounts": {
      "sauce": 2,
      "dressing": 8,
      "cookie": 18,
      "beverage": 3,
      "cheese": 5,
      "bread": 4,
      "ice_cream": 6,
      "milk": 4,
      "baking": 1,
      "spread": 2,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "dressing",
      "ice_cream",
      "cheese",
      "bread",
      "milk",
      "beverage",
      "sauce",
      "spread",
      "baking",
      "candy"
    ],
    "totalObs": 93,
    "source": "usda"
  },
  "my_essentials": {
    "displayName": "My Essentials",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 55,
      "dairy": 23,
      "frozen": 14
    },
    "subtypeCounts": {
      "bread": 3,
      "yogurt": 5,
      "cheese": 12,
      "milk": 6,
      "dressing": 4,
      "cookie": 2,
      "sauce": 2,
      "spread": 3,
      "candy": 2,
      "baking": 3,
      "boxed_meal": 10,
      "ice_cream": 8
    },
    "subtypes": [
      "cheese",
      "boxed_meal",
      "ice_cream",
      "milk",
      "yogurt",
      "dressing",
      "bread",
      "spread",
      "baking",
      "cookie",
      "sauce",
      "candy"
    ],
    "totalObs": 92,
    "source": "usda"
  },
  "vlasic": {
    "displayName": "Vlasic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 92
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 92,
    "source": "usda"
  },
  "stonyfield": {
    "displayName": "Stonyfield",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 5,
      "dairy": 81,
      "beverage": 4,
      "pantry": 2
    },
    "subtypeCounts": {
      "ice_cream": 5,
      "yogurt": 70,
      "milk": 10,
      "beverage": 4,
      "candy": 2,
      "cheese": 1
    },
    "subtypes": [
      "yogurt",
      "milk",
      "ice_cream",
      "beverage",
      "candy",
      "cheese"
    ],
    "totalObs": 92,
    "source": "usda"
  },
  "ronzoni": {
    "displayName": "Ronzoni",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 92
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 92,
    "source": "usda"
  },
  "greenwise": {
    "displayName": "Greenwise",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 50,
      "dairy": 17,
      "beverage": 15,
      "meat": 2,
      "produce": 3,
      "frozen": 5
    },
    "subtypeCounts": {
      "candy": 4,
      "chocolate": 2,
      "sweetener": 3,
      "cheese": 3,
      "beverage": 15,
      "sausage": 2,
      "bread": 3,
      "boxed_meal": 7,
      "cookie": 3,
      "yogurt": 2,
      "milk": 11,
      "baking": 3
    },
    "subtypes": [
      "beverage",
      "milk",
      "boxed_meal",
      "candy",
      "sweetener",
      "cheese",
      "bread",
      "cookie",
      "baking",
      "chocolate",
      "sausage",
      "yogurt"
    ],
    "totalObs": 92,
    "source": "usda"
  },
  "signature_kitchens": {
    "displayName": "Signature Kitchens",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 74,
      "beverage": 2,
      "frozen": 15,
      "produce": 1
    },
    "subtypeCounts": {
      "bread": 15,
      "dressing": 8,
      "sauce": 3,
      "beverage": 2,
      "cookie": 13,
      "candy": 8,
      "boxed_meal": 9,
      "ice_cream": 3
    },
    "subtypes": [
      "bread",
      "cookie",
      "boxed_meal",
      "dressing",
      "candy",
      "sauce",
      "ice_cream",
      "beverage"
    ],
    "totalObs": 92,
    "source": "usda"
  },
  "earthbound_farm": {
    "displayName": "Earthbound Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 62,
      "frozen": 22,
      "pantry": 5,
      "meat": 1,
      "beverage": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "beverage": 1
    },
    "subtypes": [
      "boxed_meal",
      "beverage"
    ],
    "totalObs": 91,
    "source": "usda"
  },
  "culinary_circle": {
    "displayName": "Culinary Circle",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 35,
      "pantry": 32,
      "frozen": 21,
      "beverage": 3
    },
    "subtypeCounts": {
      "cheese": 34,
      "boxed_meal": 6,
      "spread": 3,
      "candy": 2,
      "cookie": 5,
      "chocolate": 6,
      "ice_cream": 18,
      "bread": 1,
      "sauce": 3,
      "yogurt": 1,
      "beverage": 3
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "boxed_meal",
      "chocolate",
      "cookie",
      "spread",
      "sauce",
      "beverage",
      "candy",
      "bread",
      "yogurt"
    ],
    "totalObs": 91,
    "source": "usda"
  },
  "old_orchard": {
    "displayName": "Old Orchard",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 91
    },
    "subtypeCounts": {
      "beverage": 91
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 91,
    "source": "usda"
  },
  "hot_pockets": {
    "displayName": "Hot Pockets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 90,
      "dairy": 1
    },
    "subtypeCounts": {
      "boxed_meal": 90
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 91,
    "source": "usda"
  },
  "top_associates": {
    "displayName": "Topco Associates,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 58,
      "frozen": 14,
      "dairy": 9,
      "beverage": 8,
      "produce": 2
    },
    "subtypeCounts": {
      "boxed_meal": 19,
      "cheese": 3,
      "sauce": 6,
      "beverage": 8,
      "bread": 1,
      "candy": 19,
      "milk": 2,
      "yogurt": 3,
      "chocolate": 1,
      "cookie": 12,
      "spread": 2
    },
    "subtypes": [
      "boxed_meal",
      "candy",
      "cookie",
      "beverage",
      "sauce",
      "cheese",
      "yogurt",
      "milk",
      "spread",
      "bread",
      "chocolate"
    ],
    "totalObs": 91,
    "source": "usda"
  },
  "stonewall_kitchen": {
    "displayName": "Stonewall Kitchen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 88,
      "dairy": 2
    },
    "subtypeCounts": {
      "cookie": 2,
      "spread": 38,
      "dressing": 25,
      "sauce": 5,
      "milk": 1,
      "chocolate": 2,
      "cheese": 1
    },
    "subtypes": [
      "spread",
      "dressing",
      "sauce",
      "cookie",
      "chocolate",
      "milk",
      "cheese"
    ],
    "totalObs": 90,
    "source": "usda"
  },
  "fannie_may": {
    "displayName": "Fannie May",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 90
    },
    "subtypeCounts": {
      "chocolate": 72,
      "candy": 18
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 90,
    "source": "usda"
  },
  "saffron_road": {
    "displayName": "Saffron Road",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 50,
      "pantry": 39
    },
    "subtypeCounts": {
      "boxed_meal": 54
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 89,
    "source": "usda"
  },
  "culinaria": {
    "displayName": "Culinaria",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 31,
      "pantry": 41,
      "beverage": 5,
      "dairy": 6,
      "meat": 6
    },
    "subtypeCounts": {
      "ice_cream": 31,
      "chocolate": 16,
      "dressing": 8,
      "beverage": 5,
      "candy": 3,
      "boxed_meal": 6,
      "cheese": 5
    },
    "subtypes": [
      "ice_cream",
      "chocolate",
      "dressing",
      "boxed_meal",
      "beverage",
      "cheese",
      "candy"
    ],
    "totalObs": 89,
    "source": "usda"
  },
  "blue_ribbon_classics": {
    "displayName": "Blue Ribbon Classics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 89
    },
    "subtypeCounts": {
      "ice_cream": 89
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 89,
    "source": "usda"
  },
  "reese": {
    "displayName": "Reese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 89
    },
    "subtypeCounts": {
      "bread": 10,
      "sauce": 5,
      "spread": 3
    },
    "subtypes": [
      "bread",
      "sauce",
      "spread"
    ],
    "totalObs": 89,
    "source": "usda"
  },
  "charms": {
    "displayName": "Charms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 88
    },
    "subtypeCounts": {
      "candy": 88
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 88,
    "source": "usda"
  },
  "clif_kid": {
    "displayName": "Clif Kid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 88
    },
    "subtypeCounts": {
      "candy": 8
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 88,
    "source": "usda"
  },
  "vega": {
    "displayName": "Vega",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 82,
      "dairy": 6
    },
    "subtypeCounts": {
      "yogurt": 5,
      "milk": 1
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 88,
    "source": "usda"
  },
  "ice_mountain": {
    "displayName": "Ice Mountain",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 87
    },
    "subtypeCounts": {
      "beverage": 87
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 87,
    "source": "usda"
  },
  "kens_steak_house": {
    "displayName": "Kens Steak House",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 87
    },
    "subtypeCounts": {
      "dressing": 85,
      "sauce": 2
    },
    "subtypes": [
      "dressing",
      "sauce"
    ],
    "totalObs": 87,
    "source": "usda"
  },
  "special_k": {
    "displayName": "Special K",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 87
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 87,
    "source": "usda"
  },
  "clear_american": {
    "displayName": "Clear American",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 87
    },
    "subtypeCounts": {
      "beverage": 87
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 87,
    "source": "usda"
  },
  "rxbar": {
    "displayName": "Rxbar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 87
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 87,
    "source": "usda"
  },
  "clearly_organic": {
    "displayName": "Clearly Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11,
      "pantry": 64,
      "frozen": 8,
      "dairy": 4
    },
    "subtypeCounts": {
      "beverage": 11,
      "bread": 2,
      "sweetener": 4,
      "spread": 3,
      "dressing": 11,
      "boxed_meal": 8,
      "cheese": 2,
      "cookie": 2,
      "baking": 1,
      "candy": 6,
      "sauce": 3
    },
    "subtypes": [
      "beverage",
      "dressing",
      "boxed_meal",
      "candy",
      "sweetener",
      "spread",
      "sauce",
      "bread",
      "cheese",
      "cookie",
      "baking"
    ],
    "totalObs": 87,
    "source": "usda"
  },
  "arnold": {
    "displayName": "Arnold",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 86
    },
    "subtypeCounts": {
      "bread": 86
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 86,
    "source": "usda"
  },
  "zephyrhills": {
    "displayName": "Zephyrhills",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 86
    },
    "subtypeCounts": {
      "beverage": 86
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 86,
    "source": "usda"
  },
  "ozarka": {
    "displayName": "Ozarka",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 86
    },
    "subtypeCounts": {
      "beverage": 86
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 86,
    "source": "usda"
  },
  "festival": {
    "displayName": "Festival",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 72,
      "beverage": 10,
      "meat": 4
    },
    "subtypeCounts": {
      "chocolate": 3,
      "candy": 5,
      "beverage": 10,
      "sauce": 15,
      "bread": 6,
      "sausage": 4,
      "baking": 1,
      "cookie": 2
    },
    "subtypes": [
      "sauce",
      "beverage",
      "bread",
      "candy",
      "sausage",
      "chocolate",
      "cookie",
      "baking"
    ],
    "totalObs": 86,
    "source": "usda"
  },
  "oreo": {
    "displayName": "Oreo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 83,
      "frozen": 3
    },
    "subtypeCounts": {
      "cookie": 76,
      "ice_cream": 3,
      "candy": 6,
      "chocolate": 1
    },
    "subtypes": [
      "cookie",
      "candy",
      "ice_cream",
      "chocolate"
    ],
    "totalObs": 86,
    "source": "usda"
  },
  "best_yet": {
    "displayName": "Best Yet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 7,
      "pantry": 50,
      "beverage": 16,
      "meat": 1,
      "dairy": 12
    },
    "subtypeCounts": {
      "bread": 3,
      "beverage": 16,
      "candy": 3,
      "boxed_meal": 4,
      "sausage": 1,
      "cheese": 7,
      "sauce": 8,
      "ice_cream": 2,
      "yogurt": 5,
      "dressing": 10,
      "cookie": 4,
      "spread": 1
    },
    "subtypes": [
      "beverage",
      "dressing",
      "sauce",
      "cheese",
      "yogurt",
      "boxed_meal",
      "cookie",
      "bread",
      "candy",
      "ice_cream",
      "sausage",
      "spread"
    ],
    "totalObs": 86,
    "source": "usda"
  },
  "la_yogurt": {
    "displayName": "La Yogurt",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 85
    },
    "subtypeCounts": {
      "yogurt": 84,
      "milk": 1
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 85,
    "source": "usda"
  },
  "evol": {
    "displayName": "Evol.",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 85
    },
    "subtypeCounts": {
      "boxed_meal": 85
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 85,
    "source": "usda"
  },
  "zoneperfect": {
    "displayName": "Zoneperfect",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 85
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 85,
    "source": "usda"
  },
  "papa_johns_salads_produce": {
    "displayName": "Papa John's Salads Produce",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 49,
      "pantry": 10,
      "dairy": 8,
      "meat": 18
    },
    "subtypeCounts": {
      "yogurt": 8,
      "boxed_meal": 18
    },
    "subtypes": [
      "boxed_meal",
      "yogurt"
    ],
    "totalObs": 85,
    "source": "usda"
  },
  "elmer_cho_late": {
    "displayName": "Elmer Chocolate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 84
    },
    "subtypeCounts": {
      "chocolate": 63,
      "candy": 21
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 84,
    "source": "usda"
  },
  "spice_islands": {
    "displayName": "Spice Islands",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 84
    },
    "subtypeCounts": {
      "sauce": 53
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 84,
    "source": "usda"
  },
  "ra": {
    "displayName": "Cora",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 82,
      "dairy": 2
    },
    "subtypeCounts": {
      "cookie": 4,
      "cheese": 2,
      "sauce": 2
    },
    "subtypes": [
      "cookie",
      "cheese",
      "sauce"
    ],
    "totalObs": 84,
    "source": "usda"
  },
  "thomas": {
    "displayName": "Thomas'",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 82,
      "frozen": 1
    },
    "subtypeCounts": {
      "bread": 79,
      "cookie": 1
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 83,
    "source": "usda"
  },
  "lindsay": {
    "displayName": "Lindsay",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 83
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 83,
    "source": "usda"
  },
  "smart_sense": {
    "displayName": "Smart Sense",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 49,
      "dairy": 1,
      "beverage": 33
    },
    "subtypeCounts": {
      "candy": 14,
      "cookie": 10,
      "sweetener": 1,
      "cheese": 1,
      "beverage": 33,
      "sauce": 1
    },
    "subtypes": [
      "beverage",
      "candy",
      "cookie",
      "sweetener",
      "cheese",
      "sauce"
    ],
    "totalObs": 83,
    "source": "usda"
  },
  "voortman_bakery": {
    "displayName": "Voortman Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 82
    },
    "subtypeCounts": {
      "cookie": 81,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 82,
    "source": "usda"
  },
  "sweet_smiles": {
    "displayName": "Sweet Smiles",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 82
    },
    "subtypeCounts": {
      "candy": 75,
      "chocolate": 7
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 82,
    "source": "usda"
  },
  "sun_harvest": {
    "displayName": "Sun Harvest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 42,
      "dairy": 8,
      "beverage": 7,
      "produce": 13,
      "frozen": 10,
      "meat": 2
    },
    "subtypeCounts": {
      "milk": 4,
      "sweetener": 9,
      "baking": 1,
      "beverage": 7,
      "candy": 1,
      "cookie": 1,
      "dressing": 6,
      "boxed_meal": 5,
      "spread": 10,
      "sausage": 2
    },
    "subtypes": [
      "spread",
      "sweetener",
      "beverage",
      "dressing",
      "boxed_meal",
      "milk",
      "sausage",
      "baking",
      "candy",
      "cookie"
    ],
    "totalObs": 82,
    "source": "usda"
  },
  "nob_hill_trading": {
    "displayName": "Nob Hill Trading",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 57,
      "frozen": 4,
      "meat": 1,
      "dairy": 20
    },
    "subtypeCounts": {
      "spread": 12,
      "boxed_meal": 5,
      "cheese": 20,
      "dressing": 14,
      "cookie": 1,
      "baking": 1
    },
    "subtypes": [
      "cheese",
      "dressing",
      "spread",
      "boxed_meal",
      "cookie",
      "baking"
    ],
    "totalObs": 82,
    "source": "usda"
  },
  "crunch": {
    "displayName": "Crunch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 79,
      "frozen": 2
    },
    "subtypeCounts": {
      "chocolate": 46,
      "ice_cream": 2,
      "candy": 26,
      "cookie": 7
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie",
      "ice_cream"
    ],
    "totalObs": 81,
    "source": "usda"
  },
  "land_o_lakes": {
    "displayName": "Land O Lakes",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 79,
      "pantry": 1,
      "frozen": 1
    },
    "subtypeCounts": {
      "cheese": 51,
      "milk": 23,
      "sauce": 1,
      "yogurt": 3,
      "ice_cream": 1
    },
    "subtypes": [
      "cheese",
      "milk",
      "yogurt",
      "sauce",
      "ice_cream"
    ],
    "totalObs": 81,
    "source": "usda"
  },
  "haggen": {
    "displayName": "Haggen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 63,
      "beverage": 8,
      "dairy": 1,
      "frozen": 9
    },
    "subtypeCounts": {
      "sweetener": 1,
      "sauce": 3,
      "beverage": 8,
      "spread": 9,
      "baking": 1,
      "cheese": 1,
      "boxed_meal": 2
    },
    "subtypes": [
      "spread",
      "beverage",
      "sauce",
      "boxed_meal",
      "sweetener",
      "baking",
      "cheese"
    ],
    "totalObs": 81,
    "source": "usda"
  },
  "bimbo_bakeries": {
    "displayName": "Bimbo Bakeries ,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 80,
      "frozen": 1
    },
    "subtypeCounts": {
      "bread": 70,
      "cookie": 11
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 81,
    "source": "usda"
  },
  "boars_head": {
    "displayName": "Boar's Head",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 52,
      "pantry": 21,
      "meat": 8
    },
    "subtypeCounts": {
      "cheese": 52,
      "sausage": 6,
      "dressing": 5,
      "boxed_meal": 2
    },
    "subtypes": [
      "cheese",
      "sausage",
      "dressing",
      "boxed_meal"
    ],
    "totalObs": 81,
    "source": "usda"
  },
  "zatarains": {
    "displayName": "Zatarain's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 58,
      "frozen": 22
    },
    "subtypeCounts": {
      "boxed_meal": 22,
      "sauce": 42,
      "baking": 1
    },
    "subtypes": [
      "sauce",
      "boxed_meal",
      "baking"
    ],
    "totalObs": 80,
    "source": "usda"
  },
  "suja": {
    "displayName": "Suja",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 80
    },
    "subtypeCounts": {
      "beverage": 80
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 80,
    "source": "usda"
  },
  "manischewitz": {
    "displayName": "Manischewitz",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 79,
      "frozen": 1
    },
    "subtypeCounts": {
      "cookie": 25,
      "bread": 1,
      "chocolate": 7,
      "boxed_meal": 16,
      "candy": 10,
      "sauce": 1,
      "dressing": 2,
      "baking": 1,
      "sweetener": 1
    },
    "subtypes": [
      "cookie",
      "boxed_meal",
      "candy",
      "chocolate",
      "dressing",
      "bread",
      "sauce",
      "baking",
      "sweetener"
    ],
    "totalObs": 80,
    "source": "usda"
  },
  "hudsonville": {
    "displayName": "Hudsonville",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 80
    },
    "subtypeCounts": {
      "ice_cream": 80
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 80,
    "source": "usda"
  },
  "enjoy_life": {
    "displayName": "Enjoy Life",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 80
    },
    "subtypeCounts": {
      "cookie": 25,
      "chocolate": 16,
      "baking": 1,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "chocolate",
      "baking",
      "candy"
    ],
    "totalObs": 80,
    "source": "usda"
  },
  "nugo": {
    "displayName": "Nugo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 80
    },
    "subtypeCounts": {
      "chocolate": 4,
      "cookie": 14
    },
    "subtypes": [
      "cookie",
      "chocolate"
    ],
    "totalObs": 80,
    "source": "usda"
  },
  "hormel": {
    "displayName": "Hormel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 41,
      "pantry": 26,
      "dairy": 3,
      "frozen": 7,
      "produce": 2,
      "beverage": 1
    },
    "subtypeCounts": {
      "sausage": 41,
      "dressing": 19,
      "cheese": 3,
      "boxed_meal": 7,
      "sauce": 2,
      "bread": 1,
      "candy": 1,
      "beverage": 1,
      "baking": 1
    },
    "subtypes": [
      "sausage",
      "dressing",
      "boxed_meal",
      "cheese",
      "sauce",
      "bread",
      "candy",
      "beverage",
      "baking"
    ],
    "totalObs": 80,
    "source": "usda"
  },
  "knorr": {
    "displayName": "Knorr",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 79
    },
    "subtypeCounts": {
      "boxed_meal": 4,
      "sauce": 74
    },
    "subtypes": [
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 79,
    "source": "usda"
  },
  "kitkat": {
    "displayName": "Kitkat",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 79
    },
    "subtypeCounts": {
      "cookie": 21,
      "candy": 41,
      "chocolate": 17
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate"
    ],
    "totalObs": 79,
    "source": "usda"
  },
  "tropical": {
    "displayName": "Tropical",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 4,
      "dairy": 71,
      "beverage": 4
    },
    "subtypeCounts": {
      "spread": 3,
      "milk": 7,
      "yogurt": 8,
      "cheese": 56,
      "beverage": 4
    },
    "subtypes": [
      "cheese",
      "yogurt",
      "milk",
      "beverage",
      "spread"
    ],
    "totalObs": 79,
    "source": "usda"
  },
  "banquet": {
    "displayName": "Banquet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 78,
      "pantry": 1
    },
    "subtypeCounts": {
      "boxed_meal": 78,
      "dressing": 1
    },
    "subtypes": [
      "boxed_meal",
      "dressing"
    ],
    "totalObs": 79,
    "source": "usda"
  },
  "nancys": {
    "displayName": "Nancy's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 74,
      "frozen": 5
    },
    "subtypeCounts": {
      "yogurt": 65,
      "cheese": 6,
      "milk": 3,
      "bread": 2,
      "boxed_meal": 3
    },
    "subtypes": [
      "yogurt",
      "cheese",
      "milk",
      "boxed_meal",
      "bread"
    ],
    "totalObs": 79,
    "source": "usda"
  },
  "centrella": {
    "displayName": "Centrella",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 65,
      "dairy": 10,
      "frozen": 2,
      "meat": 1,
      "beverage": 1
    },
    "subtypeCounts": {
      "sauce": 9,
      "boxed_meal": 1,
      "cheese": 8,
      "dressing": 8,
      "bread": 10,
      "sweetener": 2,
      "sausage": 1,
      "ice_cream": 1,
      "milk": 2,
      "beverage": 1
    },
    "subtypes": [
      "bread",
      "sauce",
      "cheese",
      "dressing",
      "sweetener",
      "milk",
      "boxed_meal",
      "sausage",
      "ice_cream",
      "beverage"
    ],
    "totalObs": 79,
    "source": "usda"
  },
  "philadelphia": {
    "displayName": "Philadelphia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 77,
      "frozen": 1
    },
    "subtypeCounts": {
      "cheese": 76,
      "bread": 1,
      "milk": 1
    },
    "subtypes": [
      "cheese",
      "bread",
      "milk"
    ],
    "totalObs": 78,
    "source": "usda"
  },
  "lenny_larrys": {
    "displayName": "Lenny & Larry's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 78
    },
    "subtypeCounts": {
      "cookie": 78
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 78,
    "source": "usda"
  },
  "7_eleven": {
    "displayName": "7-eleven",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 2,
      "pantry": 62,
      "dairy": 7,
      "beverage": 1,
      "frozen": 3,
      "meat": 3
    },
    "subtypeCounts": {
      "cookie": 22,
      "candy": 27,
      "cheese": 4,
      "chocolate": 2,
      "bread": 1,
      "beverage": 1,
      "ice_cream": 3,
      "boxed_meal": 3,
      "yogurt": 3
    },
    "subtypes": [
      "candy",
      "cookie",
      "cheese",
      "ice_cream",
      "boxed_meal",
      "yogurt",
      "chocolate",
      "bread",
      "beverage"
    ],
    "totalObs": 78,
    "source": "usda"
  },
  "fage": {
    "displayName": "Fage",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 77
    },
    "subtypeCounts": {
      "yogurt": 74,
      "milk": 3
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 77,
    "source": "usda"
  },
  "tostitos": {
    "displayName": "Tostitos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 70,
      "dairy": 7
    },
    "subtypeCounts": {
      "cheese": 7
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 77,
    "source": "usda"
  },
  "maud_borup": {
    "displayName": "Maud Borup",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 77
    },
    "subtypeCounts": {
      "candy": 64,
      "chocolate": 13
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 77,
    "source": "usda"
  },
  "cravn_flavor": {
    "displayName": "Crav'n Flavor",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 46,
      "pantry": 30
    },
    "subtypeCounts": {
      "boxed_meal": 46,
      "cookie": 29,
      "candy": 1
    },
    "subtypes": [
      "boxed_meal",
      "cookie",
      "candy"
    ],
    "totalObs": 76,
    "source": "usda"
  },
  "white_rose": {
    "displayName": "White Rose",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 37,
      "pantry": 15,
      "frozen": 14,
      "produce": 1,
      "beverage": 9
    },
    "subtypeCounts": {
      "cheese": 27,
      "yogurt": 1,
      "dressing": 4,
      "spread": 2,
      "beverage": 9,
      "milk": 7,
      "ice_cream": 1,
      "bread": 1,
      "sauce": 1
    },
    "subtypes": [
      "cheese",
      "beverage",
      "milk",
      "dressing",
      "spread",
      "yogurt",
      "ice_cream",
      "bread",
      "sauce"
    ],
    "totalObs": 76,
    "source": "usda"
  },
  "sadaf": {
    "displayName": "Sadaf",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 59,
      "beverage": 4,
      "frozen": 10,
      "produce": 3
    },
    "subtypeCounts": {
      "cookie": 4,
      "spread": 3,
      "sauce": 7,
      "beverage": 4,
      "boxed_meal": 3,
      "baking": 1,
      "dressing": 3,
      "sweetener": 2
    },
    "subtypes": [
      "sauce",
      "cookie",
      "beverage",
      "spread",
      "boxed_meal",
      "dressing",
      "sweetener",
      "baking"
    ],
    "totalObs": 76,
    "source": "usda"
  },
  "save_mart_supermarkets": {
    "displayName": "Save Mart Supermarkets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 70,
      "beverage": 5,
      "dairy": 1
    },
    "subtypeCounts": {
      "sauce": 8,
      "dressing": 3,
      "boxed_meal": 6,
      "chocolate": 9,
      "sweetener": 3,
      "beverage": 5,
      "bread": 4,
      "yogurt": 1,
      "spread": 1
    },
    "subtypes": [
      "chocolate",
      "sauce",
      "boxed_meal",
      "beverage",
      "bread",
      "dressing",
      "sweetener",
      "yogurt",
      "spread"
    ],
    "totalObs": 76,
    "source": "usda"
  },
  "dutch_farms": {
    "displayName": "Dutch Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 62,
      "meat": 5,
      "pantry": 5,
      "frozen": 3,
      "beverage": 1
    },
    "subtypeCounts": {
      "milk": 6,
      "cheese": 52,
      "sausage": 5,
      "bread": 5,
      "boxed_meal": 3,
      "beverage": 1,
      "yogurt": 1
    },
    "subtypes": [
      "cheese",
      "milk",
      "sausage",
      "bread",
      "boxed_meal",
      "beverage",
      "yogurt"
    ],
    "totalObs": 76,
    "source": "usda"
  },
  "thinkthin": {
    "displayName": "Thinkthin",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 76
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 76,
    "source": "usda"
  },
  "fairway": {
    "displayName": "Fairway",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 7,
      "pantry": 48,
      "beverage": 9,
      "dairy": 8,
      "frozen": 3
    },
    "subtypeCounts": {
      "cookie": 6,
      "beverage": 9,
      "boxed_meal": 1,
      "cheese": 3,
      "chocolate": 10,
      "spread": 4,
      "candy": 13,
      "milk": 4,
      "ice_cream": 2
    },
    "subtypes": [
      "candy",
      "chocolate",
      "beverage",
      "cookie",
      "spread",
      "milk",
      "cheese",
      "ice_cream",
      "boxed_meal"
    ],
    "totalObs": 75,
    "source": "usda"
  },
  "pez": {
    "displayName": "Pez",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 75
    },
    "subtypeCounts": {
      "candy": 75
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 75,
    "source": "usda"
  },
  "mario": {
    "displayName": "Mario",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 75
    },
    "subtypeCounts": {
      "dressing": 2
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 75,
    "source": "usda"
  },
  "renaissance_food": {
    "displayName": "Renaissance Food",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 9,
      "produce": 47,
      "pantry": 13,
      "meat": 4,
      "frozen": 1
    },
    "subtypeCounts": {
      "yogurt": 9,
      "boxed_meal": 4,
      "dressing": 1
    },
    "subtypes": [
      "yogurt",
      "boxed_meal",
      "dressing"
    ],
    "totalObs": 74,
    "source": "usda"
  },
  "star_wars": {
    "displayName": "Star Wars",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 71,
      "dairy": 2,
      "frozen": 1
    },
    "subtypeCounts": {
      "candy": 59,
      "cookie": 2,
      "chocolate": 10,
      "cheese": 1,
      "yogurt": 1,
      "ice_cream": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie",
      "cheese",
      "yogurt",
      "ice_cream"
    ],
    "totalObs": 74,
    "source": "usda"
  },
  "giovanni_rana": {
    "displayName": "Giovanni Rana",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 73
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 73,
    "source": "usda"
  },
  "allens": {
    "displayName": "Allens",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 70,
      "frozen": 2,
      "meat": 1
    },
    "subtypeCounts": {
      "boxed_meal": 3
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 73,
    "source": "usda"
  },
  "president": {
    "displayName": "President",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 73
    },
    "subtypeCounts": {
      "cheese": 73
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 73,
    "source": "usda"
  },
  "twix": {
    "displayName": "Twix",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 61,
      "frozen": 12
    },
    "subtypeCounts": {
      "candy": 35,
      "chocolate": 18,
      "ice_cream": 12,
      "cookie": 8
    },
    "subtypes": [
      "candy",
      "chocolate",
      "ice_cream",
      "cookie"
    ],
    "totalObs": 73,
    "source": "usda"
  },
  "enlightened": {
    "displayName": "Enlightened",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 57,
      "pantry": 16
    },
    "subtypeCounts": {
      "ice_cream": 57
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 73,
    "source": "usda"
  },
  "divina": {
    "displayName": "Divina",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 73
    },
    "subtypeCounts": {
      "spread": 5,
      "bread": 5
    },
    "subtypes": [
      "spread",
      "bread"
    ],
    "totalObs": 73,
    "source": "usda"
  },
  "juicy_juice": {
    "displayName": "Juicy Juice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 67,
      "frozen": 4,
      "pantry": 2
    },
    "subtypeCounts": {
      "beverage": 67,
      "ice_cream": 4,
      "candy": 2
    },
    "subtypes": [
      "beverage",
      "ice_cream",
      "candy"
    ],
    "totalObs": 73,
    "source": "usda"
  },
  "brown_haley": {
    "displayName": "Brown & Haley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 72
    },
    "subtypeCounts": {
      "candy": 61,
      "chocolate": 8,
      "cookie": 2
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 72,
    "source": "usda"
  },
  "dietz_watson": {
    "displayName": "Dietz & Watson",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 56,
      "pantry": 13,
      "meat": 3
    },
    "subtypeCounts": {
      "cheese": 56,
      "dressing": 4,
      "sausage": 3
    },
    "subtypes": [
      "cheese",
      "dressing",
      "sausage"
    ],
    "totalObs": 72,
    "source": "usda"
  },
  "jays": {
    "displayName": "Jays",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 72
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 72,
    "source": "usda"
  },
  "supervalu": {
    "displayName": "Supervalu",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34,
      "beverage": 9,
      "frozen": 2,
      "meat": 1,
      "dairy": 26
    },
    "subtypeCounts": {
      "chocolate": 4,
      "beverage": 9,
      "cookie": 1,
      "candy": 11,
      "boxed_meal": 3,
      "sausage": 1,
      "sauce": 2,
      "dressing": 2,
      "cheese": 12
    },
    "subtypes": [
      "cheese",
      "candy",
      "beverage",
      "chocolate",
      "boxed_meal",
      "sauce",
      "dressing",
      "cookie",
      "sausage"
    ],
    "totalObs": 72,
    "source": "usda"
  },
  "tropicana": {
    "displayName": "Tropicana",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 70,
      "produce": 1
    },
    "subtypeCounts": {
      "beverage": 70
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 71,
    "source": "usda"
  },
  "hy_vee_select": {
    "displayName": "Hy-vee Select",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31,
      "dairy": 22,
      "beverage": 2,
      "frozen": 16
    },
    "subtypeCounts": {
      "cheese": 20,
      "beverage": 2,
      "sauce": 2,
      "ice_cream": 1,
      "yogurt": 2,
      "dressing": 9,
      "boxed_meal": 1
    },
    "subtypes": [
      "cheese",
      "dressing",
      "beverage",
      "sauce",
      "yogurt",
      "ice_cream",
      "boxed_meal"
    ],
    "totalObs": 71,
    "source": "usda"
  },
  "sparkling_ice": {
    "displayName": "Sparkling Ice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 71
    },
    "subtypeCounts": {
      "beverage": 71
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 71,
    "source": "usda"
  },
  "sunrise": {
    "displayName": "Sunrise",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 70,
      "produce": 1
    },
    "subtypeCounts": {
      "candy": 66
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 71,
    "source": "usda"
  },
  "epic": {
    "displayName": "Epic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 66,
      "dairy": 4,
      "beverage": 1
    },
    "subtypeCounts": {
      "dressing": 2,
      "cheese": 4,
      "beverage": 1,
      "boxed_meal": 6
    },
    "subtypes": [
      "boxed_meal",
      "cheese",
      "dressing",
      "beverage"
    ],
    "totalObs": 71,
    "source": "usda"
  },
  "laffy_taffy": {
    "displayName": "Laffy Taffy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 70
    },
    "subtypeCounts": {
      "candy": 70
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 70,
    "source": "usda"
  },
  "burn_farms": {
    "displayName": "Burn Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 70
    },
    "subtypeCounts": {
      "yogurt": 22,
      "cheese": 39,
      "milk": 9
    },
    "subtypes": [
      "cheese",
      "yogurt",
      "milk"
    ],
    "totalObs": 70,
    "source": "usda"
  },
  "life_savers": {
    "displayName": "Life Savers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 70
    },
    "subtypeCounts": {
      "candy": 70
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 70,
    "source": "usda"
  },
  "weber": {
    "displayName": "Weber",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 70
    },
    "subtypeCounts": {
      "sauce": 63
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 70,
    "source": "usda"
  },
  "nickelodeon": {
    "displayName": "Nickelodeon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 2,
      "frozen": 5,
      "pantry": 62,
      "dairy": 1
    },
    "subtypeCounts": {
      "ice_cream": 4,
      "candy": 52,
      "chocolate": 6,
      "cookie": 3,
      "boxed_meal": 1,
      "cheese": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "ice_cream",
      "cookie",
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 70,
    "source": "usda"
  },
  "urban_accents": {
    "displayName": "Urban Accents",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 69
    },
    "subtypeCounts": {
      "sauce": 54
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 69,
    "source": "usda"
  },
  "talenti": {
    "displayName": "Talenti",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 69
    },
    "subtypeCounts": {
      "ice_cream": 69
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 69,
    "source": "usda"
  },
  "whitmans": {
    "displayName": "Whitman's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 69
    },
    "subtypeCounts": {
      "chocolate": 56,
      "candy": 13
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 69,
    "source": "usda"
  },
  "sugar_n_spice": {
    "displayName": "Sugar N Spice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 68,
      "produce": 1
    },
    "subtypeCounts": {
      "candy": 1,
      "sauce": 3
    },
    "subtypes": [
      "sauce",
      "candy"
    ],
    "totalObs": 69,
    "source": "usda"
  },
  "apple_eve": {
    "displayName": "Apple & Eve",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 69
    },
    "subtypeCounts": {
      "beverage": 69
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 69,
    "source": "usda"
  },
  "schnuck_markets": {
    "displayName": "Schnuck Markets,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 33,
      "frozen": 9,
      "dairy": 20,
      "beverage": 3,
      "meat": 4
    },
    "subtypeCounts": {
      "boxed_meal": 8,
      "bread": 6,
      "sweetener": 8,
      "dressing": 4,
      "sauce": 2,
      "cheese": 2,
      "candy": 2,
      "beverage": 3,
      "ice_cream": 1,
      "yogurt": 8
    },
    "subtypes": [
      "boxed_meal",
      "sweetener",
      "yogurt",
      "bread",
      "dressing",
      "beverage",
      "sauce",
      "cheese",
      "candy",
      "ice_cream"
    ],
    "totalObs": 69,
    "source": "usda"
  },
  "r_w_knudsen_family": {
    "displayName": "R-w-knudsen Family",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 68,
      "pantry": 1
    },
    "subtypeCounts": {
      "beverage": 68
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 69,
    "source": "usda"
  },
  "food_city": {
    "displayName": "Food City",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28,
      "dairy": 11,
      "meat": 6,
      "frozen": 24
    },
    "subtypeCounts": {
      "baking": 1,
      "sauce": 5,
      "cookie": 8,
      "bread": 10,
      "milk": 11,
      "sausage": 6,
      "ice_cream": 23
    },
    "subtypes": [
      "ice_cream",
      "milk",
      "bread",
      "cookie",
      "sausage",
      "sauce",
      "baking"
    ],
    "totalObs": 69,
    "source": "usda"
  },
  "bertolli": {
    "displayName": "Bertolli",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 4,
      "frozen": 65
    },
    "subtypeCounts": {
      "boxed_meal": 65
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 69,
    "source": "usda"
  },
  "shamrock_farms": {
    "displayName": "Shamrock Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 69
    },
    "subtypeCounts": {
      "milk": 61,
      "cheese": 8
    },
    "subtypes": [
      "milk",
      "cheese"
    ],
    "totalObs": 69,
    "source": "usda"
  },
  "cadbury": {
    "displayName": "Cadbury",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 69
    },
    "subtypeCounts": {
      "cookie": 23,
      "candy": 15,
      "chocolate": 31
    },
    "subtypes": [
      "chocolate",
      "cookie",
      "candy"
    ],
    "totalObs": 69,
    "source": "usda"
  },
  "minute_maid": {
    "displayName": "Minute Maid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 68,
      "frozen": 1
    },
    "subtypeCounts": {
      "beverage": 68,
      "ice_cream": 1
    },
    "subtypes": [
      "beverage",
      "ice_cream"
    ],
    "totalObs": 69,
    "source": "usda"
  },
  "resers_fine": {
    "displayName": "Reser's Fine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 29,
      "meat": 26,
      "produce": 3,
      "dairy": 3,
      "frozen": 7
    },
    "subtypeCounts": {
      "boxed_meal": 33,
      "cheese": 3
    },
    "subtypes": [
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 68,
    "source": "usda"
  },
  "fresh_gourmet": {
    "displayName": "Fresh Gourmet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 65,
      "produce": 2,
      "dairy": 1
    },
    "subtypeCounts": {
      "dressing": 39,
      "bread": 22,
      "cheese": 1
    },
    "subtypes": [
      "dressing",
      "bread",
      "cheese"
    ],
    "totalObs": 68,
    "source": "usda"
  },
  "tootsie": {
    "displayName": "Tootsie",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 68
    },
    "subtypeCounts": {
      "candy": 67,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 68,
    "source": "usda"
  },
  "perrier": {
    "displayName": "Perrier",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 68
    },
    "subtypeCounts": {
      "beverage": 68
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 68,
    "source": "usda"
  },
  "edys": {
    "displayName": "Edy's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 68
    },
    "subtypeCounts": {
      "ice_cream": 68
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 68,
    "source": "usda"
  },
  "ease": {
    "displayName": "@ease",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 67
    },
    "subtypeCounts": {
      "boxed_meal": 60
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 67,
    "source": "usda"
  },
  "sunny_d": {
    "displayName": "Sunny D",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 65,
      "frozen": 2
    },
    "subtypeCounts": {
      "beverage": 65,
      "ice_cream": 2
    },
    "subtypes": [
      "beverage",
      "ice_cream"
    ],
    "totalObs": 67,
    "source": "usda"
  },
  "weis_markets": {
    "displayName": "Weis Markets,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 59,
      "frozen": 5,
      "dairy": 2,
      "meat": 1
    },
    "subtypeCounts": {
      "candy": 36,
      "ice_cream": 1,
      "chocolate": 3,
      "cheese": 2,
      "bread": 2,
      "cookie": 4,
      "boxed_meal": 5,
      "spread": 2
    },
    "subtypes": [
      "candy",
      "boxed_meal",
      "cookie",
      "chocolate",
      "cheese",
      "bread",
      "spread",
      "ice_cream"
    ],
    "totalObs": 67,
    "source": "usda"
  },
  "fresh_express": {
    "displayName": "Fresh Express",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 8,
      "produce": 59
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 67,
    "source": "usda"
  },
  "market_essentials": {
    "displayName": "Market Essentials",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 61,
      "beverage": 1,
      "dairy": 5
    },
    "subtypeCounts": {
      "sauce": 7,
      "dressing": 3,
      "candy": 7,
      "sweetener": 1,
      "beverage": 1,
      "cheese": 4,
      "boxed_meal": 11,
      "cookie": 5
    },
    "subtypes": [
      "boxed_meal",
      "sauce",
      "candy",
      "cookie",
      "cheese",
      "dressing",
      "sweetener",
      "beverage"
    ],
    "totalObs": 67,
    "source": "usda"
  },
  "eatz": {
    "displayName": "Eatz",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 63,
      "dairy": 3
    },
    "subtypeCounts": {
      "cookie": 36,
      "cheese": 3
    },
    "subtypes": [
      "cookie",
      "cheese"
    ],
    "totalObs": 66,
    "source": "usda"
  },
  "skinny_w": {
    "displayName": "Skinnyw",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 41,
      "pantry": 25
    },
    "subtypeCounts": {
      "ice_cream": 41,
      "candy": 10,
      "chocolate": 14,
      "cookie": 1
    },
    "subtypes": [
      "ice_cream",
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 66,
    "source": "usda"
  },
  "nerds": {
    "displayName": "Nerds",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 66
    },
    "subtypeCounts": {
      "candy": 66
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 66,
    "source": "usda"
  },
  "clear_value": {
    "displayName": "Clear Value",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 49,
      "dairy": 5,
      "frozen": 11,
      "beverage": 1
    },
    "subtypeCounts": {
      "dressing": 3,
      "sauce": 3,
      "boxed_meal": 1,
      "candy": 25,
      "chocolate": 1,
      "cookie": 8,
      "milk": 4,
      "ice_cream": 7,
      "sweetener": 2,
      "baking": 1,
      "beverage": 1
    },
    "subtypes": [
      "candy",
      "cookie",
      "ice_cream",
      "milk",
      "dressing",
      "sauce",
      "sweetener",
      "boxed_meal",
      "chocolate",
      "baking",
      "beverage"
    ],
    "totalObs": 66,
    "source": "usda"
  },
  "lavita": {
    "displayName": "Colavita",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 65
    },
    "subtypeCounts": {
      "sauce": 1,
      "dressing": 1
    },
    "subtypes": [
      "sauce",
      "dressing"
    ],
    "totalObs": 65,
    "source": "usda"
  },
  "michael_angelos": {
    "displayName": "Michael Angelo's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 64,
      "pantry": 1
    },
    "subtypeCounts": {
      "boxed_meal": 64
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 65,
    "source": "usda"
  },
  "golden_flake": {
    "displayName": "Golden Flake",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 65
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 65,
    "source": "usda"
  },
  "dole_fresh": {
    "displayName": "Dole Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 64,
      "frozen": 1
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 65,
    "source": "usda"
  },
  "pinnacle": {
    "displayName": "Pinnacle",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 46,
      "pantry": 19
    },
    "subtypeCounts": {
      "boxed_meal": 25,
      "bread": 8,
      "sauce": 1,
      "dressing": 2
    },
    "subtypes": [
      "boxed_meal",
      "bread",
      "dressing",
      "sauce"
    ],
    "totalObs": 65,
    "source": "usda"
  },
  "noosa": {
    "displayName": "Noosa",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 65
    },
    "subtypeCounts": {
      "yogurt": 64,
      "milk": 1
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 65,
    "source": "usda"
  },
  "cadia": {
    "displayName": "Cadia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10,
      "pantry": 37,
      "frozen": 10,
      "dairy": 8
    },
    "subtypeCounts": {
      "beverage": 10,
      "boxed_meal": 5,
      "baking": 1,
      "cookie": 8,
      "ice_cream": 3,
      "cheese": 8,
      "sweetener": 3,
      "spread": 3
    },
    "subtypes": [
      "beverage",
      "cookie",
      "cheese",
      "boxed_meal",
      "ice_cream",
      "sweetener",
      "spread",
      "baking"
    ],
    "totalObs": 65,
    "source": "usda"
  },
  "field_day": {
    "displayName": "Field Day",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 52,
      "produce": 1,
      "beverage": 12
    },
    "subtypeCounts": {
      "sauce": 4,
      "dressing": 6,
      "cookie": 2,
      "beverage": 12,
      "spread": 4,
      "boxed_meal": 6
    },
    "subtypes": [
      "beverage",
      "dressing",
      "boxed_meal",
      "sauce",
      "spread",
      "cookie"
    ],
    "totalObs": 65,
    "source": "usda"
  },
  "siggis": {
    "displayName": "Siggi's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 64
    },
    "subtypeCounts": {
      "yogurt": 64
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 64,
    "source": "usda"
  },
  "pride_of_india": {
    "displayName": "Pride Of India",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 64
    },
    "subtypeCounts": {
      "sauce": 16
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 64,
    "source": "usda"
  },
  "lance": {
    "displayName": "Lance",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 64
    },
    "subtypeCounts": {
      "cookie": 60,
      "candy": 2
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 64,
    "source": "usda"
  },
  "eat_smart": {
    "displayName": "Eat Smart",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 52,
      "pantry": 8,
      "meat": 3,
      "frozen": 1
    },
    "subtypeCounts": {
      "dressing": 2,
      "boxed_meal": 3
    },
    "subtypes": [
      "boxed_meal",
      "dressing"
    ],
    "totalObs": 64,
    "source": "usda"
  },
  "uncle_rays": {
    "displayName": "Uncle Rays",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 64
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 64,
    "source": "usda"
  },
  "bg": {
    "displayName": "B&g",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 63
    },
    "subtypeCounts": {
      "sauce": 3,
      "boxed_meal": 1,
      "spread": 1
    },
    "subtypes": [
      "sauce",
      "boxed_meal",
      "spread"
    ],
    "totalObs": 63,
    "source": "usda"
  },
  "frigo": {
    "displayName": "Frigo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 63
    },
    "subtypeCounts": {
      "cheese": 63
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 63,
    "source": "usda"
  },
  "galbani": {
    "displayName": "Galbani",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 63
    },
    "subtypeCounts": {
      "cheese": 63
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 63,
    "source": "usda"
  },
  "mike_and_ike": {
    "displayName": "Mike And Ike",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 63
    },
    "subtypeCounts": {
      "candy": 63
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 63,
    "source": "usda"
  },
  "sweet_ps_bake_shop": {
    "displayName": "Sweet P's Bake Shop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 63
    },
    "subtypeCounts": {
      "cookie": 63
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 63,
    "source": "usda"
  },
  "bell_view": {
    "displayName": "Bell-view",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 62,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1,
      "spread": 9,
      "dressing": 1
    },
    "subtypes": [
      "spread",
      "cheese",
      "dressing"
    ],
    "totalObs": 63,
    "source": "usda"
  },
  "north_star": {
    "displayName": "North Star",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 57,
      "pantry": 3,
      "dairy": 3
    },
    "subtypeCounts": {
      "ice_cream": 57,
      "candy": 1,
      "milk": 3
    },
    "subtypes": [
      "ice_cream",
      "milk",
      "candy"
    ],
    "totalObs": 63,
    "source": "usda"
  },
  "woodstock": {
    "displayName": "Woodstock",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22,
      "frozen": 40,
      "produce": 1
    },
    "subtypeCounts": {
      "dressing": 5,
      "boxed_meal": 3
    },
    "subtypes": [
      "dressing",
      "boxed_meal"
    ],
    "totalObs": 63,
    "source": "usda"
  },
  "foodtown": {
    "displayName": "Foodtown",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30,
      "dairy": 23,
      "frozen": 8,
      "beverage": 2
    },
    "subtypeCounts": {
      "bread": 1,
      "cheese": 12,
      "sauce": 6,
      "candy": 1,
      "ice_cream": 8,
      "yogurt": 9,
      "milk": 2,
      "dressing": 5,
      "beverage": 2,
      "spread": 8
    },
    "subtypes": [
      "cheese",
      "yogurt",
      "ice_cream",
      "spread",
      "sauce",
      "dressing",
      "milk",
      "beverage",
      "bread",
      "candy"
    ],
    "totalObs": 63,
    "source": "usda"
  },
  "hellmanns": {
    "displayName": "Hellmann's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 61,
      "meat": 1
    },
    "subtypeCounts": {
      "dressing": 60,
      "boxed_meal": 1
    },
    "subtypes": [
      "dressing",
      "boxed_meal"
    ],
    "totalObs": 62,
    "source": "usda"
  },
  "storck": {
    "displayName": "Storck",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 62
    },
    "subtypeCounts": {
      "chocolate": 16,
      "candy": 44,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 62,
    "source": "usda"
  },
  "perrys_ice_cream": {
    "displayName": "Perry's Ice Cream",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 62
    },
    "subtypeCounts": {
      "ice_cream": 62
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 62,
    "source": "usda"
  },
  "value_rner": {
    "displayName": "Value Corner",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 20,
      "pantry": 36,
      "beverage": 1,
      "frozen": 5
    },
    "subtypeCounts": {
      "milk": 17,
      "cookie": 14,
      "bread": 8,
      "beverage": 1,
      "sweetener": 1,
      "dressing": 4,
      "ice_cream": 1,
      "spread": 2,
      "cheese": 2,
      "sauce": 1
    },
    "subtypes": [
      "milk",
      "cookie",
      "bread",
      "dressing",
      "spread",
      "cheese",
      "beverage",
      "sweetener",
      "ice_cream",
      "sauce"
    ],
    "totalObs": 62,
    "source": "usda"
  },
  "belvita": {
    "displayName": "Belvita",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 62
    },
    "subtypeCounts": {
      "cookie": 56
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 62,
    "source": "usda"
  },
  "boulder_canyon": {
    "displayName": "Boulder Canyon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 61,
      "frozen": 1
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 62,
    "source": "usda"
  },
  "good_health": {
    "displayName": "Good Health",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 62
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 62,
    "source": "usda"
  },
  "brownberry": {
    "displayName": "Brownberry",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 62
    },
    "subtypeCounts": {
      "bread": 62
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 62,
    "source": "usda"
  },
  "cracker_barrel": {
    "displayName": "Cracker Barrel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 61,
      "frozen": 1
    },
    "subtypeCounts": {
      "cheese": 61,
      "boxed_meal": 1
    },
    "subtypes": [
      "cheese",
      "boxed_meal"
    ],
    "totalObs": 62,
    "source": "usda"
  },
  "simply_organic": {
    "displayName": "Simply Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 62
    },
    "subtypeCounts": {
      "sauce": 47,
      "dressing": 3
    },
    "subtypes": [
      "sauce",
      "dressing"
    ],
    "totalObs": 62,
    "source": "usda"
  },
  "kashi": {
    "displayName": "Kashi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 46,
      "frozen": 16
    },
    "subtypeCounts": {
      "boxed_meal": 16
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 62,
    "source": "usda"
  },
  "popsicle": {
    "displayName": "Popsicle",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 60,
      "pantry": 1
    },
    "subtypeCounts": {
      "ice_cream": 60,
      "candy": 1
    },
    "subtypes": [
      "ice_cream",
      "candy"
    ],
    "totalObs": 61,
    "source": "usda"
  },
  "el_mexicano": {
    "displayName": "El Mexicano",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 38,
      "pantry": 18,
      "beverage": 5
    },
    "subtypeCounts": {
      "yogurt": 13,
      "milk": 4,
      "cheese": 21,
      "cookie": 7,
      "sauce": 3,
      "candy": 2,
      "beverage": 5,
      "baking": 1,
      "sweetener": 1
    },
    "subtypes": [
      "cheese",
      "yogurt",
      "cookie",
      "beverage",
      "milk",
      "sauce",
      "candy",
      "baking",
      "sweetener"
    ],
    "totalObs": 61,
    "source": "usda"
  },
  "annies_homegrown": {
    "displayName": "Annie's Homegrown",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 47,
      "frozen": 8,
      "dairy": 6
    },
    "subtypeCounts": {
      "cookie": 23,
      "candy": 13,
      "ice_cream": 4,
      "boxed_meal": 6,
      "yogurt": 6
    },
    "subtypes": [
      "cookie",
      "candy",
      "boxed_meal",
      "yogurt",
      "ice_cream"
    ],
    "totalObs": 61,
    "source": "usda"
  },
  "green_way": {
    "displayName": "Green Way",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 33,
      "beverage": 7,
      "frozen": 14,
      "dairy": 7
    },
    "subtypeCounts": {
      "beverage": 7,
      "cookie": 7,
      "sauce": 2,
      "milk": 4,
      "ice_cream": 12,
      "sweetener": 1,
      "dressing": 8
    },
    "subtypes": [
      "ice_cream",
      "dressing",
      "beverage",
      "cookie",
      "milk",
      "sauce",
      "sweetener"
    ],
    "totalObs": 61,
    "source": "usda"
  },
  "met_rx": {
    "displayName": "Met-rx",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 60,
      "dairy": 1
    },
    "subtypeCounts": {
      "milk": 1,
      "cookie": 2
    },
    "subtypes": [
      "cookie",
      "milk"
    ],
    "totalObs": 61,
    "source": "usda"
  },
  "udis": {
    "displayName": "Udis",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31,
      "frozen": 29
    },
    "subtypeCounts": {
      "bread": 27,
      "cookie": 6,
      "boxed_meal": 24
    },
    "subtypes": [
      "bread",
      "boxed_meal",
      "cookie"
    ],
    "totalObs": 60,
    "source": "usda"
  },
  "best": {
    "displayName": "Best",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 58,
      "beverage": 2
    },
    "subtypeCounts": {
      "dressing": 57,
      "beverage": 2
    },
    "subtypes": [
      "dressing",
      "beverage"
    ],
    "totalObs": 60,
    "source": "usda"
  },
  "piggly_wiggly": {
    "displayName": "Piggly Wiggly",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 37,
      "beverage": 7,
      "dairy": 11,
      "frozen": 5
    },
    "subtypeCounts": {
      "candy": 11,
      "chocolate": 1,
      "bread": 1,
      "cookie": 7,
      "beverage": 7,
      "cheese": 9,
      "ice_cream": 3,
      "milk": 2,
      "dressing": 4,
      "boxed_meal": 4,
      "sauce": 1
    },
    "subtypes": [
      "candy",
      "cheese",
      "cookie",
      "beverage",
      "dressing",
      "boxed_meal",
      "ice_cream",
      "milk",
      "chocolate",
      "bread",
      "sauce"
    ],
    "totalObs": 60,
    "source": "usda"
  },
  "zapps": {
    "displayName": "Zapps",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 57,
      "frozen": 3
    },
    "subtypeCounts": {
      "boxed_meal": 3
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 60,
    "source": "usda"
  },
  "now_and_later": {
    "displayName": "Now And Later",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 60
    },
    "subtypeCounts": {
      "candy": 60
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 60,
    "source": "usda"
  },
  "one": {
    "displayName": "One",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 60
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 60,
    "source": "usda"
  },
  "capri_sun": {
    "displayName": "Capri Sun",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 60
    },
    "subtypeCounts": {
      "beverage": 60
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 60,
    "source": "usda"
  },
  "wilton": {
    "displayName": "Wilton",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 60
    },
    "subtypeCounts": {
      "cookie": 35,
      "candy": 21,
      "baking": 1
    },
    "subtypes": [
      "cookie",
      "candy",
      "baking"
    ],
    "totalObs": 60,
    "source": "usda"
  },
  "casa_cardenas": {
    "displayName": "Casa Cardenas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12,
      "pantry": 44,
      "produce": 1,
      "beverage": 3
    },
    "subtypeCounts": {
      "cheese": 2,
      "cookie": 9,
      "milk": 7,
      "baking": 8,
      "spread": 1,
      "sauce": 4,
      "bread": 4,
      "beverage": 3,
      "yogurt": 3,
      "dressing": 3
    },
    "subtypes": [
      "cookie",
      "baking",
      "milk",
      "sauce",
      "bread",
      "beverage",
      "yogurt",
      "dressing",
      "cheese",
      "spread"
    ],
    "totalObs": 60,
    "source": "usda"
  },
  "olde_thompson": {
    "displayName": "Olde Thompson",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 60
    },
    "subtypeCounts": {
      "sauce": 44
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 60,
    "source": "usda"
  },
  "mw_polar": {
    "displayName": "Mw Polar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 59
    },
    "subtypeCounts": {
      "spread": 7,
      "sweetener": 1
    },
    "subtypes": [
      "spread",
      "sweetener"
    ],
    "totalObs": 59,
    "source": "usda"
  },
  "natures_basket": {
    "displayName": "Nature's Basket",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32,
      "beverage": 3,
      "produce": 17,
      "meat": 4,
      "frozen": 3
    },
    "subtypeCounts": {
      "beverage": 3,
      "sausage": 4,
      "ice_cream": 1,
      "boxed_meal": 5,
      "sweetener": 1
    },
    "subtypes": [
      "boxed_meal",
      "sausage",
      "beverage",
      "ice_cream",
      "sweetener"
    ],
    "totalObs": 59,
    "source": "usda"
  },
  "hiland": {
    "displayName": "Hiland",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 23,
      "frozen": 35,
      "beverage": 1
    },
    "subtypeCounts": {
      "milk": 12,
      "cheese": 9,
      "ice_cream": 35,
      "yogurt": 2,
      "beverage": 1
    },
    "subtypes": [
      "ice_cream",
      "milk",
      "cheese",
      "yogurt",
      "beverage"
    ],
    "totalObs": 59,
    "source": "usda"
  },
  "midwood": {
    "displayName": "Midwood",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 59
    },
    "subtypeCounts": {
      "candy": 58,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 59,
    "source": "usda"
  },
  "stone_ridge_creamery": {
    "displayName": "Stone Ridge Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 59
    },
    "subtypeCounts": {
      "ice_cream": 59
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 59,
    "source": "usda"
  },
  "fritos": {
    "displayName": "Fritos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 57,
      "dairy": 2
    },
    "subtypeCounts": {
      "cheese": 2
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 59,
    "source": "usda"
  },
  "full_circle": {
    "displayName": "Full Circle",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41,
      "beverage": 8,
      "frozen": 6,
      "dairy": 2,
      "produce": 1
    },
    "subtypeCounts": {
      "cookie": 5,
      "beverage": 8,
      "boxed_meal": 3,
      "bread": 6,
      "milk": 1,
      "dressing": 8
    },
    "subtypes": [
      "beverage",
      "dressing",
      "bread",
      "cookie",
      "boxed_meal",
      "milk"
    ],
    "totalObs": 58,
    "source": "usda"
  },
  "starbucks": {
    "displayName": "Starbucks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 52,
      "beverage": 4,
      "dairy": 2
    },
    "subtypeCounts": {
      "beverage": 21,
      "candy": 8,
      "cookie": 16,
      "chocolate": 4,
      "milk": 2
    },
    "subtypes": [
      "beverage",
      "cookie",
      "candy",
      "chocolate",
      "milk"
    ],
    "totalObs": 58,
    "source": "usda"
  },
  "eilliens": {
    "displayName": "Eillien's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 58
    },
    "subtypeCounts": {
      "candy": 48,
      "chocolate": 7,
      "spread": 1,
      "baking": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "spread",
      "baking"
    ],
    "totalObs": 58,
    "source": "usda"
  },
  "lucerne": {
    "displayName": "Lucerne",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 55,
      "frozen": 3
    },
    "subtypeCounts": {
      "milk": 10,
      "cheese": 35,
      "ice_cream": 3,
      "yogurt": 4
    },
    "subtypes": [
      "cheese",
      "milk",
      "yogurt",
      "ice_cream"
    ],
    "totalObs": 58,
    "source": "usda"
  },
  "health_warrior": {
    "displayName": "Health Warrior",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 58
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 58,
    "source": "usda"
  },
  "spice_supreme": {
    "displayName": "Spice Supreme",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 58
    },
    "subtypeCounts": {
      "sauce": 49,
      "dressing": 1
    },
    "subtypes": [
      "sauce",
      "dressing"
    ],
    "totalObs": 58,
    "source": "usda"
  },
  "tinas": {
    "displayName": "Tina's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 58
    },
    "subtypeCounts": {
      "boxed_meal": 58
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 58,
    "source": "usda"
  },
  "la_preferida": {
    "displayName": "La Preferida",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 57
    },
    "subtypeCounts": {
      "sweetener": 3,
      "sauce": 10,
      "baking": 2
    },
    "subtypes": [
      "sauce",
      "sweetener",
      "baking"
    ],
    "totalObs": 57,
    "source": "usda"
  },
  "best_maid": {
    "displayName": "Best Maid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 57
    },
    "subtypeCounts": {
      "cookie": 2
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 57,
    "source": "usda"
  },
  "pacific": {
    "displayName": "Pacific",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41,
      "dairy": 4,
      "produce": 10,
      "beverage": 2
    },
    "subtypeCounts": {
      "boxed_meal": 33,
      "cheese": 1,
      "bread": 5,
      "beverage": 2,
      "milk": 3
    },
    "subtypes": [
      "boxed_meal",
      "bread",
      "milk",
      "beverage",
      "cheese"
    ],
    "totalObs": 57,
    "source": "usda"
  },
  "wild_oats_marketplace": {
    "displayName": "Wild Oats Marketplace",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41,
      "frozen": 9,
      "produce": 3,
      "dairy": 4
    },
    "subtypeCounts": {
      "cookie": 5,
      "bread": 9,
      "boxed_meal": 6,
      "baking": 1,
      "milk": 2,
      "yogurt": 1,
      "dressing": 2,
      "spread": 3
    },
    "subtypes": [
      "bread",
      "boxed_meal",
      "cookie",
      "spread",
      "milk",
      "dressing",
      "baking",
      "yogurt"
    ],
    "totalObs": 57,
    "source": "usda"
  },
  "mi_stenita": {
    "displayName": "Mi Costenita",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 56,
      "dairy": 1
    },
    "subtypeCounts": {
      "baking": 17,
      "sauce": 2,
      "candy": 2,
      "chocolate": 1,
      "cookie": 1,
      "milk": 1
    },
    "subtypes": [
      "baking",
      "sauce",
      "candy",
      "chocolate",
      "cookie",
      "milk"
    ],
    "totalObs": 57,
    "source": "usda"
  },
  "floridas_natural": {
    "displayName": "Florida's Natural",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 56,
      "pantry": 1
    },
    "subtypeCounts": {
      "beverage": 56,
      "candy": 1
    },
    "subtypes": [
      "beverage",
      "candy"
    ],
    "totalObs": 57,
    "source": "usda"
  },
  "liebers": {
    "displayName": "Liebers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 2,
      "pantry": 52,
      "beverage": 3
    },
    "subtypeCounts": {
      "ice_cream": 2,
      "dressing": 9,
      "cookie": 11,
      "candy": 13,
      "baking": 2,
      "sauce": 3,
      "beverage": 3,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "cookie",
      "dressing",
      "sauce",
      "beverage",
      "ice_cream",
      "baking",
      "chocolate"
    ],
    "totalObs": 57,
    "source": "usda"
  },
  "creamette": {
    "displayName": "Creamette",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 56
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 56,
    "source": "usda"
  },
  "pringles": {
    "displayName": "Pringles",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 56
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 56,
    "source": "usda"
  },
  "tootsie_roll": {
    "displayName": "Tootsie Roll",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 56
    },
    "subtypeCounts": {
      "candy": 55,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 56,
    "source": "usda"
  },
  "candyrific": {
    "displayName": "Candyrific",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 56
    },
    "subtypeCounts": {
      "candy": 56
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 56,
    "source": "usda"
  },
  "la_brea_bakery": {
    "displayName": "La Brea Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 54,
      "frozen": 2
    },
    "subtypeCounts": {
      "bread": 56
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 56,
    "source": "usda"
  },
  "walden_farms": {
    "displayName": "Walden Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 54,
      "dairy": 1
    },
    "subtypeCounts": {
      "spread": 5,
      "dressing": 48,
      "sauce": 1,
      "cheese": 1
    },
    "subtypes": [
      "dressing",
      "spread",
      "sauce",
      "cheese"
    ],
    "totalObs": 55,
    "source": "usda"
  },
  "sensible_portions": {
    "displayName": "Sensible Portions",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 55
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 55,
    "source": "usda"
  },
  "little_debbie": {
    "displayName": "Little Debbie",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 55
    },
    "subtypeCounts": {
      "cookie": 50,
      "candy": 5
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 55,
    "source": "usda"
  },
  "haribo": {
    "displayName": "Haribo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 55
    },
    "subtypeCounts": {
      "candy": 54,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 55,
    "source": "usda"
  },
  "danone_us": {
    "displayName": "Danone Us,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 48,
      "pantry": 7
    },
    "subtypeCounts": {
      "yogurt": 45,
      "cheese": 1,
      "milk": 2
    },
    "subtypes": [
      "yogurt",
      "milk",
      "cheese"
    ],
    "totalObs": 55,
    "source": "usda"
  },
  "lakewood": {
    "displayName": "Lakewood",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 54,
      "pantry": 1
    },
    "subtypeCounts": {
      "beverage": 54
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 55,
    "source": "usda"
  },
  "yasso": {
    "displayName": "Yasso",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 55
    },
    "subtypeCounts": {
      "ice_cream": 55
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 55,
    "source": "usda"
  },
  "albertsons": {
    "displayName": "Albertsons",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11,
      "pantry": 35,
      "dairy": 8,
      "beverage": 1
    },
    "subtypeCounts": {
      "ice_cream": 11,
      "bread": 31,
      "cookie": 2,
      "milk": 6,
      "beverage": 1
    },
    "subtypes": [
      "bread",
      "ice_cream",
      "milk",
      "cookie",
      "beverage"
    ],
    "totalObs": 55,
    "source": "usda"
  },
  "walgreens": {
    "displayName": "Walgreens",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 53,
      "dairy": 2
    },
    "subtypeCounts": {
      "chocolate": 6,
      "candy": 31,
      "cookie": 9,
      "cheese": 1,
      "sauce": 1,
      "milk": 1,
      "sweetener": 2
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate",
      "sweetener",
      "cheese",
      "sauce",
      "milk"
    ],
    "totalObs": 55,
    "source": "usda"
  },
  "terra": {
    "displayName": "Terra",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 54
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 54,
    "source": "usda"
  },
  "cento": {
    "displayName": "Cento",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 53,
      "beverage": 1
    },
    "subtypeCounts": {
      "boxed_meal": 9,
      "beverage": 1,
      "sauce": 2
    },
    "subtypes": [
      "boxed_meal",
      "sauce",
      "beverage"
    ],
    "totalObs": 54,
    "source": "usda"
  },
  "iberia": {
    "displayName": "Iberia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35,
      "dairy": 1,
      "beverage": 18
    },
    "subtypeCounts": {
      "sauce": 5,
      "baking": 7,
      "milk": 1,
      "beverage": 18
    },
    "subtypes": [
      "beverage",
      "baking",
      "sauce",
      "milk"
    ],
    "totalObs": 54,
    "source": "usda"
  },
  "popchips": {
    "displayName": "Popchips",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 54
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 54,
    "source": "usda"
  },
  "simply_roundys": {
    "displayName": "Simply Roundys",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 8,
      "pantry": 26,
      "dairy": 4,
      "frozen": 10,
      "produce": 6
    },
    "subtypeCounts": {
      "beverage": 8,
      "sweetener": 3,
      "spread": 4,
      "cookie": 1,
      "baking": 1,
      "boxed_meal": 2,
      "cheese": 1,
      "ice_cream": 7,
      "yogurt": 2,
      "bread": 1,
      "milk": 1
    },
    "subtypes": [
      "beverage",
      "ice_cream",
      "spread",
      "sweetener",
      "boxed_meal",
      "yogurt",
      "cookie",
      "baking",
      "cheese",
      "bread",
      "milk"
    ],
    "totalObs": 54,
    "source": "usda"
  },
  "local_hive": {
    "displayName": "Local Hive",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 54
    },
    "subtypeCounts": {
      "sweetener": 54
    },
    "subtypes": [
      "sweetener"
    ],
    "totalObs": 54,
    "source": "usda"
  },
  "victoria": {
    "displayName": "Victoria",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 54
    },
    "subtypeCounts": {
      "cookie": 5
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 54,
    "source": "usda"
  },
  "velveeta": {
    "displayName": "Velveeta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11,
      "dairy": 43
    },
    "subtypeCounts": {
      "boxed_meal": 11,
      "cheese": 43
    },
    "subtypes": [
      "cheese",
      "boxed_meal"
    ],
    "totalObs": 54,
    "source": "usda"
  },
  "maries": {
    "displayName": "Marie's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 53
    },
    "subtypeCounts": {
      "dressing": 53
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 53,
    "source": "usda"
  },
  "polar": {
    "displayName": "Polar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18,
      "beverage": 35
    },
    "subtypeCounts": {
      "beverage": 35,
      "cookie": 1
    },
    "subtypes": [
      "beverage",
      "cookie"
    ],
    "totalObs": 53,
    "source": "usda"
  },
  "mrs_wages": {
    "displayName": "Mrs.wages",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 52,
      "dairy": 1
    },
    "subtypeCounts": {
      "sauce": 47,
      "dressing": 3,
      "spread": 1,
      "cheese": 1
    },
    "subtypes": [
      "sauce",
      "dressing",
      "spread",
      "cheese"
    ],
    "totalObs": 53,
    "source": "usda"
  },
  "greek_gods": {
    "displayName": "The Greek Gods",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 52,
      "pantry": 1
    },
    "subtypeCounts": {
      "yogurt": 52,
      "sweetener": 1
    },
    "subtypes": [
      "yogurt",
      "sweetener"
    ],
    "totalObs": 53,
    "source": "usda"
  },
  "wholesome_pantry": {
    "displayName": "Wholesome Pantry",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 14,
      "pantry": 20,
      "frozen": 1,
      "dairy": 10,
      "beverage": 8
    },
    "subtypeCounts": {
      "cookie": 3,
      "boxed_meal": 4,
      "milk": 4,
      "bread": 3,
      "yogurt": 2,
      "beverage": 8,
      "sauce": 1,
      "sweetener": 1,
      "cheese": 4
    },
    "subtypes": [
      "beverage",
      "boxed_meal",
      "milk",
      "cheese",
      "cookie",
      "bread",
      "yogurt",
      "sauce",
      "sweetener"
    ],
    "totalObs": 53,
    "source": "usda"
  },
  "cumberland_farms": {
    "displayName": "Cumberland Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35,
      "beverage": 10,
      "frozen": 4,
      "dairy": 3,
      "produce": 1
    },
    "subtypeCounts": {
      "chocolate": 11,
      "beverage": 10,
      "cookie": 8,
      "candy": 2,
      "ice_cream": 4,
      "yogurt": 3
    },
    "subtypes": [
      "chocolate",
      "beverage",
      "cookie",
      "ice_cream",
      "yogurt",
      "candy"
    ],
    "totalObs": 53,
    "source": "usda"
  },
  "muellers": {
    "displayName": "Mueller's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 52
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 52,
    "source": "usda"
  },
  "la_stena": {
    "displayName": "La Costena",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 52
    },
    "subtypeCounts": {
      "baking": 1,
      "dressing": 3,
      "boxed_meal": 1
    },
    "subtypes": [
      "dressing",
      "baking",
      "boxed_meal"
    ],
    "totalObs": 52,
    "source": "usda"
  },
  "alouette": {
    "displayName": "Alouette",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 52
    },
    "subtypeCounts": {
      "cheese": 51,
      "milk": 1
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 52,
    "source": "usda"
  },
  "giorgio": {
    "displayName": "Giorgio",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24,
      "produce": 27,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1,
      "baking": 4
    },
    "subtypes": [
      "baking",
      "cheese"
    ],
    "totalObs": 52,
    "source": "usda"
  },
  "kowalskis_markets": {
    "displayName": "Kowalski's Markets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 38,
      "dairy": 9,
      "meat": 4,
      "produce": 1
    },
    "subtypeCounts": {
      "spread": 4,
      "candy": 11,
      "cookie": 3,
      "chocolate": 9,
      "cheese": 9,
      "sausage": 1,
      "bread": 1,
      "boxed_meal": 3,
      "dressing": 3
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cheese",
      "spread",
      "cookie",
      "boxed_meal",
      "dressing",
      "sausage",
      "bread"
    ],
    "totalObs": 52,
    "source": "usda"
  },
  "honey_stinger": {
    "displayName": "Honey Stinger",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 52
    },
    "subtypeCounts": {
      "chocolate": 5,
      "cookie": 3
    },
    "subtypes": [
      "chocolate",
      "cookie"
    ],
    "totalObs": 52,
    "source": "usda"
  },
  "shaws": {
    "displayName": "Shaws",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 46,
      "dairy": 6
    },
    "subtypeCounts": {
      "bread": 46,
      "milk": 3
    },
    "subtypes": [
      "bread",
      "milk"
    ],
    "totalObs": 52,
    "source": "usda"
  },
  "foster_farms": {
    "displayName": "Foster Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 52
    },
    "subtypeCounts": {
      "boxed_meal": 52
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 52,
    "source": "usda"
  },
  "halo_top": {
    "displayName": "Halo Top",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 52
    },
    "subtypeCounts": {
      "ice_cream": 52
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 52,
    "source": "usda"
  },
  "sanders": {
    "displayName": "Sanders",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 45,
      "frozen": 7
    },
    "subtypeCounts": {
      "chocolate": 30,
      "candy": 13,
      "ice_cream": 7,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "ice_cream",
      "cookie"
    ],
    "totalObs": 52,
    "source": "usda"
  },
  "tops_markets": {
    "displayName": "Tops Markets,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13,
      "frozen": 4,
      "pantry": 33,
      "beverage": 2
    },
    "subtypeCounts": {
      "cheese": 13,
      "chocolate": 5,
      "cookie": 4,
      "boxed_meal": 2,
      "sauce": 3,
      "candy": 10,
      "dressing": 2,
      "beverage": 2
    },
    "subtypes": [
      "cheese",
      "candy",
      "chocolate",
      "cookie",
      "sauce",
      "boxed_meal",
      "dressing",
      "beverage"
    ],
    "totalObs": 52,
    "source": "usda"
  },
  "natures_bakery": {
    "displayName": "Nature's Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 51
    },
    "subtypeCounts": {
      "cookie": 15
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 51,
    "source": "usda"
  },
  "sweet_shop": {
    "displayName": "Sweet Shop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 51
    },
    "subtypeCounts": {
      "cookie": 6,
      "candy": 3,
      "chocolate": 42
    },
    "subtypes": [
      "chocolate",
      "cookie",
      "candy"
    ],
    "totalObs": 51,
    "source": "usda"
  },
  "farm_rich": {
    "displayName": "Farm Rich",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 51
    },
    "subtypeCounts": {
      "boxed_meal": 48,
      "ice_cream": 2,
      "bread": 1
    },
    "subtypes": [
      "boxed_meal",
      "ice_cream",
      "bread"
    ],
    "totalObs": 51,
    "source": "usda"
  },
  "sanpellegrino": {
    "displayName": "Sanpellegrino",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 51
    },
    "subtypeCounts": {
      "beverage": 51
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 51,
    "source": "usda"
  },
  "primo_taglio": {
    "displayName": "Primo Taglio",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 51
    },
    "subtypeCounts": {
      "cheese": 51
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 51,
    "source": "usda"
  },
  "motts": {
    "displayName": "Mott's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 29,
      "produce": 6,
      "frozen": 4,
      "pantry": 12
    },
    "subtypeCounts": {
      "beverage": 29,
      "ice_cream": 4,
      "candy": 12
    },
    "subtypes": [
      "beverage",
      "candy",
      "ice_cream"
    ],
    "totalObs": 51,
    "source": "usda"
  },
  "wallaby": {
    "displayName": "Wallaby",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 51
    },
    "subtypeCounts": {
      "yogurt": 47,
      "milk": 4
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 51,
    "source": "usda"
  },
  "spice_hunter": {
    "displayName": "The Spice Hunter",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 51
    },
    "subtypeCounts": {
      "sauce": 26
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 51,
    "source": "usda"
  },
  "pictsweet": {
    "displayName": "Pictsweet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 51
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "bread": 1
    },
    "subtypes": [
      "boxed_meal",
      "bread"
    ],
    "totalObs": 51,
    "source": "usda"
  },
  "new_york_bakery": {
    "displayName": "New York Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 25,
      "pantry": 25
    },
    "subtypeCounts": {
      "bread": 37,
      "cookie": 2,
      "dressing": 8,
      "boxed_meal": 1
    },
    "subtypes": [
      "bread",
      "dressing",
      "cookie",
      "boxed_meal"
    ],
    "totalObs": 50,
    "source": "usda"
  },
  "applegate": {
    "displayName": "Applegate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 11,
      "dairy": 25,
      "frozen": 14
    },
    "subtypeCounts": {
      "sausage": 11,
      "cheese": 25,
      "boxed_meal": 14
    },
    "subtypes": [
      "cheese",
      "boxed_meal",
      "sausage"
    ],
    "totalObs": 50,
    "source": "usda"
  },
  "yocrunch": {
    "displayName": "Yocrunch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 50
    },
    "subtypeCounts": {
      "yogurt": 50
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 50,
    "source": "usda"
  },
  "san_giorgio": {
    "displayName": "San Giorgio",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 50
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 50,
    "source": "usda"
  },
  "price_rite": {
    "displayName": "Price Rite",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 5,
      "dairy": 15,
      "beverage": 5,
      "pantry": 25
    },
    "subtypeCounts": {
      "cheese": 12,
      "beverage": 5,
      "sauce": 2,
      "milk": 2,
      "cookie": 2,
      "bread": 1,
      "yogurt": 1,
      "candy": 1,
      "dressing": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "cheese",
      "beverage",
      "sauce",
      "milk",
      "cookie",
      "bread",
      "yogurt",
      "candy",
      "dressing",
      "boxed_meal"
    ],
    "totalObs": 50,
    "source": "usda"
  },
  "baskin_robbins": {
    "displayName": "Baskin Robbins",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 49,
      "dairy": 1
    },
    "subtypeCounts": {
      "ice_cream": 49,
      "yogurt": 1
    },
    "subtypes": [
      "ice_cream",
      "yogurt"
    ],
    "totalObs": 50,
    "source": "usda"
  },
  "mars_cho_late_north_america": {
    "displayName": "Mars Chocolate North America",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 50
    },
    "subtypeCounts": {
      "candy": 32,
      "chocolate": 16,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 50,
    "source": "usda"
  },
  "psst": {
    "displayName": "Psst",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 38,
      "dairy": 2,
      "frozen": 10
    },
    "subtypeCounts": {
      "cookie": 11,
      "dressing": 2,
      "sauce": 2,
      "cheese": 2,
      "spread": 2,
      "bread": 5,
      "ice_cream": 4,
      "boxed_meal": 5
    },
    "subtypes": [
      "cookie",
      "bread",
      "boxed_meal",
      "ice_cream",
      "dressing",
      "sauce",
      "cheese",
      "spread"
    ],
    "totalObs": 50,
    "source": "usda"
  },
  "tazah": {
    "displayName": "Tazah",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 5,
      "pantry": 40,
      "beverage": 2,
      "frozen": 3
    },
    "subtypeCounts": {
      "cheese": 5,
      "cookie": 2,
      "candy": 1,
      "beverage": 2,
      "bread": 1,
      "spread": 1,
      "dressing": 1,
      "sweetener": 1
    },
    "subtypes": [
      "cheese",
      "cookie",
      "beverage",
      "candy",
      "bread",
      "spread",
      "dressing",
      "sweetener"
    ],
    "totalObs": 50,
    "source": "usda"
  },
  "bissingers": {
    "displayName": "Bissinger's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 49
    },
    "subtypeCounts": {
      "candy": 16,
      "chocolate": 33
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 49,
    "source": "usda"
  },
  "klondike": {
    "displayName": "Klondike",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 44,
      "pantry": 4,
      "produce": 1
    },
    "subtypeCounts": {
      "ice_cream": 44,
      "candy": 4
    },
    "subtypes": [
      "ice_cream",
      "candy"
    ],
    "totalObs": 49,
    "source": "usda"
  },
  "kum_go": {
    "displayName": "Kum & Go",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 39,
      "beverage": 8,
      "produce": 2
    },
    "subtypeCounts": {
      "candy": 16,
      "chocolate": 3,
      "beverage": 8,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "beverage",
      "chocolate",
      "cookie"
    ],
    "totalObs": 49,
    "source": "usda"
  },
  "primal_kitchen": {
    "displayName": "Primal Kitchen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 44,
      "frozen": 5
    },
    "subtypeCounts": {
      "boxed_meal": 5,
      "dressing": 27,
      "chocolate": 1
    },
    "subtypes": [
      "dressing",
      "boxed_meal",
      "chocolate"
    ],
    "totalObs": 49,
    "source": "usda"
  },
  "del_dixi": {
    "displayName": "Del-dixi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 49
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 49,
    "source": "usda"
  },
  "kelloggs": {
    "displayName": "Kellogg's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 49
    },
    "subtypeCounts": {
      "candy": 44,
      "cookie": 2
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 49,
    "source": "usda"
  },
  "publix_super_markets": {
    "displayName": "Publix Super Markets,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13,
      "meat": 3,
      "dairy": 15,
      "pantry": 16,
      "produce": 1,
      "beverage": 1
    },
    "subtypeCounts": {
      "boxed_meal": 2,
      "sausage": 2,
      "cheese": 7,
      "ice_cream": 10,
      "milk": 7,
      "yogurt": 1,
      "bread": 8,
      "chocolate": 2,
      "dressing": 3,
      "beverage": 1
    },
    "subtypes": [
      "ice_cream",
      "bread",
      "cheese",
      "milk",
      "dressing",
      "boxed_meal",
      "sausage",
      "chocolate",
      "yogurt",
      "beverage"
    ],
    "totalObs": 49,
    "source": "usda"
  },
  "deep": {
    "displayName": "Deep",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 7,
      "pantry": 32,
      "beverage": 1,
      "dairy": 9
    },
    "subtypeCounts": {
      "boxed_meal": 5,
      "bread": 3,
      "beverage": 1,
      "candy": 1,
      "cheese": 1,
      "baking": 4,
      "milk": 1,
      "yogurt": 7,
      "dressing": 1,
      "sauce": 2
    },
    "subtypes": [
      "yogurt",
      "boxed_meal",
      "baking",
      "bread",
      "sauce",
      "beverage",
      "candy",
      "cheese",
      "milk",
      "dressing"
    ],
    "totalObs": 49,
    "source": "usda"
  },
  "glen_urt": {
    "displayName": "Glencourt",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27,
      "frozen": 13,
      "dairy": 6,
      "beverage": 1,
      "produce": 2
    },
    "subtypeCounts": {
      "yogurt": 3,
      "sauce": 4,
      "baking": 1,
      "boxed_meal": 20,
      "bread": 4,
      "beverage": 1
    },
    "subtypes": [
      "boxed_meal",
      "sauce",
      "bread",
      "yogurt",
      "baking",
      "beverage"
    ],
    "totalObs": 49,
    "source": "usda"
  },
  "morton": {
    "displayName": "Morton",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 48
    },
    "subtypeCounts": {
      "sauce": 47
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 48,
    "source": "usda"
  },
  "kahiki": {
    "displayName": "Kahiki",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 48
    },
    "subtypeCounts": {
      "boxed_meal": 47
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 48,
    "source": "usda"
  },
  "weight_watchers": {
    "displayName": "Weight Watchers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 16,
      "frozen": 29,
      "pantry": 3
    },
    "subtypeCounts": {
      "cheese": 16,
      "ice_cream": 23,
      "boxed_meal": 6,
      "chocolate": 1,
      "cookie": 2
    },
    "subtypes": [
      "ice_cream",
      "cheese",
      "boxed_meal",
      "cookie",
      "chocolate"
    ],
    "totalObs": 48,
    "source": "usda"
  },
  "perdue": {
    "displayName": "Perdue",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 47,
      "pantry": 1
    },
    "subtypeCounts": {
      "boxed_meal": 48
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 48,
    "source": "usda"
  },
  "catawba_candy": {
    "displayName": "Catawba Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 48
    },
    "subtypeCounts": {
      "candy": 47,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 48,
    "source": "usda"
  },
  "stella": {
    "displayName": "Stella",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 47
    },
    "subtypeCounts": {
      "cheese": 47
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 47,
    "source": "usda"
  },
  "marvel": {
    "displayName": "Marvel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 3,
      "pantry": 42,
      "beverage": 1,
      "frozen": 1
    },
    "subtypeCounts": {
      "cheese": 3,
      "chocolate": 6,
      "candy": 31,
      "beverage": 1,
      "boxed_meal": 1,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cheese",
      "beverage",
      "boxed_meal",
      "cookie"
    ],
    "totalObs": 47,
    "source": "usda"
  },
  "yumearth": {
    "displayName": "Yumearth",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 47
    },
    "subtypeCounts": {
      "candy": 47
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 47,
    "source": "usda"
  },
  "progressive_balloons_gifts": {
    "displayName": "Progressive Balloons & Gifts",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 47
    },
    "subtypeCounts": {
      "chocolate": 5,
      "candy": 42
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 47,
    "source": "usda"
  },
  "theo": {
    "displayName": "Theo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 47
    },
    "subtypeCounts": {
      "chocolate": 43,
      "candy": 3
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 47,
    "source": "usda"
  },
  "cheribundi": {
    "displayName": "Cheribundi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 47
    },
    "subtypeCounts": {
      "beverage": 47
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 47,
    "source": "usda"
  },
  "naked": {
    "displayName": "Naked",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 33,
      "pantry": 14
    },
    "subtypeCounts": {
      "beverage": 33
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 47,
    "source": "usda"
  },
  "faraon": {
    "displayName": "Faraon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 33,
      "dairy": 1,
      "beverage": 11,
      "frozen": 1,
      "produce": 1
    },
    "subtypeCounts": {
      "baking": 2,
      "cheese": 1,
      "beverage": 11,
      "sauce": 2,
      "sweetener": 1
    },
    "subtypes": [
      "beverage",
      "baking",
      "sauce",
      "cheese",
      "sweetener"
    ],
    "totalObs": 47,
    "source": "usda"
  },
  "heinz": {
    "displayName": "Heinz",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 43,
      "frozen": 4
    },
    "subtypeCounts": {
      "dressing": 10,
      "boxed_meal": 4,
      "sauce": 3
    },
    "subtypes": [
      "dressing",
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 47,
    "source": "usda"
  },
  "v8": {
    "displayName": "V8",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 4,
      "beverage": 43
    },
    "subtypeCounts": {
      "beverage": 43
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 47,
    "source": "usda"
  },
  "pampa": {
    "displayName": "Pampa",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 45,
      "dairy": 2
    },
    "subtypeCounts": {
      "bread": 2,
      "sauce": 3,
      "milk": 2,
      "dressing": 1,
      "spread": 3,
      "sweetener": 1
    },
    "subtypes": [
      "sauce",
      "spread",
      "bread",
      "milk",
      "dressing",
      "sweetener"
    ],
    "totalObs": 47,
    "source": "usda"
  },
  "gefen": {
    "displayName": "Gefen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 40,
      "frozen": 4,
      "produce": 1,
      "beverage": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "cookie": 5,
      "dressing": 2,
      "chocolate": 3,
      "spread": 3,
      "bread": 1,
      "baking": 1,
      "beverage": 1,
      "sweetener": 1
    },
    "subtypes": [
      "cookie",
      "chocolate",
      "spread",
      "dressing",
      "boxed_meal",
      "bread",
      "baking",
      "beverage",
      "sweetener"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "mrs_dash": {
    "displayName": "Mrs Dash",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 46
    },
    "subtypeCounts": {
      "sauce": 40
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "tessemaes": {
    "displayName": "Tessemae's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 40,
      "produce": 6
    },
    "subtypeCounts": {
      "dressing": 33,
      "sauce": 7
    },
    "subtypes": [
      "dressing",
      "sauce"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "straus_family_creamery": {
    "displayName": "Straus Family Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 19,
      "dairy": 27
    },
    "subtypeCounts": {
      "ice_cream": 19,
      "milk": 14,
      "yogurt": 13
    },
    "subtypes": [
      "ice_cream",
      "milk",
      "yogurt"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "jumex": {
    "displayName": "Jumex",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 46
    },
    "subtypeCounts": {
      "beverage": 46
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "better_made": {
    "displayName": "Better Made",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 45,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "sour_punch": {
    "displayName": "Sour Punch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 46
    },
    "subtypeCounts": {
      "candy": 46
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "oscar_mayer": {
    "displayName": "Oscar Mayer",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 34,
      "frozen": 6,
      "pantry": 6
    },
    "subtypeCounts": {
      "sausage": 34,
      "boxed_meal": 6,
      "dressing": 6
    },
    "subtypes": [
      "sausage",
      "boxed_meal",
      "dressing"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "demets": {
    "displayName": "Demet's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 46
    },
    "subtypeCounts": {
      "candy": 10,
      "chocolate": 36
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "dierbergs": {
    "displayName": "Dierbergs",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31,
      "dairy": 12,
      "frozen": 2,
      "produce": 1
    },
    "subtypeCounts": {
      "candy": 18,
      "cheese": 11,
      "cookie": 3,
      "chocolate": 3,
      "bread": 6,
      "milk": 1,
      "boxed_meal": 2
    },
    "subtypes": [
      "candy",
      "cheese",
      "bread",
      "cookie",
      "chocolate",
      "boxed_meal",
      "milk"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "rainbo": {
    "displayName": "Rainbo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 46
    },
    "subtypeCounts": {
      "bread": 46
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "yoders": {
    "displayName": "Yoder's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 36,
      "beverage": 4,
      "pantry": 6
    },
    "subtypeCounts": {
      "yogurt": 1,
      "milk": 3,
      "beverage": 4,
      "cheese": 32,
      "spread": 1,
      "bread": 4
    },
    "subtypes": [
      "cheese",
      "beverage",
      "bread",
      "milk",
      "yogurt",
      "spread"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "acme_fresh_market": {
    "displayName": "Acme Fresh Market",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 2,
      "dairy": 10,
      "frozen": 29,
      "meat": 3,
      "beverage": 2
    },
    "subtypeCounts": {
      "cheese": 10,
      "bread": 1,
      "ice_cream": 29,
      "boxed_meal": 1,
      "sausage": 2,
      "beverage": 2
    },
    "subtypes": [
      "ice_cream",
      "cheese",
      "sausage",
      "beverage",
      "bread",
      "boxed_meal"
    ],
    "totalObs": 46,
    "source": "usda"
  },
  "activia": {
    "displayName": "Activia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 45
    },
    "subtypeCounts": {
      "yogurt": 40,
      "milk": 5
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 45,
    "source": "usda"
  },
  "rudis": {
    "displayName": "Rudi's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 44,
      "frozen": 1
    },
    "subtypeCounts": {
      "bread": 44,
      "boxed_meal": 1
    },
    "subtypes": [
      "bread",
      "boxed_meal"
    ],
    "totalObs": 45,
    "source": "usda"
  },
  "go_veggie": {
    "displayName": "Go Veggie",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 43,
      "pantry": 2
    },
    "subtypeCounts": {
      "cheese": 43
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 45,
    "source": "usda"
  },
  "garden_of_eatin": {
    "displayName": "Garden Of Eatin'",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 45
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 45,
    "source": "usda"
  },
  "lewis_bake_shop": {
    "displayName": "Lewis Bake Shop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 45
    },
    "subtypeCounts": {
      "bread": 45
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 45,
    "source": "usda"
  },
  "little_secrets": {
    "displayName": "Little Secrets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 45
    },
    "subtypeCounts": {
      "candy": 31,
      "cookie": 12,
      "chocolate": 2
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate"
    ],
    "totalObs": 45,
    "source": "usda"
  },
  "sathers": {
    "displayName": "Sathers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 45
    },
    "subtypeCounts": {
      "candy": 45
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 45,
    "source": "usda"
  },
  "power_crunch": {
    "displayName": "Power Crunch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 45
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 45,
    "source": "usda"
  },
  "delimex": {
    "displayName": "Delimex",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 45
    },
    "subtypeCounts": {
      "boxed_meal": 45
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 45,
    "source": "usda"
  },
  "super_chill": {
    "displayName": "Super Chill",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 45
    },
    "subtypeCounts": {
      "beverage": 45
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 45,
    "source": "usda"
  },
  "freihofers": {
    "displayName": "Freihofer's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 45
    },
    "subtypeCounts": {
      "bread": 44,
      "cookie": 1
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 45,
    "source": "usda"
  },
  "jose_ole": {
    "displayName": "Jose Ole",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 45
    },
    "subtypeCounts": {
      "boxed_meal": 45
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 45,
    "source": "usda"
  },
  "innovasian": {
    "displayName": "Innovasian",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 43,
      "pantry": 1
    },
    "subtypeCounts": {
      "boxed_meal": 43
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "bionaturae": {
    "displayName": "Bionaturae",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 33,
      "beverage": 11
    },
    "subtypeCounts": {
      "spread": 9,
      "beverage": 11
    },
    "subtypes": [
      "beverage",
      "spread"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "s_tts_of_wis_nsin": {
    "displayName": "Scott's Of Wisconsin",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 42,
      "pantry": 2
    },
    "subtypeCounts": {
      "cheese": 42,
      "chocolate": 1
    },
    "subtypes": [
      "cheese",
      "chocolate"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "progresso": {
    "displayName": "Progresso",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 43,
      "frozen": 1
    },
    "subtypeCounts": {
      "boxed_meal": 43
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "fancypants_baking": {
    "displayName": "Fancypants Baking",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 44
    },
    "subtypeCounts": {
      "cookie": 42,
      "candy": 2
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "gustare_vita": {
    "displayName": "Gustare Vita",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32,
      "frozen": 10,
      "beverage": 2
    },
    "subtypeCounts": {
      "ice_cream": 8,
      "beverage": 2,
      "baking": 1,
      "boxed_meal": 2,
      "bread": 1
    },
    "subtypes": [
      "ice_cream",
      "beverage",
      "boxed_meal",
      "baking",
      "bread"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "lake_champlain_cho_lates": {
    "displayName": "Lake Champlain Chocolates",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 44
    },
    "subtypeCounts": {
      "chocolate": 39,
      "candy": 5
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "fiesta": {
    "displayName": "Fiesta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 4,
      "pantry": 31,
      "frozen": 4,
      "dairy": 5
    },
    "subtypeCounts": {
      "beverage": 4,
      "sauce": 4,
      "cookie": 9,
      "baking": 2,
      "ice_cream": 4,
      "milk": 3,
      "yogurt": 2
    },
    "subtypes": [
      "cookie",
      "beverage",
      "sauce",
      "ice_cream",
      "milk",
      "baking",
      "yogurt"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "cvs_pharmacy": {
    "displayName": "Cvs Pharmacy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 42,
      "frozen": 2
    },
    "subtypeCounts": {
      "chocolate": 12,
      "candy": 13,
      "cookie": 13,
      "boxed_meal": 2
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate",
      "boxed_meal"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "lewis": {
    "displayName": "Lewis",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 44
    },
    "subtypeCounts": {
      "bread": 44
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "sunbelt_bakery": {
    "displayName": "Sunbelt Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 44
    },
    "subtypeCounts": {
      "cookie": 2
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "hodgson_mill": {
    "displayName": "Hodgson Mill",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 44
    },
    "subtypeCounts": {
      "baking": 17,
      "sauce": 1,
      "bread": 3
    },
    "subtypes": [
      "baking",
      "bread",
      "sauce"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "schwartz_brothers_bakery": {
    "displayName": "Schwartz Brothers Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 44
    },
    "subtypeCounts": {
      "bread": 14,
      "cookie": 26,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "bread",
      "candy"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "smart_ones": {
    "displayName": "Smart Ones",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 44
    },
    "subtypeCounts": {
      "boxed_meal": 43
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 44,
    "source": "usda"
  },
  "gedney": {
    "displayName": "Gedney",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 44
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 44,
    "source": "usda"
  },
  "wonder": {
    "displayName": "Wonder",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 43
    },
    "subtypeCounts": {
      "bread": 40
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "glutino": {
    "displayName": "Glutino",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41,
      "frozen": 2
    },
    "subtypeCounts": {
      "bread": 6,
      "cookie": 18,
      "baking": 1
    },
    "subtypes": [
      "cookie",
      "bread",
      "baking"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "alessi": {
    "displayName": "Alessi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 43
    },
    "subtypeCounts": {
      "bread": 6,
      "sauce": 6,
      "dressing": 3,
      "cookie": 2
    },
    "subtypes": [
      "bread",
      "sauce",
      "dressing",
      "cookie"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "natures_harvest": {
    "displayName": "Nature's Harvest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 42,
      "produce": 1
    },
    "subtypeCounts": {
      "bread": 25,
      "chocolate": 3,
      "candy": 1,
      "baking": 1
    },
    "subtypes": [
      "bread",
      "chocolate",
      "candy",
      "baking"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "dum_dums": {
    "displayName": "Dum Dums",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 43
    },
    "subtypeCounts": {
      "candy": 43
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "cascadian_farm": {
    "displayName": "Cascadian Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10,
      "pantry": 33
    },
    "subtypeCounts": {
      "spread": 3,
      "cookie": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "spread",
      "cookie",
      "boxed_meal"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "sweet_earth": {
    "displayName": "Sweet Earth",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 40,
      "pantry": 3
    },
    "subtypeCounts": {
      "boxed_meal": 40
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "lotus": {
    "displayName": "Lotus",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35,
      "beverage": 3,
      "frozen": 5
    },
    "subtypeCounts": {
      "cookie": 21,
      "beverage": 3,
      "ice_cream": 5
    },
    "subtypes": [
      "cookie",
      "ice_cream",
      "beverage"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "too_good_gourmet": {
    "displayName": "Too Good Gourmet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 43
    },
    "subtypeCounts": {
      "cookie": 32,
      "sauce": 2,
      "candy": 7,
      "chocolate": 2
    },
    "subtypes": [
      "cookie",
      "candy",
      "sauce",
      "chocolate"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "essential_baking": {
    "displayName": "Essential Baking",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 43
    },
    "subtypeCounts": {
      "bread": 43
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "smart_final_iris": {
    "displayName": "Smart & Final Iris",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 7,
      "pantry": 23,
      "dairy": 10,
      "meat": 2,
      "beverage": 1
    },
    "subtypeCounts": {
      "ice_cream": 2,
      "cookie": 3,
      "boxed_meal": 2,
      "baking": 2,
      "sausage": 2,
      "cheese": 8,
      "dressing": 1,
      "bread": 1,
      "sauce": 2,
      "beverage": 1
    },
    "subtypes": [
      "cheese",
      "cookie",
      "ice_cream",
      "boxed_meal",
      "baking",
      "sausage",
      "sauce",
      "dressing",
      "bread",
      "beverage"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "flix_candy": {
    "displayName": "Flix Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 43
    },
    "subtypeCounts": {
      "candy": 42,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "flav_r_pac": {
    "displayName": "Flav-r-pac",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 43
    },
    "subtypeCounts": {
      "boxed_meal": 2
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "three_bridges": {
    "displayName": "Three Bridges",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41,
      "dairy": 1,
      "frozen": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 43,
    "source": "usda"
  },
  "gonzalez": {
    "displayName": "Gonzalez",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25,
      "dairy": 7,
      "beverage": 8,
      "frozen": 2
    },
    "subtypeCounts": {
      "milk": 7,
      "dressing": 7,
      "cookie": 1,
      "sauce": 2,
      "beverage": 8,
      "ice_cream": 2
    },
    "subtypes": [
      "beverage",
      "milk",
      "dressing",
      "sauce",
      "ice_cream",
      "cookie"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "food_for_life": {
    "displayName": "Food For Life",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41,
      "frozen": 1
    },
    "subtypeCounts": {
      "bread": 38
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "chilis": {
    "displayName": "Chili's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 4,
      "frozen": 38
    },
    "subtypeCounts": {
      "cheese": 4,
      "boxed_meal": 38
    },
    "subtypes": [
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "pr_e": {
    "displayName": "Prince",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 42
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "moonstruck": {
    "displayName": "Moonstruck",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 42
    },
    "subtypeCounts": {
      "candy": 6,
      "chocolate": 36
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "zoet": {
    "displayName": "Zoet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41,
      "dairy": 1
    },
    "subtypeCounts": {
      "chocolate": 41,
      "cheese": 1
    },
    "subtypes": [
      "chocolate",
      "cheese"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "everfresh": {
    "displayName": "Everfresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 41,
      "pantry": 1
    },
    "subtypeCounts": {
      "beverage": 41
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "alter_e": {
    "displayName": "Alter Eco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 42
    },
    "subtypeCounts": {
      "chocolate": 39
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "walkers": {
    "displayName": "Walkers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 42
    },
    "subtypeCounts": {
      "cookie": 41,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "t_g_i_fridays": {
    "displayName": "T.g.i. Fridays",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 25,
      "pantry": 16,
      "dairy": 1
    },
    "subtypeCounts": {
      "boxed_meal": 24,
      "ice_cream": 1,
      "cheese": 1,
      "sauce": 1,
      "dressing": 1
    },
    "subtypes": [
      "boxed_meal",
      "ice_cream",
      "cheese",
      "sauce",
      "dressing"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "hyde_and_eek_boutique": {
    "displayName": "Hyde And Eek! Boutique",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 42
    },
    "subtypeCounts": {
      "cookie": 25,
      "candy": 17
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "eilliens_candies": {
    "displayName": "Eilliens Candies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 42
    },
    "subtypeCounts": {
      "candy": 33,
      "chocolate": 7
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "daiya": {
    "displayName": "Daiya",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 36,
      "pantry": 5,
      "frozen": 1
    },
    "subtypeCounts": {
      "cheese": 24,
      "yogurt": 12,
      "dressing": 5,
      "ice_cream": 1
    },
    "subtypes": [
      "cheese",
      "yogurt",
      "dressing",
      "ice_cream"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "tipton_grove": {
    "displayName": "Tipton Grove",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20,
      "beverage": 22
    },
    "subtypeCounts": {
      "beverage": 22
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "wylwood": {
    "displayName": "Wylwood",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32,
      "frozen": 10
    },
    "subtypeCounts": {
      "dressing": 1
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "wild_oats": {
    "displayName": "Wild Oats",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27,
      "produce": 4,
      "frozen": 9,
      "dairy": 2
    },
    "subtypeCounts": {
      "boxed_meal": 3,
      "cookie": 2,
      "bread": 3,
      "yogurt": 1,
      "dressing": 5
    },
    "subtypes": [
      "dressing",
      "boxed_meal",
      "bread",
      "cookie",
      "yogurt"
    ],
    "totalObs": 42,
    "source": "usda"
  },
  "boston_market": {
    "displayName": "Boston Market",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 41
    },
    "subtypeCounts": {
      "boxed_meal": 41
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "sour_patch_kids": {
    "displayName": "Sour Patch Kids",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 33,
      "frozen": 8
    },
    "subtypeCounts": {
      "candy": 33,
      "ice_cream": 8
    },
    "subtypes": [
      "candy",
      "ice_cream"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "klarbrunn": {
    "displayName": "Klarbrunn",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 41
    },
    "subtypeCounts": {
      "beverage": 41
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "hil": {
    "displayName": "Hilco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41
    },
    "subtypeCounts": {
      "candy": 41
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "hint": {
    "displayName": "Hint",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 41
    },
    "subtypeCounts": {
      "beverage": 41
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "nutri_grain": {
    "displayName": "Nutri Grain",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41
    },
    "subtypeCounts": {
      "cookie": 3
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "graeters": {
    "displayName": "Graeter's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 41
    },
    "subtypeCounts": {
      "ice_cream": 41
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "create_a_treat": {
    "displayName": "Create A Treat",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41
    },
    "subtypeCounts": {
      "cookie": 39,
      "candy": 2
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "bee": {
    "displayName": "Bee",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41
    },
    "subtypeCounts": {
      "cookie": 7,
      "candy": 34
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "lil_dutch_maid": {
    "displayName": "Lil Dutch Maid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41
    },
    "subtypeCounts": {
      "cookie": 41
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "sartori": {
    "displayName": "Sartori",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 41
    },
    "subtypeCounts": {
      "cheese": 41
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "dierbergs_kitchen": {
    "displayName": "Dierbergs Kitchen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23,
      "meat": 6,
      "dairy": 9,
      "produce": 3
    },
    "subtypeCounts": {
      "boxed_meal": 6,
      "cookie": 9,
      "bread": 10,
      "sauce": 1,
      "cheese": 9
    },
    "subtypes": [
      "bread",
      "cookie",
      "cheese",
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "nabis_biscuit": {
    "displayName": "Nabisco Biscuit",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 41
    },
    "subtypeCounts": {
      "cookie": 35
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "grace": {
    "displayName": "Grace",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 29,
      "dairy": 1,
      "beverage": 11
    },
    "subtypeCounts": {
      "sauce": 12,
      "milk": 1,
      "baking": 4,
      "cookie": 2,
      "beverage": 11
    },
    "subtypes": [
      "sauce",
      "beverage",
      "baking",
      "cookie",
      "milk"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "anderson_erickson_dairy": {
    "displayName": "Anderson Erickson Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 41
    },
    "subtypeCounts": {
      "milk": 25,
      "cheese": 8,
      "yogurt": 8
    },
    "subtypes": [
      "milk",
      "cheese",
      "yogurt"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "borns": {
    "displayName": "Coborn's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 39,
      "meat": 2
    },
    "subtypeCounts": {
      "cookie": 10,
      "sausage": 1,
      "bread": 16,
      "boxed_meal": 1
    },
    "subtypes": [
      "bread",
      "cookie",
      "sausage",
      "boxed_meal"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "voss": {
    "displayName": "Voss",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 41
    },
    "subtypeCounts": {
      "beverage": 41
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 41,
    "source": "usda"
  },
  "polaner": {
    "displayName": "Polaner",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 40
    },
    "subtypeCounts": {
      "spread": 40
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "so_delicious_dairy_free": {
    "displayName": "So Delicious Dairy Free",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 39,
      "frozen": 1
    },
    "subtypeCounts": {
      "yogurt": 31,
      "milk": 2,
      "cheese": 6,
      "ice_cream": 1
    },
    "subtypes": [
      "yogurt",
      "cheese",
      "milk",
      "ice_cream"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "perfect_bar": {
    "displayName": "Perfect Bar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 40
    },
    "subtypeCounts": {
      "candy": 1
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "skinner": {
    "displayName": "Skinner",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 40
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 40,
    "source": "usda"
  },
  "york": {
    "displayName": "York",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 40
    },
    "subtypeCounts": {
      "chocolate": 18,
      "cookie": 2,
      "candy": 20
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "tai_pei": {
    "displayName": "Tai Pei",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 40
    },
    "subtypeCounts": {
      "boxed_meal": 36
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "bimbo": {
    "displayName": "Bimbo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 40
    },
    "subtypeCounts": {
      "bread": 31,
      "cookie": 3
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "knudsen": {
    "displayName": "Knudsen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 40
    },
    "subtypeCounts": {
      "cheese": 28,
      "milk": 12
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "open_acres": {
    "displayName": "Open Acres",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 16,
      "frozen": 5,
      "meat": 6,
      "pantry": 13
    },
    "subtypeCounts": {
      "boxed_meal": 7,
      "sausage": 4,
      "cookie": 6
    },
    "subtypes": [
      "boxed_meal",
      "cookie",
      "sausage"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "fresh_finds": {
    "displayName": "Fresh Finds",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 37,
      "beverage": 3
    },
    "subtypeCounts": {
      "sauce": 15,
      "cookie": 1,
      "boxed_meal": 4,
      "beverage": 3
    },
    "subtypes": [
      "sauce",
      "boxed_meal",
      "beverage",
      "cookie"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "cedarlane": {
    "displayName": "Cedarlane",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 21,
      "pantry": 5,
      "meat": 14
    },
    "subtypeCounts": {
      "boxed_meal": 35
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "panera_bread": {
    "displayName": "Panera Bread",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36,
      "frozen": 4
    },
    "subtypeCounts": {
      "dressing": 24,
      "bread": 15,
      "boxed_meal": 1
    },
    "subtypes": [
      "dressing",
      "bread",
      "boxed_meal"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "mikesells": {
    "displayName": "Mikesell's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 40
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 40,
    "source": "usda"
  },
  "tree_top": {
    "displayName": "Tree Top",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 39,
      "pantry": 1
    },
    "subtypeCounts": {
      "beverage": 39,
      "candy": 1
    },
    "subtypes": [
      "beverage",
      "candy"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "pepsi": {
    "displayName": "Pepsico,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 7,
      "beverage": 33
    },
    "subtypeCounts": {
      "candy": 3,
      "beverage": 33
    },
    "subtypes": [
      "beverage",
      "candy"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "balance": {
    "displayName": "Balance",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 40
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 40,
    "source": "usda"
  },
  "kays": {
    "displayName": "Kay's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 31,
      "pantry": 9
    },
    "subtypeCounts": {
      "ice_cream": 31,
      "cookie": 2
    },
    "subtypes": [
      "ice_cream",
      "cookie"
    ],
    "totalObs": 40,
    "source": "usda"
  },
  "enstrom": {
    "displayName": "Enstrom",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 39
    },
    "subtypeCounts": {
      "chocolate": 30,
      "candy": 9
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 39,
    "source": "usda"
  },
  "toms": {
    "displayName": "Tom's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 39
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 39,
    "source": "usda"
  },
  "premier_protein": {
    "displayName": "Premier Protein",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 38,
      "beverage": 1
    },
    "subtypeCounts": {
      "beverage": 1
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 39,
    "source": "usda"
  },
  "albanese": {
    "displayName": "Albanese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 39
    },
    "subtypeCounts": {
      "candy": 36,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 39,
    "source": "usda"
  },
  "gatorade": {
    "displayName": "Gatorade",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36,
      "beverage": 3
    },
    "subtypeCounts": {
      "beverage": 3
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 39,
    "source": "usda"
  },
  "melissas": {
    "displayName": "Melissas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 17,
      "frozen": 1,
      "pantry": 21
    },
    "subtypeCounts": {
      "bread": 1,
      "baking": 6,
      "spread": 1,
      "sauce": 4
    },
    "subtypes": [
      "baking",
      "sauce",
      "bread",
      "spread"
    ],
    "totalObs": 39,
    "source": "usda"
  },
  "jos_candies": {
    "displayName": "Jo's Candies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 39
    },
    "subtypeCounts": {
      "cookie": 11,
      "chocolate": 11,
      "candy": 17
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate"
    ],
    "totalObs": 39,
    "source": "usda"
  },
  "giannas": {
    "displayName": "Gianna's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 39
    },
    "subtypeCounts": {
      "cookie": 37,
      "bread": 1,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "bread",
      "candy"
    ],
    "totalObs": 39,
    "source": "usda"
  },
  "schar": {
    "displayName": "Schar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34,
      "frozen": 5
    },
    "subtypeCounts": {
      "cookie": 16,
      "bread": 16,
      "boxed_meal": 3,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "bread",
      "boxed_meal",
      "candy"
    ],
    "totalObs": 39,
    "source": "usda"
  },
  "frontera": {
    "displayName": "Frontera",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "frozen": 23
    },
    "subtypeCounts": {
      "sauce": 12,
      "boxed_meal": 23
    },
    "subtypes": [
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 39,
    "source": "usda"
  },
  "bayview_farms": {
    "displayName": "Bayview Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 6,
      "pantry": 3,
      "frozen": 12,
      "dairy": 18
    },
    "subtypeCounts": {
      "beverage": 6,
      "bread": 3,
      "ice_cream": 12,
      "yogurt": 8,
      "milk": 8,
      "cheese": 2
    },
    "subtypes": [
      "ice_cream",
      "yogurt",
      "milk",
      "beverage",
      "bread",
      "cheese"
    ],
    "totalObs": 39,
    "source": "usda"
  },
  "dreyers": {
    "displayName": "Dreyer's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 39
    },
    "subtypeCounts": {
      "ice_cream": 38,
      "bread": 1
    },
    "subtypes": [
      "ice_cream",
      "bread"
    ],
    "totalObs": 39,
    "source": "usda"
  },
  "aldens_organic": {
    "displayName": "Alden's Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 38
    },
    "subtypeCounts": {
      "ice_cream": 38
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "american_beauty": {
    "displayName": "American Beauty",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 38
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 38,
    "source": "usda"
  },
  "schwebels": {
    "displayName": "Schwebel's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 38
    },
    "subtypeCounts": {
      "bread": 38
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "our_specialty": {
    "displayName": "Our Specialty",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 37,
      "dairy": 1
    },
    "subtypeCounts": {
      "cookie": 34,
      "bread": 3,
      "yogurt": 1
    },
    "subtypes": [
      "cookie",
      "bread",
      "yogurt"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "outshine": {
    "displayName": "Outshine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 36,
      "beverage": 2
    },
    "subtypeCounts": {
      "ice_cream": 36,
      "beverage": 2
    },
    "subtypes": [
      "ice_cream",
      "beverage"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "tones": {
    "displayName": "Tones",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 38
    },
    "subtypeCounts": {
      "sauce": 30
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "crowley": {
    "displayName": "Crowley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 37,
      "beverage": 1
    },
    "subtypeCounts": {
      "cheese": 10,
      "milk": 18,
      "yogurt": 9,
      "beverage": 1
    },
    "subtypes": [
      "milk",
      "cheese",
      "yogurt",
      "beverage"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "dairy_pure": {
    "displayName": "Dairy Pure",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 38
    },
    "subtypeCounts": {
      "milk": 37,
      "cheese": 1
    },
    "subtypes": [
      "milk",
      "cheese"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "llege_inn": {
    "displayName": "College Inn",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 38
    },
    "subtypeCounts": {
      "boxed_meal": 38
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "maple_grove_farms_of_vermont": {
    "displayName": "Maple Grove Farms Of Vermont",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 38
    },
    "subtypeCounts": {
      "dressing": 38
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "mrs_bairds": {
    "displayName": "Mrs Baird's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 38
    },
    "subtypeCounts": {
      "bread": 38
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "thats_it": {
    "displayName": "That's It.",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 38
    },
    "subtypeCounts": {
      "chocolate": 13
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "hungry_man": {
    "displayName": "Hungry-man",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 38
    },
    "subtypeCounts": {
      "boxed_meal": 38
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "garden_highway": {
    "displayName": "Garden Highway",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 26,
      "dairy": 2,
      "pantry": 9,
      "frozen": 1
    },
    "subtypeCounts": {
      "yogurt": 2,
      "boxed_meal": 1
    },
    "subtypes": [
      "yogurt",
      "boxed_meal"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "radz": {
    "displayName": "Radz",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 38
    },
    "subtypeCounts": {
      "candy": 38
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "its_your_churn": {
    "displayName": "It's Your Churn",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 38
    },
    "subtypeCounts": {
      "ice_cream": 38
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "alpina": {
    "displayName": "Alpina",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 38
    },
    "subtypeCounts": {
      "yogurt": 36,
      "milk": 2
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 38,
    "source": "usda"
  },
  "mrs_fields": {
    "displayName": "Mrs.fields",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 37
    },
    "subtypeCounts": {
      "cookie": 22,
      "chocolate": 11,
      "candy": 4
    },
    "subtypes": [
      "cookie",
      "chocolate",
      "candy"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "greens": {
    "displayName": "Green's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 21,
      "pantry": 16
    },
    "subtypeCounts": {
      "ice_cream": 21,
      "chocolate": 2
    },
    "subtypes": [
      "ice_cream",
      "chocolate"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "braswells": {
    "displayName": "Braswell's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 37
    },
    "subtypeCounts": {
      "spread": 24,
      "sweetener": 2,
      "dressing": 8,
      "sauce": 2
    },
    "subtypes": [
      "spread",
      "dressing",
      "sweetener",
      "sauce"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "terrys": {
    "displayName": "Terry's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 37
    },
    "subtypeCounts": {
      "chocolate": 6
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "voortman": {
    "displayName": "Voortman",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 37
    },
    "subtypeCounts": {
      "cookie": 37
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "haolam": {
    "displayName": "Haolam",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 37
    },
    "subtypeCounts": {
      "cheese": 37
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "de_cec": {
    "displayName": "De Cecco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 37
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 37,
    "source": "usda"
  },
  "manns": {
    "displayName": "Mann's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 1,
      "pantry": 3,
      "produce": 31,
      "frozen": 2
    },
    "subtypeCounts": {
      "boxed_meal": 2
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "s_rosens": {
    "displayName": "S.rosen's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 37
    },
    "subtypeCounts": {
      "bread": 37
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "natures_own": {
    "displayName": "Nature's Own",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35,
      "beverage": 2
    },
    "subtypeCounts": {
      "bread": 35,
      "beverage": 2
    },
    "subtypes": [
      "bread",
      "beverage"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "red_apple_cheese": {
    "displayName": "Red Apple Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 37
    },
    "subtypeCounts": {
      "cheese": 37
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "imagine": {
    "displayName": "Imagine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35,
      "dairy": 2
    },
    "subtypeCounts": {
      "boxed_meal": 26,
      "sauce": 2,
      "cookie": 1,
      "cheese": 2
    },
    "subtypes": [
      "boxed_meal",
      "sauce",
      "cheese",
      "cookie"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "lactaid": {
    "displayName": "Lactaid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 25,
      "frozen": 12
    },
    "subtypeCounts": {
      "milk": 23,
      "ice_cream": 12,
      "cheese": 2
    },
    "subtypes": [
      "milk",
      "ice_cream",
      "cheese"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "kerns": {
    "displayName": "Kern's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 3,
      "beverage": 28,
      "pantry": 6
    },
    "subtypeCounts": {
      "milk": 3,
      "beverage": 28,
      "bread": 6
    },
    "subtypes": [
      "beverage",
      "bread",
      "milk"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "super_store_industries": {
    "displayName": "Super Store Industries",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 5,
      "dairy": 11,
      "beverage": 1,
      "frozen": 20
    },
    "subtypeCounts": {
      "cookie": 1,
      "cheese": 9,
      "beverage": 1,
      "ice_cream": 20,
      "milk": 1,
      "bread": 1,
      "yogurt": 1
    },
    "subtypes": [
      "ice_cream",
      "cheese",
      "cookie",
      "beverage",
      "milk",
      "bread",
      "yogurt"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "rafael_padilla_cia_s_en_c": {
    "displayName": "Rafael Padilla & Cia S. En C.",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 5,
      "frozen": 6,
      "pantry": 23,
      "dairy": 3
    },
    "subtypeCounts": {
      "beverage": 5,
      "boxed_meal": 7,
      "bread": 1,
      "dressing": 5,
      "sweetener": 2,
      "cheese": 3,
      "chocolate": 1,
      "sauce": 4
    },
    "subtypes": [
      "boxed_meal",
      "beverage",
      "dressing",
      "sauce",
      "cheese",
      "sweetener",
      "bread",
      "chocolate"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "la_fe": {
    "displayName": "La Fe",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 24,
      "pantry": 9,
      "dairy": 2,
      "beverage": 2
    },
    "subtypeCounts": {
      "bread": 3,
      "boxed_meal": 2,
      "baking": 3,
      "cheese": 2,
      "beverage": 2
    },
    "subtypes": [
      "bread",
      "baking",
      "boxed_meal",
      "cheese",
      "beverage"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "castello": {
    "displayName": "Castello",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 37
    },
    "subtypeCounts": {
      "cheese": 37
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "crystal_creamery": {
    "displayName": "Crystal Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11,
      "beverage": 3,
      "frozen": 23
    },
    "subtypeCounts": {
      "cheese": 3,
      "beverage": 3,
      "milk": 8,
      "ice_cream": 23
    },
    "subtypes": [
      "ice_cream",
      "milk",
      "cheese",
      "beverage"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "toufayan_bakeries": {
    "displayName": "Toufayan Bakeries",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 37
    },
    "subtypeCounts": {
      "bread": 37
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 37,
    "source": "usda"
  },
  "pamelas": {
    "displayName": "Pamela's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36
    },
    "subtypeCounts": {
      "baking": 4,
      "cookie": 19,
      "chocolate": 1
    },
    "subtypes": [
      "cookie",
      "baking",
      "chocolate"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "andes": {
    "displayName": "Andes",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36
    },
    "subtypeCounts": {
      "chocolate": 22,
      "candy": 12,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "smarties": {
    "displayName": "Smarties",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36
    },
    "subtypeCounts": {
      "candy": 35,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "good_livin": {
    "displayName": "Good Livin",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20,
      "beverage": 16
    },
    "subtypeCounts": {
      "candy": 18,
      "beverage": 16,
      "chocolate": 1,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "beverage",
      "chocolate",
      "cookie"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "luvo": {
    "displayName": "Luvo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 34,
      "pantry": 2
    },
    "subtypeCounts": {
      "boxed_meal": 33,
      "ice_cream": 1,
      "bread": 1
    },
    "subtypes": [
      "boxed_meal",
      "ice_cream",
      "bread"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "kirkland_signature": {
    "displayName": "Kirkland Signature",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22,
      "beverage": 6,
      "dairy": 6,
      "frozen": 1,
      "meat": 1
    },
    "subtypeCounts": {
      "sweetener": 4,
      "beverage": 6,
      "spread": 1,
      "milk": 1,
      "bread": 1,
      "candy": 2,
      "cookie": 2,
      "cheese": 4,
      "sauce": 3,
      "boxed_meal": 1,
      "baking": 1,
      "sausage": 1,
      "chocolate": 1
    },
    "subtypes": [
      "beverage",
      "sweetener",
      "cheese",
      "sauce",
      "candy",
      "cookie",
      "spread",
      "milk",
      "bread",
      "boxed_meal",
      "baking",
      "sausage",
      "chocolate"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "shop_n_save": {
    "displayName": "Shop N Save",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28,
      "dairy": 8
    },
    "subtypeCounts": {
      "bread": 5,
      "cheese": 1,
      "chocolate": 3,
      "candy": 20,
      "milk": 7
    },
    "subtypes": [
      "candy",
      "milk",
      "bread",
      "chocolate",
      "cheese"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "daily_crave": {
    "displayName": "The Daily Crave",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "yummy": {
    "displayName": "Yummy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 34,
      "pantry": 2
    },
    "subtypeCounts": {
      "boxed_meal": 34,
      "candy": 2
    },
    "subtypes": [
      "boxed_meal",
      "candy"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "tony_chacheres": {
    "displayName": "Tony Chachere's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36
    },
    "subtypeCounts": {
      "sauce": 31,
      "dressing": 3,
      "baking": 1
    },
    "subtypes": [
      "sauce",
      "dressing",
      "baking"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "thorntons": {
    "displayName": "Thorntons",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35,
      "produce": 1
    },
    "subtypeCounts": {
      "candy": 12,
      "chocolate": 23
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "haddon_house": {
    "displayName": "Haddon House",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36
    },
    "subtypeCounts": {
      "sauce": 1
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "dutch_valley_food_distributors": {
    "displayName": "Dutch Valley Food Distributors",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36
    },
    "subtypeCounts": {
      "dressing": 1,
      "candy": 33,
      "chocolate": 2
    },
    "subtypes": [
      "candy",
      "chocolate",
      "dressing"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "dav_i": {
    "displayName": "Davinci",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 36,
    "source": "usda"
  },
  "muller": {
    "displayName": "Muller",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 36
    },
    "subtypeCounts": {
      "yogurt": 36
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "schmidt": {
    "displayName": "Schmidt",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36
    },
    "subtypeCounts": {
      "bread": 36
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "markets_of_meijer": {
    "displayName": "Markets Of Meijer",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30,
      "dairy": 6
    },
    "subtypeCounts": {
      "cookie": 13,
      "bread": 14,
      "cheese": 6
    },
    "subtypes": [
      "bread",
      "cookie",
      "cheese"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "arla": {
    "displayName": "Arla",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 35,
      "pantry": 1
    },
    "subtypeCounts": {
      "cheese": 35
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "pro_bar": {
    "displayName": "Pro Bar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36
    },
    "subtypeCounts": {
      "candy": 1
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "hebert": {
    "displayName": "Hebert",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 36
    },
    "subtypeCounts": {
      "chocolate": 30,
      "candy": 6
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 36,
    "source": "usda"
  },
  "napoleon": {
    "displayName": "Napoleon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35
    },
    "subtypeCounts": {
      "candy": 2,
      "dressing": 1
    },
    "subtypes": [
      "candy",
      "dressing"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "tofts": {
    "displayName": "Toft's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 24,
      "dairy": 11
    },
    "subtypeCounts": {
      "ice_cream": 24,
      "milk": 9,
      "cheese": 2
    },
    "subtypes": [
      "ice_cream",
      "milk",
      "cheese"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "jovial": {
    "displayName": "Jovial",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35
    },
    "subtypeCounts": {
      "baking": 6,
      "cookie": 5
    },
    "subtypes": [
      "baking",
      "cookie"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "true_goodness": {
    "displayName": "True Goodness",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19,
      "frozen": 11,
      "produce": 1,
      "dairy": 4
    },
    "subtypeCounts": {
      "bread": 2,
      "cookie": 2,
      "boxed_meal": 4,
      "cheese": 4
    },
    "subtypes": [
      "boxed_meal",
      "cheese",
      "bread",
      "cookie"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "frenchs": {
    "displayName": "French's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35
    },
    "subtypeCounts": {
      "sauce": 17,
      "dressing": 11
    },
    "subtypes": [
      "sauce",
      "dressing"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "bobs": {
    "displayName": "Bobs",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35
    },
    "subtypeCounts": {
      "candy": 28,
      "dressing": 7
    },
    "subtypes": [
      "candy",
      "dressing"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "reds": {
    "displayName": "Red's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 35
    },
    "subtypeCounts": {
      "boxed_meal": 35
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "archway": {
    "displayName": "Archway",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35
    },
    "subtypeCounts": {
      "cookie": 34,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "bakery_baked_with_pride": {
    "displayName": "The Bakery Baked With Pride",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35
    },
    "subtypeCounts": {
      "cookie": 27,
      "bread": 7,
      "chocolate": 1
    },
    "subtypes": [
      "cookie",
      "bread",
      "chocolate"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "urban_remedy": {
    "displayName": "Urban Remedy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 18,
      "pantry": 13,
      "meat": 2,
      "dairy": 1,
      "produce": 1
    },
    "subtypeCounts": {
      "beverage": 18,
      "boxed_meal": 2,
      "cookie": 1,
      "candy": 1
    },
    "subtypes": [
      "beverage",
      "boxed_meal",
      "cookie",
      "candy"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "promised_land_dairy": {
    "displayName": "Promised Land Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 35
    },
    "subtypeCounts": {
      "milk": 35
    },
    "subtypes": [
      "milk"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "pacific_ast_selections": {
    "displayName": "Pacific Coast Selections",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34,
      "frozen": 1
    },
    "subtypeCounts": {
      "bread": 5,
      "boxed_meal": 1,
      "sauce": 4,
      "dressing": 2,
      "spread": 3,
      "sweetener": 2,
      "chocolate": 1
    },
    "subtypes": [
      "bread",
      "sauce",
      "spread",
      "dressing",
      "sweetener",
      "boxed_meal",
      "chocolate"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "dorothy_lane_market": {
    "displayName": "Dorothy Lane Market",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 33,
      "beverage": 2
    },
    "subtypeCounts": {
      "bread": 4,
      "spread": 9,
      "cookie": 9,
      "dressing": 1,
      "beverage": 2,
      "chocolate": 1,
      "sweetener": 2
    },
    "subtypes": [
      "spread",
      "cookie",
      "bread",
      "beverage",
      "sweetener",
      "dressing",
      "chocolate"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "unreal": {
    "displayName": "Unreal",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35
    },
    "subtypeCounts": {
      "candy": 22,
      "chocolate": 10
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "smithfield": {
    "displayName": "Smithfield",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 4,
      "meat": 27,
      "pantry": 1,
      "produce": 3
    },
    "subtypeCounts": {
      "cheese": 4,
      "sausage": 27,
      "dressing": 1
    },
    "subtypes": [
      "sausage",
      "cheese",
      "dressing"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "tates_bake_shop": {
    "displayName": "Tate's Bake Shop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35
    },
    "subtypeCounts": {
      "cookie": 35
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "perfect_pasta": {
    "displayName": "Perfect Pasta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31,
      "frozen": 4
    },
    "subtypeCounts": {
      "boxed_meal": 4
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "circle_k": {
    "displayName": "Circle K",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35
    },
    "subtypeCounts": {
      "cookie": 3,
      "beverage": 1,
      "candy": 14
    },
    "subtypes": [
      "candy",
      "cookie",
      "beverage"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "roth": {
    "displayName": "Roth",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 35
    },
    "subtypeCounts": {
      "cheese": 35
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "cha_ching": {
    "displayName": "Cha-ching",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34,
      "beverage": 1
    },
    "subtypeCounts": {
      "dressing": 5,
      "cookie": 14,
      "beverage": 1,
      "bread": 2,
      "sauce": 1
    },
    "subtypes": [
      "cookie",
      "dressing",
      "bread",
      "beverage",
      "sauce"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "back_to_nature": {
    "displayName": "Back To Nature",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32,
      "beverage": 3
    },
    "subtypeCounts": {
      "cookie": 31,
      "boxed_meal": 1,
      "beverage": 3
    },
    "subtypes": [
      "cookie",
      "beverage",
      "boxed_meal"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "margaret_holmes": {
    "displayName": "Margaret Holmes",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 35,
    "source": "usda"
  },
  "untry_fresh": {
    "displayName": "Country Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12,
      "frozen": 1,
      "pantry": 1,
      "produce": 21
    },
    "subtypeCounts": {
      "cheese": 6,
      "milk": 6,
      "ice_cream": 1,
      "candy": 1
    },
    "subtypes": [
      "cheese",
      "milk",
      "ice_cream",
      "candy"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "dean_ja_bs": {
    "displayName": "Dean Jabs",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 35
    },
    "subtypeCounts": {
      "sauce": 25,
      "candy": 1
    },
    "subtypes": [
      "sauce",
      "candy"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "golchin": {
    "displayName": "Golchin",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32,
      "beverage": 3
    },
    "subtypeCounts": {
      "candy": 4,
      "beverage": 3,
      "dressing": 1,
      "spread": 7
    },
    "subtypes": [
      "spread",
      "candy",
      "beverage",
      "dressing"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "vintage": {
    "displayName": "Vintage",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 35
    },
    "subtypeCounts": {
      "beverage": 35
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "cascade_ice": {
    "displayName": "Cascade Ice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 35
    },
    "subtypeCounts": {
      "beverage": 35
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "olhaus": {
    "displayName": "Coolhaus",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 35
    },
    "subtypeCounts": {
      "ice_cream": 35
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 35,
    "source": "usda"
  },
  "bblestone_bread": {
    "displayName": "Cobblestone Bread",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34
    },
    "subtypeCounts": {
      "bread": 34
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "riceselect": {
    "displayName": "Riceselect",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 34,
    "source": "usda"
  },
  "ortega": {
    "displayName": "Ortega",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30,
      "dairy": 4
    },
    "subtypeCounts": {
      "sauce": 19,
      "cheese": 4,
      "dressing": 3
    },
    "subtypes": [
      "sauce",
      "cheese",
      "dressing"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "heavenly_organics": {
    "displayName": "Heavenly Organics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34
    },
    "subtypeCounts": {
      "candy": 6,
      "chocolate": 23,
      "sweetener": 5
    },
    "subtypes": [
      "chocolate",
      "candy",
      "sweetener"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "natierra": {
    "displayName": "Natierra",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34
    },
    "subtypeCounts": {
      "sauce": 26,
      "baking": 4,
      "cookie": 1
    },
    "subtypes": [
      "sauce",
      "baking",
      "cookie"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "sun_chips": {
    "displayName": "Sun Chips",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 34,
    "source": "usda"
  },
  "cho_love": {
    "displayName": "Chocolove",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34
    },
    "subtypeCounts": {
      "chocolate": 28,
      "candy": 6
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "king_arthur_flour": {
    "displayName": "King Arthur Flour",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34
    },
    "subtypeCounts": {
      "baking": 33,
      "sauce": 1
    },
    "subtypes": [
      "baking",
      "sauce"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "horizon": {
    "displayName": "Horizon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 28,
      "pantry": 6
    },
    "subtypeCounts": {
      "milk": 18,
      "candy": 3,
      "cookie": 3,
      "cheese": 3,
      "yogurt": 7
    },
    "subtypes": [
      "milk",
      "yogurt",
      "candy",
      "cookie",
      "cheese"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "maggi": {
    "displayName": "Maggi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34
    },
    "subtypeCounts": {
      "sauce": 32,
      "boxed_meal": 2
    },
    "subtypes": [
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "hawaiian_punch": {
    "displayName": "Hawaiian Punch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 9,
      "beverage": 20,
      "frozen": 5
    },
    "subtypeCounts": {
      "candy": 9,
      "beverage": 20,
      "ice_cream": 5
    },
    "subtypes": [
      "beverage",
      "candy",
      "ice_cream"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "kellogg": {
    "displayName": "The Kellogg",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34
    },
    "subtypeCounts": {
      "cookie": 6,
      "candy": 5
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "lemonhead": {
    "displayName": "Lemonhead",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 33,
      "frozen": 1
    },
    "subtypeCounts": {
      "candy": 33,
      "ice_cream": 1
    },
    "subtypes": [
      "candy",
      "ice_cream"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "silk": {
    "displayName": "Silk",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 34
    },
    "subtypeCounts": {
      "yogurt": 30,
      "milk": 4
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "momentum": {
    "displayName": "Momentum",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34
    },
    "subtypeCounts": {
      "chocolate": 7,
      "candy": 23
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "galil": {
    "displayName": "Galil",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31,
      "frozen": 1,
      "produce": 2
    },
    "subtypeCounts": {
      "spread": 8,
      "cookie": 3,
      "candy": 6
    },
    "subtypes": [
      "spread",
      "candy",
      "cookie"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "hain_celestial": {
    "displayName": "Hain Celestial",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31,
      "beverage": 3
    },
    "subtypeCounts": {
      "boxed_meal": 6,
      "beverage": 3
    },
    "subtypes": [
      "boxed_meal",
      "beverage"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "rite_aid": {
    "displayName": "Rite Aid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24,
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10,
      "candy": 10,
      "cookie": 2,
      "chocolate": 3,
      "spread": 1,
      "sauce": 1
    },
    "subtypes": [
      "beverage",
      "candy",
      "chocolate",
      "cookie",
      "spread",
      "sauce"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "glory": {
    "displayName": "Glory",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28,
      "produce": 6
    },
    "subtypeCounts": {
      "boxed_meal": 1
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "stauffers": {
    "displayName": "Stauffer's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34
    },
    "subtypeCounts": {
      "chocolate": 2,
      "cookie": 32
    },
    "subtypes": [
      "cookie",
      "chocolate"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "eden": {
    "displayName": "Eden",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30,
      "produce": 1,
      "beverage": 3
    },
    "subtypeCounts": {
      "sauce": 4,
      "baking": 3,
      "spread": 4,
      "dressing": 1,
      "beverage": 3
    },
    "subtypes": [
      "sauce",
      "spread",
      "baking",
      "beverage",
      "dressing"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "marinela": {
    "displayName": "Marinela",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 34
    },
    "subtypeCounts": {
      "cookie": 33,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "hello_kitty": {
    "displayName": "Hello Kitty",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 1,
      "pantry": 33
    },
    "subtypeCounts": {
      "ice_cream": 1,
      "sauce": 1,
      "candy": 23,
      "cookie": 7,
      "chocolate": 2
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate",
      "ice_cream",
      "sauce"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "spindrift": {
    "displayName": "Spindrift",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 34
    },
    "subtypeCounts": {
      "beverage": 34
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 34,
    "source": "usda"
  },
  "ballreichs": {
    "displayName": "Ballreich's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 33
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 33,
    "source": "usda"
  },
  "warheads": {
    "displayName": "Warheads",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31,
      "frozen": 2
    },
    "subtypeCounts": {
      "candy": 31,
      "ice_cream": 2
    },
    "subtypes": [
      "candy",
      "ice_cream"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "slimfast": {
    "displayName": "Slimfast",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 33
    },
    "subtypeCounts": {
      "cookie": 2,
      "chocolate": 1,
      "beverage": 1
    },
    "subtypes": [
      "cookie",
      "chocolate",
      "beverage"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "on_border": {
    "displayName": "On The Border",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27,
      "dairy": 6
    },
    "subtypeCounts": {
      "cheese": 6
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "white_castle": {
    "displayName": "White Castle",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 32,
      "pantry": 1
    },
    "subtypeCounts": {
      "boxed_meal": 31,
      "ice_cream": 1,
      "bread": 1
    },
    "subtypes": [
      "boxed_meal",
      "ice_cream",
      "bread"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "kite_hill": {
    "displayName": "Kite Hill",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 33
    },
    "subtypeCounts": {
      "cheese": 9,
      "yogurt": 22,
      "milk": 2
    },
    "subtypes": [
      "yogurt",
      "cheese",
      "milk"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "price_first": {
    "displayName": "Price First",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 7,
      "pantry": 23,
      "beverage": 2,
      "frozen": 1
    },
    "subtypeCounts": {
      "yogurt": 3,
      "dressing": 3,
      "cookie": 2,
      "beverage": 2,
      "bread": 7,
      "spread": 2,
      "ice_cream": 1,
      "milk": 4
    },
    "subtypes": [
      "bread",
      "milk",
      "yogurt",
      "dressing",
      "cookie",
      "beverage",
      "spread",
      "ice_cream"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "pet": {
    "displayName": "Pet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10,
      "dairy": 21,
      "beverage": 2
    },
    "subtypeCounts": {
      "ice_cream": 10,
      "milk": 21,
      "beverage": 2
    },
    "subtypes": [
      "milk",
      "ice_cream",
      "beverage"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "santa_cruz_organic": {
    "displayName": "Santa Cruz Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 28,
      "pantry": 5
    },
    "subtypeCounts": {
      "beverage": 28,
      "spread": 5
    },
    "subtypes": [
      "beverage",
      "spread"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "treat_street": {
    "displayName": "Treat Street",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 33
    },
    "subtypeCounts": {
      "candy": 30,
      "cookie": 1,
      "chocolate": 2
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "harry_david": {
    "displayName": "Harry & David",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 33
    },
    "subtypeCounts": {
      "cookie": 5,
      "candy": 2,
      "chocolate": 19,
      "spread": 2
    },
    "subtypes": [
      "chocolate",
      "cookie",
      "candy",
      "spread"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "yanceys_fancy": {
    "displayName": "Yancey's Fancy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 33
    },
    "subtypeCounts": {
      "cheese": 33
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "my_mo": {
    "displayName": "My/mo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 33
    },
    "subtypeCounts": {
      "ice_cream": 33
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "sophia": {
    "displayName": "Sophia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30,
      "beverage": 2,
      "dairy": 1
    },
    "subtypeCounts": {
      "bread": 5,
      "cookie": 2,
      "beverage": 2,
      "cheese": 1,
      "sweetener": 3,
      "sauce": 3
    },
    "subtypes": [
      "bread",
      "sweetener",
      "sauce",
      "cookie",
      "beverage",
      "cheese"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "gomacro": {
    "displayName": "Gomacro",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 33
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 33,
    "source": "usda"
  },
  "fred_meyer": {
    "displayName": "Fred Meyer",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "dairy": 15,
      "meat": 2
    },
    "subtypeCounts": {
      "dressing": 5,
      "bread": 3,
      "cheese": 6,
      "milk": 2,
      "yogurt": 7,
      "sausage": 2,
      "boxed_meal": 1
    },
    "subtypes": [
      "yogurt",
      "cheese",
      "dressing",
      "bread",
      "milk",
      "sausage",
      "boxed_meal"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "american_heritage": {
    "displayName": "American Heritage",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 33
    },
    "subtypeCounts": {
      "cheese": 33
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "old_home": {
    "displayName": "Old Home",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15,
      "pantry": 18
    },
    "subtypeCounts": {
      "yogurt": 10,
      "cheese": 5,
      "bread": 18
    },
    "subtypes": [
      "bread",
      "yogurt",
      "cheese"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "price_chopper_supermarkets": {
    "displayName": "Price Chopper Supermarkets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11,
      "pantry": 16,
      "produce": 3,
      "dairy": 3
    },
    "subtypeCounts": {
      "ice_cream": 11,
      "candy": 6,
      "sauce": 1,
      "boxed_meal": 1,
      "chocolate": 1,
      "bread": 3,
      "cheese": 3
    },
    "subtypes": [
      "ice_cream",
      "candy",
      "bread",
      "cheese",
      "sauce",
      "boxed_meal",
      "chocolate"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "crystal_geyser": {
    "displayName": "Crystal Geyser",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 33
    },
    "subtypeCounts": {
      "beverage": 33
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "rolo": {
    "displayName": "Rolo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 29,
      "frozen": 4
    },
    "subtypeCounts": {
      "chocolate": 16,
      "candy": 13,
      "ice_cream": 4
    },
    "subtypes": [
      "chocolate",
      "candy",
      "ice_cream"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "danone": {
    "displayName": "Danone",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 33
    },
    "subtypeCounts": {
      "milk": 17,
      "yogurt": 16
    },
    "subtypes": [
      "milk",
      "yogurt"
    ],
    "totalObs": 33,
    "source": "usda"
  },
  "endangered_species_cho_late": {
    "displayName": "Endangered Species Chocolate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32
    },
    "subtypeCounts": {
      "chocolate": 30,
      "candy": 2
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "better_chip": {
    "displayName": "The Better Chip",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 32,
    "source": "usda"
  },
  "moran_orporated": {
    "displayName": "The Moran Incorporated",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19,
      "frozen": 10,
      "dairy": 2,
      "beverage": 1
    },
    "subtypeCounts": {
      "bread": 7,
      "sweetener": 1,
      "boxed_meal": 8,
      "cheese": 2,
      "sauce": 2,
      "beverage": 1,
      "candy": 4
    },
    "subtypes": [
      "boxed_meal",
      "bread",
      "candy",
      "cheese",
      "sauce",
      "sweetener",
      "beverage"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "s_pellegrino": {
    "displayName": "S.pellegrino",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 32
    },
    "subtypeCounts": {
      "beverage": 32
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "de_rated_okie": {
    "displayName": "Deratedokie",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32
    },
    "subtypeCounts": {
      "cookie": 32
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "sweets": {
    "displayName": "Sweets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32
    },
    "subtypeCounts": {
      "chocolate": 6,
      "candy": 26
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "hostess": {
    "displayName": "Hostess",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23,
      "frozen": 8,
      "dairy": 1
    },
    "subtypeCounts": {
      "bread": 6,
      "cookie": 16,
      "ice_cream": 8,
      "cheese": 1,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "ice_cream",
      "bread",
      "cheese",
      "candy"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "muscle_milk": {
    "displayName": "Muscle Milk",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27,
      "dairy": 5
    },
    "subtypeCounts": {
      "yogurt": 5
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "rosina": {
    "displayName": "Rosina",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10,
      "pantry": 22
    },
    "subtypeCounts": {
      "boxed_meal": 10
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "melville_candy": {
    "displayName": "Melville Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32
    },
    "subtypeCounts": {
      "candy": 30,
      "chocolate": 2
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "nassau_candy": {
    "displayName": "Nassau Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32
    },
    "subtypeCounts": {
      "candy": 13,
      "chocolate": 16,
      "cookie": 3
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "divine_cho_late": {
    "displayName": "Divine Chocolate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32
    },
    "subtypeCounts": {
      "chocolate": 32
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "montchevre": {
    "displayName": "Montchevre",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 32
    },
    "subtypeCounts": {
      "cheese": 32
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "sun_of_italy": {
    "displayName": "Sun Of Italy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 4,
      "pantry": 28
    },
    "subtypeCounts": {
      "cheese": 4
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "sweethearts": {
    "displayName": "Sweethearts",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 32
    },
    "subtypeCounts": {
      "candy": 32
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "arizona": {
    "displayName": "Arizona",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 28,
      "pantry": 4
    },
    "subtypeCounts": {
      "beverage": 28,
      "sauce": 4
    },
    "subtypes": [
      "beverage",
      "sauce"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "polly_o": {
    "displayName": "Polly-o",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 32
    },
    "subtypeCounts": {
      "cheese": 32
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 32,
    "source": "usda"
  },
  "two_brothers": {
    "displayName": "Two Brothers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20,
      "frozen": 11
    },
    "subtypeCounts": {
      "chocolate": 14,
      "ice_cream": 11,
      "candy": 1,
      "spread": 1,
      "dressing": 2,
      "sauce": 2
    },
    "subtypes": [
      "chocolate",
      "ice_cream",
      "dressing",
      "sauce",
      "candy",
      "spread"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "bomb_pop": {
    "displayName": "Bomb Pop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 31
    },
    "subtypeCounts": {
      "ice_cream": 31
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "real": {
    "displayName": "Real",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 7,
      "beverage": 6,
      "dairy": 6,
      "produce": 3,
      "meat": 9
    },
    "subtypeCounts": {
      "baking": 1,
      "beverage": 6,
      "cheese": 2,
      "sauce": 2,
      "yogurt": 4,
      "boxed_meal": 9
    },
    "subtypes": [
      "boxed_meal",
      "beverage",
      "yogurt",
      "cheese",
      "sauce",
      "baking"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "hammonds_candies": {
    "displayName": "Hammonds Candies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31
    },
    "subtypeCounts": {
      "chocolate": 8,
      "candy": 23
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "paskesz": {
    "displayName": "Paskesz",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31
    },
    "subtypeCounts": {
      "candy": 18,
      "cookie": 6,
      "baking": 1,
      "chocolate": 1,
      "dressing": 1
    },
    "subtypes": [
      "candy",
      "cookie",
      "baking",
      "chocolate",
      "dressing"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "robert_rothschild_farm": {
    "displayName": "Robert Rothschild Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25,
      "dairy": 5,
      "produce": 1
    },
    "subtypeCounts": {
      "spread": 18,
      "cheese": 5,
      "dressing": 2
    },
    "subtypes": [
      "spread",
      "cheese",
      "dressing"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "forager_project": {
    "displayName": "Forager Project",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 27,
      "pantry": 1,
      "beverage": 3
    },
    "subtypeCounts": {
      "yogurt": 25,
      "milk": 2,
      "beverage": 3
    },
    "subtypes": [
      "yogurt",
      "beverage",
      "milk"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "oatmega": {
    "displayName": "Oatmega",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31
    },
    "subtypeCounts": {
      "cookie": 3
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "dirty": {
    "displayName": "Dirty",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 31,
    "source": "usda"
  },
  "jimmy_dean": {
    "displayName": "Jimmy Dean",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 18,
      "meat": 13
    },
    "subtypeCounts": {
      "boxed_meal": 18,
      "sausage": 13
    },
    "subtypes": [
      "boxed_meal",
      "sausage"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "johnv_e": {
    "displayName": "Johnvince",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31
    },
    "subtypeCounts": {
      "candy": 24,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "three_twins_ice_cream": {
    "displayName": "Three Twins Ice Cream",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 31
    },
    "subtypeCounts": {
      "ice_cream": 31
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "oberweis": {
    "displayName": "Oberweis",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 26,
      "dairy": 5
    },
    "subtypeCounts": {
      "ice_cream": 26,
      "milk": 5
    },
    "subtypes": [
      "ice_cream",
      "milk"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "good_culture": {
    "displayName": "Good Culture",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 31
    },
    "subtypeCounts": {
      "cheese": 25,
      "milk": 5,
      "yogurt": 1
    },
    "subtypes": [
      "cheese",
      "milk",
      "yogurt"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "breakstones": {
    "displayName": "Breakstone's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 31
    },
    "subtypeCounts": {
      "cheese": 26,
      "milk": 5
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "trumoo": {
    "displayName": "Trumoo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 22,
      "frozen": 9
    },
    "subtypeCounts": {
      "milk": 22,
      "ice_cream": 9
    },
    "subtypes": [
      "milk",
      "ice_cream"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "xochitl": {
    "displayName": "Xochitl",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 29,
      "dairy": 2
    },
    "subtypeCounts": {
      "cheese": 2
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "hagan": {
    "displayName": "Hagan",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 31
    },
    "subtypeCounts": {
      "ice_cream": 31
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "fun_sweets": {
    "displayName": "Fun Sweets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31
    },
    "subtypeCounts": {
      "candy": 31
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "safeway_kitchens": {
    "displayName": "Safeway Kitchens",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27,
      "frozen": 4
    },
    "subtypeCounts": {
      "cookie": 5,
      "sauce": 4,
      "sweetener": 2,
      "ice_cream": 1,
      "boxed_meal": 3,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "sauce",
      "boxed_meal",
      "sweetener",
      "ice_cream",
      "candy"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "grandmas": {
    "displayName": "Grandma's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31
    },
    "subtypeCounts": {
      "cookie": 31
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "butternut": {
    "displayName": "Butternut",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31
    },
    "subtypeCounts": {
      "bread": 31
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "roundys_select": {
    "displayName": "Roundy's Select",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "beverage": 4,
      "frozen": 6,
      "dairy": 8
    },
    "subtypeCounts": {
      "candy": 1,
      "chocolate": 3,
      "beverage": 4,
      "ice_cream": 6,
      "spread": 4,
      "milk": 7,
      "dressing": 2,
      "cheese": 1,
      "boxed_meal": 2
    },
    "subtypes": [
      "milk",
      "ice_cream",
      "beverage",
      "spread",
      "chocolate",
      "dressing",
      "boxed_meal",
      "candy",
      "cheese"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "mrs_kleins": {
    "displayName": "Mrs Klein's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30,
      "frozen": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "john_soules": {
    "displayName": "John Soules",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 31
    },
    "subtypeCounts": {
      "boxed_meal": 31
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "severino_homemade_pasta": {
    "displayName": "Severino Homemade Pasta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19,
      "frozen": 11,
      "meat": 1
    },
    "subtypeCounts": {
      "boxed_meal": 12
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "vigo": {
    "displayName": "Vigo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31
    },
    "subtypeCounts": {
      "sauce": 1
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "ta_ma_boys": {
    "displayName": "Tacoma Boys",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 31
    },
    "subtypeCounts": {
      "dressing": 18,
      "spread": 4,
      "baking": 3,
      "sauce": 1
    },
    "subtypes": [
      "dressing",
      "spread",
      "baking",
      "sauce"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "jenis": {
    "displayName": "Jenis",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 31
    },
    "subtypeCounts": {
      "ice_cream": 31
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "umpqua_dairy": {
    "displayName": "Umpqua Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 31
    },
    "subtypeCounts": {
      "cheese": 1,
      "milk": 30
    },
    "subtypes": [
      "milk",
      "cheese"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "p_f_changs": {
    "displayName": "P.f. Chang's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 31
    },
    "subtypeCounts": {
      "boxed_meal": 31
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 31,
    "source": "usda"
  },
  "ocho": {
    "displayName": "Ocho",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {
      "candy": 18,
      "chocolate": 9
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "late_july_snacks": {
    "displayName": "Late July Snacks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 30,
    "source": "usda"
  },
  "daves_killer_bread": {
    "displayName": "Dave's Killer Bread",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {
      "bread": 30
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "palazzolos": {
    "displayName": "Palazzolo's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 30
    },
    "subtypeCounts": {
      "ice_cream": 30
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "cacique": {
    "displayName": "Cacique",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 29,
      "frozen": 1
    },
    "subtypeCounts": {
      "cheese": 23,
      "milk": 6,
      "boxed_meal": 1
    },
    "subtypes": [
      "cheese",
      "milk",
      "boxed_meal"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "jarlsberg": {
    "displayName": "Jarlsberg",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 30
    },
    "subtypeCounts": {
      "cheese": 30
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "rhodes": {
    "displayName": "Rhodes",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 29,
      "pantry": 1
    },
    "subtypeCounts": {
      "bread": 30
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "superior_on_main": {
    "displayName": "Superior On Main",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {
      "cookie": 30
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "untry_kitchen": {
    "displayName": "Country Kitchen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {
      "bread": 30
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "alo": {
    "displayName": "Alo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 30
    },
    "subtypeCounts": {
      "beverage": 30
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "bobos": {
    "displayName": "Bobo's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {
      "cookie": 4
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "anderson_dairy": {
    "displayName": "Anderson Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 30
    },
    "subtypeCounts": {
      "milk": 26,
      "cheese": 4
    },
    "subtypes": [
      "milk",
      "cheese"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "athenos": {
    "displayName": "Athenos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 27,
      "pantry": 3
    },
    "subtypeCounts": {
      "cheese": 27,
      "dressing": 3
    },
    "subtypes": [
      "cheese",
      "dressing"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "ross_acquisition": {
    "displayName": "Ross Acquisition",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {
      "cookie": 1,
      "candy": 24,
      "chocolate": 5
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "snyder_of_berlin": {
    "displayName": "Snyder Of Berlin",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 30,
    "source": "usda"
  },
  "paw_patrol": {
    "displayName": "Paw Patrol",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28,
      "dairy": 2
    },
    "subtypeCounts": {
      "candy": 23,
      "cheese": 2,
      "chocolate": 1,
      "cookie": 4
    },
    "subtypes": [
      "candy",
      "cookie",
      "cheese",
      "chocolate"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "utz_quality": {
    "displayName": "Utz Quality ,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 30,
    "source": "usda"
  },
  "riviana": {
    "displayName": "Riviana",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 30,
    "source": "usda"
  },
  "alvarado_st_bakery": {
    "displayName": "Alvarado St. Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {
      "bread": 29
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "maple_hill_creamery": {
    "displayName": "Maple Hill Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 30
    },
    "subtypeCounts": {
      "yogurt": 30
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "stonyfield_organic": {
    "displayName": "Stonyfield Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 24,
      "frozen": 4,
      "pantry": 1,
      "beverage": 1
    },
    "subtypeCounts": {
      "yogurt": 22,
      "ice_cream": 4,
      "candy": 1,
      "milk": 2,
      "beverage": 1
    },
    "subtypes": [
      "yogurt",
      "ice_cream",
      "milk",
      "candy",
      "beverage"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "axelrod": {
    "displayName": "Axelrod",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 30
    },
    "subtypeCounts": {
      "yogurt": 16,
      "cheese": 8,
      "milk": 6
    },
    "subtypes": [
      "yogurt",
      "cheese",
      "milk"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "royal": {
    "displayName": "Royal",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {
      "baking": 3,
      "sauce": 1
    },
    "subtypes": [
      "baking",
      "sauce"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "smiths": {
    "displayName": "Smith's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 6,
      "dairy": 21,
      "pantry": 3
    },
    "subtypeCounts": {
      "ice_cream": 6,
      "milk": 19,
      "cheese": 2,
      "dressing": 1,
      "cookie": 1,
      "bread": 1
    },
    "subtypes": [
      "milk",
      "ice_cream",
      "cheese",
      "dressing",
      "cookie",
      "bread"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "magnum": {
    "displayName": "Magnum",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 30
    },
    "subtypeCounts": {
      "ice_cream": 30
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "pearsons": {
    "displayName": "Pearson's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {
      "chocolate": 8,
      "candy": 22
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "palmers_candies": {
    "displayName": "Palmer's Candies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 30
    },
    "subtypeCounts": {
      "candy": 23,
      "chocolate": 7
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 30,
    "source": "usda"
  },
  "vermont_creamery": {
    "displayName": "Vermont Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 29
    },
    "subtypeCounts": {
      "cheese": 25,
      "milk": 3,
      "yogurt": 1
    },
    "subtypes": [
      "cheese",
      "milk",
      "yogurt"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "cains": {
    "displayName": "Cains",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28,
      "produce": 1
    },
    "subtypeCounts": {
      "dressing": 13,
      "sauce": 2
    },
    "subtypes": [
      "dressing",
      "sauce"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "kaskeys": {
    "displayName": "Kaskey's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 29
    },
    "subtypeCounts": {
      "boxed_meal": 27,
      "sauce": 2
    },
    "subtypes": [
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "anderson_erickson": {
    "displayName": "Anderson Erickson",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 26,
      "beverage": 3
    },
    "subtypeCounts": {
      "yogurt": 10,
      "milk": 16,
      "beverage": 3
    },
    "subtypes": [
      "milk",
      "yogurt",
      "beverage"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "original_gourmet": {
    "displayName": "Original Gourmet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 29
    },
    "subtypeCounts": {
      "candy": 9,
      "cookie": 20
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "eating_right": {
    "displayName": "Eating Right",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "frozen": 15
    },
    "subtypeCounts": {
      "cookie": 1,
      "bread": 1,
      "boxed_meal": 15
    },
    "subtypes": [
      "boxed_meal",
      "cookie",
      "bread"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "martins": {
    "displayName": "Martin's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 1,
      "pantry": 28
    },
    "subtypeCounts": {
      "bread": 6
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "veryfine": {
    "displayName": "Veryfine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 28,
      "pantry": 1
    },
    "subtypeCounts": {
      "beverage": 28
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "el_sembrador": {
    "displayName": "El Sembrador",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 21,
      "pantry": 4,
      "dairy": 3,
      "produce": 1
    },
    "subtypeCounts": {
      "boxed_meal": 8,
      "cheese": 3,
      "baking": 1,
      "ice_cream": 1,
      "bread": 4
    },
    "subtypes": [
      "boxed_meal",
      "bread",
      "cheese",
      "baking",
      "ice_cream"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "moonpie": {
    "displayName": "Moonpie",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28,
      "frozen": 1
    },
    "subtypeCounts": {
      "cookie": 26,
      "ice_cream": 1,
      "candy": 2
    },
    "subtypes": [
      "cookie",
      "candy",
      "ice_cream"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "penny_smart": {
    "displayName": "Penny Smart",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11,
      "pantry": 17,
      "beverage": 1
    },
    "subtypeCounts": {
      "cheese": 5,
      "milk": 4,
      "bread": 4,
      "beverage": 1,
      "sauce": 4,
      "dressing": 2
    },
    "subtypes": [
      "cheese",
      "milk",
      "bread",
      "sauce",
      "dressing",
      "beverage"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "riceland": {
    "displayName": "Riceland",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 29
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 29,
    "source": "usda"
  },
  "rac_nto": {
    "displayName": "Racconto",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23,
      "beverage": 1,
      "dairy": 5
    },
    "subtypeCounts": {
      "sauce": 2,
      "beverage": 1,
      "cheese": 5
    },
    "subtypes": [
      "cheese",
      "sauce",
      "beverage"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "bonne_maman": {
    "displayName": "Bonne Maman",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28,
      "dairy": 1
    },
    "subtypeCounts": {
      "spread": 28,
      "cheese": 1
    },
    "subtypes": [
      "spread",
      "cheese"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "state_fair": {
    "displayName": "State Fair",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 25,
      "pantry": 4
    },
    "subtypeCounts": {
      "boxed_meal": 25,
      "sauce": 1,
      "dressing": 2
    },
    "subtypes": [
      "boxed_meal",
      "dressing",
      "sauce"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "farm_fresh": {
    "displayName": "Farm Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 4,
      "dairy": 24,
      "produce": 1
    },
    "subtypeCounts": {
      "milk": 20,
      "cheese": 4,
      "dressing": 3
    },
    "subtypes": [
      "milk",
      "cheese",
      "dressing"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "hy_top": {
    "displayName": "Hy-top",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20,
      "frozen": 2,
      "dairy": 3,
      "beverage": 4
    },
    "subtypeCounts": {
      "sweetener": 1,
      "sauce": 3,
      "bread": 3,
      "dressing": 3,
      "cheese": 2,
      "candy": 2,
      "milk": 1,
      "beverage": 4
    },
    "subtypes": [
      "beverage",
      "sauce",
      "bread",
      "dressing",
      "cheese",
      "candy",
      "sweetener",
      "milk"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "time_originals": {
    "displayName": "Time Originals",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "beverage": 3,
      "frozen": 6,
      "dairy": 3,
      "meat": 1,
      "produce": 1
    },
    "subtypeCounts": {
      "cookie": 7,
      "beverage": 3,
      "ice_cream": 6,
      "cheese": 3,
      "dressing": 2,
      "spread": 1,
      "chocolate": 2,
      "sausage": 1
    },
    "subtypes": [
      "cookie",
      "ice_cream",
      "beverage",
      "cheese",
      "dressing",
      "chocolate",
      "spread",
      "sausage"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "nchita": {
    "displayName": "nchita",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24,
      "beverage": 5
    },
    "subtypeCounts": {
      "baking": 5,
      "beverage": 5,
      "sauce": 3,
      "sweetener": 1
    },
    "subtypes": [
      "baking",
      "beverage",
      "sauce",
      "sweetener"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "toll_house": {
    "displayName": "Toll House",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 16,
      "pantry": 13
    },
    "subtypeCounts": {
      "ice_cream": 10,
      "cookie": 9,
      "bread": 6,
      "chocolate": 3,
      "baking": 1
    },
    "subtypes": [
      "ice_cream",
      "cookie",
      "bread",
      "chocolate",
      "baking"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "fruit2o": {
    "displayName": "Fruit2o",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 29
    },
    "subtypeCounts": {
      "beverage": 29
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "la_croix": {
    "displayName": "La Croix",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 29
    },
    "subtypeCounts": {
      "beverage": 29
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "severino": {
    "displayName": "Severino",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 6,
      "pantry": 23
    },
    "subtypeCounts": {
      "boxed_meal": 6
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "kit_kat": {
    "displayName": "Kit Kat",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 4,
      "pantry": 25
    },
    "subtypeCounts": {
      "ice_cream": 4,
      "cookie": 2,
      "candy": 17,
      "chocolate": 6
    },
    "subtypes": [
      "candy",
      "chocolate",
      "ice_cream",
      "cookie"
    ],
    "totalObs": 29,
    "source": "usda"
  },
  "taza_cho_late": {
    "displayName": "Taza Chocolate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "chocolate": 21,
      "candy": 5,
      "cookie": 2
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "ring_pop": {
    "displayName": "Ring Pop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "candy": 28
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "madhava": {
    "displayName": "Madhava",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25,
      "beverage": 3
    },
    "subtypeCounts": {
      "sweetener": 25,
      "beverage": 3
    },
    "subtypes": [
      "sweetener",
      "beverage"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "untry_dairy": {
    "displayName": "Country Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 19,
      "dairy": 9
    },
    "subtypeCounts": {
      "ice_cream": 19,
      "milk": 9
    },
    "subtypes": [
      "ice_cream",
      "milk"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "little_salad_bar": {
    "displayName": "Little Salad Bar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 22,
      "pantry": 6
    },
    "subtypeCounts": {
      "dressing": 4
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "good_humor": {
    "displayName": "Good Humor",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 28
    },
    "subtypeCounts": {
      "ice_cream": 28
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "safeway_select": {
    "displayName": "Safeway Select",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "frozen": 14
    },
    "subtypeCounts": {
      "cookie": 1,
      "boxed_meal": 5,
      "sauce": 2,
      "ice_cream": 9,
      "dressing": 4,
      "spread": 4
    },
    "subtypes": [
      "ice_cream",
      "boxed_meal",
      "dressing",
      "spread",
      "sauce",
      "cookie"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "pop_rners": {
    "displayName": "Popcorners",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 28,
    "source": "usda"
  },
  "affy_tapple": {
    "displayName": "Affy Tapple",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 6,
      "produce": 22
    },
    "subtypeCounts": {
      "candy": 2,
      "chocolate": 3,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "la_bonne_vie": {
    "displayName": "La Bonne Vie",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 28
    },
    "subtypeCounts": {
      "cheese": 27,
      "milk": 1
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "garden_of_life": {
    "displayName": "Garden Of Life",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "chocolate": 2
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "ritter_sport": {
    "displayName": "Ritter Sport",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "candy": 1,
      "chocolate": 26,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "sunbeam": {
    "displayName": "Sunbeam",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "bread": 28
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "skinnygirl": {
    "displayName": "Skinnygirl",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26,
      "beverage": 2
    },
    "subtypeCounts": {
      "dressing": 6,
      "beverage": 2,
      "chocolate": 5,
      "baking": 1,
      "spread": 5
    },
    "subtypes": [
      "dressing",
      "chocolate",
      "spread",
      "beverage",
      "baking"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "kiss_my_keto": {
    "displayName": "Kiss My Keto",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "boxed_meal": 6,
      "chocolate": 6,
      "candy": 2,
      "cookie": 2
    },
    "subtypes": [
      "boxed_meal",
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "el_viajero": {
    "displayName": "El Viajero",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 28
    },
    "subtypeCounts": {
      "cheese": 22,
      "yogurt": 2,
      "milk": 4
    },
    "subtypes": [
      "cheese",
      "milk",
      "yogurt"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "garden_lites": {
    "displayName": "Garden Lites",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 28
    },
    "subtypeCounts": {
      "boxed_meal": 14,
      "bread": 13
    },
    "subtypes": [
      "boxed_meal",
      "bread"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "shoprite_trading": {
    "displayName": "Shoprite Trading",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21,
      "frozen": 2,
      "dairy": 3,
      "beverage": 2
    },
    "subtypeCounts": {
      "sauce": 2,
      "boxed_meal": 2,
      "cookie": 3,
      "cheese": 3,
      "beverage": 2,
      "dressing": 2
    },
    "subtypes": [
      "cookie",
      "cheese",
      "sauce",
      "boxed_meal",
      "beverage",
      "dressing"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "bowl_basket": {
    "displayName": "Bowl& Basket",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 4,
      "produce": 1,
      "pantry": 20,
      "frozen": 3
    },
    "subtypeCounts": {
      "milk": 4,
      "baking": 1,
      "bread": 4,
      "dressing": 1,
      "ice_cream": 3
    },
    "subtypes": [
      "milk",
      "bread",
      "ice_cream",
      "baking",
      "dressing"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "south_beach_diet": {
    "displayName": "South Beach Diet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27,
      "dairy": 1
    },
    "subtypeCounts": {
      "yogurt": 1
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "parrot": {
    "displayName": "Parrot",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 21,
      "pantry": 6,
      "dairy": 1
    },
    "subtypeCounts": {
      "beverage": 21,
      "milk": 1,
      "baking": 1
    },
    "subtypes": [
      "beverage",
      "milk",
      "baking"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "dillman_farm": {
    "displayName": "Dillman Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "spread": 27,
      "dressing": 1
    },
    "subtypes": [
      "spread",
      "dressing"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "project_7": {
    "displayName": "Project 7",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "candy": 28
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "black_forest_organic": {
    "displayName": "Black Forest Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "candy": 28
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "terrapin_ridge_farms": {
    "displayName": "Terrapin Ridge Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27,
      "dairy": 1
    },
    "subtypeCounts": {
      "dressing": 13,
      "spread": 13,
      "cheese": 1
    },
    "subtypes": [
      "dressing",
      "spread",
      "cheese"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "zi": {
    "displayName": "Zico",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 28
    },
    "subtypeCounts": {
      "beverage": 28
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "seattle_cho_lates": {
    "displayName": "Seattle Chocolates",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "chocolate": 27,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "meiji": {
    "displayName": "Meiji",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "cookie": 19,
      "candy": 4,
      "chocolate": 5
    },
    "subtypes": [
      "cookie",
      "chocolate",
      "candy"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "juanitas": {
    "displayName": "Juanita's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "boxed_meal": 22
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "sir_kensingtons": {
    "displayName": "Sir Kensington's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "dressing": 28
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "brookside": {
    "displayName": "Brookside",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "chocolate": 19,
      "candy": 3
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "pero_family_farms": {
    "displayName": "Pero Family Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 24,
      "pantry": 3,
      "meat": 1
    },
    "subtypeCounts": {
      "sauce": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "vita": {
    "displayName": "Vita",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 1,
      "beverage": 27
    },
    "subtypeCounts": {
      "milk": 1,
      "beverage": 27
    },
    "subtypes": [
      "beverage",
      "milk"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "natures_path": {
    "displayName": "Nature's Path",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "cookie": 1,
      "bread": 1
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "meadow_gold": {
    "displayName": "Meadow Gold",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 19,
      "frozen": 8,
      "beverage": 1
    },
    "subtypeCounts": {
      "milk": 15,
      "cheese": 4,
      "ice_cream": 8,
      "beverage": 1
    },
    "subtypes": [
      "milk",
      "ice_cream",
      "cheese",
      "beverage"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "wedderspoon": {
    "displayName": "Wedderspoon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "sweetener": 27,
      "candy": 1
    },
    "subtypes": [
      "sweetener",
      "candy"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "speedy_choice": {
    "displayName": "Speedy Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 28
    },
    "subtypeCounts": {
      "candy": 24,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "mountain_dairy": {
    "displayName": "Mountain Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 2,
      "dairy": 26
    },
    "subtypeCounts": {
      "beverage": 2,
      "milk": 26
    },
    "subtypes": [
      "milk",
      "beverage"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "cub": {
    "displayName": "Cub",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 1,
      "pantry": 20,
      "dairy": 6,
      "meat": 1
    },
    "subtypeCounts": {
      "beverage": 1,
      "bread": 18,
      "milk": 6,
      "sausage": 1
    },
    "subtypes": [
      "bread",
      "milk",
      "beverage",
      "sausage"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "odwalla": {
    "displayName": "Odwalla",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 20,
      "pantry": 7,
      "dairy": 1
    },
    "subtypeCounts": {
      "beverage": 20,
      "milk": 1
    },
    "subtypes": [
      "beverage",
      "milk"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "w_belle_creamery": {
    "displayName": "Cow Belle Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 28
    },
    "subtypeCounts": {
      "ice_cream": 28
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "dasani": {
    "displayName": "Dasani",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 28
    },
    "subtypeCounts": {
      "beverage": 28
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "la_romanella": {
    "displayName": "La Romanella",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 3,
      "pantry": 20,
      "dairy": 5
    },
    "subtypeCounts": {
      "boxed_meal": 3,
      "cheese": 5,
      "baking": 2
    },
    "subtypes": [
      "cheese",
      "boxed_meal",
      "baking"
    ],
    "totalObs": 28,
    "source": "usda"
  },
  "jacksons_honest": {
    "displayName": "Jackson's Honest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 27,
    "source": "usda"
  },
  "laughing_w": {
    "displayName": "The Laughing Cow",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 27
    },
    "subtypeCounts": {
      "cheese": 27
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "mission": {
    "displayName": "Mission",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25,
      "dairy": 2
    },
    "subtypeCounts": {
      "cheese": 2
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "zone_perfect": {
    "displayName": "Zone Perfect",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 27,
    "source": "usda"
  },
  "johnsonville": {
    "displayName": "Johnsonville",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 5,
      "meat": 20,
      "frozen": 2
    },
    "subtypeCounts": {
      "bread": 5,
      "sausage": 20,
      "boxed_meal": 2
    },
    "subtypes": [
      "sausage",
      "bread",
      "boxed_meal"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "fitcrunch": {
    "displayName": "Fitcrunch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 27,
    "source": "usda"
  },
  "cucina_amore": {
    "displayName": "Cucina & Amore",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {
      "spread": 5,
      "cookie": 2,
      "dressing": 1,
      "bread": 2
    },
    "subtypes": [
      "spread",
      "cookie",
      "bread",
      "dressing"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "blakes": {
    "displayName": "Blake's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 22,
      "pantry": 5
    },
    "subtypeCounts": {
      "boxed_meal": 22,
      "spread": 1
    },
    "subtypes": [
      "boxed_meal",
      "spread"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "three_twins": {
    "displayName": "Three Twins",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 27
    },
    "subtypeCounts": {
      "ice_cream": 27
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "chilly_w": {
    "displayName": "Chilly Cow",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 27
    },
    "subtypeCounts": {
      "ice_cream": 27
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "john_f_martin_sons": {
    "displayName": "John F Martin & Sons",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 7,
      "dairy": 20
    },
    "subtypeCounts": {
      "sausage": 7,
      "cheese": 20
    },
    "subtypes": [
      "cheese",
      "sausage"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "josephs": {
    "displayName": "Joseph's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26,
      "produce": 1
    },
    "subtypeCounts": {
      "bread": 10
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "go_raw": {
    "displayName": "Go Raw",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {
      "dressing": 3,
      "chocolate": 3,
      "cookie": 5
    },
    "subtypes": [
      "cookie",
      "dressing",
      "chocolate"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "walnut_creek": {
    "displayName": "Walnut Creek",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13,
      "frozen": 1,
      "pantry": 12,
      "meat": 1
    },
    "subtypeCounts": {
      "cheese": 13,
      "bread": 4,
      "spread": 3,
      "dressing": 1,
      "sausage": 1,
      "sweetener": 1
    },
    "subtypes": [
      "cheese",
      "bread",
      "spread",
      "dressing",
      "sausage",
      "sweetener"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "clif_bar_and": {
    "displayName": "Clif Bar And",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 27,
    "source": "usda"
  },
  "loacker": {
    "displayName": "Loacker",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {
      "chocolate": 3,
      "cookie": 24
    },
    "subtypes": [
      "cookie",
      "chocolate"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "lucky_untry": {
    "displayName": "Lucky Country",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {
      "candy": 27
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "jewel_os": {
    "displayName": "Jewel-osco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 1,
      "beverage": 3,
      "pantry": 23
    },
    "subtypeCounts": {
      "sausage": 1,
      "beverage": 3,
      "cookie": 18,
      "chocolate": 2,
      "candy": 2,
      "baking": 1
    },
    "subtypes": [
      "cookie",
      "beverage",
      "chocolate",
      "candy",
      "sausage",
      "baking"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "rich_products": {
    "displayName": "Rich Products",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "frozen": 14
    },
    "subtypeCounts": {
      "cookie": 12,
      "ice_cream": 6,
      "boxed_meal": 8,
      "bread": 1
    },
    "subtypes": [
      "cookie",
      "boxed_meal",
      "ice_cream",
      "bread"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "la_molienda": {
    "displayName": "La Molienda",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {
      "baking": 1,
      "candy": 16,
      "cookie": 7
    },
    "subtypes": [
      "candy",
      "cookie",
      "baking"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "blueprint": {
    "displayName": "Blueprint",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 26,
      "dairy": 1
    },
    "subtypeCounts": {
      "beverage": 26,
      "yogurt": 1
    },
    "subtypes": [
      "beverage",
      "yogurt"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "dynasty": {
    "displayName": "Dynasty",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {
      "dressing": 1,
      "sauce": 6,
      "baking": 1
    },
    "subtypes": [
      "sauce",
      "dressing",
      "baking"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "humpty_dumpty": {
    "displayName": "Humpty Dumpty",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 27,
    "source": "usda"
  },
  "dierbergs_markets": {
    "displayName": "Dierbergs Markets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 1,
      "pantry": 25,
      "dairy": 1
    },
    "subtypeCounts": {
      "bread": 8,
      "candy": 15,
      "chocolate": 2,
      "cheese": 1
    },
    "subtypes": [
      "candy",
      "bread",
      "chocolate",
      "cheese"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "waymouth_farms": {
    "displayName": "Waymouth Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {
      "candy": 20,
      "cookie": 2,
      "chocolate": 1,
      "sweetener": 1,
      "dressing": 1
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate",
      "sweetener",
      "dressing"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "kaukauna": {
    "displayName": "Kaukauna",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 27
    },
    "subtypeCounts": {
      "cheese": 27
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "great_lakes_cheese": {
    "displayName": "Great Lakes Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 27
    },
    "subtypeCounts": {
      "cheese": 27
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "bashas": {
    "displayName": "Bashas'",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 9,
      "pantry": 15,
      "produce": 3
    },
    "subtypeCounts": {
      "cheese": 7,
      "milk": 2,
      "bread": 2,
      "candy": 3
    },
    "subtypes": [
      "cheese",
      "candy",
      "milk",
      "bread"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "la_flor": {
    "displayName": "La Flor",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {
      "sauce": 18
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "sierra_nevada_cheese": {
    "displayName": "Sierra Nevada Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 27
    },
    "subtypeCounts": {
      "cheese": 16,
      "yogurt": 11
    },
    "subtypes": [
      "cheese",
      "yogurt"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "weis_organics": {
    "displayName": "Weis Organics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17,
      "beverage": 1,
      "dairy": 4,
      "produce": 5
    },
    "subtypeCounts": {
      "sweetener": 1,
      "beverage": 1,
      "milk": 3,
      "baking": 1,
      "boxed_meal": 2
    },
    "subtypes": [
      "milk",
      "boxed_meal",
      "sweetener",
      "beverage",
      "baking"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "gia_russa": {
    "displayName": "Gia Russa",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26,
      "dairy": 1
    },
    "subtypeCounts": {
      "dressing": 1,
      "cookie": 1,
      "cheese": 1,
      "sauce": 1,
      "boxed_meal": 2
    },
    "subtypes": [
      "boxed_meal",
      "dressing",
      "cookie",
      "cheese",
      "sauce"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "good_humor_breyers_ice_cream": {
    "displayName": "Good Humor-breyers Ice Cream",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 27
    },
    "subtypeCounts": {
      "ice_cream": 27
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "lumbia_gorge_organic": {
    "displayName": "Columbia Gorge Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 26,
      "dairy": 1
    },
    "subtypeCounts": {
      "beverage": 26,
      "milk": 1
    },
    "subtypes": [
      "beverage",
      "milk"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "okies_united": {
    "displayName": "Cookies United",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {
      "cookie": 27
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "enjoy": {
    "displayName": "Enjoy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {
      "candy": 23,
      "cookie": 2
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "c2o": {
    "displayName": "C2o",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 23,
      "pantry": 1,
      "frozen": 3
    },
    "subtypeCounts": {
      "beverage": 23,
      "ice_cream": 3
    },
    "subtypes": [
      "beverage",
      "ice_cream"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "swanson": {
    "displayName": "Swanson",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 2,
      "pantry": 25
    },
    "subtypeCounts": {
      "boxed_meal": 25,
      "sauce": 2
    },
    "subtypes": [
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "izzio_artisan_bakery": {
    "displayName": "Izzio Artisan Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 27
    },
    "subtypeCounts": {
      "bread": 27
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 27,
    "source": "usda"
  },
  "stella_doro": {
    "displayName": "Stella D'oro",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "bread": 1,
      "cookie": 25
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "nathans_famous": {
    "displayName": "Nathan's Famous",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "frozen": 10
    },
    "subtypeCounts": {
      "boxed_meal": 10,
      "bread": 3
    },
    "subtypes": [
      "boxed_meal",
      "bread"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "heluva_good": {
    "displayName": "Heluva Good!",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 25,
      "pantry": 1
    },
    "subtypeCounts": {
      "cheese": 25,
      "dressing": 1
    },
    "subtypes": [
      "cheese",
      "dressing"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "vv_supremo": {
    "displayName": "Vv Supremo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 26
    },
    "subtypeCounts": {
      "cheese": 24,
      "milk": 2
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "briannas": {
    "displayName": "Briannas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "dressing": 26
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "kitchen_oked": {
    "displayName": "Kitchen Cooked",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "blooms": {
    "displayName": "Bloom's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "cookie": 8,
      "candy": 12
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "orgain": {
    "displayName": "Orgain",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 26,
    "source": "usda"
  },
  "mahatma": {
    "displayName": "Mahatma",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 26,
    "source": "usda"
  },
  "barber": {
    "displayName": "Barber",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 26
    },
    "subtypeCounts": {
      "boxed_meal": 26
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "pillsbury": {
    "displayName": "Pillsbury",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 17,
      "pantry": 9
    },
    "subtypeCounts": {
      "bread": 10,
      "boxed_meal": 8,
      "baking": 7,
      "cookie": 1
    },
    "subtypes": [
      "bread",
      "boxed_meal",
      "baking",
      "cookie"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "bahlsen": {
    "displayName": "Bahlsen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25,
      "frozen": 1
    },
    "subtypeCounts": {
      "cookie": 25,
      "boxed_meal": 1
    },
    "subtypes": [
      "cookie",
      "boxed_meal"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "simply_value": {
    "displayName": "Simply Value",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 3,
      "pantry": 15,
      "beverage": 1,
      "frozen": 7
    },
    "subtypeCounts": {
      "cheese": 2,
      "spread": 2,
      "dressing": 4,
      "baking": 2,
      "milk": 1,
      "bread": 1,
      "beverage": 1,
      "ice_cream": 7,
      "cookie": 1
    },
    "subtypes": [
      "ice_cream",
      "dressing",
      "cheese",
      "spread",
      "baking",
      "milk",
      "bread",
      "beverage",
      "cookie"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "chosen": {
    "displayName": "Chosen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "dressing": 25,
      "sauce": 1
    },
    "subtypes": [
      "dressing",
      "sauce"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "bjs_wholesale_club_orate": {
    "displayName": "Bj's Wholesale Club / Corporate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 6,
      "dairy": 5,
      "pantry": 10,
      "beverage": 2,
      "frozen": 3
    },
    "subtypeCounts": {
      "cheese": 2,
      "cookie": 1,
      "sauce": 3,
      "beverage": 2,
      "boxed_meal": 1,
      "milk": 3,
      "chocolate": 1,
      "dressing": 1,
      "ice_cream": 2
    },
    "subtypes": [
      "sauce",
      "milk",
      "cheese",
      "beverage",
      "ice_cream",
      "cookie",
      "boxed_meal",
      "chocolate",
      "dressing"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "santas_treats": {
    "displayName": "Santa's Treats",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "candy": 20,
      "cookie": 1,
      "chocolate": 5
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "house_of_dorchester": {
    "displayName": "House Of Dorchester",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "chocolate": 26
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "divine": {
    "displayName": "Divine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "chocolate": 26
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "nutrisystem": {
    "displayName": "Nutrisystem",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24,
      "frozen": 2
    },
    "subtypeCounts": {
      "boxed_meal": 2,
      "cookie": 3,
      "bread": 2
    },
    "subtypes": [
      "cookie",
      "boxed_meal",
      "bread"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "pez_candy": {
    "displayName": "Pez Candy,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "candy": 26
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "candy_carnival": {
    "displayName": "Candy Carnival",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "candy": 26
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "nostimo": {
    "displayName": "Nostimo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 26
    },
    "subtypeCounts": {
      "yogurt": 26
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "simply_7": {
    "displayName": "Simply 7",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 26,
    "source": "usda"
  },
  "frontier": {
    "displayName": "Frontier",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "sauce": 16,
      "dressing": 1,
      "bread": 1
    },
    "subtypes": [
      "sauce",
      "dressing",
      "bread"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "crunch_pak": {
    "displayName": "Crunch Pak",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 26
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 26,
    "source": "usda"
  },
  "drews": {
    "displayName": "Drew's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "dressing": 21,
      "sauce": 4
    },
    "subtypes": [
      "dressing",
      "sauce"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "oh_sugar": {
    "displayName": "Oh Sugar!",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "candy": 23,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "annies": {
    "displayName": "Annie's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22,
      "dairy": 4
    },
    "subtypeCounts": {
      "dressing": 7,
      "yogurt": 4,
      "cookie": 2,
      "candy": 8
    },
    "subtypes": [
      "candy",
      "dressing",
      "yogurt",
      "cookie"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "dickinsons": {
    "displayName": "Dickinson's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24,
      "dairy": 1,
      "beverage": 1
    },
    "subtypeCounts": {
      "spread": 21,
      "cheese": 1,
      "beverage": 1
    },
    "subtypes": [
      "spread",
      "cheese",
      "beverage"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "nuovo_pasta": {
    "displayName": "Nuovo Pasta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24,
      "frozen": 2
    },
    "subtypeCounts": {
      "boxed_meal": 2
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "alpine_valley": {
    "displayName": "Alpine Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 26
    },
    "subtypeCounts": {
      "candy": 5,
      "bread": 21
    },
    "subtypes": [
      "bread",
      "candy"
    ],
    "totalObs": 26,
    "source": "usda"
  },
  "bella_famiglia": {
    "displayName": "Bella Famiglia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 25,
    "source": "usda"
  },
  "glorybee": {
    "displayName": "Glorybee",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {
      "sweetener": 23,
      "spread": 1,
      "baking": 1
    },
    "subtypes": [
      "sweetener",
      "spread",
      "baking"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "sun_bird": {
    "displayName": "Sun-bird",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {
      "sauce": 25
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "this_saves_lives": {
    "displayName": "This Saves Lives",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 25,
    "source": "usda"
  },
  "murrays": {
    "displayName": "Murray's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 20,
      "pantry": 5
    },
    "subtypeCounts": {
      "cheese": 20,
      "spread": 4
    },
    "subtypes": [
      "cheese",
      "spread"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "shearers": {
    "displayName": "Shearer's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 25,
    "source": "usda"
  },
  "dare": {
    "displayName": "Dare",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {
      "cookie": 24
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "kimberleys_bakeshoppe": {
    "displayName": "Kimberley's Bakeshoppe",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {
      "cookie": 24
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "lean_pockets": {
    "displayName": "Lean Pockets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 25
    },
    "subtypeCounts": {
      "boxed_meal": 25
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "heart_of_dairyland": {
    "displayName": "Heart Of Dairyland",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 25
    },
    "subtypeCounts": {
      "cheese": 25
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "zachary": {
    "displayName": "Zachary",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {
      "candy": 17,
      "chocolate": 6,
      "spread": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "spread"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "kuhne": {
    "displayName": "Kuhne",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {
      "dressing": 6
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "milky_way": {
    "displayName": "Milky Way",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22,
      "frozen": 3
    },
    "subtypeCounts": {
      "chocolate": 11,
      "candy": 11,
      "ice_cream": 3
    },
    "subtypes": [
      "chocolate",
      "candy",
      "ice_cream"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "fat_boy": {
    "displayName": "Fat Boy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "frozen": 10
    },
    "subtypeCounts": {
      "sauce": 9,
      "ice_cream": 10
    },
    "subtypes": [
      "ice_cream",
      "sauce"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "good_smart": {
    "displayName": "Good & Smart",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 7,
      "pantry": 18
    },
    "subtypeCounts": {
      "beverage": 7,
      "candy": 2,
      "cookie": 2
    },
    "subtypes": [
      "beverage",
      "candy",
      "cookie"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "preferred_selection": {
    "displayName": "Preferred Selection",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "dairy": 8,
      "frozen": 2
    },
    "subtypeCounts": {
      "cheese": 8,
      "ice_cream": 2,
      "chocolate": 4,
      "sauce": 2,
      "spread": 2
    },
    "subtypes": [
      "cheese",
      "chocolate",
      "ice_cream",
      "sauce",
      "spread"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "jo_lee_food_products": {
    "displayName": "Jo-lee Food Products,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {
      "candy": 19,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "hill_untry_fare": {
    "displayName": "Hill Country Fare",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "frozen": 9,
      "beverage": 2,
      "meat": 3,
      "dairy": 1
    },
    "subtypeCounts": {
      "dressing": 1,
      "boxed_meal": 1,
      "candy": 4,
      "ice_cream": 9,
      "beverage": 2,
      "sausage": 3,
      "baking": 1
    },
    "subtypes": [
      "ice_cream",
      "candy",
      "sausage",
      "beverage",
      "dressing",
      "boxed_meal",
      "baking"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "chef_merito": {
    "displayName": "Chef Merito",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {
      "sauce": 24
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "farmland": {
    "displayName": "Farmland",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 14,
      "dairy": 10,
      "frozen": 1
    },
    "subtypeCounts": {
      "sausage": 14,
      "milk": 10,
      "boxed_meal": 1
    },
    "subtypes": [
      "sausage",
      "milk",
      "boxed_meal"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "kingston_marketing": {
    "displayName": "Kingston Marketing",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 20,
      "pantry": 4,
      "frozen": 1
    },
    "subtypeCounts": {
      "cheese": 20,
      "cookie": 3,
      "bread": 1
    },
    "subtypes": [
      "cheese",
      "cookie",
      "bread"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "nounos": {
    "displayName": "Nounos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 25
    },
    "subtypeCounts": {
      "yogurt": 25
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "good_food_made_simple": {
    "displayName": "Good Food Made Simple",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 25
    },
    "subtypeCounts": {
      "boxed_meal": 25
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "long_grove_nfectionery": {
    "displayName": "Long Grove Confectionery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {
      "candy": 7,
      "chocolate": 14,
      "cookie": 4
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "ttondale": {
    "displayName": "Cottondale",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {
      "candy": 17,
      "cookie": 3,
      "chocolate": 5
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "treasure_treats": {
    "displayName": "Treasure Treats",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {
      "candy": 25
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "buckley_farms": {
    "displayName": "Buckley Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 1,
      "frozen": 8,
      "meat": 14,
      "dairy": 2
    },
    "subtypeCounts": {
      "boxed_meal": 8,
      "sausage": 14,
      "cheese": 2
    },
    "subtypes": [
      "sausage",
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "mccutcheon_apple_products": {
    "displayName": "Mccutcheon Apple Products,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 25
    },
    "subtypeCounts": {
      "spread": 16,
      "dressing": 6
    },
    "subtypes": [
      "spread",
      "dressing"
    ],
    "totalObs": 25,
    "source": "usda"
  },
  "lilys": {
    "displayName": "Lilys",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "chocolate": 17,
      "candy": 5,
      "dressing": 2
    },
    "subtypes": [
      "chocolate",
      "candy",
      "dressing"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "black_bear": {
    "displayName": "Black Bear",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 19,
      "pantry": 2,
      "beverage": 3
    },
    "subtypeCounts": {
      "cheese": 19,
      "beverage": 3
    },
    "subtypes": [
      "cheese",
      "beverage"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "great_midwest": {
    "displayName": "Great Midwest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 24
    },
    "subtypeCounts": {
      "cheese": 24
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "kernel_seasons": {
    "displayName": "Kernel Season's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "sauce": 24
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "marlow": {
    "displayName": "Marlow",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "candy": 24
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "earths_best_organic": {
    "displayName": "Earth's Best Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11,
      "pantry": 11,
      "frozen": 2
    },
    "subtypeCounts": {
      "yogurt": 11,
      "cookie": 2,
      "bread": 2
    },
    "subtypes": [
      "yogurt",
      "cookie",
      "bread"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "holsum": {
    "displayName": "Holsum",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "bread": 23
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "mrs_freshleys": {
    "displayName": "Mrs. Freshley's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "cookie": 18,
      "bread": 2
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "native_forest": {
    "displayName": "Native Forest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "baking": 3
    },
    "subtypes": [
      "baking"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "baby_ruth": {
    "displayName": "Baby Ruth",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "candy": 22,
      "chocolate": 2
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "bar_s": {
    "displayName": "Bar-s",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 13,
      "frozen": 8,
      "dairy": 3
    },
    "subtypeCounts": {
      "sausage": 13,
      "boxed_meal": 8,
      "cheese": 3
    },
    "subtypes": [
      "sausage",
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "oked_perfect": {
    "displayName": "Cooked Perfect",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 5,
      "frozen": 19
    },
    "subtypeCounts": {
      "sausage": 5,
      "boxed_meal": 19
    },
    "subtypes": [
      "boxed_meal",
      "sausage"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "nature_nates": {
    "displayName": "Nature Nate's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "sweetener": 21,
      "spread": 2
    },
    "subtypes": [
      "sweetener",
      "spread"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "tonys_cho_lonely": {
    "displayName": "Tony's Chocolonely",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "chocolate": 23,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "uncle_matts": {
    "displayName": "Uncle Matt's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 3,
      "beverage": 21
    },
    "subtypeCounts": {
      "ice_cream": 3,
      "beverage": 21
    },
    "subtypes": [
      "beverage",
      "ice_cream"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "maple_hill": {
    "displayName": "Maple Hill",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 24
    },
    "subtypeCounts": {
      "milk": 7,
      "yogurt": 17
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "bakery_fresh_goodness": {
    "displayName": "Bakery Fresh Goodness",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "cookie": 15,
      "bread": 9
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "chuao_cho_latier": {
    "displayName": "Chuao Chocolatier",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "chocolate": 21,
      "cookie": 2
    },
    "subtypes": [
      "chocolate",
      "cookie"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "milkyway": {
    "displayName": "Milkyway",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "candy": 15,
      "chocolate": 9
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "natural_nectar": {
    "displayName": "Natural Nectar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "beverage": 8
    },
    "subtypeCounts": {
      "cookie": 8,
      "sauce": 1,
      "bread": 4,
      "beverage": 8
    },
    "subtypes": [
      "cookie",
      "beverage",
      "bread",
      "sauce"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "wild_ophelia": {
    "displayName": "Wild Ophelia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "chocolate": 15,
      "candy": 9
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "family_dollar_stores": {
    "displayName": "Family Dollar Stores",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22,
      "dairy": 2
    },
    "subtypeCounts": {
      "candy": 7,
      "sauce": 5,
      "cookie": 5,
      "cheese": 2
    },
    "subtypes": [
      "candy",
      "sauce",
      "cookie",
      "cheese"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "dean": {
    "displayName": "Dean",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11,
      "pantry": 1,
      "dairy": 12
    },
    "subtypeCounts": {
      "ice_cream": 11,
      "beverage": 1,
      "milk": 12
    },
    "subtypes": [
      "milk",
      "ice_cream",
      "beverage"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "ferrero_rocher": {
    "displayName": "Ferrero Rocher",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "chocolate": 23,
      "bread": 1
    },
    "subtypes": [
      "chocolate",
      "bread"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "mediterranean_organic": {
    "displayName": "Mediterranean Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "spread": 8
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "rner_store": {
    "displayName": "Corner Store",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22,
      "beverage": 2
    },
    "subtypeCounts": {
      "candy": 13,
      "chocolate": 1,
      "cookie": 1,
      "beverage": 2
    },
    "subtypes": [
      "candy",
      "beverage",
      "chocolate",
      "cookie"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "zergut": {
    "displayName": "Zergut",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22,
      "dairy": 2
    },
    "subtypeCounts": {
      "spread": 4,
      "cookie": 1,
      "milk": 1,
      "cheese": 1
    },
    "subtypes": [
      "spread",
      "cookie",
      "milk",
      "cheese"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "gaea": {
    "displayName": "Gaea",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22,
      "dairy": 2
    },
    "subtypeCounts": {
      "cheese": 2,
      "dressing": 1
    },
    "subtypes": [
      "cheese",
      "dressing"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "kens": {
    "displayName": "Ken's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "dressing": 23,
      "sauce": 1
    },
    "subtypes": [
      "dressing",
      "sauce"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "crofters": {
    "displayName": "Crofters",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "spread": 24
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "clover_stornetta_farms": {
    "displayName": "Clover Stornetta Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 24
    },
    "subtypeCounts": {
      "cheese": 20,
      "milk": 4
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "dolcezza": {
    "displayName": "Dolcezza",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 24
    },
    "subtypeCounts": {
      "ice_cream": 24
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "simply_enjoy": {
    "displayName": "Simply Enjoy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 1,
      "dairy": 4,
      "pantry": 11,
      "frozen": 8
    },
    "subtypeCounts": {
      "boxed_meal": 6,
      "cheese": 4,
      "bread": 1,
      "spread": 1,
      "chocolate": 1,
      "ice_cream": 2,
      "dressing": 1
    },
    "subtypes": [
      "boxed_meal",
      "cheese",
      "ice_cream",
      "bread",
      "spread",
      "chocolate",
      "dressing"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "calise_bakery": {
    "displayName": "Calise Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "bread": 24
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "namaste": {
    "displayName": "Namaste",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23,
      "dairy": 1
    },
    "subtypeCounts": {
      "boxed_meal": 2,
      "baking": 17,
      "sauce": 4
    },
    "subtypes": [
      "baking",
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "pamana": {
    "displayName": "Pamana",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 5,
      "pantry": 17,
      "dairy": 1,
      "produce": 1
    },
    "subtypeCounts": {
      "spread": 2,
      "sauce": 7,
      "milk": 1
    },
    "subtypes": [
      "sauce",
      "spread",
      "milk"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "kitchen_basics": {
    "displayName": "Kitchen Basics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "sauce": 2,
      "boxed_meal": 22
    },
    "subtypes": [
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "village_hearth": {
    "displayName": "Village Hearth",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "bread": 24
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "heiners": {
    "displayName": "Heiner's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "bread": 24
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "bai": {
    "displayName": "Bai",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 24
    },
    "subtypeCounts": {
      "beverage": 24
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "hp_okie": {
    "displayName": "Hp Cookie",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 24
    },
    "subtypeCounts": {
      "cookie": 24
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "tantillo": {
    "displayName": "Tantillo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22,
      "beverage": 2
    },
    "subtypeCounts": {
      "bread": 2,
      "beverage": 2
    },
    "subtypes": [
      "bread",
      "beverage"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "prestige": {
    "displayName": "Prestige",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 24
    },
    "subtypeCounts": {
      "ice_cream": 24
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "3_musketeers": {
    "displayName": "3 Musketeers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23,
      "frozen": 1
    },
    "subtypeCounts": {
      "candy": 12,
      "chocolate": 11,
      "ice_cream": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "ice_cream"
    ],
    "totalObs": 24,
    "source": "usda"
  },
  "stroehmann": {
    "displayName": "Stroehmann",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "bread": 23
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "macrina_bakery": {
    "displayName": "Macrina Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "bread": 23
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "jonny_pops": {
    "displayName": "Jonny Pops",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 23
    },
    "subtypeCounts": {
      "ice_cream": 23
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "natural_directions": {
    "displayName": "Natural Directions",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 7,
      "pantry": 15,
      "beverage": 1
    },
    "subtypeCounts": {
      "cheese": 5,
      "spread": 2,
      "baking": 1,
      "milk": 2,
      "beverage": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "cheese",
      "spread",
      "milk",
      "baking",
      "beverage",
      "boxed_meal"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "old_bay": {
    "displayName": "Old Bay",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "sauce": 21
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "stubbs": {
    "displayName": "Stubb's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22,
      "frozen": 1
    },
    "subtypeCounts": {
      "sauce": 21,
      "boxed_meal": 1
    },
    "subtypes": [
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "gourmet_garden": {
    "displayName": "Gourmet Garden",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "produce": 13
    },
    "subtypeCounts": {
      "sauce": 1
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "kleinpeter": {
    "displayName": "Kleinpeter",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 2,
      "dairy": 21
    },
    "subtypeCounts": {
      "beverage": 2,
      "milk": 21
    },
    "subtypes": [
      "milk",
      "beverage"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "carnation": {
    "displayName": "Carnation",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 19,
      "pantry": 4
    },
    "subtypeCounts": {
      "milk": 17,
      "yogurt": 2
    },
    "subtypes": [
      "milk",
      "yogurt"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "unty_market": {
    "displayName": "County Market",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "dairy": 5,
      "beverage": 2
    },
    "subtypeCounts": {
      "bread": 13,
      "cheese": 2,
      "boxed_meal": 2,
      "beverage": 2,
      "milk": 3
    },
    "subtypes": [
      "bread",
      "milk",
      "cheese",
      "boxed_meal",
      "beverage"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "fairlife": {
    "displayName": "Fairlife",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 19,
      "frozen": 4
    },
    "subtypeCounts": {
      "milk": 19,
      "ice_cream": 4
    },
    "subtypes": [
      "milk",
      "ice_cream"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "nabis": {
    "displayName": "Nabisco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22,
      "dairy": 1
    },
    "subtypeCounts": {
      "cookie": 20,
      "chocolate": 1,
      "cheese": 1
    },
    "subtypes": [
      "cookie",
      "chocolate",
      "cheese"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "canada_dry": {
    "displayName": "Canada Dry",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 23
    },
    "subtypeCounts": {
      "beverage": 23
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "rummo": {
    "displayName": "Rummo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 23,
    "source": "usda"
  },
  "entenmanns": {
    "displayName": "Entenmann's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "cookie": 21
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "puraqua": {
    "displayName": "Puraqua",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 23
    },
    "subtypeCounts": {
      "beverage": 23
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "bubbies": {
    "displayName": "Bubbies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 14,
      "pantry": 9
    },
    "subtypeCounts": {
      "ice_cream": 14
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "okf": {
    "displayName": "Okf",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 22,
      "dairy": 1
    },
    "subtypeCounts": {
      "beverage": 22,
      "milk": 1
    },
    "subtypes": [
      "beverage",
      "milk"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "torie_howard": {
    "displayName": "Torie & Howard",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "candy": 23
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "ice_chips": {
    "displayName": "Ice Chips",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "candy": 23
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "ta_bell": {
    "displayName": "Taco Bell",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10,
      "sauce": 6
    },
    "subtypes": [
      "cheese",
      "sauce"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "miyokos": {
    "displayName": "Miyoko's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 23
    },
    "subtypeCounts": {
      "cheese": 23
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "just_add": {
    "displayName": "Just Add",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20,
      "produce": 3
    },
    "subtypeCounts": {
      "sauce": 15
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "babybel": {
    "displayName": "Babybel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 23
    },
    "subtypeCounts": {
      "cheese": 23
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "impact_nfections": {
    "displayName": "Impact Confections,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "candy": 23
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "hp_hood": {
    "displayName": "Hp Hood",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14,
      "frozen": 8,
      "meat": 1
    },
    "subtypeCounts": {
      "cheese": 5,
      "milk": 4,
      "ice_cream": 8,
      "yogurt": 5,
      "sausage": 1
    },
    "subtypes": [
      "ice_cream",
      "cheese",
      "yogurt",
      "milk",
      "sausage"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "amazing_taste": {
    "displayName": "Amazing Taste",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "sauce": 22
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "les": {
    "displayName": "les",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 23
    },
    "subtypeCounts": {
      "boxed_meal": 7,
      "bread": 16
    },
    "subtypes": [
      "bread",
      "boxed_meal"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "off_eaten_path": {
    "displayName": "Off The Eaten Path",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 23,
    "source": "usda"
  },
  "arctic_zero": {
    "displayName": "Arctic Zero",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 23
    },
    "subtypeCounts": {
      "ice_cream": 23
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "kings_hawaiian": {
    "displayName": "King's Hawaiian",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "bread": 23
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "giuliano": {
    "displayName": "Giuliano",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 23,
    "source": "usda"
  },
  "nalley": {
    "displayName": "Nalley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "dressing": 2
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "shirakiku": {
    "displayName": "Shirakiku",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20,
      "beverage": 1,
      "frozen": 2
    },
    "subtypeCounts": {
      "baking": 2,
      "beverage": 1,
      "boxed_meal": 2
    },
    "subtypes": [
      "baking",
      "boxed_meal",
      "beverage"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "pure": {
    "displayName": "Pure",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "beverage": 7
    },
    "subtypeCounts": {
      "beverage": 7,
      "candy": 1
    },
    "subtypes": [
      "beverage",
      "candy"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "505_southwestern": {
    "displayName": "505 Southwestern",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 2,
      "pantry": 3,
      "frozen": 18
    },
    "subtypeCounts": {
      "cheese": 2,
      "boxed_meal": 18
    },
    "subtypes": [
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "beetnik": {
    "displayName": "Beetnik",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 23
    },
    "subtypeCounts": {
      "boxed_meal": 23
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "parade": {
    "displayName": "Parade",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15,
      "pantry": 4,
      "frozen": 2,
      "beverage": 2
    },
    "subtypeCounts": {
      "cheese": 13,
      "baking": 1,
      "bread": 3,
      "yogurt": 2,
      "candy": 1,
      "beverage": 2
    },
    "subtypes": [
      "cheese",
      "bread",
      "yogurt",
      "beverage",
      "baking",
      "candy"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "devour": {
    "displayName": "Devour",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 23
    },
    "subtypeCounts": {
      "boxed_meal": 23
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "dobrova": {
    "displayName": "Dobrova",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "sweetener": 2,
      "candy": 2,
      "spread": 1,
      "cookie": 2
    },
    "subtypes": [
      "sweetener",
      "candy",
      "cookie",
      "spread"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "homekist": {
    "displayName": "Homekist",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "cookie": 23
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "madelaine_cho_late": {
    "displayName": "Madelaine Cholate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "chocolate": 19,
      "candy": 4
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "mayfield": {
    "displayName": "Mayfield",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 1,
      "frozen": 20,
      "dairy": 2
    },
    "subtypeCounts": {
      "beverage": 1,
      "ice_cream": 20,
      "milk": 1,
      "cheese": 1
    },
    "subtypes": [
      "ice_cream",
      "beverage",
      "milk",
      "cheese"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "pure_growth_organic": {
    "displayName": "Pure Growth Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "cookie": 9
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "betty_crocker": {
    "displayName": "Betty Crocker",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22,
      "produce": 1
    },
    "subtypeCounts": {
      "cookie": 4,
      "candy": 16,
      "dressing": 2
    },
    "subtypes": [
      "candy",
      "cookie",
      "dressing"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "mansmiths": {
    "displayName": "Mansmith's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 23
    },
    "subtypeCounts": {
      "sauce": 14
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "old_el_paso": {
    "displayName": "Old El Paso",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11,
      "pantry": 5,
      "frozen": 7
    },
    "subtypeCounts": {
      "cheese": 9,
      "sauce": 5,
      "boxed_meal": 7,
      "milk": 2
    },
    "subtypes": [
      "cheese",
      "boxed_meal",
      "sauce",
      "milk"
    ],
    "totalObs": 23,
    "source": "usda"
  },
  "brown_w": {
    "displayName": "Brown Cow",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 22
    },
    "subtypeCounts": {
      "yogurt": 22
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "sam_mills": {
    "displayName": "Sam Mills",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "cookie": 5
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "feel_good": {
    "displayName": "Feel Good",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 22
    },
    "subtypeCounts": {
      "boxed_meal": 22
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "kerrygold": {
    "displayName": "Kerrygold",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 22
    },
    "subtypeCounts": {
      "cheese": 22
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "hennings_wis_nsin_cheese": {
    "displayName": "Henning's Wisconsin Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 22
    },
    "subtypeCounts": {
      "cheese": 22
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "garofalo": {
    "displayName": "Garofalo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 22,
    "source": "usda"
  },
  "ball_park": {
    "displayName": "Ball Park",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21,
      "frozen": 1
    },
    "subtypeCounts": {
      "bread": 21,
      "boxed_meal": 1
    },
    "subtypes": [
      "bread",
      "boxed_meal"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "cho_maker": {
    "displayName": "Chocomaker",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "chocolate": 10,
      "candy": 11,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "seggiano": {
    "displayName": "Seggiano",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "dressing": 2
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "simply_asia": {
    "displayName": "Simply Asia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21,
      "frozen": 1
    },
    "subtypeCounts": {
      "sauce": 16,
      "boxed_meal": 3
    },
    "subtypes": [
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "polar_treats": {
    "displayName": "Polar Treats",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 22
    },
    "subtypeCounts": {
      "ice_cream": 22
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "westpac": {
    "displayName": "Westpac",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 22
    },
    "subtypeCounts": {
      "boxed_meal": 1
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "organicville": {
    "displayName": "Organicville",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "dressing": 22
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "snack_fresh": {
    "displayName": "Snack Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 22
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 22,
    "source": "usda"
  },
  "untry_club": {
    "displayName": "Country Club",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 22
    },
    "subtypeCounts": {
      "ice_cream": 22
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "red_button_vintage_creamery": {
    "displayName": "Red Button Vintage Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 22
    },
    "subtypeCounts": {
      "ice_cream": 22
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "mc_nnells": {
    "displayName": "Mcconnell's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 21,
      "pantry": 1
    },
    "subtypeCounts": {
      "ice_cream": 21,
      "cookie": 1
    },
    "subtypes": [
      "ice_cream",
      "cookie"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "taffy_town": {
    "displayName": "Taffy Town",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "candy": 22
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "gardein": {
    "displayName": "Gardein",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 16,
      "pantry": 6
    },
    "subtypeCounts": {
      "boxed_meal": 22
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "simply_orange": {
    "displayName": "Simply Orange",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 22
    },
    "subtypeCounts": {
      "beverage": 22
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "lenders": {
    "displayName": "Lender's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17,
      "frozen": 5
    },
    "subtypeCounts": {
      "bread": 22
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "harmless_harvest": {
    "displayName": "Harmless Harvest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 14,
      "dairy": 8
    },
    "subtypeCounts": {
      "beverage": 14,
      "yogurt": 8
    },
    "subtypes": [
      "beverage",
      "yogurt"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "cho_rite": {
    "displayName": "Chocorite",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 1,
      "pantry": 21
    },
    "subtypeCounts": {
      "milk": 1,
      "chocolate": 8,
      "candy": 2
    },
    "subtypes": [
      "chocolate",
      "candy",
      "milk"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "farmer_john": {
    "displayName": "Farmer John",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 22
    },
    "subtypeCounts": {
      "sausage": 22
    },
    "subtypes": [
      "sausage"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "tassos": {
    "displayName": "Tassos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1,
      "spread": 4
    },
    "subtypes": [
      "spread",
      "cheese"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "kinders": {
    "displayName": "Kinder's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20,
      "frozen": 2
    },
    "subtypeCounts": {
      "sauce": 12,
      "dressing": 5,
      "boxed_meal": 2
    },
    "subtypes": [
      "sauce",
      "dressing",
      "boxed_meal"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "lik_m_aid": {
    "displayName": "Lik-m-aid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "candy": 22
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "torn_glasser": {
    "displayName": "Torn & Glasser",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21,
      "produce": 1
    },
    "subtypeCounts": {
      "candy": 15,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "quesos_la_ricura": {
    "displayName": "Quesos La Ricura",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 22
    },
    "subtypeCounts": {
      "cheese": 20,
      "milk": 1,
      "yogurt": 1
    },
    "subtypes": [
      "cheese",
      "milk",
      "yogurt"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "san_francis_salt": {
    "displayName": "San Francisco Salt",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "sauce": 22
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "double_rainbow": {
    "displayName": "Double Rainbow",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 22
    },
    "subtypeCounts": {
      "ice_cream": 22
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "karoun": {
    "displayName": "Karoun",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 22
    },
    "subtypeCounts": {
      "yogurt": 10,
      "cheese": 10,
      "milk": 2
    },
    "subtypes": [
      "yogurt",
      "cheese",
      "milk"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "small_planet": {
    "displayName": "Small Planet ,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21,
      "frozen": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "ciao_bella": {
    "displayName": "Ciao Bella",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 22
    },
    "subtypeCounts": {
      "ice_cream": 22
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "mc_rmick_gourmet": {
    "displayName": "Mccormick Gourmet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "sauce": 18
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "rising_moon": {
    "displayName": "Rising Moon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 4,
      "pantry": 18
    },
    "subtypeCounts": {
      "boxed_meal": 4
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "cho_late_cho_late_cho_late": {
    "displayName": "Chocolate Chocolate Chocolate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "candy": 6,
      "chocolate": 14,
      "cookie": 2
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "yuenglings": {
    "displayName": "Yuengling's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 22
    },
    "subtypeCounts": {
      "ice_cream": 22
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "wholesome": {
    "displayName": "Wholesome",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "sweetener": 10,
      "candy": 12
    },
    "subtypes": [
      "candy",
      "sweetener"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "kalona_super_natural": {
    "displayName": "Kalona Super Natural",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 22
    },
    "subtypeCounts": {
      "yogurt": 6,
      "cheese": 6,
      "milk": 10
    },
    "subtypes": [
      "milk",
      "yogurt",
      "cheese"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "ocean_mist_farms": {
    "displayName": "Ocean Mist Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 21,
      "pantry": 1
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 22,
    "source": "usda"
  },
  "beanitos": {
    "displayName": "Beanitos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 22,
    "source": "usda"
  },
  "stockmeyer": {
    "displayName": "Stockmeyer",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "boxed_meal": 3,
      "spread": 4,
      "cookie": 11
    },
    "subtypes": [
      "cookie",
      "spread",
      "boxed_meal"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "finlandia": {
    "displayName": "Finlandia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 22
    },
    "subtypeCounts": {
      "cheese": 22
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "stonyfield_farm": {
    "displayName": "Stonyfield Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 21,
      "beverage": 1
    },
    "subtypeCounts": {
      "yogurt": 21,
      "beverage": 1
    },
    "subtypes": [
      "yogurt",
      "beverage"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "ben_jerrys_homemade": {
    "displayName": "Ben & Jerry's Homemade",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 22
    },
    "subtypeCounts": {
      "ice_cream": 20,
      "bread": 2
    },
    "subtypes": [
      "ice_cream",
      "bread"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "american_li_rice": {
    "displayName": "American Licorice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "candy": 22
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "tolerant": {
    "displayName": "Tolerant",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 22,
    "source": "usda"
  },
  "curate": {
    "displayName": "Curate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "chocolate": 1
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "probar": {
    "displayName": "Probar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "candy": 1
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "r_w_knudsen": {
    "displayName": "R.w.knudsen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 21,
      "pantry": 1
    },
    "subtypeCounts": {
      "beverage": 21,
      "sauce": 1
    },
    "subtypes": [
      "beverage",
      "sauce"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "oberlander": {
    "displayName": "Oberlander",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {
      "cookie": 21,
      "bread": 1
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "clover": {
    "displayName": "Clover",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 7,
      "dairy": 15
    },
    "subtypeCounts": {
      "ice_cream": 7,
      "milk": 4,
      "cheese": 3,
      "yogurt": 7
    },
    "subtypes": [
      "ice_cream",
      "yogurt",
      "milk",
      "cheese"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "balance_bar": {
    "displayName": "Balance Bar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 22,
    "source": "usda"
  },
  "wonka": {
    "displayName": "Wonka",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 5,
      "pantry": 17
    },
    "subtypeCounts": {
      "ice_cream": 5,
      "candy": 17
    },
    "subtypes": [
      "candy",
      "ice_cream"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "propel": {
    "displayName": "Propel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 22
    },
    "subtypeCounts": {
      "beverage": 22
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "better_living": {
    "displayName": "Better Living",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 8,
      "pantry": 14
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "ice_cream": 7,
      "chocolate": 5,
      "cookie": 1,
      "candy": 2
    },
    "subtypes": [
      "ice_cream",
      "chocolate",
      "candy",
      "boxed_meal",
      "cookie"
    ],
    "totalObs": 22,
    "source": "usda"
  },
  "miss_vickies": {
    "displayName": "Miss Vickie's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 22
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 22,
    "source": "usda"
  },
  "way_better_snacks": {
    "displayName": "Way Better Snacks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 21,
    "source": "usda"
  },
  "louisiana": {
    "displayName": "Louisiana",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20,
      "frozen": 1
    },
    "subtypeCounts": {
      "sauce": 16,
      "boxed_meal": 1
    },
    "subtypes": [
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "bella_sun_luci": {
    "displayName": "Bella Sun Luci",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "sauce": 3
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "biena": {
    "displayName": "Biena",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 21,
    "source": "usda"
  },
  "bama": {
    "displayName": "Bama",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "spread": 16,
      "dressing": 5
    },
    "subtypes": [
      "spread",
      "dressing"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "lindt_sprungli_schweiz_ag": {
    "displayName": "Lindt & Sprungli (schweiz) Ag",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "chocolate": 21
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "barcel": {
    "displayName": "Barcel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 21,
    "source": "usda"
  },
  "supreme_protein": {
    "displayName": "Supreme Protein",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 21,
    "source": "usda"
  },
  "de_good_lish": {
    "displayName": "De Good Lish",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "frozen": 6,
      "dairy": 1,
      "produce": 2
    },
    "subtypeCounts": {
      "cookie": 3,
      "boxed_meal": 2,
      "chocolate": 7,
      "ice_cream": 4,
      "candy": 1,
      "cheese": 1
    },
    "subtypes": [
      "chocolate",
      "ice_cream",
      "cookie",
      "boxed_meal",
      "candy",
      "cheese"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "flatout": {
    "displayName": "Flatout",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "bread": 21
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "king_cheese": {
    "displayName": "King Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 21
    },
    "subtypeCounts": {
      "cheese": 20,
      "yogurt": 1
    },
    "subtypes": [
      "cheese",
      "yogurt"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "clearly": {
    "displayName": "Clearly",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18,
      "dairy": 3
    },
    "subtypeCounts": {
      "sweetener": 1,
      "candy": 1,
      "spread": 7,
      "cookie": 1
    },
    "subtypes": [
      "spread",
      "sweetener",
      "candy",
      "cookie"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "gourmet_du_village": {
    "displayName": "Gourmet Du Village",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "sauce": 18,
      "candy": 2,
      "cookie": 1
    },
    "subtypes": [
      "sauce",
      "candy",
      "cookie"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "king_soopers": {
    "displayName": "King Soopers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "dairy": 6,
      "meat": 1,
      "frozen": 1
    },
    "subtypeCounts": {
      "bread": 5,
      "cookie": 4,
      "cheese": 1,
      "milk": 5,
      "boxed_meal": 2
    },
    "subtypes": [
      "bread",
      "milk",
      "cookie",
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "sierra_nevada": {
    "displayName": "Sierra Nevada",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 21
    },
    "subtypeCounts": {
      "cheese": 17,
      "yogurt": 4
    },
    "subtypes": [
      "cheese",
      "yogurt"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "belfonte": {
    "displayName": "Belfonte",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 6,
      "dairy": 15
    },
    "subtypeCounts": {
      "ice_cream": 6,
      "yogurt": 11,
      "cheese": 3,
      "milk": 1
    },
    "subtypes": [
      "yogurt",
      "ice_cream",
      "cheese",
      "milk"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "harvest_farms": {
    "displayName": "Harvest Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 7,
      "dairy": 7,
      "produce": 7
    },
    "subtypeCounts": {
      "cheese": 3,
      "milk": 3
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "snackwells": {
    "displayName": "Snackwell's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "cookie": 21
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "nicks": {
    "displayName": "Nick's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "frozen": 9
    },
    "subtypeCounts": {
      "ice_cream": 9
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "strohs": {
    "displayName": "Stroh's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 21
    },
    "subtypeCounts": {
      "ice_cream": 21
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "pierre": {
    "displayName": "Pierre",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 20,
      "pantry": 1
    },
    "subtypeCounts": {
      "boxed_meal": 20,
      "cookie": 1
    },
    "subtypes": [
      "boxed_meal",
      "cookie"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "bunny": {
    "displayName": "Bunny",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20,
      "frozen": 1
    },
    "subtypeCounts": {
      "bread": 20,
      "candy": 1
    },
    "subtypes": [
      "bread",
      "candy"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "wildbrine": {
    "displayName": "Wildbrine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18,
      "meat": 2,
      "dairy": 1
    },
    "subtypeCounts": {
      "boxed_meal": 2,
      "cheese": 1
    },
    "subtypes": [
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "carolina": {
    "displayName": "Carolina",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 21,
    "source": "usda"
  },
  "canyon_bakehouse": {
    "displayName": "Canyon Bakehouse",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "bread": 21
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "kool_aid": {
    "displayName": "Kool-aid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 13,
      "pantry": 5,
      "frozen": 3
    },
    "subtypeCounts": {
      "beverage": 13,
      "candy": 5,
      "ice_cream": 3
    },
    "subtypes": [
      "beverage",
      "candy",
      "ice_cream"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "two_bite": {
    "displayName": "Two-bite",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "cookie": 21
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "clancys": {
    "displayName": "Clancy's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 21,
    "source": "usda"
  },
  "joan_of_arc": {
    "displayName": "Joan Of Arc",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 21
    },
    "subtypeCounts": {
      "cheese": 21
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "husmans": {
    "displayName": "Husman's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 21,
    "source": "usda"
  },
  "mother_raw": {
    "displayName": "Mother Raw",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "dressing": 21
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "simply_indulgent_gourmet": {
    "displayName": "Simply Indulgent Gourmet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "cookie": 21
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "schweppes": {
    "displayName": "Schweppes",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 21
    },
    "subtypeCounts": {
      "beverage": 21
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "red_pink": {
    "displayName": "Red Pink",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "candy": 15,
      "chocolate": 6
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "cedar_crest": {
    "displayName": "Cedar Crest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 21
    },
    "subtypeCounts": {
      "ice_cream": 21
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "rienzi": {
    "displayName": "Rienzi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "green_valley_creamery": {
    "displayName": "Green Valley Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 21
    },
    "subtypeCounts": {
      "yogurt": 18,
      "milk": 2,
      "cheese": 1
    },
    "subtypes": [
      "yogurt",
      "milk",
      "cheese"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "nagra": {
    "displayName": "nagra",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 9,
      "pantry": 12
    },
    "subtypeCounts": {
      "boxed_meal": 13,
      "dressing": 3,
      "cookie": 3,
      "bread": 1
    },
    "subtypes": [
      "boxed_meal",
      "dressing",
      "cookie",
      "bread"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "friendly_farms": {
    "displayName": "Friendly Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 21
    },
    "subtypeCounts": {
      "milk": 3,
      "yogurt": 17,
      "cheese": 1
    },
    "subtypes": [
      "yogurt",
      "milk",
      "cheese"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "wm_wrigley_jr": {
    "displayName": "Wm. Wrigley Jr.",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "candy": 21
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "advancepierre": {
    "displayName": "Advancepierre",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 21
    },
    "subtypeCounts": {
      "boxed_meal": 21
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "sukhis": {
    "displayName": "Sukhi's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 16,
      "pantry": 5
    },
    "subtypeCounts": {
      "boxed_meal": 16,
      "sauce": 2
    },
    "subtypes": [
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "barkthins": {
    "displayName": "Barkthins",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "candy": 15,
      "chocolate": 5,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "central_market": {
    "displayName": "Central Market",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 1,
      "pantry": 8,
      "beverage": 1,
      "meat": 3,
      "dairy": 2,
      "frozen": 6
    },
    "subtypeCounts": {
      "beverage": 1,
      "cookie": 1,
      "chocolate": 1,
      "sausage": 3,
      "milk": 2,
      "ice_cream": 2,
      "boxed_meal": 4
    },
    "subtypes": [
      "boxed_meal",
      "sausage",
      "milk",
      "ice_cream",
      "beverage",
      "cookie",
      "chocolate"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "candy_ville": {
    "displayName": "Candy-ville",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "candy": 21
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "atkinsons": {
    "displayName": "Atkinson's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "candy": 17
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "dukes": {
    "displayName": "Dukes",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "dressing": 16,
      "cookie": 4
    },
    "subtypes": [
      "dressing",
      "cookie"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "baron_cho_latier": {
    "displayName": "Baron Chocolatier",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "chocolate": 20,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "candy_store": {
    "displayName": "Candy Store",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "candy": 21
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "national": {
    "displayName": "National",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "sauce": 12
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "unique": {
    "displayName": "Unique",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 21,
    "source": "usda"
  },
  "unilever": {
    "displayName": "Unilever",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 21
    },
    "subtypeCounts": {
      "ice_cream": 21
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "shahia": {
    "displayName": "Shahia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17,
      "beverage": 3,
      "frozen": 1
    },
    "subtypeCounts": {
      "dressing": 2,
      "beverage": 3,
      "sweetener": 1
    },
    "subtypes": [
      "beverage",
      "dressing",
      "sweetener"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "fo": {
    "displayName": "Foco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 21
    },
    "subtypeCounts": {
      "beverage": 21
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "hans_kissle": {
    "displayName": "Hans Kissle",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 7,
      "meat": 12,
      "dairy": 2
    },
    "subtypeCounts": {
      "boxed_meal": 12,
      "cheese": 2
    },
    "subtypes": [
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "jel_sert": {
    "displayName": "The Jel Sert",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 20,
      "beverage": 1
    },
    "subtypeCounts": {
      "ice_cream": 20,
      "beverage": 1
    },
    "subtypes": [
      "ice_cream",
      "beverage"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "dudleys": {
    "displayName": "Dudley's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "bread": 21
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "minors": {
    "displayName": "Minor's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "boxed_meal": 5,
      "sauce": 13
    },
    "subtypes": [
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "rold_gold": {
    "displayName": "Rold Gold",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 21
    },
    "subtypeCounts": {
      "candy": 1
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 21,
    "source": "usda"
  },
  "girards": {
    "displayName": "Girard's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "dressing": 20
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "emerils": {
    "displayName": "Emeril's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "frozen": 5
    },
    "subtypeCounts": {
      "sauce": 10,
      "boxed_meal": 8
    },
    "subtypes": [
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "tasty": {
    "displayName": "Tasty",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "frozen": 4
    },
    "subtypeCounts": {
      "candy": 4,
      "cookie": 10,
      "dressing": 1,
      "ice_cream": 4
    },
    "subtypes": [
      "cookie",
      "candy",
      "ice_cream",
      "dressing"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "asian_gourmet": {
    "displayName": "Asian Gourmet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "candy": 1
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "san_mar_s": {
    "displayName": "San Marcos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 20,
    "source": "usda"
  },
  "daisy": {
    "displayName": "Daisy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 20
    },
    "subtypeCounts": {
      "milk": 14,
      "cheese": 6
    },
    "subtypes": [
      "milk",
      "cheese"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "stonemill": {
    "displayName": "Stonemill",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "sauce": 6
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "dr_mcdougalls_right": {
    "displayName": "Dr. Mcdougall's Right",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "boxed_meal": 20
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "nickles": {
    "displayName": "Nickles",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "bread": 20
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "santa_barbara_olive": {
    "displayName": "Santa Barbara Olive",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 20,
    "source": "usda"
  },
  "vosges": {
    "displayName": "Vosges",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "chocolate": 15,
      "candy": 5
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "little_potato": {
    "displayName": "Little Potato",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 20
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 20,
    "source": "usda"
  },
  "equal_exchange": {
    "displayName": "Equal Exchange",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "chocolate": 15,
      "candy": 1,
      "baking": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "baking"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "jennie_o": {
    "displayName": "Jennie-o",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 11,
      "frozen": 9
    },
    "subtypeCounts": {
      "sausage": 11,
      "boxed_meal": 9
    },
    "subtypes": [
      "sausage",
      "boxed_meal"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "red_hots": {
    "displayName": "Red Hots",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "candy": 20
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "rotellas_italian_bakery": {
    "displayName": "Rotella's Italian Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "bread": 18,
      "cookie": 2
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "fresh_frozen": {
    "displayName": "Fresh Frozen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 19,
      "produce": 1
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 20,
    "source": "usda"
  },
  "think": {
    "displayName": "Think!",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 20,
    "source": "usda"
  },
  "chips_ahoy": {
    "displayName": "Chips Ahoy!",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19,
      "frozen": 1
    },
    "subtypeCounts": {
      "cookie": 19,
      "ice_cream": 1
    },
    "subtypes": [
      "cookie",
      "ice_cream"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "seapoint_farms": {
    "displayName": "Seapoint Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 8,
      "frozen": 12
    },
    "subtypeCounts": {
      "boxed_meal": 4
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "sola": {
    "displayName": "Sola",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 8,
      "pantry": 8,
      "dairy": 4
    },
    "subtypeCounts": {
      "ice_cream": 7,
      "bread": 7,
      "yogurt": 4
    },
    "subtypes": [
      "ice_cream",
      "bread",
      "yogurt"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "foodhold": {
    "displayName": "Foodhold",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "dairy": 2,
      "beverage": 2
    },
    "subtypeCounts": {
      "candy": 3,
      "bread": 2,
      "cheese": 2,
      "chocolate": 2,
      "cookie": 1,
      "beverage": 2
    },
    "subtypes": [
      "candy",
      "bread",
      "cheese",
      "chocolate",
      "beverage",
      "cookie"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "junior_mints": {
    "displayName": "Junior Mints",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "candy": 7,
      "chocolate": 13
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "vidal": {
    "displayName": "Vidal",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "candy": 20
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "aqua_star": {
    "displayName": "Aqua Star",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 20
    },
    "subtypeCounts": {
      "boxed_meal": 20
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "hippeas": {
    "displayName": "Hippeas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 20,
    "source": "usda"
  },
  "rustic_bakery": {
    "displayName": "Rustic Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "cookie": 15,
      "bread": 4,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "bread",
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "kedem": {
    "displayName": "Kedem",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 15,
      "pantry": 5
    },
    "subtypeCounts": {
      "beverage": 15,
      "cookie": 5
    },
    "subtypes": [
      "beverage",
      "cookie"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "justins": {
    "displayName": "Justin's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "candy": 17
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "goetzes": {
    "displayName": "Goetze's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "candy": 20
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "rayberns": {
    "displayName": "Raybern's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 20
    },
    "subtypeCounts": {
      "boxed_meal": 20
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "dilettante_cho_lates": {
    "displayName": "Dilettante Chocolates",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "chocolate": 15,
      "cookie": 3,
      "candy": 2
    },
    "subtypes": [
      "chocolate",
      "cookie",
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "ferrero_llection": {
    "displayName": "Ferrero Collection",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "chocolate": 15,
      "candy": 5
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "ugar_mountain": {
    "displayName": "Cougar Mountain",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19,
      "frozen": 1
    },
    "subtypeCounts": {
      "cookie": 19,
      "bread": 1
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "sarris_candies": {
    "displayName": "Sarris Candies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "chocolate": 11,
      "candy": 8
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "nescafe": {
    "displayName": "Nescafe",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "beverage": 20
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "nestle_frozen_food_division": {
    "displayName": "Nestle -frozen Food Division",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 20
    },
    "subtypeCounts": {
      "boxed_meal": 20
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "russell_stover_candies": {
    "displayName": "Russell Stover Candies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "chocolate": 14,
      "candy": 6
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "joseph_farms": {
    "displayName": "Joseph Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 20
    },
    "subtypeCounts": {
      "cheese": 20
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "la_criolla": {
    "displayName": "La Criolla",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "sauce": 4
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "anthonys": {
    "displayName": "Anthony's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 20,
    "source": "usda"
  },
  "special_value": {
    "displayName": "Special Value",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 3,
      "dairy": 5,
      "pantry": 11,
      "beverage": 1
    },
    "subtypeCounts": {
      "cheese": 5,
      "sauce": 2,
      "beverage": 1,
      "dressing": 4,
      "baking": 1
    },
    "subtypes": [
      "cheese",
      "dressing",
      "sauce",
      "beverage",
      "baking"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "royal_snacks": {
    "displayName": "Royal Snacks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "candy": 20
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "kurtz": {
    "displayName": "Kurtz",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "sauce": 1
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "old_fashioned_cheese": {
    "displayName": "Old Fashioned Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 20
    },
    "subtypeCounts": {
      "cheese": 20
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "deep_river_snacks": {
    "displayName": "Deep River Snacks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 20,
    "source": "usda"
  },
  "ri": {
    "displayName": "Rico",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "frozen": 7
    },
    "subtypeCounts": {
      "boxed_meal": 5,
      "sauce": 2
    },
    "subtypes": [
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "bruces": {
    "displayName": "Bruce's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 20,
    "source": "usda"
  },
  "fresh_creative": {
    "displayName": "Fresh Creative",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "meat": 7,
      "dairy": 2
    },
    "subtypeCounts": {
      "dressing": 2,
      "boxed_meal": 7,
      "cheese": 2
    },
    "subtypes": [
      "boxed_meal",
      "dressing",
      "cheese"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "augason_farms": {
    "displayName": "Augason Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17,
      "dairy": 3
    },
    "subtypeCounts": {
      "baking": 7,
      "sauce": 4,
      "dressing": 1
    },
    "subtypes": [
      "baking",
      "sauce",
      "dressing"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "three_saints_baking": {
    "displayName": "Three Saints Baking",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "cookie": 20
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "shasha": {
    "displayName": "Shasha",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "cookie": 16,
      "bread": 3
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "rocky_mountain_cho_late_factory": {
    "displayName": "Rocky Mountain Chocolate Factory",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "candy": 6,
      "chocolate": 14
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "redners_warehouse_markets": {
    "displayName": "Redner's Warehouse Markets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "beverage": 2,
      "meat": 2,
      "dairy": 2
    },
    "subtypeCounts": {
      "beverage": 2,
      "bread": 8,
      "dressing": 4,
      "sausage": 2,
      "cheese": 2
    },
    "subtypes": [
      "bread",
      "dressing",
      "beverage",
      "sausage",
      "cheese"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "midwest_untry_fare": {
    "displayName": "Midwest Country Fare",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 1,
      "pantry": 18,
      "frozen": 1
    },
    "subtypeCounts": {
      "cheese": 1,
      "dressing": 6,
      "boxed_meal": 1,
      "cookie": 1
    },
    "subtypes": [
      "dressing",
      "cheese",
      "boxed_meal",
      "cookie"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "jif": {
    "displayName": "Jif",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 20
    },
    "subtypeCounts": {
      "candy": 1,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 20,
    "source": "usda"
  },
  "on_r": {
    "displayName": "On-cor",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 19
    },
    "subtypeCounts": {
      "boxed_meal": 19
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "rumiano": {
    "displayName": "Rumiano",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 19
    },
    "subtypeCounts": {
      "cheese": 19
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "boursin": {
    "displayName": "Boursin",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 19
    },
    "subtypeCounts": {
      "cheese": 19
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "friendship_dairies": {
    "displayName": "Friendship Dairies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 19
    },
    "subtypeCounts": {
      "cheese": 13,
      "milk": 6
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "chi_chis": {
    "displayName": "Chi-chi's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 3,
      "pantry": 11,
      "frozen": 5
    },
    "subtypeCounts": {
      "cheese": 3,
      "boxed_meal": 5,
      "sauce": 2
    },
    "subtypes": [
      "boxed_meal",
      "cheese",
      "sauce"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "hot_tamales": {
    "displayName": "Hot Tamales",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "candy": 19
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "el_guapo": {
    "displayName": "El Guapo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "baking": 1,
      "sauce": 4,
      "candy": 2,
      "cookie": 1
    },
    "subtypes": [
      "sauce",
      "candy",
      "baking",
      "cookie"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "sun_maid": {
    "displayName": "Sun-maid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 2,
      "pantry": 17
    },
    "subtypeCounts": {
      "dressing": 5,
      "bread": 6,
      "cookie": 6
    },
    "subtypes": [
      "bread",
      "cookie",
      "dressing"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "powerful": {
    "displayName": "Powerful",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 16,
      "pantry": 3
    },
    "subtypeCounts": {
      "yogurt": 16
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "kikkoman": {
    "displayName": "Kikkoman",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "sauce": 15,
      "dressing": 2,
      "boxed_meal": 1
    },
    "subtypes": [
      "sauce",
      "dressing",
      "boxed_meal"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "sour_jacks": {
    "displayName": "Sour Jacks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "candy": 19
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "viloe": {
    "displayName": "Viloe",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 14,
      "pantry": 4,
      "dairy": 1
    },
    "subtypeCounts": {
      "beverage": 14,
      "candy": 4,
      "milk": 1
    },
    "subtypes": [
      "beverage",
      "candy",
      "milk"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "red_vines": {
    "displayName": "Red Vines",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "candy": 19
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "smashmallow": {
    "displayName": "Smashmallow",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "candy": 19
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "vita_ice": {
    "displayName": "Vita Ice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 19
    },
    "subtypeCounts": {
      "beverage": 19
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "hi_chew": {
    "displayName": "Hi-chew",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "candy": 19
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "tampi": {
    "displayName": "Tampico",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 16,
      "pantry": 3
    },
    "subtypeCounts": {
      "beverage": 16
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "just": {
    "displayName": "Just",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 2,
      "beverage": 3,
      "pantry": 14
    },
    "subtypeCounts": {
      "beverage": 3,
      "dressing": 11,
      "cookie": 3
    },
    "subtypes": [
      "dressing",
      "beverage",
      "cookie"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "splash": {
    "displayName": "Splash",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 19
    },
    "subtypeCounts": {
      "beverage": 19
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "weis_2_go": {
    "displayName": "Weis 2 Go",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 1,
      "pantry": 8,
      "meat": 10
    },
    "subtypeCounts": {
      "cheese": 1,
      "boxed_meal": 10
    },
    "subtypes": [
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "paqui": {
    "displayName": "Paqui",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 19,
    "source": "usda"
  },
  "granny_bs": {
    "displayName": "Granny B's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "cookie": 19
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "royal_dansk": {
    "displayName": "Royal Dansk",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "cookie": 19
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "la_pasta": {
    "displayName": "La Pasta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 19,
    "source": "usda"
  },
  "old_dominion_peanut": {
    "displayName": "Old Dominion Peanut",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "candy": 17,
      "cookie": 1,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "no_w": {
    "displayName": "No Cow",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "cookie": 2
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "cardenas": {
    "displayName": "Cardenas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10,
      "pantry": 9
    },
    "subtypeCounts": {
      "milk": 7,
      "cheese": 3,
      "baking": 6,
      "cookie": 1
    },
    "subtypes": [
      "milk",
      "baking",
      "cheese",
      "cookie"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "elli": {
    "displayName": "Elli",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 19
    },
    "subtypeCounts": {
      "yogurt": 18,
      "cheese": 1
    },
    "subtypes": [
      "yogurt",
      "cheese"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "spaans": {
    "displayName": "Spaans",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "cookie": 18,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "gold_emblem_abound": {
    "displayName": "Gold Emblem Abound",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 2,
      "pantry": 17
    },
    "subtypeCounts": {
      "beverage": 2,
      "sweetener": 2,
      "candy": 2,
      "cookie": 3
    },
    "subtypes": [
      "cookie",
      "beverage",
      "sweetener",
      "candy"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "associated_wholesale_grocers": {
    "displayName": "Associated Wholesale Grocers,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 9,
      "pantry": 6,
      "dairy": 4
    },
    "subtypeCounts": {
      "ice_cream": 4,
      "sauce": 2,
      "baking": 1,
      "bread": 1,
      "cheese": 4
    },
    "subtypes": [
      "ice_cream",
      "cheese",
      "sauce",
      "baking",
      "bread"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "tait_farm": {
    "displayName": "Tait Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "spread": 8,
      "dressing": 4
    },
    "subtypes": [
      "spread",
      "dressing"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "artisan_bistro": {
    "displayName": "Artisan Bistro",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 19
    },
    "subtypeCounts": {
      "boxed_meal": 19
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "gullon": {
    "displayName": "Gullon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "cookie": 17
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "silver_hills": {
    "displayName": "Silver Hills",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "bread": 19
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "chungs": {
    "displayName": "Chung's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 19
    },
    "subtypeCounts": {
      "boxed_meal": 19
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "chabaso_bakery": {
    "displayName": "Chabaso Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "bread": 19
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "life_choice": {
    "displayName": "Life Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 19,
    "source": "usda"
  },
  "buds_best_okies": {
    "displayName": "Buds Bestokies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "cookie": 19
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "tabatchnick": {
    "displayName": "Tabatchnick",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 16,
      "pantry": 3
    },
    "subtypeCounts": {
      "boxed_meal": 19
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "la_moderna": {
    "displayName": "La Moderna",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "cookie": 4
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "pik_nik": {
    "displayName": "Pik-nik",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 19,
    "source": "usda"
  },
  "food_town_stores": {
    "displayName": "Food Town Stores",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "frozen": 2,
      "dairy": 1
    },
    "subtypeCounts": {
      "boxed_meal": 10,
      "bread": 1,
      "milk": 1
    },
    "subtypes": [
      "boxed_meal",
      "bread",
      "milk"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "las_campanas": {
    "displayName": "Las Campanas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 19
    },
    "subtypeCounts": {
      "boxed_meal": 19
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "lowell": {
    "displayName": "Lowell",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 1,
      "pantry": 15,
      "beverage": 3
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "beverage": 3,
      "spread": 9
    },
    "subtypes": [
      "spread",
      "beverage",
      "boxed_meal"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "spring_haven_farms": {
    "displayName": "Spring Haven Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 19
    },
    "subtypeCounts": {
      "cheese": 19
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "cra_via": {
    "displayName": "Cracovia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "meat": 3
    },
    "subtypeCounts": {
      "spread": 3,
      "boxed_meal": 3,
      "cookie": 2
    },
    "subtypes": [
      "spread",
      "boxed_meal",
      "cookie"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "claussen": {
    "displayName": "Claussen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 19,
    "source": "usda"
  },
  "gli": {
    "displayName": "Glico",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "cookie": 18,
      "chocolate": 1
    },
    "subtypes": [
      "cookie",
      "chocolate"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "sw": {
    "displayName": "S&w",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 19,
    "source": "usda"
  },
  "freshlike": {
    "displayName": "Freshlike",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 19,
    "source": "usda"
  },
  "gelato_fias": {
    "displayName": "Gelato Fiasco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 19
    },
    "subtypeCounts": {
      "ice_cream": 19
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "middleswarth": {
    "displayName": "Middleswarth",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 19,
    "source": "usda"
  },
  "farmers_market": {
    "displayName": "Farmers Market",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "produce": 1,
      "dairy": 3
    },
    "subtypeCounts": {
      "candy": 1,
      "yogurt": 1
    },
    "subtypes": [
      "candy",
      "yogurt"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "jfc": {
    "displayName": "Jfc",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18,
      "frozen": 1
    },
    "subtypeCounts": {
      "dressing": 1,
      "sauce": 4,
      "chocolate": 1,
      "spread": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "sauce",
      "dressing",
      "chocolate",
      "spread",
      "boxed_meal"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "ritrovo_selections": {
    "displayName": "Ritrovo Selections",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "spread": 4,
      "sauce": 2,
      "sweetener": 1,
      "bread": 1,
      "dressing": 3
    },
    "subtypes": [
      "spread",
      "dressing",
      "sauce",
      "sweetener",
      "bread"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "manitou_trading": {
    "displayName": "Manitou Trading",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "sauce": 2
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "natures_path_organic": {
    "displayName": "Nature's Path Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "lonial": {
    "displayName": "Colonial",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "bread": 19
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "scripture_candy": {
    "displayName": "Scripture Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {
      "candy": 18,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "clear_choice": {
    "displayName": "Clear Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 19
    },
    "subtypeCounts": {
      "beverage": 19
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "winter_brook": {
    "displayName": "Winter Brook",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 19
    },
    "subtypeCounts": {
      "beverage": 19
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "amish_valley": {
    "displayName": "Amish Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 19
    },
    "subtypeCounts": {
      "cheese": 19
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "sno_pac": {
    "displayName": "Sno Pac",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 19
    },
    "subtypeCounts": {
      "boxed_meal": 1
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "fresh_garden_highway": {
    "displayName": "Fresh Garden Highway",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 1,
      "produce": 12,
      "pantry": 5,
      "frozen": 1
    },
    "subtypeCounts": {
      "yogurt": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "yogurt",
      "boxed_meal"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "big_green_organic_food": {
    "displayName": "Big Green Organic Food",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 19,
    "source": "usda"
  },
  "paleo_ranch": {
    "displayName": "Paleo Ranch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 19
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 19,
    "source": "usda"
  },
  "buitoni": {
    "displayName": "Buitoni",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "solero": {
    "displayName": "Solero",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 19
    },
    "subtypeCounts": {
      "ice_cream": 19
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 19,
    "source": "usda"
  },
  "superpretzel": {
    "displayName": "Superpretzel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 18
    },
    "subtypeCounts": {
      "boxed_meal": 17,
      "bread": 1
    },
    "subtypes": [
      "boxed_meal",
      "bread"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "glacier_ridge_farms": {
    "displayName": "Glacier Ridge Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 16,
      "pantry": 2
    },
    "subtypeCounts": {
      "cheese": 16
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "steves_ice_cream": {
    "displayName": "Steve's Ice Cream",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 17,
      "pantry": 1
    },
    "subtypeCounts": {
      "ice_cream": 17,
      "baking": 1
    },
    "subtypes": [
      "ice_cream",
      "baking"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "blue_ribbon": {
    "displayName": "Blue Ribbon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "frozen": 2,
      "meat": 4
    },
    "subtypeCounts": {
      "bread": 1,
      "ice_cream": 2,
      "sausage": 4
    },
    "subtypes": [
      "sausage",
      "ice_cream",
      "bread"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "emmi": {
    "displayName": "Emmi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 18
    },
    "subtypeCounts": {
      "cheese": 18
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "zing": {
    "displayName": "Zing",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 18,
    "source": "usda"
  },
  "williams": {
    "displayName": "Williams",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "dairy": 2
    },
    "subtypeCounts": {
      "sauce": 16,
      "cheese": 2
    },
    "subtypes": [
      "sauce",
      "cheese"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "jon_donaire": {
    "displayName": "Jon Donaire",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 18
    },
    "subtypeCounts": {
      "ice_cream": 18
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "christopher_ranch": {
    "displayName": "Christopher Ranch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 7,
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 18,
    "source": "usda"
  },
  "van_leeuwen": {
    "displayName": "Van Leeuwen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 18
    },
    "subtypeCounts": {
      "ice_cream": 18
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "sunsweet": {
    "displayName": "Sunsweet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 15,
      "pantry": 3
    },
    "subtypeCounts": {
      "beverage": 15,
      "chocolate": 1
    },
    "subtypes": [
      "beverage",
      "chocolate"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "ibake": {
    "displayName": "Ibake",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "cookie": 18
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "snak_club": {
    "displayName": "Snak Club",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "candy": 18
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "til_ws_me_home": {
    "displayName": "Til The Cows Come Home",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 18
    },
    "subtypeCounts": {
      "ice_cream": 18
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "uncle_harrys": {
    "displayName": "Uncle Harry's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 17,
      "pantry": 1
    },
    "subtypeCounts": {
      "ice_cream": 17,
      "sweetener": 1
    },
    "subtypes": [
      "ice_cream",
      "sweetener"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "explore_cuisine": {
    "displayName": "Explore Cuisine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 18,
    "source": "usda"
  },
  "sprout": {
    "displayName": "Sprout",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 4,
      "dairy": 11,
      "pantry": 3
    },
    "subtypeCounts": {
      "beverage": 4,
      "yogurt": 11
    },
    "subtypes": [
      "yogurt",
      "beverage"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "organic_creamery": {
    "displayName": "Organic Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 18
    },
    "subtypeCounts": {
      "cheese": 18
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "reddi_wip": {
    "displayName": "Reddi Wip",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 18
    },
    "subtypeCounts": {
      "milk": 18
    },
    "subtypes": [
      "milk"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "madegood": {
    "displayName": "Madegood",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "cookie": 5
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "best_bar_ever": {
    "displayName": "The Best Bar Ever",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 18,
    "source": "usda"
  },
  "sambazon": {
    "displayName": "Sambazon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 15,
      "frozen": 3
    },
    "subtypeCounts": {
      "beverage": 15,
      "ice_cream": 3
    },
    "subtypes": [
      "beverage",
      "ice_cream"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "rhythm": {
    "displayName": "Rhythm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 18,
    "source": "usda"
  },
  "stonefire": {
    "displayName": "Stonefire",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17,
      "frozen": 1
    },
    "subtypeCounts": {
      "bread": 16
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "taylor_fresh": {
    "displayName": "Taylor Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 10,
      "pantry": 8
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 18,
    "source": "usda"
  },
  "calbee": {
    "displayName": "Calbee",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 18,
    "source": "usda"
  },
  "rip_van": {
    "displayName": "Rip Van",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "cookie": 17
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "godiva_cho_latier": {
    "displayName": "Godiva Chocolatier,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "chocolate": 18
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "sunrise_natural": {
    "displayName": "Sunrise Natural",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "candy": 12,
      "baking": 1
    },
    "subtypes": [
      "candy",
      "baking"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "icelandic_provisions": {
    "displayName": "Icelandic Provisions",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 18
    },
    "subtypeCounts": {
      "yogurt": 18
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "red_bird": {
    "displayName": "Red Bird",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17,
      "frozen": 1
    },
    "subtypeCounts": {
      "candy": 17,
      "boxed_meal": 1
    },
    "subtypes": [
      "candy",
      "boxed_meal"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "banza": {
    "displayName": "Banza",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17,
      "frozen": 1
    },
    "subtypeCounts": {
      "bread": 1
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "stoneridge": {
    "displayName": "Stoneridge",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 18
    },
    "subtypeCounts": {
      "cheese": 18
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "lesserevil": {
    "displayName": "Lesserevil",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "cookie": 6
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "olde_cape_d": {
    "displayName": "Olde Cape Cod",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "dressing": 15,
      "sauce": 3
    },
    "subtypes": [
      "dressing",
      "sauce"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "hannaford_bros": {
    "displayName": "Hannaford Bros",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "meat": 2,
      "dairy": 4,
      "beverage": 1
    },
    "subtypeCounts": {
      "dressing": 1,
      "boxed_meal": 5,
      "beverage": 1,
      "cheese": 2,
      "bread": 2,
      "milk": 1
    },
    "subtypes": [
      "boxed_meal",
      "cheese",
      "bread",
      "dressing",
      "beverage",
      "milk"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "brighams": {
    "displayName": "Brigham's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 18
    },
    "subtypeCounts": {
      "ice_cream": 18
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "marietta": {
    "displayName": "Marietta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "cookie": 18
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "ancient_harvest": {
    "displayName": "Ancient Harvest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "baking": 1
    },
    "subtypes": [
      "baking"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "better_valu": {
    "displayName": "Better Valu",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "dairy": 3,
      "frozen": 2
    },
    "subtypeCounts": {
      "cheese": 1,
      "boxed_meal": 1,
      "milk": 2,
      "dressing": 5,
      "cookie": 1,
      "ice_cream": 1
    },
    "subtypes": [
      "dressing",
      "milk",
      "cheese",
      "boxed_meal",
      "cookie",
      "ice_cream"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "abbott": {
    "displayName": "Abbott",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 18,
    "source": "usda"
  },
  "mcvities": {
    "displayName": "Mcvitie's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "cookie": 16,
      "chocolate": 2
    },
    "subtypes": [
      "cookie",
      "chocolate"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "bg_north_america": {
    "displayName": "B&g North America,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "frozen": 7
    },
    "subtypeCounts": {
      "spread": 1,
      "sauce": 5,
      "bread": 2,
      "boxed_meal": 2,
      "baking": 1
    },
    "subtypes": [
      "sauce",
      "bread",
      "boxed_meal",
      "spread",
      "baking"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "millers": {
    "displayName": "Miller's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 16,
      "pantry": 2
    },
    "subtypeCounts": {
      "cheese": 16,
      "sweetener": 1
    },
    "subtypes": [
      "cheese",
      "sweetener"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "adams_brooks": {
    "displayName": "Adams & Brooks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "candy": 18
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "choctal": {
    "displayName": "Choctal",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 18
    },
    "subtypeCounts": {
      "ice_cream": 18
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "morinaga": {
    "displayName": "Morinaga",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "dairy": 6
    },
    "subtypeCounts": {
      "candy": 12,
      "yogurt": 6
    },
    "subtypes": [
      "candy",
      "yogurt"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "egglands_best": {
    "displayName": "Eggland's Best",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 18
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 18,
    "source": "usda"
  },
  "stone_house_bread": {
    "displayName": "Stone House Bread",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "spread": 2,
      "bread": 15,
      "baking": 1
    },
    "subtypes": [
      "bread",
      "spread",
      "baking"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "jans": {
    "displayName": "Jans",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 3,
      "beverage": 8,
      "pantry": 7
    },
    "subtypeCounts": {
      "milk": 3,
      "beverage": 8,
      "cookie": 3
    },
    "subtypes": [
      "beverage",
      "milk",
      "cookie"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "etais": {
    "displayName": "Etai's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "frozen": 4,
      "meat": 4
    },
    "subtypeCounts": {
      "boxed_meal": 8
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "arnies": {
    "displayName": "Arnie's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "bread": 15,
      "cookie": 1,
      "dressing": 2
    },
    "subtypes": [
      "bread",
      "dressing",
      "cookie"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "esther_price": {
    "displayName": "Esther Price",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "chocolate": 16,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "shur_saving": {
    "displayName": "Shur Saving",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 9,
      "dairy": 1,
      "frozen": 7,
      "beverage": 1
    },
    "subtypeCounts": {
      "cookie": 5,
      "cheese": 1,
      "ice_cream": 7,
      "spread": 1,
      "sauce": 1,
      "beverage": 1
    },
    "subtypes": [
      "ice_cream",
      "cookie",
      "cheese",
      "spread",
      "sauce",
      "beverage"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "sugarfina": {
    "displayName": "Sugarfina",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "chocolate": 2,
      "candy": 16
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "taylors": {
    "displayName": "Taylors",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "candy": 15,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "food_should_taste_good": {
    "displayName": "Food Should Taste Good",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 18,
    "source": "usda"
  },
  "square_organics": {
    "displayName": "Square Organics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 18,
    "source": "usda"
  },
  "bonnies_jams": {
    "displayName": "Bonnie's Jams",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {
      "spread": 18
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "weyauwega": {
    "displayName": "Weyauwega",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 18
    },
    "subtypeCounts": {
      "cheese": 18
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "red_top_reserve": {
    "displayName": "Red Top Reserve",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 4,
      "dairy": 14
    },
    "subtypeCounts": {
      "ice_cream": 4,
      "yogurt": 14
    },
    "subtypes": [
      "yogurt",
      "ice_cream"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "chiquita": {
    "displayName": "Chiquita",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 12,
      "dairy": 6
    },
    "subtypeCounts": {
      "yogurt": 6
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "crazy_cuizine": {
    "displayName": "Crazy Cuizine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 18
    },
    "subtypeCounts": {
      "boxed_meal": 18
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 18,
    "source": "usda"
  },
  "uncle_bens": {
    "displayName": "Uncle Ben's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 18
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 18,
    "source": "usda"
  },
  "sandwich_bros_of_wis_nsin": {
    "displayName": "Sandwich Bros. Of Wisconsin",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 17
    },
    "subtypeCounts": {
      "boxed_meal": 17
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "st_dalfour": {
    "displayName": "St. Dalfour",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "meat": 2
    },
    "subtypeCounts": {
      "spread": 15,
      "boxed_meal": 2
    },
    "subtypes": [
      "spread",
      "boxed_meal"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "herb_ox": {
    "displayName": "Herb-ox",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "sauce": 17
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "claeys": {
    "displayName": "Claeys",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "candy": 17
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "harvest_snaps": {
    "displayName": "Harvest Snaps",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "dressing": 3
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "tcho": {
    "displayName": "Tcho",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "frozen": 1
    },
    "subtypeCounts": {
      "chocolate": 14,
      "ice_cream": 1,
      "candy": 1,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "ice_cream",
      "candy",
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "wallaby_organic": {
    "displayName": "Wallaby Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 17
    },
    "subtypeCounts": {
      "yogurt": 17
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "betty_lous": {
    "displayName": "Betty Lou's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "candy": 3
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "once_upon_a_farm": {
    "displayName": "Once Upon A Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 12,
      "dairy": 4,
      "frozen": 1
    },
    "subtypeCounts": {
      "beverage": 12,
      "yogurt": 4,
      "boxed_meal": 1
    },
    "subtypes": [
      "beverage",
      "yogurt",
      "boxed_meal"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "good_bean": {
    "displayName": "The Good Bean",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "chocolate": 2
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "kara_cho_lates": {
    "displayName": "Kara Chocolates",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "candy": 14,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "smart_simple": {
    "displayName": "Smart & Simple",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "dairy": 1
    },
    "subtypeCounts": {
      "dressing": 4,
      "cheese": 1,
      "baking": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "dressing",
      "cheese",
      "baking",
      "boxed_meal"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "louisa": {
    "displayName": "Louisa",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "frozen": 4
    },
    "subtypeCounts": {
      "boxed_meal": 4
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "jennies": {
    "displayName": "Jennies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "cookie": 16
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "stonemill_kitchens": {
    "displayName": "Stonemill Kitchens",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 8,
      "pantry": 8,
      "meat": 1
    },
    "subtypeCounts": {
      "cheese": 8,
      "bread": 4,
      "boxed_meal": 1
    },
    "subtypes": [
      "cheese",
      "bread",
      "boxed_meal"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "geisha": {
    "displayName": "Geisha",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "beverage": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "beverage": 1,
      "baking": 1
    },
    "subtypes": [
      "boxed_meal",
      "beverage",
      "baking"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "cuetara": {
    "displayName": "Cuetara",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "cookie": 17
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "fud": {
    "displayName": "Fud",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 2,
      "dairy": 15
    },
    "subtypeCounts": {
      "sausage": 2,
      "milk": 1,
      "cheese": 14
    },
    "subtypes": [
      "cheese",
      "sausage",
      "milk"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "luigis": {
    "displayName": "Luigi's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 17
    },
    "subtypeCounts": {
      "ice_cream": 17
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "alexia": {
    "displayName": "Alexia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 16,
      "pantry": 1
    },
    "subtypeCounts": {
      "bread": 5,
      "boxed_meal": 2
    },
    "subtypes": [
      "bread",
      "boxed_meal"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "oceans_halo": {
    "displayName": "Oceans Halo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "beverage": 3
    },
    "subtypeCounts": {
      "boxed_meal": 9,
      "sauce": 4,
      "beverage": 3
    },
    "subtypes": [
      "boxed_meal",
      "sauce",
      "beverage"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "seapak": {
    "displayName": "Seapak",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 17
    },
    "subtypeCounts": {
      "boxed_meal": 17
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "wei_chuan": {
    "displayName": "Wei-chuan",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11,
      "dairy": 2,
      "pantry": 3,
      "beverage": 1
    },
    "subtypeCounts": {
      "boxed_meal": 10,
      "beverage": 1
    },
    "subtypes": [
      "boxed_meal",
      "beverage"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "snapple": {
    "displayName": "Snapple",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 15,
      "frozen": 2
    },
    "subtypeCounts": {
      "beverage": 15,
      "ice_cream": 2
    },
    "subtypes": [
      "beverage",
      "ice_cream"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "lets_do_organic": {
    "displayName": "Let's Do Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "baking": 17
    },
    "subtypes": [
      "baking"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "seattle_sourdough_baking": {
    "displayName": "Seattle Sourdough Baking",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "bread": 17
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "valley_fine": {
    "displayName": "Valley Fine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 17,
    "source": "usda"
  },
  "marin_french_cheese": {
    "displayName": "Marin French Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 17
    },
    "subtypeCounts": {
      "cheese": 17
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "mcclures": {
    "displayName": "Mcclure's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 17,
    "source": "usda"
  },
  "ginger_people": {
    "displayName": "The Ginger People",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 2,
      "pantry": 15
    },
    "subtypeCounts": {
      "beverage": 2,
      "candy": 6,
      "cookie": 1,
      "sauce": 2,
      "spread": 1
    },
    "subtypes": [
      "candy",
      "beverage",
      "sauce",
      "cookie",
      "spread"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "wright": {
    "displayName": "Wright",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 16,
      "pantry": 1
    },
    "subtypeCounts": {
      "sausage": 16,
      "dressing": 1
    },
    "subtypes": [
      "sausage",
      "dressing"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "exceptional_value": {
    "displayName": "Exceptional Value",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "dairy": 2
    },
    "subtypeCounts": {
      "baking": 1,
      "sauce": 3,
      "sweetener": 1,
      "dressing": 1,
      "cheese": 2,
      "cookie": 5
    },
    "subtypes": [
      "cookie",
      "sauce",
      "cheese",
      "baking",
      "sweetener",
      "dressing"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "my_dads_okies": {
    "displayName": "My Dad's Cookies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "cookie": 17
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "julies_organic": {
    "displayName": "Julie's Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 16,
      "pantry": 1
    },
    "subtypeCounts": {
      "ice_cream": 16,
      "cookie": 1
    },
    "subtypes": [
      "ice_cream",
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "ziyad": {
    "displayName": "Ziyad",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "dairy": 1,
      "beverage": 3
    },
    "subtypeCounts": {
      "candy": 2,
      "dressing": 2,
      "bread": 1,
      "cheese": 1,
      "baking": 1,
      "spread": 2,
      "cookie": 1,
      "beverage": 3
    },
    "subtypes": [
      "beverage",
      "candy",
      "dressing",
      "spread",
      "bread",
      "cheese",
      "baking",
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "quest_nutrition": {
    "displayName": "Quest Nutrition",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "cookie": 2,
      "candy": 2
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "breckenridge_farms": {
    "displayName": "Breckenridge Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "dairy": 2
    },
    "subtypeCounts": {
      "milk": 2
    },
    "subtypes": [
      "milk"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "upstate_farms": {
    "displayName": "Upstate Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 17
    },
    "subtypeCounts": {
      "yogurt": 5,
      "milk": 11,
      "cheese": 1
    },
    "subtypes": [
      "milk",
      "yogurt",
      "cheese"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "erin_bakers": {
    "displayName": "Erin Baker's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "cookie": 14
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "adams_reserve": {
    "displayName": "Adams Reserve",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 4,
      "pantry": 13
    },
    "subtypeCounts": {
      "cheese": 4,
      "sauce": 10
    },
    "subtypes": [
      "sauce",
      "cheese"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "sixlets": {
    "displayName": "Sixlets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "chocolate": 9,
      "cookie": 1,
      "candy": 7
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "perugina": {
    "displayName": "Perugina",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "chocolate": 15,
      "candy": 1,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "chompies": {
    "displayName": "Chompie's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "dairy": 2
    },
    "subtypeCounts": {
      "bread": 10,
      "cookie": 5,
      "cheese": 2
    },
    "subtypes": [
      "bread",
      "cookie",
      "cheese"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "vitacup": {
    "displayName": "Vitacup",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "beverage": 17
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "beanfields": {
    "displayName": "Beanfields",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 17,
    "source": "usda"
  },
  "peloponnese": {
    "displayName": "Peloponnese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "dressing": 2
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "red_rock_deli": {
    "displayName": "Red Rock Deli",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 17,
    "source": "usda"
  },
  "bit_o_honey": {
    "displayName": "Bit-o-honey",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "candy": 17
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "dippin_dots": {
    "displayName": "Dippin' Dots",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 14,
      "pantry": 3
    },
    "subtypeCounts": {
      "ice_cream": 14,
      "cookie": 2,
      "candy": 1
    },
    "subtypes": [
      "ice_cream",
      "cookie",
      "candy"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "lancaster": {
    "displayName": "Lancaster",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "meat": 2
    },
    "subtypeCounts": {
      "candy": 15,
      "sausage": 2
    },
    "subtypes": [
      "candy",
      "sausage"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "thrifty": {
    "displayName": "Thrifty",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 16,
      "dairy": 1
    },
    "subtypeCounts": {
      "ice_cream": 16,
      "yogurt": 1
    },
    "subtypes": [
      "ice_cream",
      "yogurt"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "better_than_bouillon": {
    "displayName": "Better Than Bouillon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "sauce": 17
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "pataks": {
    "displayName": "Patak's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "sauce": 5
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "krunchy_melts": {
    "displayName": "Krunchy Melts",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "cookie": 17
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "dragonfly": {
    "displayName": "Dragonfly",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "sauce": 1,
      "spread": 1,
      "candy": 1
    },
    "subtypes": [
      "boxed_meal",
      "sauce",
      "spread",
      "candy"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "martinellis": {
    "displayName": "Martinelli's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 17
    },
    "subtypeCounts": {
      "beverage": 17
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "nonnis": {
    "displayName": "Nonni's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "cookie": 16,
      "chocolate": 1
    },
    "subtypes": [
      "cookie",
      "chocolate"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "aloha": {
    "displayName": "Aloha",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "beverage": 1
    },
    "subtypeCounts": {
      "beverage": 1
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "harmons_neighborhood_grocer": {
    "displayName": "Harmons Neighborhood Grocer",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "meat": 1
    },
    "subtypeCounts": {
      "candy": 11,
      "boxed_meal": 3,
      "sausage": 1
    },
    "subtypes": [
      "candy",
      "boxed_meal",
      "sausage"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "jewel_bake_shop": {
    "displayName": "Jewel Bake Shop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "cookie": 9,
      "bread": 6
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "primary_lors": {
    "displayName": "Primary Colors",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "cookie": 5,
      "candy": 12
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "daily_greens": {
    "displayName": "Daily Greens",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 17
    },
    "subtypeCounts": {
      "beverage": 17
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "dufflet": {
    "displayName": "Dufflet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "chocolate": 9,
      "cookie": 2,
      "candy": 6
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "a_uple_of_squares": {
    "displayName": "A Couple Of Squares",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "cookie": 17
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "shopkins": {
    "displayName": "Shopkins",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "candy": 14,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "star_market": {
    "displayName": "Star Market",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16,
      "beverage": 1
    },
    "subtypeCounts": {
      "bread": 16,
      "beverage": 1
    },
    "subtypes": [
      "bread",
      "beverage"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "aunt_millies_bakehouse": {
    "displayName": "Aunt Millie's Bakehouse",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "bread": 17
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "sweet_magnolia_gelato": {
    "displayName": "Sweet Magnolia Gelato",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 17
    },
    "subtypeCounts": {
      "ice_cream": 17
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "hoffmans": {
    "displayName": "Hoffman's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 17
    },
    "subtypeCounts": {
      "cheese": 17
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "jewel": {
    "displayName": "Jewel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "dairy": 6
    },
    "subtypeCounts": {
      "bread": 10,
      "cookie": 1,
      "milk": 4
    },
    "subtypes": [
      "bread",
      "milk",
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "muscletech": {
    "displayName": "Muscletech",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "cookie": 4
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "laziza": {
    "displayName": "Laziza",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 17
    },
    "subtypeCounts": {
      "sauce": 2
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "tropicana_products": {
    "displayName": "Tropicana Products,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 17
    },
    "subtypeCounts": {
      "beverage": 17
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "blue_bell_creameries": {
    "displayName": "Blue Bell Creameries,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 17
    },
    "subtypeCounts": {
      "ice_cream": 17
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 17,
    "source": "usda"
  },
  "ole_mexican": {
    "displayName": "Ole Mexican",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 7,
      "pantry": 9
    },
    "subtypeCounts": {
      "cheese": 7,
      "baking": 6,
      "bread": 1
    },
    "subtypes": [
      "cheese",
      "baking",
      "bread"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "adams": {
    "displayName": "Adams",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "sauce": 4
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "house_autry": {
    "displayName": "House-autry",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "sauce": 15,
      "baking": 1
    },
    "subtypes": [
      "sauce",
      "baking"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "pennsylvania_dutchman": {
    "displayName": "Pennsylvania Dutchman",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "produce": 3
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 16,
    "source": "usda"
  },
  "crock_pot": {
    "displayName": "Crock-pot",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "sauce": 15,
      "boxed_meal": 1
    },
    "subtypes": [
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "angelic_bakehouse": {
    "displayName": "Angelic Bakehouse",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "bread": 15
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "treasure_cave": {
    "displayName": "Treasure Cave",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 16
    },
    "subtypeCounts": {
      "cheese": 16
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "herdez": {
    "displayName": "Herdez",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 1,
      "frozen": 8,
      "pantry": 7
    },
    "subtypeCounts": {
      "cheese": 1,
      "boxed_meal": 6
    },
    "subtypes": [
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "star": {
    "displayName": "Star",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "beverage": 2
    },
    "subtypeCounts": {
      "dressing": 1,
      "beverage": 2
    },
    "subtypes": [
      "beverage",
      "dressing"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "seneca": {
    "displayName": "Seneca",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "frozen": 1
    },
    "subtypeCounts": {
      "candy": 1
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "musselmans": {
    "displayName": "Musselman's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 5,
      "beverage": 11
    },
    "subtypeCounts": {
      "beverage": 11
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "butterball": {
    "displayName": "Butterball",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 14,
      "frozen": 2
    },
    "subtypeCounts": {
      "sausage": 14,
      "boxed_meal": 2
    },
    "subtypes": [
      "sausage",
      "boxed_meal"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "mrs_ts": {
    "displayName": "Mrs.t's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 16
    },
    "subtypeCounts": {
      "boxed_meal": 16
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "goodie_girl": {
    "displayName": "Goodie Girl",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "cookie": 16
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "raw_rev": {
    "displayName": "Raw Rev",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 16,
    "source": "usda"
  },
  "gimbals": {
    "displayName": "Gimbal's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "candy": 16
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "san_luis_sourdough": {
    "displayName": "San Luis Sourdough",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "bread": 16
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "pacific_ast": {
    "displayName": "Pacific Coast",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "dairy": 1,
      "beverage": 1
    },
    "subtypeCounts": {
      "baking": 1,
      "boxed_meal": 1,
      "beverage": 1,
      "dressing": 1,
      "bread": 4,
      "sweetener": 1
    },
    "subtypes": [
      "bread",
      "baking",
      "boxed_meal",
      "beverage",
      "dressing",
      "sweetener"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "talking_rain": {
    "displayName": "Talking Rain",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 16
    },
    "subtypeCounts": {
      "beverage": 16
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "candy_crush": {
    "displayName": "Candy Crush",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "candy": 14,
      "cookie": 1,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "russos_bakery": {
    "displayName": "Russo's Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "bread": 16
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "richin": {
    "displayName": "Richin",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "dairy": 1
    },
    "subtypeCounts": {
      "spread": 1
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "drumstick": {
    "displayName": "Drumstick",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 16
    },
    "subtypeCounts": {
      "ice_cream": 16
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "sun_tropics": {
    "displayName": "Sun Tropics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 6,
      "beverage": 10
    },
    "subtypeCounts": {
      "cookie": 3,
      "beverage": 10
    },
    "subtypes": [
      "beverage",
      "cookie"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "cajun_injector": {
    "displayName": "Cajun Injector",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "sauce": 15
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "wylers": {
    "displayName": "Wyler's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 7,
      "pantry": 9
    },
    "subtypeCounts": {
      "ice_cream": 7,
      "sauce": 9
    },
    "subtypes": [
      "sauce",
      "ice_cream"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "bauduc": {
    "displayName": "Bauducco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "cookie": 13,
      "bread": 3
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "new_bridge": {
    "displayName": "New Bridge",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 16
    },
    "subtypeCounts": {
      "cheese": 16
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "munk_pack": {
    "displayName": "Munk Pack",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "cookie": 11
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "one_potato_two_potato": {
    "displayName": "One Potato Two Potato",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 16,
    "source": "usda"
  },
  "blanxart": {
    "displayName": "Blanxart",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "chocolate": 16
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "butter_kernel": {
    "displayName": "Butter Kernel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 16,
    "source": "usda"
  },
  "ener_g": {
    "displayName": "Ener-g",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "dairy": 1
    },
    "subtypeCounts": {
      "bread": 13,
      "baking": 1
    },
    "subtypes": [
      "bread",
      "baking"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "pastene": {
    "displayName": "Pastene",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "krakus": {
    "displayName": "Krakus",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 4,
      "pantry": 12
    },
    "subtypeCounts": {
      "beverage": 4,
      "cookie": 7,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "beverage",
      "candy"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "clear_fruit": {
    "displayName": "Clear Fruit",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 16
    },
    "subtypeCounts": {
      "beverage": 16
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "lukes_organic": {
    "displayName": "Luke's Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 16,
    "source": "usda"
  },
  "wai_lana": {
    "displayName": "Wai Lana",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 16,
    "source": "usda"
  },
  "angry_birds": {
    "displayName": "Angry Birds",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "candy": 15,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "chicago_bar": {
    "displayName": "Chicago Bar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 16,
    "source": "usda"
  },
  "frankford_candy": {
    "displayName": "Frankford Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "candy": 15,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "united_natural": {
    "displayName": "United Natural ,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15,
      "beverage": 1
    },
    "subtypeCounts": {
      "baking": 3,
      "cookie": 2,
      "beverage": 1,
      "sauce": 2
    },
    "subtypes": [
      "baking",
      "cookie",
      "sauce",
      "beverage"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "little_temptations": {
    "displayName": "Little Temptations",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "candy": 14,
      "chocolate": 2
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "roons": {
    "displayName": "Coco-roons",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "cookie": 16
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "rothbury_farms": {
    "displayName": "Rothbury Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "bread": 16
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "grimmway_farms": {
    "displayName": "Grimmway Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 12,
      "beverage": 4
    },
    "subtypeCounts": {
      "beverage": 4
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "luigi_vitelli": {
    "displayName": "Luigi Vitelli",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "dairy": 3
    },
    "subtypeCounts": {
      "cheese": 3
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "la_morena": {
    "displayName": "La Morena",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 16,
    "source": "usda"
  },
  "spice_classics": {
    "displayName": "Spice Classics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "sauce": 13,
      "dressing": 1
    },
    "subtypes": [
      "sauce",
      "dressing"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "thinsters": {
    "displayName": "Thinsters",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "cookie": 15,
      "chocolate": 1
    },
    "subtypes": [
      "cookie",
      "chocolate"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "breadsmith": {
    "displayName": "Breadsmith",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "bread": 16
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "streits": {
    "displayName": "Streit's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "chocolate": 5,
      "boxed_meal": 5,
      "sauce": 2,
      "bread": 1,
      "candy": 1,
      "spread": 2
    },
    "subtypes": [
      "chocolate",
      "boxed_meal",
      "sauce",
      "spread",
      "bread",
      "candy"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "nec": {
    "displayName": "Necco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "candy": 15,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "franks": {
    "displayName": "Frank's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "beverage": 1,
      "produce": 1
    },
    "subtypeCounts": {
      "sauce": 2,
      "beverage": 1
    },
    "subtypes": [
      "sauce",
      "beverage"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "storck_lp": {
    "displayName": "Storck Lp",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "candy": 10,
      "chocolate": 6
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "hinode": {
    "displayName": "Hinode",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 16,
    "source": "usda"
  },
  "daily_chef_food_service": {
    "displayName": "Daily Chef Food Service",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 1,
      "pantry": 3,
      "dairy": 9,
      "frozen": 3
    },
    "subtypeCounts": {
      "sausage": 1,
      "cheese": 9,
      "boxed_meal": 1,
      "ice_cream": 2,
      "dressing": 1
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "sausage",
      "boxed_meal",
      "dressing"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "grainful": {
    "displayName": "Grainful",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 16
    },
    "subtypeCounts": {
      "boxed_meal": 16
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "happy_apples": {
    "displayName": "Happy Apples",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 16
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 16,
    "source": "usda"
  },
  "bragg": {
    "displayName": "Bragg",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "dressing": 9,
      "sauce": 3,
      "baking": 1
    },
    "subtypes": [
      "dressing",
      "sauce",
      "baking"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "sechlers": {
    "displayName": "Sechler's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "sauce": 1
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "natures_greens": {
    "displayName": "Nature's Greens",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 13,
      "meat": 1,
      "pantry": 1,
      "frozen": 1
    },
    "subtypeCounts": {
      "boxed_meal": 2
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "johnnys": {
    "displayName": "Johnny's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "sauce": 12,
      "dressing": 3
    },
    "subtypes": [
      "sauce",
      "dressing"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "p_t": {
    "displayName": "P$$t",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "dairy": 1,
      "frozen": 4
    },
    "subtypeCounts": {
      "sauce": 3,
      "cheese": 1,
      "cookie": 5,
      "ice_cream": 1,
      "bread": 1,
      "boxed_meal": 4
    },
    "subtypes": [
      "cookie",
      "boxed_meal",
      "sauce",
      "cheese",
      "ice_cream",
      "bread"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "hu": {
    "displayName": "Hu",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "chocolate": 15
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "guylian": {
    "displayName": "Guylian",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "chocolate": 16
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "scharffen_berger": {
    "displayName": "Scharffen Berger",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "chocolate": 14,
      "baking": 2
    },
    "subtypes": [
      "chocolate",
      "baking"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "milka": {
    "displayName": "Milka",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "cookie": 4,
      "chocolate": 11,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "cookie",
      "candy"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "bakery_fresh": {
    "displayName": "Bakery Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "cookie": 16
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "salad_pizazz": {
    "displayName": "Salad Pizazz!",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "dressing": 16
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "skippy": {
    "displayName": "Skippy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 7,
      "frozen": 9
    },
    "subtypeCounts": {
      "cookie": 4,
      "boxed_meal": 9,
      "candy": 3
    },
    "subtypes": [
      "boxed_meal",
      "cookie",
      "candy"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "simple_squares": {
    "displayName": "Simple Squares",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 16,
    "source": "usda"
  },
  "cleo_leo_recipes": {
    "displayName": "Cleo & Leo Recipes",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "dairy": 6
    },
    "subtypeCounts": {
      "cookie": 8,
      "cheese": 6,
      "bread": 1
    },
    "subtypes": [
      "cookie",
      "cheese",
      "bread"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "silver_falls": {
    "displayName": "Silver Falls",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 16
    },
    "subtypeCounts": {
      "beverage": 16
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "sunshine": {
    "displayName": "Sunshine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 2,
      "dairy": 10,
      "beverage": 4
    },
    "subtypeCounts": {
      "candy": 1,
      "milk": 4,
      "beverage": 4,
      "sauce": 1
    },
    "subtypes": [
      "milk",
      "beverage",
      "candy",
      "sauce"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "sams_club_west": {
    "displayName": "Sam's Club West",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 4,
      "dairy": 6,
      "meat": 1,
      "frozen": 5
    },
    "subtypeCounts": {
      "cheese": 5,
      "boxed_meal": 1,
      "milk": 1,
      "ice_cream": 1
    },
    "subtypes": [
      "cheese",
      "boxed_meal",
      "milk",
      "ice_cream"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "family_favorites": {
    "displayName": "Family Favorites",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 15,
      "pantry": 1
    },
    "subtypeCounts": {
      "boxed_meal": 15
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "izze": {
    "displayName": "Izze",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 3,
      "beverage": 13
    },
    "subtypeCounts": {
      "candy": 3,
      "beverage": 13
    },
    "subtypes": [
      "beverage",
      "candy"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "caldwell_fresh": {
    "displayName": "Caldwell Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 14,
      "meat": 1,
      "pantry": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "dressing": 1
    },
    "subtypes": [
      "boxed_meal",
      "dressing"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "mediterra": {
    "displayName": "Mediterra",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 16,
    "source": "usda"
  },
  "haks": {
    "displayName": "Hak's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "dressing": 16
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "nestle_dreyers_ice_cream": {
    "displayName": "Nestle Dreyer's Ice Cream",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 15,
      "dairy": 1
    },
    "subtypeCounts": {
      "ice_cream": 15,
      "yogurt": 1
    },
    "subtypes": [
      "ice_cream",
      "yogurt"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "carmit": {
    "displayName": "Carmit",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "candy": 1,
      "chocolate": 10,
      "cookie": 5
    },
    "subtypes": [
      "chocolate",
      "cookie",
      "candy"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "nomi": {
    "displayName": "Nomi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 4,
      "pantry": 12
    },
    "subtypeCounts": {
      "beverage": 4
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "deweys_bakery": {
    "displayName": "Dewey's Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 16
    },
    "subtypeCounts": {
      "cookie": 16
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "cass_clay": {
    "displayName": "Cass-clay",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 16
    },
    "subtypeCounts": {
      "milk": 16
    },
    "subtypes": [
      "milk"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "liberte": {
    "displayName": "Liberte",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 16
    },
    "subtypeCounts": {
      "yogurt": 16
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 16,
    "source": "usda"
  },
  "mi_del": {
    "displayName": "Mi-del",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "cookie": 15
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "caesar_cardinis": {
    "displayName": "Caesar Cardini's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "dressing": 10,
      "bread": 5
    },
    "subtypes": [
      "dressing",
      "bread"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "world_of_chia": {
    "displayName": "World Of Chia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "spread": 15
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "danimals": {
    "displayName": "Danimals",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "yogurt": 15
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "kretschmar": {
    "displayName": "Kretschmar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14,
      "meat": 1
    },
    "subtypeCounts": {
      "cheese": 14,
      "sausage": 1
    },
    "subtypes": [
      "cheese",
      "sausage"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "free2b": {
    "displayName": "Free2b",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "chocolate": 9,
      "candy": 6
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "merkts": {
    "displayName": "Merkts",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "cheese": 15
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "carvel": {
    "displayName": "Carvel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12,
      "dairy": 3
    },
    "subtypeCounts": {
      "ice_cream": 12,
      "milk": 3
    },
    "subtypes": [
      "ice_cream",
      "milk"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "adolphs": {
    "displayName": "Adolph's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "sauce": 15
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "spangler": {
    "displayName": "Spangler",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "candy": 15
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "blue_plate": {
    "displayName": "Blue Plate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "dressing": 15
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "love_in_air": {
    "displayName": "Love In The Air",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "candy": 10,
      "chocolate": 5
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "better_bakery": {
    "displayName": "Better Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 15
    },
    "subtypeCounts": {
      "boxed_meal": 15
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "celebrity": {
    "displayName": "Celebrity",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "cheese": 15
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "sheila_gs": {
    "displayName": "Sheila G's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "candy": 9,
      "cookie": 4,
      "chocolate": 2
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "cerulean_seas": {
    "displayName": "Cerulean Seas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "sauce": 12,
      "boxed_meal": 1
    },
    "subtypes": [
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "jimmy": {
    "displayName": "Jimmy!",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "bolners_fiesta": {
    "displayName": "Bolner's Fiesta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "sauce": 13
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "nesquik": {
    "displayName": "Nesquik",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "milk": 15
    },
    "subtypes": [
      "milk"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "crazy_monkey_baking": {
    "displayName": "Crazy Monkey Baking",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "cookie": 15
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "whoppers": {
    "displayName": "Whoppers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "dairy": 1
    },
    "subtypeCounts": {
      "chocolate": 8,
      "candy": 6,
      "yogurt": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "yogurt"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "famous_amos": {
    "displayName": "Famous Amos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "cookie": 15
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "montebello": {
    "displayName": "Montebello",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "tgi_fridays": {
    "displayName": "Tgi Fridays",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 4,
      "dairy": 1,
      "frozen": 10
    },
    "subtypeCounts": {
      "cheese": 1,
      "boxed_meal": 10,
      "sauce": 1
    },
    "subtypes": [
      "boxed_meal",
      "cheese",
      "sauce"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "whole_fruit": {
    "displayName": "Whole Fruit",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 15
    },
    "subtypeCounts": {
      "ice_cream": 15
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "simply_fresh": {
    "displayName": "Simply Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 1,
      "pantry": 7,
      "produce": 5,
      "dairy": 2
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "cheese": 2
    },
    "subtypes": [
      "cheese",
      "boxed_meal"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "pressery": {
    "displayName": "Pressery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "beverage": 3
    },
    "subtypeCounts": {
      "boxed_meal": 12,
      "beverage": 3
    },
    "subtypes": [
      "boxed_meal",
      "beverage"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "krinos": {
    "displayName": "Krinos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "dairy": 2
    },
    "subtypeCounts": {
      "cookie": 1,
      "dressing": 1,
      "candy": 1,
      "cheese": 2
    },
    "subtypes": [
      "cheese",
      "cookie",
      "dressing",
      "candy"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "bountiful_harvest": {
    "displayName": "Bountiful Harvest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "lucky_leaf": {
    "displayName": "Lucky Leaf",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 8,
      "pantry": 7
    },
    "subtypeCounts": {
      "beverage": 8
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "bantam_bagels": {
    "displayName": "Bantam Bagels",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 15
    },
    "subtypeCounts": {
      "boxed_meal": 8,
      "bread": 7
    },
    "subtypes": [
      "boxed_meal",
      "bread"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "heath": {
    "displayName": "Heath",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "frozen": 1
    },
    "subtypeCounts": {
      "chocolate": 6,
      "candy": 8,
      "ice_cream": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "ice_cream"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "wackyms_kitchen": {
    "displayName": "Wackym's Kitchen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "cookie": 15
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "campfire": {
    "displayName": "Campfire",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "candy": 14,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "marcum": {
    "displayName": "Marcum",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "sauce": 14
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "lillys": {
    "displayName": "Lilly's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "cookie": 11,
      "chocolate": 1,
      "bread": 3
    },
    "subtypes": [
      "cookie",
      "bread",
      "chocolate"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "bachman": {
    "displayName": "Bachman",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "health_valley_organic": {
    "displayName": "Health Valley Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "boxed_meal": 14
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "real_good_food": {
    "displayName": "The Real Good Food",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 15
    },
    "subtypeCounts": {
      "bread": 1,
      "ice_cream": 7,
      "boxed_meal": 7
    },
    "subtypes": [
      "ice_cream",
      "boxed_meal",
      "bread"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "carey": {
    "displayName": "Carey",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "agri_mark": {
    "displayName": "Agri-mark,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "cheese": 15
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "lundberg": {
    "displayName": "Lundberg",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "giffords": {
    "displayName": "Gifford's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 15
    },
    "subtypeCounts": {
      "ice_cream": 15
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "casa_fiesta": {
    "displayName": "Casa Fiesta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "sauce": 6
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "mama_sitas": {
    "displayName": "Mama Sita's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "sauce": 15
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "best_west": {
    "displayName": "Best West",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "beehive_cheese": {
    "displayName": "Beehive Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "cheese": 15
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "castellino": {
    "displayName": "Castellino",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "frozen": 1
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "johanna": {
    "displayName": "Johanna ,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12,
      "beverage": 3
    },
    "subtypeCounts": {
      "yogurt": 12,
      "beverage": 3
    },
    "subtypes": [
      "yogurt",
      "beverage"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "lucys": {
    "displayName": "Lucys",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "cookie": 15
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "go_organic": {
    "displayName": "Go Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "candy": 14
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "rise": {
    "displayName": "Rise",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "tree_ripe": {
    "displayName": "Tree Ripe",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 15
    },
    "subtypeCounts": {
      "beverage": 15
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "world_market": {
    "displayName": "World Market",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "beverage": 1
    },
    "subtypeCounts": {
      "chocolate": 4,
      "spread": 6,
      "cookie": 3,
      "beverage": 1
    },
    "subtypes": [
      "spread",
      "chocolate",
      "cookie",
      "beverage"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "humboldt_creamery": {
    "displayName": "Humboldt Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13,
      "dairy": 2
    },
    "subtypeCounts": {
      "ice_cream": 13,
      "milk": 2
    },
    "subtypes": [
      "ice_cream",
      "milk"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "dr_praegers": {
    "displayName": "Dr. Praeger's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13,
      "pantry": 2
    },
    "subtypeCounts": {
      "boxed_meal": 13,
      "cookie": 1
    },
    "subtypes": [
      "boxed_meal",
      "cookie"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "furlani": {
    "displayName": "Furlani",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 14,
      "pantry": 1
    },
    "subtypeCounts": {
      "bread": 14,
      "boxed_meal": 1
    },
    "subtypes": [
      "bread",
      "boxed_meal"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "love_beets": {
    "displayName": "Love Beets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 4,
      "beverage": 3,
      "produce": 8
    },
    "subtypeCounts": {
      "beverage": 3
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "wilmot_farms": {
    "displayName": "Wilmot Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "cheese": 15
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "arrowhead_mills": {
    "displayName": "Arrowhead Mills",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "baking": 14
    },
    "subtypes": [
      "baking"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "sunridge_farms": {
    "displayName": "Sunridge Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "candy": 5,
      "chocolate": 3,
      "cookie": 2
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "fire_flavor": {
    "displayName": "Fire & Flavor",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "sauce": 12
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "highland_crest": {
    "displayName": "Highland Crest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13,
      "frozen": 1,
      "pantry": 1
    },
    "subtypeCounts": {
      "cheese": 9,
      "milk": 4,
      "ice_cream": 1,
      "spread": 1
    },
    "subtypes": [
      "cheese",
      "milk",
      "ice_cream",
      "spread"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "riega": {
    "displayName": "Riega",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "sauce": 15
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "smari": {
    "displayName": "Smari",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "yogurt": 15
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "king_of_pops": {
    "displayName": "King Of Pops",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 15
    },
    "subtypeCounts": {
      "ice_cream": 15
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "two_good": {
    "displayName": "Two Good",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "yogurt": 15
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "alta_dena": {
    "displayName": "Alta Dena",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "cheese": 8,
      "milk": 7
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "red_hills_fruit": {
    "displayName": "Red Hills Fruit",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "spread": 7
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "purity": {
    "displayName": "Purity",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 1,
      "dairy": 6,
      "frozen": 7,
      "beverage": 1
    },
    "subtypeCounts": {
      "bread": 1,
      "milk": 6,
      "ice_cream": 7,
      "beverage": 1
    },
    "subtypes": [
      "ice_cream",
      "milk",
      "bread",
      "beverage"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "miracle_whip": {
    "displayName": "Miracle Whip",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "dressing": 15
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "peppa_pig": {
    "displayName": "Peppa Pig",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "candy": 11,
      "cookie": 4
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "berkeley_farms": {
    "displayName": "Berkeley Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "milk": 10,
      "cheese": 5
    },
    "subtypes": [
      "milk",
      "cheese"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "wella_bar": {
    "displayName": "Wella Bar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "getgo": {
    "displayName": "Getgo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "candy": 11,
      "cookie": 4
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "refreshe": {
    "displayName": "Refreshe",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 15
    },
    "subtypeCounts": {
      "beverage": 15
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "dsd_merchandisers": {
    "displayName": "Dsd Merchandisers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "candy": 14
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "casaro": {
    "displayName": "Casaro",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "cheese": 15
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "dreamworks": {
    "displayName": "Dreamworks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 4,
      "pantry": 11
    },
    "subtypeCounts": {
      "beverage": 4,
      "candy": 10,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "beverage",
      "chocolate"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "golden_creme": {
    "displayName": "Golden Creme",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "milk": 15
    },
    "subtypes": [
      "milk"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "rhythm_superfoods": {
    "displayName": "Rhythm Superfoods",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "produce": 1
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "jilbert": {
    "displayName": "Jilbert",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "cheese": 11,
      "milk": 4
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "guaranteed_value": {
    "displayName": "Guaranteed Value",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 2,
      "pantry": 4,
      "frozen": 5,
      "produce": 2,
      "beverage": 1,
      "dairy": 1
    },
    "subtypeCounts": {
      "sausage": 2,
      "dressing": 2,
      "boxed_meal": 2,
      "beverage": 1,
      "cookie": 1,
      "milk": 1,
      "ice_cream": 3,
      "sweetener": 1
    },
    "subtypes": [
      "ice_cream",
      "sausage",
      "dressing",
      "boxed_meal",
      "beverage",
      "cookie",
      "milk",
      "sweetener"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "rosa_brothers_milk": {
    "displayName": "Rosa Brothers Milk",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13,
      "frozen": 2
    },
    "subtypeCounts": {
      "milk": 13,
      "ice_cream": 2
    },
    "subtypes": [
      "milk",
      "ice_cream"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "dreamland": {
    "displayName": "Dreamland",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 3,
      "meat": 12
    },
    "subtypeCounts": {
      "sauce": 1,
      "boxed_meal": 12
    },
    "subtypes": [
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "pamelas_products": {
    "displayName": "Pamela's Products",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "cookie": 10
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "that_pickle_guy": {
    "displayName": "That Pickle Guy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "zola": {
    "displayName": "Zola",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 15
    },
    "subtypeCounts": {
      "beverage": 15
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "golden_grain": {
    "displayName": "Golden Grain",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 15,
    "source": "usda"
  },
  "eas": {
    "displayName": "Eas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "dairy": 3
    },
    "subtypeCounts": {
      "milk": 3
    },
    "subtypes": [
      "milk"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "fresh_made": {
    "displayName": "Fresh Made",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 15
    },
    "subtypeCounts": {
      "yogurt": 8,
      "milk": 3,
      "cheese": 4
    },
    "subtypes": [
      "yogurt",
      "cheese",
      "milk"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "digiorno": {
    "displayName": "Digiorno",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 6,
      "dairy": 9
    },
    "subtypeCounts": {
      "bread": 2,
      "cheese": 9,
      "boxed_meal": 4
    },
    "subtypes": [
      "cheese",
      "boxed_meal",
      "bread"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "davids": {
    "displayName": "David's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 15
    },
    "subtypeCounts": {
      "candy": 2,
      "chocolate": 4,
      "cookie": 3,
      "sauce": 3
    },
    "subtypes": [
      "chocolate",
      "cookie",
      "sauce",
      "candy"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "king_kullen": {
    "displayName": "King Kullen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 2,
      "pantry": 5,
      "dairy": 8
    },
    "subtypeCounts": {
      "bread": 5,
      "milk": 8
    },
    "subtypes": [
      "milk",
      "bread"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "heart_and_soul": {
    "displayName": "Heart And Soul",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 15
    },
    "subtypeCounts": {
      "boxed_meal": 1
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "truroots": {
    "displayName": "Truroots",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14,
      "produce": 1
    },
    "subtypeCounts": {
      "cookie": 3
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 15,
    "source": "usda"
  },
  "chavrie": {
    "displayName": "Chavrie",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13,
      "meat": 1
    },
    "subtypeCounts": {
      "cheese": 13,
      "boxed_meal": 1
    },
    "subtypes": [
      "cheese",
      "boxed_meal"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "chef_paul_prudhomme": {
    "displayName": "Chef Paul Prudhomme",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "sauce": 11
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "tastykake": {
    "displayName": "Tastykake",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "cookie": 10
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "hapi": {
    "displayName": "Hapi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 9,
      "beverage": 5
    },
    "subtypeCounts": {
      "cookie": 2,
      "beverage": 5
    },
    "subtypes": [
      "beverage",
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "tabas": {
    "displayName": "Tabasco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "dressing": 2,
      "spread": 2,
      "sauce": 4
    },
    "subtypes": [
      "sauce",
      "dressing",
      "spread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "penn_maid": {
    "displayName": "Penn Maid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14
    },
    "subtypeCounts": {
      "cheese": 8,
      "milk": 6
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "tastee_choice": {
    "displayName": "Tastee Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 14
    },
    "subtypeCounts": {
      "boxed_meal": 14
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "la_chona": {
    "displayName": "La Chona",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13,
      "pantry": 1
    },
    "subtypeCounts": {
      "cheese": 10,
      "milk": 3
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "good_natured_selects": {
    "displayName": "Good Natured Selects",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "one_degree_organic": {
    "displayName": "One Degree Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "baking": 10,
      "bread": 4
    },
    "subtypes": [
      "baking",
      "bread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "orrington_farms": {
    "displayName": "Orrington Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "sauce": 14
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "eatingwell": {
    "displayName": "Eatingwell",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 14
    },
    "subtypeCounts": {
      "boxed_meal": 14
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "sweet_candy": {
    "displayName": "Sweet Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 13,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "crayola": {
    "displayName": "Crayola",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 14
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "celebration_by_sweetworks": {
    "displayName": "Celebration By Sweetworks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "chocolate": 13,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "payaso": {
    "displayName": "Payaso",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "cookie": 13
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "williams_cheese": {
    "displayName": "Williams Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14
    },
    "subtypeCounts": {
      "cheese": 14
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "jojos": {
    "displayName": "Jojo's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "chocolate": 7,
      "candy": 3
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "glucerna": {
    "displayName": "Glucerna",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 1
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "mrs_cubbisons": {
    "displayName": "Mrs. Cubbison's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "bread": 10,
      "dressing": 3
    },
    "subtypes": [
      "bread",
      "dressing"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "kuners": {
    "displayName": "Kuner's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "seviroli": {
    "displayName": "Seviroli",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 8,
      "frozen": 6
    },
    "subtypeCounts": {
      "boxed_meal": 6
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "botticelli": {
    "displayName": "Botticelli",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 1,
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "john_morrell": {
    "displayName": "John Morrell",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 14
    },
    "subtypeCounts": {
      "sausage": 14
    },
    "subtypes": [
      "sausage"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "signature_reserve": {
    "displayName": "Signature Reserve",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "frozen": 2
    },
    "subtypeCounts": {
      "chocolate": 5,
      "ice_cream": 2,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "ice_cream",
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "sid_wainer_son": {
    "displayName": "Sid Wainer & Son",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "produce": 1,
      "dairy": 1
    },
    "subtypeCounts": {
      "spread": 1,
      "baking": 1,
      "cheese": 1
    },
    "subtypes": [
      "spread",
      "baking",
      "cheese"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "helados_mexi": {
    "displayName": "Helados Mexico",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 14
    },
    "subtypeCounts": {
      "ice_cream": 14
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "lavva": {
    "displayName": "Lavva",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14
    },
    "subtypeCounts": {
      "yogurt": 14
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "inspired_organics": {
    "displayName": "Inspired Organics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 1,
      "pantry": 11,
      "beverage": 1,
      "dairy": 1
    },
    "subtypeCounts": {
      "dressing": 3,
      "beverage": 1,
      "boxed_meal": 4,
      "candy": 1,
      "sweetener": 1
    },
    "subtypes": [
      "boxed_meal",
      "dressing",
      "beverage",
      "candy",
      "sweetener"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "simplyprotein": {
    "displayName": "Simplyprotein",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "cookie": 3
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "lucerne_farms": {
    "displayName": "Lucerne Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "kize": {
    "displayName": "Kize",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 1
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "nasoya": {
    "displayName": "Nasoya",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "dressing": 4
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "ling_ling": {
    "displayName": "Ling Ling",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 14
    },
    "subtypeCounts": {
      "boxed_meal": 14
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "ready_pac_produce": {
    "displayName": "Ready Pac Produce,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 11,
      "pantry": 3
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "bob_evans": {
    "displayName": "Bob Evans",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 7,
      "meat": 1,
      "frozen": 2,
      "produce": 3,
      "pantry": 1
    },
    "subtypeCounts": {
      "sausage": 1,
      "boxed_meal": 2,
      "bread": 1
    },
    "subtypes": [
      "boxed_meal",
      "sausage",
      "bread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "seven_farms": {
    "displayName": "Seven Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "spread": 1
    },
    "subtypes": [
      "boxed_meal",
      "spread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "market_32": {
    "displayName": "Market 32",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 5,
      "dairy": 2,
      "meat": 6,
      "produce": 1
    },
    "subtypeCounts": {
      "dressing": 2,
      "candy": 1,
      "cheese": 2,
      "boxed_meal": 6
    },
    "subtypes": [
      "boxed_meal",
      "dressing",
      "cheese",
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "salem_baking": {
    "displayName": "Salem Baking",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "cookie": 13,
      "bread": 1
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "seattle_cho_late": {
    "displayName": "Seattle Chocolate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "chocolate": 13,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "cable_car": {
    "displayName": "Cable Car",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 14
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "la": {
    "displayName": "L&a",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 13,
      "pantry": 1
    },
    "subtypeCounts": {
      "beverage": 13,
      "cookie": 1
    },
    "subtypes": [
      "beverage",
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "spooky_village": {
    "displayName": "Spooky Village",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 14
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "naked_wild_honey": {
    "displayName": "Naked Wild Honey",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "sweetener": 14
    },
    "subtypes": [
      "sweetener"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "old_croc": {
    "displayName": "Old Croc",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14
    },
    "subtypeCounts": {
      "cheese": 14
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "nancy_adams": {
    "displayName": "Nancy Adams",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "chocolate": 2,
      "candy": 8,
      "cookie": 4
    },
    "subtypes": [
      "candy",
      "cookie",
      "chocolate"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "raaka": {
    "displayName": "Raaka",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "chocolate": 14
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "greenjoy": {
    "displayName": "Greenjoy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "dressing": 14
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "lombina": {
    "displayName": "Colombina",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "spread": 1,
      "candy": 9,
      "cookie": 4
    },
    "subtypes": [
      "candy",
      "cookie",
      "spread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "tone_it_up": {
    "displayName": "Tone It Up",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "kidfresh": {
    "displayName": "Kidfresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 14
    },
    "subtypeCounts": {
      "boxed_meal": 14
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "health_valley": {
    "displayName": "Health Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "boxed_meal": 12
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "good": {
    "displayName": "Good",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 5,
      "dairy": 2,
      "beverage": 7
    },
    "subtypeCounts": {
      "dressing": 5,
      "cheese": 2,
      "beverage": 7
    },
    "subtypes": [
      "beverage",
      "dressing",
      "cheese"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "murrays_products": {
    "displayName": "Murray's Products",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "green_acres": {
    "displayName": "Green Acres",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "bay_valley": {
    "displayName": "Bay Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "cookie": 7,
      "dressing": 1
    },
    "subtypes": [
      "cookie",
      "dressing"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "abdallah": {
    "displayName": "Abdallah",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 8,
      "chocolate": 6
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "andrew_everett": {
    "displayName": "Andrew & Everett",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14
    },
    "subtypeCounts": {
      "cheese": 14
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "zoi": {
    "displayName": "Zoi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14
    },
    "subtypeCounts": {
      "yogurt": 14
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "love_good_fats": {
    "displayName": "Love Good Fats",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "ferrero_u_s_a_orporated": {
    "displayName": "Ferrero U.s.a., Incorporated",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 4,
      "chocolate": 8,
      "cookie": 2
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "davids_deli": {
    "displayName": "David's Deli",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "bread": 14
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "nutty_fruity": {
    "displayName": "Nutty & Fruity",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "produce": 1
    },
    "subtypeCounts": {
      "baking": 2,
      "candy": 2
    },
    "subtypes": [
      "baking",
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "tinkyada": {
    "displayName": "Tinkyada",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "mancini": {
    "displayName": "Mancini",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "asian_best": {
    "displayName": "Asian Best",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "lotte": {
    "displayName": "Lotte",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "beverage": 1,
      "dairy": 2,
      "frozen": 1
    },
    "subtypeCounts": {
      "cookie": 6,
      "chocolate": 1,
      "beverage": 1,
      "milk": 2,
      "candy": 2,
      "ice_cream": 1
    },
    "subtypes": [
      "cookie",
      "milk",
      "candy",
      "chocolate",
      "beverage",
      "ice_cream"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "chaokoh": {
    "displayName": "Chaokoh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 6,
      "beverage": 7,
      "dairy": 1
    },
    "subtypeCounts": {
      "beverage": 7,
      "baking": 2
    },
    "subtypes": [
      "beverage",
      "baking"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "badia_spices": {
    "displayName": "Badia Spices",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "sauce": 11,
      "baking": 1
    },
    "subtypes": [
      "sauce",
      "baking"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "earths_best": {
    "displayName": "Earth's Best",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 5,
      "frozen": 8,
      "dairy": 1
    },
    "subtypeCounts": {
      "cookie": 2,
      "boxed_meal": 8,
      "yogurt": 1
    },
    "subtypes": [
      "boxed_meal",
      "cookie",
      "yogurt"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "gluck": {
    "displayName": "Gluck",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "superior_nut_candy": {
    "displayName": "Superior Nut & Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 10,
      "baking": 1
    },
    "subtypes": [
      "candy",
      "baking"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "george_delallo": {
    "displayName": "George Delallo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "meat": 2
    },
    "subtypeCounts": {
      "boxed_meal": 3,
      "spread": 2,
      "candy": 1
    },
    "subtypes": [
      "boxed_meal",
      "spread",
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "light_fit": {
    "displayName": "Light +fit",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14
    },
    "subtypeCounts": {
      "yogurt": 14
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "safies": {
    "displayName": "Safies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "white_lily": {
    "displayName": "White Lily",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "baking": 14
    },
    "subtypes": [
      "baking"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "saverne": {
    "displayName": "Saverne",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "peeled_snacks": {
    "displayName": "Peeled Snacks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "gabys_farm": {
    "displayName": "Gaby's Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 14
    },
    "subtypeCounts": {
      "ice_cream": 14
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "all_star": {
    "displayName": "All Star",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13,
      "pantry": 1
    },
    "subtypeCounts": {
      "milk": 8,
      "candy": 1,
      "cheese": 5
    },
    "subtypes": [
      "milk",
      "cheese",
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "cache_valley": {
    "displayName": "Cache Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14
    },
    "subtypeCounts": {
      "cheese": 14
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "annas": {
    "displayName": "Annas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "sweetener": 9,
      "cookie": 5
    },
    "subtypes": [
      "sweetener",
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "fruit_rush": {
    "displayName": "Fruit Rush",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 14
    },
    "subtypeCounts": {
      "beverage": 14
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "sugar_bowl_bakery": {
    "displayName": "Sugar Bowl Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "cookie": 14
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "castella": {
    "displayName": "Castella",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "meat": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "shake_n_bake": {
    "displayName": "Shake 'n Bake",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "sauce": 14
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "chef_jenn": {
    "displayName": "Chef Jenn",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11,
      "pantry": 3
    },
    "subtypeCounts": {
      "boxed_meal": 11,
      "sauce": 3
    },
    "subtypes": [
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "signature": {
    "displayName": "Signature",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 8,
      "frozen": 4,
      "dairy": 2
    },
    "subtypeCounts": {
      "cookie": 2,
      "chocolate": 2,
      "boxed_meal": 3,
      "bread": 1,
      "cheese": 2
    },
    "subtypes": [
      "boxed_meal",
      "cookie",
      "chocolate",
      "cheese",
      "bread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "hilarys": {
    "displayName": "Hilary's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "frozen": 4
    },
    "subtypeCounts": {
      "dressing": 8,
      "cookie": 1,
      "boxed_meal": 4
    },
    "subtypes": [
      "dressing",
      "boxed_meal",
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "sparkletts": {
    "displayName": "Sparkletts",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 14
    },
    "subtypeCounts": {
      "beverage": 14
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "fiesta_pi": {
    "displayName": "Fiesta Pico",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 14
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "queen_city_candy": {
    "displayName": "Queen City Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 14
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "selmas": {
    "displayName": "Selma's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "cookie": 14
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "seasonal_sweets": {
    "displayName": "Seasonal Sweets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 10,
      "cookie": 4
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "kim_jakes": {
    "displayName": "Kim & Jake's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "cookie": 6,
      "bread": 8
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "visvita": {
    "displayName": "Visvita",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 14
    },
    "subtypeCounts": {
      "beverage": 14
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "vis_nti": {
    "displayName": "Visconti",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "dairy": 1
    },
    "subtypeCounts": {
      "cookie": 2,
      "cheese": 1
    },
    "subtypes": [
      "cookie",
      "cheese"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "delhaize_america": {
    "displayName": "Delhaize America,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 8,
      "dairy": 4,
      "meat": 2
    },
    "subtypeCounts": {
      "cheese": 2,
      "dressing": 1,
      "boxed_meal": 2,
      "cookie": 3
    },
    "subtypes": [
      "cookie",
      "cheese",
      "boxed_meal",
      "dressing"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "buff_bake": {
    "displayName": "Buff Bake",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "cookie": 13
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "green_mill": {
    "displayName": "Green Mill",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 2,
      "dairy": 3,
      "frozen": 9
    },
    "subtypeCounts": {
      "bread": 4,
      "cheese": 3,
      "boxed_meal": 7
    },
    "subtypes": [
      "boxed_meal",
      "bread",
      "cheese"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "amish_wedding": {
    "displayName": "Amish Wedding",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "dairy": 1
    },
    "subtypeCounts": {
      "spread": 4
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "river_valley": {
    "displayName": "River Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13,
      "produce": 1
    },
    "subtypeCounts": {
      "ice_cream": 10
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "diamond_crystal": {
    "displayName": "Diamond Crystal",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "spread": 1,
      "sauce": 13
    },
    "subtypes": [
      "sauce",
      "spread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "ragolds": {
    "displayName": "Ragolds",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 14
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "koch": {
    "displayName": "Koch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 14
    },
    "subtypeCounts": {
      "boxed_meal": 14
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "orchard_naturals": {
    "displayName": "Orchard Naturals",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "green_mountain_creamery": {
    "displayName": "Green Mountain Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14
    },
    "subtypeCounts": {
      "yogurt": 14
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "avitae": {
    "displayName": "Avitae",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 14
    },
    "subtypeCounts": {
      "beverage": 14
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "papa_johns_salad_produce": {
    "displayName": "Papa John's Salad & Produce",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "produce": 1,
      "frozen": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "ugly": {
    "displayName": "Ugly",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 14
    },
    "subtypeCounts": {
      "beverage": 14
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "bearded_brothers": {
    "displayName": "Bearded Brothers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "de_okies": {
    "displayName": "Decocookies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "cookie": 14
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "klosterman": {
    "displayName": "Klosterman",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "bread": 14
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "localfolks": {
    "displayName": "Localfolks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "spread": 14
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "creamies": {
    "displayName": "Creamies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 14
    },
    "subtypeCounts": {
      "ice_cream": 14
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "gossner": {
    "displayName": "Gossner",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14
    },
    "subtypeCounts": {
      "milk": 14
    },
    "subtypes": [
      "milk"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "marsh": {
    "displayName": "Marsh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 4,
      "frozen": 2,
      "pantry": 8
    },
    "subtypeCounts": {
      "beverage": 4,
      "bread": 1,
      "sweetener": 1,
      "spread": 1,
      "ice_cream": 1
    },
    "subtypes": [
      "beverage",
      "bread",
      "sweetener",
      "spread",
      "ice_cream"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "formaggio": {
    "displayName": "Formaggio",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 7,
      "meat": 4,
      "pantry": 3
    },
    "subtypeCounts": {
      "cheese": 7,
      "boxed_meal": 4,
      "dressing": 3
    },
    "subtypes": [
      "cheese",
      "boxed_meal",
      "dressing"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "pete_and_gerrys_organics": {
    "displayName": "Pete And Gerry's Organics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "durkee": {
    "displayName": "Durkee",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "sauce": 8,
      "dressing": 1
    },
    "subtypes": [
      "sauce",
      "dressing"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "yum_bees": {
    "displayName": "Yum Bees",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "candy": 13,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "california_classics": {
    "displayName": "California Classics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13,
      "beverage": 1
    },
    "subtypeCounts": {
      "dressing": 13,
      "beverage": 1
    },
    "subtypes": [
      "dressing",
      "beverage"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "dalla_sta_alimentare_s_r_l": {
    "displayName": "Dalla Costa Alimentare S.r.l.",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 14,
    "source": "usda"
  },
  "francis": {
    "displayName": "Francisco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 14
    },
    "subtypeCounts": {
      "bread": 14
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "avenue_a": {
    "displayName": "Avenue A",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 6,
      "frozen": 4,
      "dairy": 3,
      "beverage": 1
    },
    "subtypeCounts": {
      "cheese": 3,
      "ice_cream": 1,
      "beverage": 1,
      "baking": 1
    },
    "subtypes": [
      "cheese",
      "ice_cream",
      "beverage",
      "baking"
    ],
    "totalObs": 14,
    "source": "usda"
  },
  "bar_harbor": {
    "displayName": "Bar Harbor",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "boxed_meal": 12,
      "sauce": 1
    },
    "subtypes": [
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "chatham_village": {
    "displayName": "Chatham Village",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "bread": 13
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "sable_rosenfeld": {
    "displayName": "Sable & Rosenfeld",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "farmhouse_culture": {
    "displayName": "Farmhouse Culture",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "kasugai": {
    "displayName": "Kasugai",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 12
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "famous_daves": {
    "displayName": "Famous Dave's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "sauce": 6
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "chefs_cupboard": {
    "displayName": "Chef's Cupboard",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "boxed_meal": 11,
      "sauce": 2
    },
    "subtypes": [
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "black_creek": {
    "displayName": "Black Creek",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {
      "cheese": 13
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "smile_save": {
    "displayName": "Smile & Save",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 10,
      "candy": 2
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "simple_mills": {
    "displayName": "Simple Mills",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 9
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "lucas": {
    "displayName": "Lucas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 8,
      "pantry": 5
    },
    "subtypeCounts": {
      "ice_cream": 8,
      "candy": 5
    },
    "subtypes": [
      "ice_cream",
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "mama_lycha": {
    "displayName": "Mama Lycha",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 9,
      "dairy": 4
    },
    "subtypeCounts": {
      "bread": 1,
      "candy": 3,
      "cheese": 1,
      "milk": 3
    },
    "subtypes": [
      "candy",
      "milk",
      "bread",
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "pagoda": {
    "displayName": "Pagoda",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13
    },
    "subtypeCounts": {
      "boxed_meal": 13
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "tims": {
    "displayName": "Tim's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "olive_garden": {
    "displayName": "Olive Garden",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "dressing": 10,
      "bread": 2
    },
    "subtypes": [
      "dressing",
      "bread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "sister_schuberts": {
    "displayName": "Sister Schubert's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12,
      "pantry": 1
    },
    "subtypeCounts": {
      "bread": 11,
      "boxed_meal": 2
    },
    "subtypes": [
      "bread",
      "boxed_meal"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "frusion": {
    "displayName": "Frusion",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12,
      "beverage": 1
    },
    "subtypeCounts": {
      "yogurt": 12,
      "beverage": 1
    },
    "subtypes": [
      "yogurt",
      "beverage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "valued_naturals": {
    "displayName": "Valued Naturals",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 7,
      "baking": 1,
      "dressing": 2
    },
    "subtypes": [
      "candy",
      "dressing",
      "baking"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "amazing_grass": {
    "displayName": "Amazing Grass",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "martinellis_gold_medal": {
    "displayName": "Martinelli's Gold Medal",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 13
    },
    "subtypeCounts": {
      "beverage": 13
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "aldens": {
    "displayName": "Alden's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13
    },
    "subtypeCounts": {
      "ice_cream": 13
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "farr_better": {
    "displayName": "Farr Better",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13
    },
    "subtypeCounts": {
      "ice_cream": 13
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "cloverland_farms_dairy": {
    "displayName": "Cloverland Farms Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {
      "milk": 13
    },
    "subtypes": [
      "milk"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "frankly_fresh": {
    "displayName": "Frankly Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 7,
      "dairy": 2,
      "pantry": 4
    },
    "subtypeCounts": {
      "boxed_meal": 7,
      "cheese": 2
    },
    "subtypes": [
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "aunt_hatties": {
    "displayName": "Aunt Hattie's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "bread": 13
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "night_hawk": {
    "displayName": "Night Hawk",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13
    },
    "subtypeCounts": {
      "boxed_meal": 13
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "clabber_girl": {
    "displayName": "Clabber Girl",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "baking": 13
    },
    "subtypes": [
      "baking"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "indian_summer": {
    "displayName": "Indian Summer",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 13
    },
    "subtypeCounts": {
      "beverage": 13
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "hawaiian_host": {
    "displayName": "Hawaiian Host",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "chocolate": 12,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "perdue_farms_orporated": {
    "displayName": "Perdue Farms Incorporated",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13
    },
    "subtypeCounts": {
      "boxed_meal": 13
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "lisy": {
    "displayName": "Lisy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 2,
      "sauce": 6
    },
    "subtypes": [
      "sauce",
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "alfaros": {
    "displayName": "Alfaro's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "bread": 13
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "razonas": {
    "displayName": "Corazonas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "oks_pantry": {
    "displayName": "Cook's Pantry",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "spread": 3,
      "sauce": 1
    },
    "subtypes": [
      "spread",
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "made_in_nature": {
    "displayName": "Made In Nature",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "megatoys": {
    "displayName": "Megatoys",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "beverage": 1
    },
    "subtypeCounts": {
      "candy": 11,
      "chocolate": 1,
      "beverage": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "beverage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "franks_redhot": {
    "displayName": "Frank's Redhot",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 3,
      "pantry": 9,
      "dairy": 1
    },
    "subtypeCounts": {
      "boxed_meal": 3,
      "sauce": 9,
      "cheese": 1
    },
    "subtypes": [
      "sauce",
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "spangler_candy": {
    "displayName": "Spangler Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 13
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "seattle_baking": {
    "displayName": "Seattle Baking",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "bread": 13
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "gourmet_dining": {
    "displayName": "Gourmet Dining",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13
    },
    "subtypeCounts": {
      "boxed_meal": 13
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "mifroma": {
    "displayName": "Mifroma",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {
      "cheese": 13
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "natures_nectar": {
    "displayName": "Nature's Nectar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 13
    },
    "subtypeCounts": {
      "beverage": 13
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "snyders_lance": {
    "displayName": "Snyder's-lance,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 2
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "brads_organic": {
    "displayName": "Brad's Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "spread": 3,
      "baking": 1,
      "dressing": 1
    },
    "subtypes": [
      "spread",
      "boxed_meal",
      "baking",
      "dressing"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "cara_mia": {
    "displayName": "Cara Mia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "hawaiian": {
    "displayName": "Hawaiian",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "sauce": 1
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "haribo_of_america": {
    "displayName": "Haribo Of America,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 13
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "bake_city": {
    "displayName": "Bake City",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 13
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "detour": {
    "displayName": "Detour",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "allegro": {
    "displayName": "Allegro",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "sauce": 11,
      "dressing": 1,
      "chocolate": 1
    },
    "subtypes": [
      "sauce",
      "dressing",
      "chocolate"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "landies_candies": {
    "displayName": "Landies Candies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 4,
      "chocolate": 8,
      "baking": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "baking"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "califia_farms": {
    "displayName": "Califia Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 7,
      "dairy": 6
    },
    "subtypeCounts": {
      "beverage": 7,
      "milk": 2,
      "yogurt": 4
    },
    "subtypes": [
      "beverage",
      "yogurt",
      "milk"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "laura_chenel": {
    "displayName": "Laura Chenel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {
      "cheese": 11,
      "yogurt": 2
    },
    "subtypes": [
      "cheese",
      "yogurt"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "koppers": {
    "displayName": "Koppers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "chocolate": 10,
      "candy": 3
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "tru_blu": {
    "displayName": "Tru-blu",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 13
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "castle_wood_reserve": {
    "displayName": "Castle Wood Reserve",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {
      "cheese": 13
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "cello": {
    "displayName": "Cello",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {
      "cheese": 13
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "hemisfares": {
    "displayName": "Hemisfares",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "dairy": 1,
      "frozen": 2
    },
    "subtypeCounts": {
      "cheese": 1,
      "ice_cream": 2,
      "dressing": 2
    },
    "subtypes": [
      "ice_cream",
      "dressing",
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "ellas_oven": {
    "displayName": "Ella's Oven",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 13
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "ellenos": {
    "displayName": "Ellenos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {
      "yogurt": 13
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "q": {
    "displayName": "Q",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 1,
      "beverage": 11,
      "dairy": 1
    },
    "subtypeCounts": {
      "bread": 1,
      "beverage": 11,
      "yogurt": 1
    },
    "subtypes": [
      "beverage",
      "bread",
      "yogurt"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "cemoi": {
    "displayName": "Cemoi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "chocolate": 12,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "brads_raw": {
    "displayName": "Brad's Raw",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "cachere_distributing": {
    "displayName": "Cachere Distributing",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 2,
      "pantry": 9,
      "beverage": 1,
      "produce": 1
    },
    "subtypeCounts": {
      "ice_cream": 2,
      "beverage": 1,
      "cookie": 3
    },
    "subtypes": [
      "cookie",
      "ice_cream",
      "beverage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "maui_style": {
    "displayName": "Maui Style",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "gs1_mexi": {
    "displayName": "Gs1 Mexico",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "dairy": 1
    },
    "subtypeCounts": {
      "candy": 2,
      "cookie": 4,
      "chocolate": 1,
      "cheese": 1
    },
    "subtypes": [
      "cookie",
      "candy",
      "chocolate",
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "quaker_oats": {
    "displayName": "The Quaker Oats",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "boomerangs": {
    "displayName": "Boomerang's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13
    },
    "subtypeCounts": {
      "boxed_meal": 12,
      "bread": 1
    },
    "subtypes": [
      "boxed_meal",
      "bread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "crescent_valley": {
    "displayName": "Crescent Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {
      "cheese": 13
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "creative_snacks": {
    "displayName": "Creative Snacks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 7
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "little_raes_bakery": {
    "displayName": "Little Rae's Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 13
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "glutenfreeda": {
    "displayName": "Glutenfreeda",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12,
      "pantry": 1
    },
    "subtypeCounts": {
      "boxed_meal": 12,
      "bread": 1
    },
    "subtypes": [
      "boxed_meal",
      "bread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "somerdale": {
    "displayName": "Somerdale",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {
      "cheese": 12,
      "milk": 1
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "sb": {
    "displayName": "S&b",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "sauce": 11
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "alive_radiant": {
    "displayName": "Alive & Radiant",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "blue_hill": {
    "displayName": "Blue Hill",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {
      "yogurt": 13
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "brads_plant_based": {
    "displayName": "Brads Plant Based",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "lonna": {
    "displayName": "Colonna",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11,
      "pantry": 2
    },
    "subtypeCounts": {
      "cheese": 11
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "spice_world": {
    "displayName": "Spice World",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "produce": 2
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "lovely_candy": {
    "displayName": "Lovely Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 13
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "delverde": {
    "displayName": "Delverde",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "hampton_creek": {
    "displayName": "Hampton Creek",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "dressing": 11,
      "sauce": 1
    },
    "subtypes": [
      "dressing",
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "urban_meadow": {
    "displayName": "Urban Meadow",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 1,
      "pantry": 10,
      "dairy": 1,
      "beverage": 1
    },
    "subtypeCounts": {
      "ice_cream": 1,
      "sweetener": 5,
      "cheese": 1,
      "bread": 1,
      "candy": 1,
      "beverage": 1
    },
    "subtypes": [
      "sweetener",
      "ice_cream",
      "cheese",
      "bread",
      "candy",
      "beverage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "san_bernardo": {
    "displayName": "San Bernardo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13
    },
    "subtypeCounts": {
      "ice_cream": 13
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "side_delights": {
    "displayName": "Side Delights",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "aleias": {
    "displayName": "Aleias",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 10,
      "bread": 2,
      "sauce": 1
    },
    "subtypes": [
      "cookie",
      "bread",
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "osem": {
    "displayName": "Osem",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "bread": 3,
      "baking": 1
    },
    "subtypes": [
      "bread",
      "baking"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "tony_packos": {
    "displayName": "Tony Packo's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "himalayan_chef": {
    "displayName": "Himalayan Chef",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "sauce": 11
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "sauers": {
    "displayName": "Sauer's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "sauce": 7,
      "dressing": 2
    },
    "subtypes": [
      "sauce",
      "dressing"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "werthers_original": {
    "displayName": "Werther's Original",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 13
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "promotion_in_motion_mpanies": {
    "displayName": "The Promotion In Motion Companies,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 13
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "elite": {
    "displayName": "Elite",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "meat": 1
    },
    "subtypeCounts": {
      "cookie": 2,
      "chocolate": 10,
      "sausage": 1
    },
    "subtypes": [
      "chocolate",
      "cookie",
      "sausage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "nulaid": {
    "displayName": "Nulaid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "rustichella_dabruzzo": {
    "displayName": "Rustichella D'abruzzo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "kc_masterpiece": {
    "displayName": "Kc Masterpiece",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "sauce": 13
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "akiyama": {
    "displayName": "Akiyama",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "oregon": {
    "displayName": "Oregon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "new_world_pasta": {
    "displayName": "New World Pasta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "ethel_m_cho_lates": {
    "displayName": "Ethel M Chocolates",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "chocolate": 13
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "biery": {
    "displayName": "Biery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {
      "cheese": 13
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "gonnella": {
    "displayName": "Gonnella",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "bread": 13
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "ocean_spray_cranberries": {
    "displayName": "Ocean Spray Cranberries,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 12,
      "pantry": 1
    },
    "subtypeCounts": {
      "beverage": 12
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "guernsey_farms_dairy": {
    "displayName": "Guernsey Farms Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11,
      "frozen": 2
    },
    "subtypeCounts": {
      "milk": 11,
      "ice_cream": 2
    },
    "subtypes": [
      "milk",
      "ice_cream"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "madewith": {
    "displayName": "Madewith",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12,
      "frozen": 1
    },
    "subtypeCounts": {
      "dressing": 2,
      "sweetener": 2,
      "spread": 6,
      "ice_cream": 1
    },
    "subtypes": [
      "spread",
      "dressing",
      "sweetener",
      "ice_cream"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "acme": {
    "displayName": "Acme",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 1,
      "pantry": 11,
      "meat": 1
    },
    "subtypeCounts": {
      "beverage": 1,
      "bread": 11,
      "boxed_meal": 1
    },
    "subtypes": [
      "bread",
      "beverage",
      "boxed_meal"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "mayfair": {
    "displayName": "Mayfair",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 12,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "progressive_balloons": {
    "displayName": "Progressive Balloons",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 13
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "peddlers_pantry": {
    "displayName": "Peddler's Pantry",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 4,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "chase_candy": {
    "displayName": "Chase Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 11,
      "chocolate": 2
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "mikeys": {
    "displayName": "Mikey's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13
    },
    "subtypeCounts": {
      "bread": 7,
      "boxed_meal": 6
    },
    "subtypes": [
      "bread",
      "boxed_meal"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "dancing_deer_baking": {
    "displayName": "Dancing Deer Baking",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 12,
      "chocolate": 1
    },
    "subtypes": [
      "cookie",
      "chocolate"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "montecito": {
    "displayName": "Montecito",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "beverage": 2
    },
    "subtypeCounts": {
      "beverage": 2
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "bread_shed": {
    "displayName": "The Bread Shed",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 1,
      "bread": 12
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "imaginings_3": {
    "displayName": "Imaginings 3",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 13
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "swedish_fish": {
    "displayName": "Swedish Fish",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 13
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "tucson_tamale": {
    "displayName": "Tucson Tamale",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12,
      "meat": 1
    },
    "subtypeCounts": {
      "boxed_meal": 12,
      "sausage": 1
    },
    "subtypes": [
      "boxed_meal",
      "sausage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "hawaii_candy": {
    "displayName": "Hawaii Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "cookie": 11,
      "dressing": 1,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "dressing",
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "pappardelles": {
    "displayName": "Pappardelle's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 2,
      "pantry": 11
    },
    "subtypeCounts": {
      "boxed_meal": 2
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "western_bagel": {
    "displayName": "Western Bagel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "bread": 13
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "reasors": {
    "displayName": "Reasor's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 13
    },
    "subtypeCounts": {
      "cheese": 13
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "pierres": {
    "displayName": "Pierre's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 13
    },
    "subtypeCounts": {
      "ice_cream": 13
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "spice_it": {
    "displayName": "Spice It",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "sauce": 6
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "select": {
    "displayName": "Select",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "bread": 13
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "hunter_hilsberg": {
    "displayName": "Hunter & Hilsberg",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "spread": 13
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "osole_mio": {
    "displayName": "O'sole Mio",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "goodnessknows": {
    "displayName": "Goodnessknows",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "chocolate": 3
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "walmart": {
    "displayName": "Walmart",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 5,
      "pantry": 7,
      "frozen": 1
    },
    "subtypeCounts": {
      "boxed_meal": 6,
      "cookie": 7
    },
    "subtypes": [
      "cookie",
      "boxed_meal"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "wolfgang_puck": {
    "displayName": "Wolfgang Puck",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "boxed_meal": 13
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "iya": {
    "displayName": "Iya",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "sauce": 9
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "adirondack": {
    "displayName": "Adirondack",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 13
    },
    "subtypeCounts": {
      "beverage": 13
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "cream_o_land": {
    "displayName": "Cream-o-land",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11,
      "beverage": 2
    },
    "subtypeCounts": {
      "milk": 11,
      "beverage": 2
    },
    "subtypes": [
      "milk",
      "beverage"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "en_re_premium": {
    "displayName": "Encore Premium",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "sauce": 10
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "grissoms_mill": {
    "displayName": "Grissom's Mill",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "bread": 13
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "sun_world": {
    "displayName": "Sun World",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 13
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 13,
    "source": "usda"
  },
  "bread_cie": {
    "displayName": "Bread & Cie",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "bread": 13
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "gourmet_llection": {
    "displayName": "The Gourmet Collection",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "sauce": 2
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "devons_mackinac_island_fudge": {
    "displayName": "Devon's Mackinac Island Fudge",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 13
    },
    "subtypeCounts": {
      "candy": 13
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 13,
    "source": "usda"
  },
  "panda": {
    "displayName": "Panda",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 9,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "bells": {
    "displayName": "Bells",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 1,
      "bread": 1,
      "dressing": 1
    },
    "subtypes": [
      "sauce",
      "bread",
      "dressing"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "janes_krazy": {
    "displayName": "Jane's Krazy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 11
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "g2g": {
    "displayName": "G2g",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "dilettante": {
    "displayName": "Dilettante",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "chocolate": 8,
      "candy": 2,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "jeffs_garden": {
    "displayName": "Jeff's Garden",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "deep_indian_kitchen": {
    "displayName": "Deep Indian Kitchen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12
    },
    "subtypeCounts": {
      "bread": 2,
      "boxed_meal": 9
    },
    "subtypes": [
      "boxed_meal",
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "choceur": {
    "displayName": "Choceur",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "chocolate": 11,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "once_again": {
    "displayName": "Once Again",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sweetener": 3,
      "boxed_meal": 9
    },
    "subtypes": [
      "boxed_meal",
      "sweetener"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "seoul": {
    "displayName": "Seoul",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "dressing": 1
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "icee": {
    "displayName": "Icee",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10,
      "pantry": 2
    },
    "subtypeCounts": {
      "ice_cream": 10,
      "candy": 1,
      "cookie": 1
    },
    "subtypes": [
      "ice_cream",
      "candy",
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "sour_patch": {
    "displayName": "Sour Patch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 12
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "robinsons": {
    "displayName": "Robinsons",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 12
    },
    "subtypeCounts": {
      "beverage": 12
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "earth_wise": {
    "displayName": "Earth Wise",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 12
    },
    "subtypeCounts": {
      "beverage": 12
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "brent_sams": {
    "displayName": "Brent & Sam's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 12
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "good2grow": {
    "displayName": "Good2grow",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 12
    },
    "subtypeCounts": {
      "beverage": 12
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "northland": {
    "displayName": "Northland",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 12
    },
    "subtypeCounts": {
      "beverage": 12
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "flora_fine": {
    "displayName": "Flora Fine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "holiday": {
    "displayName": "Holiday",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10,
      "pantry": 1,
      "produce": 1
    },
    "subtypeCounts": {
      "cheese": 10,
      "bread": 1
    },
    "subtypes": [
      "cheese",
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "pickled_pink": {
    "displayName": "Pickled Pink",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "happy_spring": {
    "displayName": "Happy Spring",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 9,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "glenoaks": {
    "displayName": "Glenoaks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {
      "yogurt": 12
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "pioneer": {
    "displayName": "Pioneer",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 10,
      "baking": 1,
      "bread": 1
    },
    "subtypes": [
      "sauce",
      "baking",
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "frutstix": {
    "displayName": "Frutstix",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 1,
      "frozen": 11
    },
    "subtypeCounts": {
      "ice_cream": 11
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "elemental": {
    "displayName": "Elemental",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "favorite_day_bakery": {
    "displayName": "Favorite Day Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "bread": 6,
      "cookie": 6
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "ronnybrook": {
    "displayName": "Ronnybrook",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {
      "yogurt": 9,
      "milk": 3
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "100_grand": {
    "displayName": "100 Grand",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 4,
      "chocolate": 8
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "kelloggs_fiberplus": {
    "displayName": "Kellogg's Fiberplus",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "western": {
    "displayName": "Western",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "dressing": 12
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "so_right": {
    "displayName": "So Right",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12
    },
    "subtypeCounts": {
      "boxed_meal": 12
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "honey_maid": {
    "displayName": "Honey Maid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 12
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "promax": {
    "displayName": "Promax",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "bubblr": {
    "displayName": "Bubbl'r",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 12
    },
    "subtypeCounts": {
      "beverage": 12
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "perfect_bite": {
    "displayName": "The Perfect Bite",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12
    },
    "subtypeCounts": {
      "boxed_meal": 9,
      "bread": 3
    },
    "subtypes": [
      "boxed_meal",
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "kangaroo": {
    "displayName": "Kangaroo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 1,
      "pantry": 11
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "bread": 11
    },
    "subtypes": [
      "bread",
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "siete": {
    "displayName": "Siete",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "dairy": 1
    },
    "subtypeCounts": {
      "sauce": 2,
      "cheese": 1
    },
    "subtypes": [
      "sauce",
      "cheese"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "raos": {
    "displayName": "Rao's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 6,
      "frozen": 6
    },
    "subtypeCounts": {
      "boxed_meal": 9
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "smart_made": {
    "displayName": "Smart Made",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12
    },
    "subtypeCounts": {
      "boxed_meal": 12
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "ri_lino": {
    "displayName": "Ricolino",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 1,
      "candy": 8,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate",
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "field_farmer": {
    "displayName": "Field + Farmer",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 7,
      "beverage": 5
    },
    "subtypeCounts": {
      "dressing": 7,
      "beverage": 5
    },
    "subtypes": [
      "dressing",
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "kates_real_food": {
    "displayName": "Kate's Real Food",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "re": {
    "displayName": "Re:",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 7,
      "beverage": 5
    },
    "subtypeCounts": {
      "beverage": 5,
      "dressing": 1
    },
    "subtypes": [
      "beverage",
      "dressing"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "odyssey": {
    "displayName": "Odyssey",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {
      "yogurt": 2,
      "cheese": 10
    },
    "subtypes": [
      "cheese",
      "yogurt"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "creative_natural_products": {
    "displayName": "Creative Natural Products,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "chocolate": 10,
      "candy": 2
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "holiday_pantry": {
    "displayName": "Holiday Pantry",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "dairy": 1,
      "beverage": 1
    },
    "subtypeCounts": {
      "candy": 10,
      "yogurt": 1,
      "beverage": 1
    },
    "subtypes": [
      "candy",
      "yogurt",
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "watkins": {
    "displayName": "Watkins",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 8
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "egg_beaters": {
    "displayName": "Egg Beaters",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "divvies": {
    "displayName": "Divvies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 12
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "momomilk_dba_milk_bar": {
    "displayName": "Momomilk, Dba Milk Bar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 12
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "wawa": {
    "displayName": "Wawa",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 6,
      "frozen": 1,
      "meat": 4,
      "dairy": 1
    },
    "subtypeCounts": {
      "cookie": 4,
      "boxed_meal": 5,
      "cheese": 1
    },
    "subtypes": [
      "boxed_meal",
      "cookie",
      "cheese"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "sabritas": {
    "displayName": "Sabritas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "saltean": {
    "displayName": "Saltean",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 12
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "ron": {
    "displayName": "Ronco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "n_rd": {
    "displayName": "Concord",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 11,
      "dressing": 1
    },
    "subtypes": [
      "sauce",
      "dressing"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "humphry_slo_mbe": {
    "displayName": "Humphry Slocombe",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12
    },
    "subtypeCounts": {
      "ice_cream": 12
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "mrs_fishers": {
    "displayName": "Mrs. Fisher's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "chuckles": {
    "displayName": "Chuckles",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 12
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "frontier_op": {
    "displayName": "Frontier -op",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 8,
      "baking": 2
    },
    "subtypes": [
      "sauce",
      "baking"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "udis_gluten_free": {
    "displayName": "Udis Gluten Free",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "frozen": 2
    },
    "subtypeCounts": {
      "bread": 10,
      "boxed_meal": 2
    },
    "subtypes": [
      "bread",
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "monarch": {
    "displayName": "Monarch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 1
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "orchard_valley_harvest": {
    "displayName": "Orchard Valley Harvest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "dressing": 9
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "taste_nirvana": {
    "displayName": "Taste Nirvana",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 12
    },
    "subtypeCounts": {
      "beverage": 12
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "vital_proteins": {
    "displayName": "Vital Proteins",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "once_again_nut_butter_llective": {
    "displayName": "Once Again Nut Butter Collective,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "dressing": 3,
      "boxed_meal": 9
    },
    "subtypes": [
      "boxed_meal",
      "dressing"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "dang": {
    "displayName": "Dang",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "baking": 1
    },
    "subtypes": [
      "baking"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "kreider_farms": {
    "displayName": "Kreider Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 2,
      "dairy": 10
    },
    "subtypeCounts": {
      "beverage": 2,
      "milk": 5
    },
    "subtypes": [
      "milk",
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "88_acres": {
    "displayName": "88 Acres",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "dressing": 2,
      "chocolate": 3
    },
    "subtypes": [
      "chocolate",
      "dressing"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "black_diamond": {
    "displayName": "Black Diamond",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {
      "cheese": 12
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "wickles": {
    "displayName": "Wickles",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "sunnys": {
    "displayName": "Sunny's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 11
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "star_dairy": {
    "displayName": "Star Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {
      "cheese": 12
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "hero": {
    "displayName": "Hero",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "spread": 12
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "ile_de_france": {
    "displayName": "Ile De France",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {
      "cheese": 12
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "ruby_rockets": {
    "displayName": "Ruby Rockets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 9,
      "dairy": 3
    },
    "subtypeCounts": {
      "ice_cream": 9,
      "yogurt": 3
    },
    "subtypes": [
      "ice_cream",
      "yogurt"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "greenbrier": {
    "displayName": "Greenbrier",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "dairy": 1
    },
    "subtypeCounts": {
      "candy": 9,
      "cheese": 1,
      "cookie": 2
    },
    "subtypes": [
      "candy",
      "cookie",
      "cheese"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "monterey_gourmet": {
    "displayName": "Monterey Gourmet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "frozen": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "fast_fixin": {
    "displayName": "Fast Fixin'",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12
    },
    "subtypeCounts": {
      "boxed_meal": 12
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "oloves": {
    "displayName": "Oloves",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "edens_kitchen": {
    "displayName": "Eden's Kitchen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "snikiddy": {
    "displayName": "Snikiddy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "isola": {
    "displayName": "Isola",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 2,
      "pantry": 10
    },
    "subtypeCounts": {
      "cheese": 2,
      "dressing": 1,
      "bread": 1,
      "cookie": 1
    },
    "subtypes": [
      "cheese",
      "dressing",
      "bread",
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "mikawaya": {
    "displayName": "Mikawaya",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12
    },
    "subtypeCounts": {
      "ice_cream": 12
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "mom_made": {
    "displayName": "Mom Made",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12
    },
    "subtypeCounts": {
      "boxed_meal": 12
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "chewy_lemonhead": {
    "displayName": "Chewy Lemonhead",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 12
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "al_dente": {
    "displayName": "Al Dente",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "podravka": {
    "displayName": "Podravka",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "meat": 1
    },
    "subtypeCounts": {
      "spread": 8,
      "sauce": 2,
      "boxed_meal": 1
    },
    "subtypes": [
      "spread",
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "sylvias": {
    "displayName": "Sylvia's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 4
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "tres_latin": {
    "displayName": "Tres Latin",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12
    },
    "subtypeCounts": {
      "boxed_meal": 12
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "l_j_minor": {
    "displayName": "L. J. Minor",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 6,
      "boxed_meal": 6
    },
    "subtypes": [
      "sauce",
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "mama_marys": {
    "displayName": "Mama Mary's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "bread": 8
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "miravalle": {
    "displayName": "Miravalle",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "baking": 2,
      "candy": 7
    },
    "subtypes": [
      "candy",
      "baking"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "amazonas_rainforest_product": {
    "displayName": "Amazonas Rainforest Product",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "produce": 1
    },
    "subtypeCounts": {
      "baking": 3
    },
    "subtypes": [
      "baking"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "le_urs": {
    "displayName": "Lecour's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 12
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "brads": {
    "displayName": "Brads",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "girl_s_uts": {
    "displayName": "Girl Scouts",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 11
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "global": {
    "displayName": "Global",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 1,
      "cookie": 10,
      "chocolate": 1
    },
    "subtypes": [
      "cookie",
      "candy",
      "chocolate"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "nothin_but": {
    "displayName": "Nothin' But",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 6
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "kings_choice": {
    "displayName": "King's Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {
      "cheese": 12
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "farm_ridge": {
    "displayName": "Farm Ridge",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "meat": 2
    },
    "subtypeCounts": {
      "boxed_meal": 2
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "toogoodgourmet": {
    "displayName": "Toogoodgourmet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 2,
      "cookie": 7,
      "candy": 1,
      "chocolate": 2
    },
    "subtypes": [
      "cookie",
      "sauce",
      "chocolate",
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "les_petites_fermieres": {
    "displayName": "Les Petites Fermieres",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {
      "cheese": 12
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "allegro_ffee": {
    "displayName": "Allegro Coffee",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 11
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "california_sun_dry": {
    "displayName": "California Sun Dry",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "jam_shoppe": {
    "displayName": "The Jam Shoppe",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "spread": 12
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "woolwich_dairy": {
    "displayName": "Woolwich Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {
      "cheese": 12
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "paisley_farm": {
    "displayName": "Paisley Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 3,
      "pantry": 9
    },
    "subtypeCounts": {
      "boxed_meal": 3
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "t_marzetti": {
    "displayName": "T. Marzetti",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "frozen": 1
    },
    "subtypeCounts": {
      "dressing": 6,
      "bread": 5
    },
    "subtypes": [
      "dressing",
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "marcela_valladolid": {
    "displayName": "Marcela Valladolid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 3,
      "frozen": 7,
      "pantry": 2
    },
    "subtypeCounts": {
      "cheese": 2,
      "boxed_meal": 7,
      "milk": 1
    },
    "subtypes": [
      "boxed_meal",
      "cheese",
      "milk"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "mizkan": {
    "displayName": "Mizkan",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "spread": 1,
      "sauce": 5,
      "dressing": 6
    },
    "subtypes": [
      "dressing",
      "sauce",
      "spread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "rib_rack": {
    "displayName": "Rib Rack",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sauce": 10
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "michael_angelos_gourmet": {
    "displayName": "Michael Angelo's Gourmet ,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 12
    },
    "subtypeCounts": {
      "boxed_meal": 12
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "sundia": {
    "displayName": "Sundia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "daelmans": {
    "displayName": "Daelmans",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 12
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "operative_regions_of_organic_producer_pools": {
    "displayName": "Cooperative Regions Of Organic Producer Pools",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11,
      "meat": 1
    },
    "subtypeCounts": {
      "cheese": 2,
      "milk": 6,
      "sausage": 1
    },
    "subtypes": [
      "milk",
      "cheese",
      "sausage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "signature_snacks": {
    "displayName": "Signature Snacks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 11,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "natures_garden": {
    "displayName": "Nature's Garden",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 7,
      "baking": 1,
      "dressing": 1
    },
    "subtypes": [
      "candy",
      "baking",
      "dressing"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "arheon": {
    "displayName": "Arheon",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "sweetener": 2
    },
    "subtypes": [
      "sweetener"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "nns": {
    "displayName": "Conn's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "spree": {
    "displayName": "Spree",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 12
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "hautly_cheese": {
    "displayName": "Hautly Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {
      "cheese": 12
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "ceres": {
    "displayName": "Ceres",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11,
      "dairy": 1
    },
    "subtypeCounts": {
      "beverage": 11,
      "yogurt": 1
    },
    "subtypes": [
      "beverage",
      "yogurt"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "dreamhouse_fine": {
    "displayName": "Dreamhouse Fine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 5,
      "chocolate": 7
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "j_higgs": {
    "displayName": "J.higgs",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "gardners_candies": {
    "displayName": "Gardners Candies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 7,
      "chocolate": 5
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "lehi_valley_trading": {
    "displayName": "Lehi Valley Trading",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 9
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "isabela": {
    "displayName": "Isabela",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "beverage": 4,
      "spread": 2,
      "cookie": 1,
      "sweetener": 1
    },
    "subtypes": [
      "beverage",
      "spread",
      "cookie",
      "sweetener"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "verona_valley": {
    "displayName": "Verona Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 5,
      "chocolate": 2,
      "bread": 1
    },
    "subtypes": [
      "candy",
      "chocolate",
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "royal_farms": {
    "displayName": "Royal Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "chocolate": 11,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "sanavi": {
    "displayName": "Sanavi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 12
    },
    "subtypeCounts": {
      "beverage": 12
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "nips": {
    "displayName": "Nips",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 12
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "frey": {
    "displayName": "Frey",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "chocolate": 9,
      "candy": 3
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "jcs_pie_bites": {
    "displayName": "Jc's Pie Bites",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "chocolate": 12
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "harry_london": {
    "displayName": "Harry London",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "chocolate": 11,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "pangburns": {
    "displayName": "Pangburn's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "chocolate": 11,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "blue_monkey": {
    "displayName": "Blue Monkey",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11,
      "pantry": 1
    },
    "subtypeCounts": {
      "beverage": 11,
      "baking": 1
    },
    "subtypes": [
      "beverage",
      "baking"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "hemis_fares": {
    "displayName": "Hemis Fares",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "frozen": 2
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "ice_cream": 1
    },
    "subtypes": [
      "boxed_meal",
      "ice_cream"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "jack_daniels": {
    "displayName": "Jack Daniel's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11,
      "frozen": 1
    },
    "subtypeCounts": {
      "chocolate": 1,
      "boxed_meal": 1,
      "candy": 1,
      "sauce": 4,
      "bread": 1
    },
    "subtypes": [
      "sauce",
      "chocolate",
      "boxed_meal",
      "candy",
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "aidells": {
    "displayName": "Aidells",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 12
    },
    "subtypeCounts": {
      "sausage": 12
    },
    "subtypes": [
      "sausage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "dairy_fresh": {
    "displayName": "Dairy Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 2,
      "dairy": 10
    },
    "subtypeCounts": {
      "bread": 2,
      "cheese": 10
    },
    "subtypes": [
      "cheese",
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "soiree_artisan_cheese": {
    "displayName": "Soiree Artisan Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {
      "cheese": 12
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "kindred_creamery": {
    "displayName": "Kindred Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 12
    },
    "subtypeCounts": {
      "cheese": 12
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "st_pierre": {
    "displayName": "St. Pierre",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "bread": 11
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "peculiar_untry_amish_llection": {
    "displayName": "Peculiar Country Amish Collection",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "meat": 1,
      "dairy": 1
    },
    "subtypeCounts": {
      "spread": 3,
      "boxed_meal": 1
    },
    "subtypes": [
      "spread",
      "boxed_meal"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "fresh_produce": {
    "displayName": "Fresh Produce",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "red_top": {
    "displayName": "Red Top",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 5,
      "dairy": 7
    },
    "subtypeCounts": {
      "ice_cream": 5,
      "yogurt": 7
    },
    "subtypes": [
      "yogurt",
      "ice_cream"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "rutters": {
    "displayName": "Rutter's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10,
      "beverage": 2
    },
    "subtypeCounts": {
      "milk": 10,
      "beverage": 2
    },
    "subtypes": [
      "milk",
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "from_ground_up": {
    "displayName": "From The Ground Up",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "paiellis": {
    "displayName": "Paielli's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "bread": 12
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "wildflour_bakehouse": {
    "displayName": "Wildflour Bakehouse",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "bread": 12
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "las_ollas": {
    "displayName": "Las Ollas",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 11
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "maxwell_house": {
    "displayName": "Maxwell House",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "beverage": 12
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "energy_glaceau": {
    "displayName": "Energy -glaceau",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 12
    },
    "subtypeCounts": {
      "beverage": 12
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "ukrops": {
    "displayName": "Ukrop's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 9,
      "frozen": 2,
      "meat": 1
    },
    "subtypeCounts": {
      "bread": 5,
      "boxed_meal": 3,
      "cookie": 1
    },
    "subtypes": [
      "bread",
      "boxed_meal",
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "hannah_max": {
    "displayName": "Hannah Max",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "cookie": 12
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "pr_bar": {
    "displayName": "Pr Bar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "vero": {
    "displayName": "Vero",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 12
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "good_to_dough": {
    "displayName": "Good To Dough",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "bread": 12
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "wondershop_at_target": {
    "displayName": "Wondershop At Target",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "candy": 8,
      "cookie": 2,
      "sweetener": 1,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "cookie",
      "sweetener",
      "chocolate"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "olly": {
    "displayName": "Olly",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 12,
    "source": "usda"
  },
  "betterbody_nutrition": {
    "displayName": "Betterbody & Nutrition,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "baking": 1,
      "dressing": 7
    },
    "subtypes": [
      "dressing",
      "baking"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "dagoba": {
    "displayName": "Dagoba",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 12
    },
    "subtypeCounts": {
      "chocolate": 11,
      "baking": 1
    },
    "subtypes": [
      "chocolate",
      "baking"
    ],
    "totalObs": 12,
    "source": "usda"
  },
  "la_morenita": {
    "displayName": "La Morenita",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "cheese": 11
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "thats_it_nutrition": {
    "displayName": "That's It Nutrition,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "chocolate": 1
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "4c": {
    "displayName": "4c",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 9,
      "pantry": 2
    },
    "subtypeCounts": {
      "cheese": 9,
      "sauce": 2
    },
    "subtypes": [
      "cheese",
      "sauce"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "tofts_one_quality": {
    "displayName": "Toft's \"\"one Quality\"\"",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 6,
      "dairy": 5
    },
    "subtypeCounts": {
      "ice_cream": 6,
      "milk": 5
    },
    "subtypes": [
      "ice_cream",
      "milk"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "patrick_cudahy": {
    "displayName": "Patrick Cudahy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 9,
      "pantry": 2
    },
    "subtypeCounts": {
      "sausage": 9,
      "dressing": 2
    },
    "subtypes": [
      "sausage",
      "dressing"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "koepplingers": {
    "displayName": "Koepplinger's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "bread": 11
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "melster_candies": {
    "displayName": "Melster Candies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 10,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "flave": {
    "displayName": "Flave!",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 8,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "trappeys": {
    "displayName": "Trappey's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "louisiana_fish_fry_products": {
    "displayName": "Louisiana Fish Fry Products",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "sauce": 9,
      "baking": 2
    },
    "subtypes": [
      "sauce",
      "baking"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "wwf_operating": {
    "displayName": "Wwf Operating",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 7,
      "frozen": 4
    },
    "subtypeCounts": {
      "milk": 2,
      "yogurt": 4,
      "ice_cream": 3,
      "cheese": 1
    },
    "subtypes": [
      "yogurt",
      "ice_cream",
      "milk",
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "favorite_day": {
    "displayName": "Favorite Day",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 10,
      "bread": 1
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "sue_bee": {
    "displayName": "Sue Bee",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "sweetener": 11
    },
    "subtypes": [
      "sweetener"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "wehah_farm": {
    "displayName": "Wehah Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "shullsburg": {
    "displayName": "Shullsburg",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "cheese": 10,
      "milk": 1
    },
    "subtypes": [
      "cheese",
      "milk"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "so_delicious": {
    "displayName": "So Delicious",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10,
      "frozen": 1
    },
    "subtypeCounts": {
      "yogurt": 10,
      "ice_cream": 1
    },
    "subtypes": [
      "yogurt",
      "ice_cream"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "papas_organic": {
    "displayName": "Papa's Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "bread": 11
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "stuffed": {
    "displayName": "Stuffed",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 8,
      "pantry": 3
    },
    "subtypeCounts": {
      "boxed_meal": 8,
      "candy": 1
    },
    "subtypes": [
      "boxed_meal",
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "mac_cho_late_bar": {
    "displayName": "Mac Chocolate Bar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "chocolate": 11
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "supreme_rice": {
    "displayName": "Supreme Rice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "marva_maid": {
    "displayName": "Marva Maid",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "milk": 11
    },
    "subtypes": [
      "milk"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "neillys": {
    "displayName": "Neilly's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "boxed_meal": 10
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "green_valley": {
    "displayName": "Green Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "dragone": {
    "displayName": "Dragone",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "cheese": 11
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "gortons": {
    "displayName": "Gorton's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "boxed_meal": 11
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "general_mills": {
    "displayName": "General Mills",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 2,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "julies": {
    "displayName": "Julie's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 9,
      "pantry": 2
    },
    "subtypeCounts": {
      "ice_cream": 9,
      "cookie": 2
    },
    "subtypes": [
      "ice_cream",
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "snapps": {
    "displayName": "Snapps",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "boxed_meal": 11
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "gobstopper": {
    "displayName": "Gobstopper",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 11
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "gnc": {
    "displayName": "Gnc",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 5,
      "pantry": 6
    },
    "subtypeCounts": {
      "ice_cream": 5
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "dq": {
    "displayName": "Dq",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "ice_cream": 11
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "payday": {
    "displayName": "Payday",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 11
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "green_blacks": {
    "displayName": "Green & Black's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "chocolate": 11
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "endorfin": {
    "displayName": "Endorfin",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "chocolate": 11
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "pride": {
    "displayName": "Pride",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "harvest_bay": {
    "displayName": "Harvest Bay",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11
    },
    "subtypeCounts": {
      "beverage": 11
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "brazi_bites": {
    "displayName": "Brazi Bites",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "bread": 5,
      "boxed_meal": 6
    },
    "subtypes": [
      "boxed_meal",
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "zee_zees": {
    "displayName": "Zee Zees",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "purely_elizabeth": {
    "displayName": "Purely Elizabeth",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "mt_vikos": {
    "displayName": "Mt Vikos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 8,
      "pantry": 3
    },
    "subtypeCounts": {
      "cheese": 8
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "seasons_choice": {
    "displayName": "Season's Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "ripple": {
    "displayName": "Ripple",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "yogurt": 6,
      "milk": 5
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "via_emilia": {
    "displayName": "Via Emilia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10,
      "pantry": 1
    },
    "subtypeCounts": {
      "ice_cream": 3,
      "boxed_meal": 4
    },
    "subtypes": [
      "boxed_meal",
      "ice_cream"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "flora": {
    "displayName": "Flora",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "bread": 2,
      "cookie": 2
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "tootsie_roll_industries": {
    "displayName": "Tootsie Roll Industries",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 8,
      "chocolate": 2
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "frontier_operative_herbs": {
    "displayName": "Frontier Cooperative Herbs",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "sauce": 9
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "truth_bar": {
    "displayName": "Truth Bar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "amos": {
    "displayName": "Amos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 11
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "untry_hearth": {
    "displayName": "Country Hearth",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "bread": 11
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "kinnikinnick": {
    "displayName": "Kinnikinnick",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 9,
      "frozen": 2
    },
    "subtypeCounts": {
      "cookie": 7,
      "bread": 4
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "leonard_novelty_bakery": {
    "displayName": "Leonard Novelty Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 11
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "el_latino": {
    "displayName": "El Latino",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 9,
      "frozen": 1,
      "pantry": 1
    },
    "subtypeCounts": {
      "cheese": 6,
      "yogurt": 2,
      "milk": 1,
      "boxed_meal": 1,
      "bread": 1
    },
    "subtypes": [
      "cheese",
      "yogurt",
      "milk",
      "boxed_meal",
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "nikos": {
    "displayName": "Nikos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "cheese": 11
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "thats_tasty": {
    "displayName": "That's Tasty",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 9,
      "pantry": 2
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "cheese_guy": {
    "displayName": "The Cheese Guy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10,
      "pantry": 1
    },
    "subtypeCounts": {
      "cheese": 10,
      "dressing": 1
    },
    "subtypes": [
      "cheese",
      "dressing"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "organicgirl": {
    "displayName": "Organicgirl",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 5,
      "produce": 4,
      "beverage": 2
    },
    "subtypeCounts": {
      "dressing": 5,
      "beverage": 2
    },
    "subtypes": [
      "dressing",
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "five_acre_farms": {
    "displayName": "Five Acre Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "milk": 6,
      "yogurt": 5
    },
    "subtypes": [
      "milk",
      "yogurt"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "gel": {
    "displayName": "Gel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "sauce": 9
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "kettle_fire": {
    "displayName": "Kettle & Fire",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "boxed_meal": 11
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "sobisk": {
    "displayName": "Sobisk",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 11
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "frans": {
    "displayName": "Fran's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "chocolate": 10,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "mayfield_creamery": {
    "displayName": "Mayfield Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "ice_cream": 11
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "life_cuisine": {
    "displayName": "Life Cuisine",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "boxed_meal": 11
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "sweetworks_nfections": {
    "displayName": "Sweetworks Confections,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 3,
      "chocolate": 8
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "flowers": {
    "displayName": "Flowers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "bread": 9,
      "cookie": 2
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "bi_lo": {
    "displayName": "Bi-lo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 5,
      "dairy": 3,
      "beverage": 3
    },
    "subtypeCounts": {
      "cheese": 3,
      "beverage": 3,
      "sauce": 1
    },
    "subtypes": [
      "cheese",
      "beverage",
      "sauce"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "royce_apparel": {
    "displayName": "Royce Apparel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 4,
      "sauce": 3,
      "spread": 1
    },
    "subtypes": [
      "cookie",
      "sauce",
      "spread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "atkins_nutritionals": {
    "displayName": "Atkins Nutritionals,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "dairy": 1
    },
    "subtypeCounts": {
      "candy": 1,
      "milk": 1,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "milk",
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "mantova": {
    "displayName": "Mantova",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "cina_selecta": {
    "displayName": "Cocina Selecta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 3,
      "pantry": 8
    },
    "subtypeCounts": {
      "cheese": 3
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "pcc": {
    "displayName": "Pcc",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 2,
      "dairy": 7,
      "meat": 2
    },
    "subtypeCounts": {
      "candy": 1,
      "baking": 1,
      "cheese": 5,
      "sausage": 2,
      "milk": 2
    },
    "subtypes": [
      "cheese",
      "sausage",
      "milk",
      "candy",
      "baking"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "diamond_bakery": {
    "displayName": "Diamond Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 11
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "tenda_bake": {
    "displayName": "Tenda-bake",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "baking": 10,
      "sauce": 1
    },
    "subtypes": [
      "baking",
      "sauce"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "al_gelato_chicago": {
    "displayName": "Al Gelato Chicago",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 2,
      "frozen": 9
    },
    "subtypeCounts": {
      "chocolate": 2,
      "ice_cream": 9
    },
    "subtypes": [
      "ice_cream",
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "godshalls": {
    "displayName": "Godshall's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 8,
      "pantry": 3
    },
    "subtypeCounts": {
      "sausage": 8,
      "dressing": 3
    },
    "subtypes": [
      "sausage",
      "dressing"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "pfeiffer": {
    "displayName": "Pfeiffer",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "dressing": 11
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "arizona_snack": {
    "displayName": "Arizona Snack",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 10
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "ld_stone_creamery": {
    "displayName": "Cold Stone Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 3,
      "frozen": 2,
      "dairy": 6
    },
    "subtypeCounts": {
      "candy": 2,
      "chocolate": 1,
      "ice_cream": 2,
      "milk": 6
    },
    "subtypes": [
      "milk",
      "candy",
      "ice_cream",
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "barbaras": {
    "displayName": "Barbara's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 10
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "rub_with_love": {
    "displayName": "Rub With Love",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "sauce": 5
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "natures_earthly_choice": {
    "displayName": "Nature's Earthly Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "frozen": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1,
      "baking": 1
    },
    "subtypes": [
      "boxed_meal",
      "baking"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "pascha": {
    "displayName": "Pascha",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "chocolate": 10,
      "spread": 1
    },
    "subtypes": [
      "chocolate",
      "spread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "miracle_noodle": {
    "displayName": "Miracle Noodle",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "boxed_meal": 5
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "dont_go_nuts": {
    "displayName": "Don't Go Nuts",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "anisas_secrets": {
    "displayName": "Anisa's Secrets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "sauce": 6
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "indianlife": {
    "displayName": "Indianlife",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "bread": 5
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "parmela_creamery": {
    "displayName": "Parmela Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "cheese": 11
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "island_sun": {
    "displayName": "Island Sun",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "salads_galore": {
    "displayName": "Salads Galore",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "meat": 8,
      "pantry": 2,
      "frozen": 1
    },
    "subtypeCounts": {
      "boxed_meal": 9
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "biazzo": {
    "displayName": "Biazzo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "cheese": 11
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "matlaws": {
    "displayName": "Matlaw's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "boxed_meal": 11
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "terana": {
    "displayName": "Terana",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "sauce": 6
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "lakeview_farms": {
    "displayName": "Lakeview Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10,
      "pantry": 1
    },
    "subtypeCounts": {
      "milk": 1,
      "cheese": 4,
      "yogurt": 5
    },
    "subtypes": [
      "yogurt",
      "cheese",
      "milk"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "amish_untry": {
    "displayName": "Amish Country",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 6,
      "pantry": 5
    },
    "subtypeCounts": {
      "cheese": 5,
      "baking": 1,
      "sauce": 3,
      "milk": 1
    },
    "subtypes": [
      "cheese",
      "sauce",
      "baking",
      "milk"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "ricks_picks": {
    "displayName": "Rick's Picks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "bassetts": {
    "displayName": "Bassetts",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 8,
      "pantry": 3
    },
    "subtypeCounts": {
      "ice_cream": 8,
      "candy": 3
    },
    "subtypes": [
      "ice_cream",
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "golden_taste": {
    "displayName": "Golden Taste",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 5,
      "meat": 6
    },
    "subtypeCounts": {
      "boxed_meal": 6
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "stop_shop": {
    "displayName": "Stop & Shop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 5,
      "beverage": 1,
      "frozen": 2,
      "produce": 3
    },
    "subtypeCounts": {
      "cookie": 1,
      "beverage": 1,
      "bread": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "cookie",
      "beverage",
      "bread",
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "sunrype": {
    "displayName": "Sunrype",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 7,
      "beverage": 4
    },
    "subtypeCounts": {
      "candy": 1,
      "beverage": 4
    },
    "subtypes": [
      "beverage",
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "gibbles": {
    "displayName": "Gibble's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "hansens_natural": {
    "displayName": "Hansens Natural",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11
    },
    "subtypeCounts": {
      "beverage": 11
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "budget_saver": {
    "displayName": "Budget Saver",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "ice_cream": 11
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "brownwood_farms": {
    "displayName": "Brownwood Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "spread": 10
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "shasta": {
    "displayName": "Shasta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11
    },
    "subtypeCounts": {
      "beverage": 11
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "bella_italia": {
    "displayName": "Bella Italia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "hawaiian_sun": {
    "displayName": "Hawaiian Sun",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 6,
      "beverage": 5
    },
    "subtypeCounts": {
      "spread": 6,
      "beverage": 5
    },
    "subtypes": [
      "spread",
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "pearls": {
    "displayName": "Pearls",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "v8_splash": {
    "displayName": "V8 Splash",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11
    },
    "subtypeCounts": {
      "beverage": 11
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "americas_northwest": {
    "displayName": "America's Northwest",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "spread": 11
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "nut_tree": {
    "displayName": "Coconut Tree Brand",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "sauce": 10
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "wichy_plantation_pvt": {
    "displayName": "Wichy Plantation (pvt)",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 8,
      "beverage": 3
    },
    "subtypeCounts": {
      "baking": 6,
      "beverage": 3
    },
    "subtypes": [
      "baking",
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "daneko": {
    "displayName": "Daneko",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "cheese": 11
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "fresh": {
    "displayName": "Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 3,
      "beverage": 3,
      "produce": 4,
      "frozen": 1
    },
    "subtypeCounts": {
      "beverage": 3,
      "boxed_meal": 1,
      "bread": 1
    },
    "subtypes": [
      "beverage",
      "boxed_meal",
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "mehadrin": {
    "displayName": "Mehadrin",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 8,
      "frozen": 3
    },
    "subtypeCounts": {
      "cheese": 3,
      "ice_cream": 3,
      "yogurt": 5
    },
    "subtypes": [
      "yogurt",
      "cheese",
      "ice_cream"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "van_de_kamps": {
    "displayName": "Van De Kamp's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 5,
      "pantry": 6
    },
    "subtypeCounts": {
      "boxed_meal": 5,
      "bread": 6
    },
    "subtypes": [
      "bread",
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "farmers_choice_dairy": {
    "displayName": "Farmers Choice Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "milk": 11
    },
    "subtypes": [
      "milk"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "great_lakes": {
    "displayName": "Great Lakes",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "sweetener": 3,
      "bread": 5
    },
    "subtypes": [
      "bread",
      "sweetener"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "punaluu_bake_shop": {
    "displayName": "Punalu'u Bake Shop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 2,
      "bread": 9
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "buck_wild": {
    "displayName": "Buck Wild",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "vista": {
    "displayName": "Vista",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 10,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "harvest_classic": {
    "displayName": "Harvest Classic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11
    },
    "subtypeCounts": {
      "beverage": 11
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "orchard_snacks": {
    "displayName": "Orchard Snacks",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 11
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "ferris": {
    "displayName": "Ferris",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 6,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "its_delish": {
    "displayName": "It's Delish",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "beverage": 1
    },
    "subtypeCounts": {
      "candy": 9,
      "beverage": 1,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "beverage",
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "got_milk": {
    "displayName": "Got Milk?",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 10,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "hannahmax_baking": {
    "displayName": "Hannahmax Baking",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 11
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "juice_served_here": {
    "displayName": "Juice Served Here",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11
    },
    "subtypeCounts": {
      "beverage": 11
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "sundae_shoppe": {
    "displayName": "Sundae Shoppe",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "ice_cream": 11
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "lumi": {
    "displayName": "Lumi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11
    },
    "subtypeCounts": {
      "beverage": 11
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "aquafina": {
    "displayName": "Aquafina",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11
    },
    "subtypeCounts": {
      "beverage": 11
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "party_sweets": {
    "displayName": "Party Sweets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 10,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "delicious_bakery": {
    "displayName": "Delicious Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 11
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "knickerbocker_baking": {
    "displayName": "Knickerbocker Baking",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "bread": 11
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "majesty_bakeries": {
    "displayName": "Majesty Bakeries",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "bread": 11
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "parisian_star": {
    "displayName": "Parisian Star",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "bread": 11
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "snowdonia_cheese": {
    "displayName": "Snowdonia Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "cheese": 11
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "jack_nicklaus": {
    "displayName": "Jack Nicklaus",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "ice_cream": 11
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "bueno": {
    "displayName": "Bueno",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 2,
      "frozen": 9
    },
    "subtypeCounts": {
      "boxed_meal": 7
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "bridgemans": {
    "displayName": "Bridgeman's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "ice_cream": 11
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "manuka_doctor": {
    "displayName": "Manuka Doctor",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "sweetener": 11
    },
    "subtypes": [
      "sweetener"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "engage_organics": {
    "displayName": "Engage Organics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "sauce": 2
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "model_dairy": {
    "displayName": "Model Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "milk": 7,
      "cheese": 4
    },
    "subtypes": [
      "milk",
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "dolce_italia": {
    "displayName": "Dolce Italia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "mrs_gerrys": {
    "displayName": "Mrs. Gerry's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 7,
      "meat": 3,
      "frozen": 1
    },
    "subtypeCounts": {
      "boxed_meal": 4
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "quirch": {
    "displayName": "Quirch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10,
      "pantry": 1
    },
    "subtypeCounts": {
      "boxed_meal": 4
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "cheating_gourmet": {
    "displayName": "Cheating Gourmet",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "boxed_meal": 11
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "shneiders": {
    "displayName": "Shneider's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 4,
      "candy": 7
    },
    "subtypes": [
      "candy",
      "cookie"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "paldo": {
    "displayName": "Paldo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11
    },
    "subtypeCounts": {
      "beverage": 11
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "claire_baie": {
    "displayName": "Claire Baie",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11
    },
    "subtypeCounts": {
      "beverage": 11
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "kraft_heinz_sauces_frozen": {
    "displayName": "Kraft Heinz Sauces & Frozen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 6,
      "frozen": 5
    },
    "subtypeCounts": {
      "sauce": 2,
      "dressing": 4,
      "boxed_meal": 5
    },
    "subtypes": [
      "boxed_meal",
      "dressing",
      "sauce"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "extend_nutrition": {
    "displayName": "Extend Nutrition",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "fremo": {
    "displayName": "Fremo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 11
    },
    "subtypeCounts": {
      "beverage": 11
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "bonavita": {
    "displayName": "Bonavita",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "my_mms": {
    "displayName": "My M&m's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 8,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "martha_white": {
    "displayName": "Martha White",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "baking": 11
    },
    "subtypes": [
      "baking"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "cut_n_clean_greens": {
    "displayName": "Cut N Clean Greens",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "vegan_robs": {
    "displayName": "Vegan Rob's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "simply": {
    "displayName": "Simply",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10,
      "frozen": 1
    },
    "subtypeCounts": {
      "beverage": 10,
      "boxed_meal": 1
    },
    "subtypes": [
      "beverage",
      "boxed_meal"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "cheesecake_factory": {
    "displayName": "The Cheesecake Factory",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 4,
      "frozen": 7
    },
    "subtypeCounts": {
      "chocolate": 3,
      "bread": 1,
      "ice_cream": 7
    },
    "subtypes": [
      "ice_cream",
      "chocolate",
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "celebration_by_frey": {
    "displayName": "Celebration By Frey",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 8,
      "chocolate": 3
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "happy_farms": {
    "displayName": "Happy Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 11
    },
    "subtypeCounts": {
      "cheese": 11
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "dylans_candy_bar": {
    "displayName": "Dylan's Candy Bar",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "candy": 4,
      "chocolate": 7
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "homeland": {
    "displayName": "Homeland",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 9,
      "pantry": 2
    },
    "subtypeCounts": {
      "cheese": 9,
      "bread": 2
    },
    "subtypes": [
      "cheese",
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "fior_fiore": {
    "displayName": "Fior Fiore",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 11
    },
    "subtypeCounts": {
      "cookie": 4,
      "bread": 1
    },
    "subtypes": [
      "cookie",
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "table_fresh": {
    "displayName": "Table Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 11
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 11,
    "source": "usda"
  },
  "gregorys": {
    "displayName": "Gregory's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 11
    },
    "subtypeCounts": {
      "bread": 11
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 11,
    "source": "usda"
  },
  "lisanatti": {
    "displayName": "Lisanatti",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "kontos": {
    "displayName": "Kontos",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "bread": 9,
      "dressing": 1
    },
    "subtypes": [
      "bread",
      "dressing"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "hatch": {
    "displayName": "Hatch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "fitactive": {
    "displayName": "Fit&active",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 2,
      "pantry": 1,
      "meat": 1,
      "beverage": 4,
      "frozen": 2
    },
    "subtypeCounts": {
      "sausage": 1,
      "beverage": 4,
      "ice_cream": 2,
      "milk": 1
    },
    "subtypes": [
      "beverage",
      "ice_cream",
      "sausage",
      "milk"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "heidelberg": {
    "displayName": "Heidelberg",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "bread": 10
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "beyond_good": {
    "displayName": "Beyond Good",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 9
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "charlottes": {
    "displayName": "Charlotte's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 2,
      "cookie": 7,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "chocolate",
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "dry": {
    "displayName": "Dry",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "owens": {
    "displayName": "Owens",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 9,
      "meat": 1
    },
    "subtypeCounts": {
      "boxed_meal": 9,
      "sausage": 1
    },
    "subtypes": [
      "boxed_meal",
      "sausage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "rigoni_di_asiago": {
    "displayName": "Rigoni Di Asiago",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "spread": 9,
      "sweetener": 1
    },
    "subtypes": [
      "spread",
      "sweetener"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "izzio": {
    "displayName": "Izzio",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "bread": 10
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "high_road": {
    "displayName": "High Road",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "ice_cream": 10
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "lindys_homemade": {
    "displayName": "Lindy's Homemade",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "ice_cream": 10
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "lilly": {
    "displayName": "Lilly",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "yogurt": 10
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "candy_break": {
    "displayName": "Candy Break",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 9,
      "chocolate": 1
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "nordica": {
    "displayName": "Nordica",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "liberty_orchards": {
    "displayName": "Liberty Orchards",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 5,
      "candy": 4,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "new_orleans_ice_cream": {
    "displayName": "New Orleans Ice Cream",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "ice_cream": 10
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "mezzetta_family": {
    "displayName": "Mezzetta Family",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "auntie_annes": {
    "displayName": "Auntie Anne's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "boxed_meal": 10
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "phillyswirl": {
    "displayName": "Phillyswirl",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "ice_cream": 10
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "optimum_nutrition": {
    "displayName": "Optimum Nutrition",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "cookie": 1
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "pixy_stix": {
    "displayName": "Pixy Stix",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 10
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "vsc_cho_lats": {
    "displayName": "Vsc Chocolats",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 10
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "belgian_boys": {
    "displayName": "Belgian Boys",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "cookie": 8,
      "candy": 1
    },
    "subtypes": [
      "cookie",
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "weyauwega_star_dairy": {
    "displayName": "Weyauwega Star Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "four_brothers": {
    "displayName": "Four Brothers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 9,
      "meat": 1
    },
    "subtypeCounts": {
      "cookie": 2,
      "sauce": 4,
      "dressing": 1,
      "sausage": 1,
      "bread": 2
    },
    "subtypes": [
      "sauce",
      "cookie",
      "bread",
      "dressing",
      "sausage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "barrel_o_fun": {
    "displayName": "Barrel O' Fun",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "eat": {
    "displayName": "Eat!",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "boxed_meal": 10
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "bone_suckin_sauce": {
    "displayName": "Bone Suckin' Sauce",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "sauce": 6
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "kinder": {
    "displayName": "Kinder",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 2,
      "chocolate": 7,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "mary_bs": {
    "displayName": "Mary B's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "bread": 10
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "fody": {
    "displayName": "Fody",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "dressing": 4,
      "candy": 1,
      "sauce": 1
    },
    "subtypes": [
      "dressing",
      "candy",
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "milford_valley": {
    "displayName": "Milford Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "boxed_meal": 10
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "queen_anne": {
    "displayName": "Queen Anne",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 10
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "rips": {
    "displayName": "Rips",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 10
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "edward_sons": {
    "displayName": "Edward & Sons",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 8,
      "beverage": 2
    },
    "subtypeCounts": {
      "cookie": 1,
      "bread": 3,
      "sauce": 3,
      "beverage": 2
    },
    "subtypes": [
      "bread",
      "sauce",
      "beverage",
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "hals_new_york": {
    "displayName": "Hal's New York",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 4,
      "beverage": 6
    },
    "subtypeCounts": {
      "beverage": 6
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "town_talk": {
    "displayName": "Town Talk",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "bread": 10
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "bakerly": {
    "displayName": "Bakerly",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "bread": 10
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "jelly_belly_candy": {
    "displayName": "Jelly Belly Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 10
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "phocus": {
    "displayName": "Phocus",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "purity_organic": {
    "displayName": "Purity Organic",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "marich": {
    "displayName": "Marich",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 8,
      "candy": 1,
      "cookie": 1
    },
    "subtypes": [
      "chocolate",
      "candy",
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "sweet_action": {
    "displayName": "Sweet Action",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "ice_cream": 10
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "great_lakes_potato_chip": {
    "displayName": "Great Lakes Potato Chip",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "fresh_lock": {
    "displayName": "Fresh Lock",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 2,
      "candy": 6
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "exo": {
    "displayName": "Exo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "happi_foodi": {
    "displayName": "Happi Foodi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "boxed_meal": 9
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "stahlbush_island_farms": {
    "displayName": "Stahlbush Island Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "dr_pepper": {
    "displayName": "Dr Pepper",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 8,
      "frozen": 1,
      "beverage": 1
    },
    "subtypeCounts": {
      "candy": 8,
      "ice_cream": 1,
      "beverage": 1
    },
    "subtypes": [
      "candy",
      "ice_cream",
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "chloes": {
    "displayName": "Chloe's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "ice_cream": 10
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "summer_fresh": {
    "displayName": "Summer Fresh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 3,
      "produce": 2,
      "meat": 4,
      "dairy": 1
    },
    "subtypeCounts": {
      "dressing": 1,
      "boxed_meal": 4,
      "cheese": 1
    },
    "subtypes": [
      "boxed_meal",
      "dressing",
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "blake_hill": {
    "displayName": "Blake Hill",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "spread": 6
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "avanza_pasta": {
    "displayName": "Avanza Pasta",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "tasteful_selections": {
    "displayName": "Tasteful Selections",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "pearl_and_johnny": {
    "displayName": "Pearl And Johnny",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "sauce": 10
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "wildscape": {
    "displayName": "Wildscape",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "boxed_meal": 9
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "margaritaville": {
    "displayName": "Margaritaville",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 2,
      "pantry": 8
    },
    "subtypeCounts": {
      "boxed_meal": 2,
      "dressing": 5,
      "sauce": 2
    },
    "subtypes": [
      "dressing",
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "redwood_hill_farm": {
    "displayName": "Redwood Hill Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "yogurt": 10
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "paleteria_la_michoacana": {
    "displayName": "Paleteria La Michoacana,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 9,
      "pantry": 1
    },
    "subtypeCounts": {
      "ice_cream": 9,
      "cookie": 1
    },
    "subtypes": [
      "ice_cream",
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "amys_kitchen": {
    "displayName": "Amy's Kitchen",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 7,
      "pantry": 3
    },
    "subtypeCounts": {
      "boxed_meal": 10
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "wm_bolthouse_farms": {
    "displayName": "Wm. Bolthouse Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 1,
      "pantry": 7,
      "beverage": 2
    },
    "subtypeCounts": {
      "dressing": 6,
      "beverage": 2
    },
    "subtypes": [
      "dressing",
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "rising_moon_organics": {
    "displayName": "Rising Moon Organics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 6,
      "frozen": 4
    },
    "subtypeCounts": {
      "boxed_meal": 4
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "rw_garcia": {
    "displayName": "Rw Garcia",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "firefly_kitchens": {
    "displayName": "Firefly Kitchens",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "moser_roth": {
    "displayName": "Moser Roth",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 10
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "la_piana": {
    "displayName": "La Piana",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "wiley_wallaby": {
    "displayName": "Wiley Wallaby",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 10
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "swad": {
    "displayName": "Swad",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 6,
      "frozen": 3,
      "dairy": 1
    },
    "subtypeCounts": {
      "baking": 1,
      "boxed_meal": 1,
      "cheese": 1
    },
    "subtypes": [
      "baking",
      "boxed_meal",
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "california_flavored_nuts": {
    "displayName": "California Flavored Nuts",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 7
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "wild_wheat_bakery": {
    "displayName": "Wild Wheat Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "bread": 10
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "beechers": {
    "displayName": "Beecher's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 9,
      "frozen": 1
    },
    "subtypeCounts": {
      "cheese": 9,
      "boxed_meal": 1
    },
    "subtypes": [
      "cheese",
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "el_sabroso": {
    "displayName": "El Sabroso",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "assi": {
    "displayName": "Assi",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 2,
      "frozen": 8
    },
    "subtypeCounts": {
      "baking": 1,
      "boxed_meal": 4,
      "ice_cream": 4
    },
    "subtypes": [
      "boxed_meal",
      "ice_cream",
      "baking"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "lindt_lindor": {
    "displayName": "Lindt Lindor",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 9,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "margies": {
    "displayName": "Margie's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "dressing": 3,
      "spread": 6,
      "sauce": 1
    },
    "subtypes": [
      "spread",
      "dressing",
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "mama_francesca": {
    "displayName": "Mama Francesca",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "produce_marketing_association": {
    "displayName": "Produce Marketing Association",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "harvest_valley": {
    "displayName": "Harvest Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "poore_brothers": {
    "displayName": "Poore Brothers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "jovy": {
    "displayName": "Jovy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 10
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "nash_f_h": {
    "displayName": "Nash Finch",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 1,
      "pantry": 8,
      "produce": 1
    },
    "subtypeCounts": {
      "milk": 1,
      "bread": 1,
      "boxed_meal": 2
    },
    "subtypes": [
      "boxed_meal",
      "milk",
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "mpanion": {
    "displayName": "Companion",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "bread": 6
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "gustafs": {
    "displayName": "Gustafs",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 10
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "sylvias_restaurant": {
    "displayName": "Sylvia's Restaurant",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "sauce": 2
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "sage_valley": {
    "displayName": "Sage Valley",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 9,
      "beverage": 1
    },
    "subtypeCounts": {
      "cookie": 3,
      "beverage": 1
    },
    "subtypes": [
      "cookie",
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "clemente_jacques": {
    "displayName": "Clemente Jacques",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "silva": {
    "displayName": "Silva",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "sauce": 4,
      "cookie": 1
    },
    "subtypes": [
      "sauce",
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "goodpop": {
    "displayName": "Goodpop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "ice_cream": 10
    },
    "subtypes": [
      "ice_cream"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "united_bakery": {
    "displayName": "United Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "bread": 10
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "palermo": {
    "displayName": "Palermo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "sauce": 1
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "soy_vay": {
    "displayName": "Soy Vay",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "sauce": 3,
      "dressing": 7
    },
    "subtypes": [
      "dressing",
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "belveder": {
    "displayName": "Belveder",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 8,
      "meat": 2
    },
    "subtypeCounts": {
      "boxed_meal": 2
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "salemville": {
    "displayName": "Salemville",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "ginger_evans": {
    "displayName": "Ginger Evans",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "baking": 6,
      "cookie": 1,
      "candy": 1
    },
    "subtypes": [
      "baking",
      "cookie",
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "bumble_bee": {
    "displayName": "Bumble Bee",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 7,
      "meat": 3
    },
    "subtypeCounts": {
      "boxed_meal": 10
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "sun_luck": {
    "displayName": "Sun Luck",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "meijer_naturals": {
    "displayName": "Meijer Naturals",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 3,
      "baking": 2,
      "cookie": 2,
      "boxed_meal": 2
    },
    "subtypes": [
      "candy",
      "baking",
      "cookie",
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "maya_kaimal": {
    "displayName": "Maya Kaimal",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "peculiar_untry": {
    "displayName": "Peculiar Country",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "spread": 8
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "amish_classics": {
    "displayName": "Amish Classics",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "charlies": {
    "displayName": "Charlie's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 2,
      "pantry": 7,
      "meat": 1
    },
    "subtypeCounts": {
      "cheese": 2,
      "cookie": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "cheese",
      "cookie",
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "cucina_di_carla": {
    "displayName": "Cucina Di Carla",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 3,
      "pantry": 7
    },
    "subtypeCounts": {
      "boxed_meal": 3
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "byrne_hollow_farm": {
    "displayName": "Byrne Hollow Farm",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "milk": 7,
      "yogurt": 3
    },
    "subtypes": [
      "milk",
      "yogurt"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "rumford": {
    "displayName": "Rumford",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "baking": 10
    },
    "subtypes": [
      "baking"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "select_choice": {
    "displayName": "Select Choice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "wholesome_goodness": {
    "displayName": "Wholesome Goodness",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 9,
      "beverage": 1
    },
    "subtypeCounts": {
      "dressing": 2,
      "boxed_meal": 1,
      "beverage": 1
    },
    "subtypes": [
      "dressing",
      "boxed_meal",
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "fifty50": {
    "displayName": "Fifty50",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 1,
      "cookie": 4,
      "spread": 5
    },
    "subtypes": [
      "spread",
      "cookie",
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "jayone": {
    "displayName": "Jayone",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 3,
      "beverage": 7
    },
    "subtypeCounts": {
      "beverage": 8,
      "sauce": 1
    },
    "subtypes": [
      "beverage",
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "lee_kum_kee": {
    "displayName": "Lee Kum Kee",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "dressing": 1,
      "sauce": 5
    },
    "subtypes": [
      "sauce",
      "dressing"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "win_schulers": {
    "displayName": "Win Schuler's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 7,
      "pantry": 3
    },
    "subtypeCounts": {
      "cheese": 7
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "gfb": {
    "displayName": "The Gfb",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "mackays": {
    "displayName": "Mackays",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "spread": 10
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "spelt_right": {
    "displayName": "Spelt Right",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 3,
      "pantry": 7
    },
    "subtypeCounts": {
      "bread": 5
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "chicago_custom": {
    "displayName": "Chicago Custom ,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "sauce": 10
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "kozlowski_farms": {
    "displayName": "Kozlowski Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "spread": 8,
      "dressing": 2
    },
    "subtypes": [
      "spread",
      "dressing"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "mayfield_dairy_farms": {
    "displayName": "Mayfield Dairy Farms,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 5,
      "dairy": 5
    },
    "subtypeCounts": {
      "ice_cream": 5,
      "milk": 5
    },
    "subtypes": [
      "ice_cream",
      "milk"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "juicy_drop": {
    "displayName": "Juicy Drop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 10
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "golden": {
    "displayName": "Golden",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 3,
      "pantry": 7
    },
    "subtypeCounts": {
      "boxed_meal": 3
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "minh": {
    "displayName": "Minh",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "boxed_meal": 10
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "california_select_farms": {
    "displayName": "California Select Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "frans_cho_lates": {
    "displayName": "Fran's Chocolates",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 4,
      "chocolate": 6
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "san_francis": {
    "displayName": "San Francisco",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 1,
      "meat": 9
    },
    "subtypeCounts": {
      "sauce": 1,
      "boxed_meal": 9
    },
    "subtypes": [
      "boxed_meal",
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "oasis": {
    "displayName": "Oasis",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 7,
      "meat": 3
    },
    "subtypeCounts": {
      "spread": 1,
      "bread": 3,
      "dressing": 1,
      "boxed_meal": 3
    },
    "subtypes": [
      "bread",
      "boxed_meal",
      "spread",
      "dressing"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "king_henrys": {
    "displayName": "King Henry's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 9
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "ta_ma_boys_markets": {
    "displayName": "Tacoma Boys Markets",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 9,
      "dairy": 1
    },
    "subtypeCounts": {
      "cheese": 1,
      "dressing": 7
    },
    "subtypes": [
      "dressing",
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "delish": {
    "displayName": "Delish",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 7,
      "beverage": 1,
      "produce": 2
    },
    "subtypeCounts": {
      "beverage": 3,
      "candy": 4,
      "cookie": 1
    },
    "subtypes": [
      "candy",
      "beverage",
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "beekman_1802_farm_pantry": {
    "displayName": "Beekman 1802 Farm Pantry",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "sweetener": 2,
      "sauce": 6,
      "dressing": 2
    },
    "subtypes": [
      "sauce",
      "sweetener",
      "dressing"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "nature_blessed": {
    "displayName": "Nature Blessed",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 1,
      "frozen": 9
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "ardens_garden": {
    "displayName": "Arden's Garden",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "wileys": {
    "displayName": "Wiley's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "sauce": 10
    },
    "subtypes": [
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "s_erely_brigitte": {
    "displayName": "Serely Brigitte",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "taste_elevated": {
    "displayName": "Taste Elevated",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "spread": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "spread",
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "delight": {
    "displayName": "Delight",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "milk": 5,
      "yogurt": 5
    },
    "subtypes": [
      "milk",
      "yogurt"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "pure_plus": {
    "displayName": "Pure Plus",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "sunny_delight_beverages": {
    "displayName": "Sunny Delight Beverages",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "noyan": {
    "displayName": "Noyan",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 5,
      "pantry": 5
    },
    "subtypeCounts": {
      "beverage": 5,
      "spread": 5
    },
    "subtypes": [
      "beverage",
      "spread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "sweet_treats": {
    "displayName": "Sweet Treats",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 10
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "petri": {
    "displayName": "Petri",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "cookie": 10
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "snackerz": {
    "displayName": "Snackerz",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 10
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "mackenthuns": {
    "displayName": "Mackenthun's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 4,
      "pantry": 5,
      "meat": 1
    },
    "subtypeCounts": {
      "chocolate": 1,
      "boxed_meal": 1
    },
    "subtypes": [
      "chocolate",
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "libre": {
    "displayName": "Coco Libre",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "truffettes_de_france": {
    "displayName": "Truffettes De France",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 9,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "praim_nfections": {
    "displayName": "Praim Confections",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 10
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "invo": {
    "displayName": "Invo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "astor_cho_late": {
    "displayName": "Astor Chocolate",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 10
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "jimmys_okies": {
    "displayName": "Jimmy's Cookies",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "cookie": 10
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "wawel": {
    "displayName": "Wawel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 6,
      "chocolate": 4
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "ssips": {
    "displayName": "Ssips",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "aqua_ball": {
    "displayName": "Aqua Ball",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "woopee": {
    "displayName": "Woopee",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "cookie": 10
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "roche_bros": {
    "displayName": "Roche Bros.",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 6,
      "dairy": 4
    },
    "subtypeCounts": {
      "candy": 1,
      "cheese": 4
    },
    "subtypes": [
      "cheese",
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "eternal": {
    "displayName": "Eternal",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "smart_juice": {
    "displayName": "Smart Juice",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "holly_baking": {
    "displayName": "Holly Baking",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "cookie": 10
    },
    "subtypes": [
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "sogo_bakery": {
    "displayName": "Sogo Bakery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "cookie": 2,
      "bread": 8
    },
    "subtypes": [
      "bread",
      "cookie"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "crosse_blackwell": {
    "displayName": "Crosse & Blackwell",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "spread": 3
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "glutenull": {
    "displayName": "Glutenull",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "cookie": 5,
      "candy": 1,
      "bread": 1
    },
    "subtypes": [
      "cookie",
      "candy",
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "california_premium": {
    "displayName": "California Premium",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "pine_river": {
    "displayName": "Pine River",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "burnett_dairy": {
    "displayName": "Burnett Dairy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "cuba_cheese_shoppe": {
    "displayName": "Cuba Cheese Shoppe",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "fluffy": {
    "displayName": "Fluffy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 2,
      "bread": 8
    },
    "subtypes": [
      "bread",
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "laura_beths": {
    "displayName": "Laura Beth's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "spread": 6,
      "dressing": 3,
      "candy": 1
    },
    "subtypes": [
      "spread",
      "dressing",
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "fine_raw": {
    "displayName": "Fine & Raw",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 10
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "vela_farms": {
    "displayName": "Vela Farms",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "spread": 9,
      "sauce": 1
    },
    "subtypes": [
      "spread",
      "sauce"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "jackies_jams": {
    "displayName": "Jackie's Jams",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "spread": 10
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "hersheys_gold": {
    "displayName": "Hershey's Gold",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 8,
      "chocolate": 2
    },
    "subtypes": [
      "candy",
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "mama_vickys_food": {
    "displayName": "Mama Vicky's Food",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "boxed_meal": 10
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "amphora": {
    "displayName": "Amphora",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "dressing": 2,
      "sauce": 5
    },
    "subtypes": [
      "sauce",
      "dressing"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "cuisine_adventures": {
    "displayName": "Cuisine Adventures",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 10
    },
    "subtypeCounts": {
      "boxed_meal": 10
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "jimmys": {
    "displayName": "Jimmy's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "dressing": 10
    },
    "subtypes": [
      "dressing"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "nona_lim": {
    "displayName": "Nona Lim",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 2,
      "pantry": 8
    },
    "subtypeCounts": {
      "boxed_meal": 10
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "elmer_candy": {
    "displayName": "Elmer Candy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 10
    },
    "subtypes": [
      "chocolate"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "harvest_club": {
    "displayName": "Harvest Club",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "produce": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "twirl_pops": {
    "displayName": "Twirl Pops",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 10
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "maltesers": {
    "displayName": "Maltesers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 7,
      "candy": 3
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "snowville_creamery": {
    "displayName": "Snowville Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "yogurt": 3,
      "milk": 7
    },
    "subtypes": [
      "milk",
      "yogurt"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "laclare_family_creamery": {
    "displayName": "Laclare Family Creamery",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "good_karma": {
    "displayName": "Good Karma",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "yogurt": 9,
      "milk": 1
    },
    "subtypes": [
      "yogurt",
      "milk"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "fever_tree": {
    "displayName": "Fever-tree",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "powergel": {
    "displayName": "Powergel",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "pure_life": {
    "displayName": "Pure Life",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "damak": {
    "displayName": "Damak",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "chocolate": 9,
      "candy": 1
    },
    "subtypes": [
      "chocolate",
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "tangy_zangy": {
    "displayName": "Tangy Zangy",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "candy": 10
    },
    "subtypes": [
      "candy"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "wunder": {
    "displayName": "Wunder",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "yogurt": 10
    },
    "subtypes": [
      "yogurt"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "18_rabbits": {
    "displayName": "18 Rabbits",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "pasta_shop": {
    "displayName": "The Pasta Shop",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 9,
      "frozen": 1
    },
    "subtypeCounts": {
      "boxed_meal": 1
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "tickle_water": {
    "displayName": "Tickle Water",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "shoppers": {
    "displayName": "Shoppers",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "bread": 10
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "alpine_lace": {
    "displayName": "Alpine Lace",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "r_everyday": {
    "displayName": "R Everyday",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 1,
      "pantry": 6,
      "beverage": 3
    },
    "subtypeCounts": {
      "cheese": 1,
      "cookie": 3,
      "sauce": 3,
      "beverage": 3
    },
    "subtypes": [
      "cookie",
      "sauce",
      "beverage",
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "bucky_badger_cheese": {
    "displayName": "Bucky Badger Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "shullsburg_wis_nsin_cheese": {
    "displayName": "Shullsburg Wisconsin Cheese",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "cheese": 10
    },
    "subtypes": [
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "stone_ridge_meat_untry_market": {
    "displayName": "Stone Ridge Meat & Country Market,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 9,
      "meat": 1
    },
    "subtypeCounts": {
      "cheese": 9,
      "sausage": 1
    },
    "subtypes": [
      "cheese",
      "sausage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "bubly": {
    "displayName": "Bubly",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "beverage": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "lawash": {
    "displayName": "Lawash",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "bread": 10
    },
    "subtypes": [
      "bread"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "simply_kraft": {
    "displayName": "Simply Kraft",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "dairy": 10
    },
    "subtypeCounts": {
      "milk": 6,
      "cheese": 4
    },
    "subtypes": [
      "milk",
      "cheese"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "h_k_anderson": {
    "displayName": "H.k Anderson",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {},
    "subtypes": [],
    "totalObs": 10,
    "source": "usda"
  },
  "totinos": {
    "displayName": "Totino's",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "frozen": 8,
      "pantry": 2
    },
    "subtypeCounts": {
      "boxed_meal": 8
    },
    "subtypes": [
      "boxed_meal"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "cafe_bustelo": {
    "displayName": "Cafe Bustelo",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "beverage": 10
    },
    "subtypes": [
      "beverage"
    ],
    "totalObs": 10,
    "source": "usda"
  },
  "fischer_wieser_specialty": {
    "displayName": "Fischer & Wieser Specialty ,",
    "canonicals": {},
    "hubs": {},
    "categories": {
      "pantry": 10
    },
    "subtypeCounts": {
      "spread": 10
    },
    "subtypes": [
      "spread"
    ],
    "totalObs": 10,
    "source": "usda"
  }
};
